import { React, useEffect, useState, useRef } from "react";
import {
  RightLayoutContainer,
  PageTitleComp,
  TableLayoutData,
  DownArrowDraw,
  DetailFields,
  GroupTitle,
} from "../../styledElements";
import {
  Button,
  PageHeader,
  Table,
  Tooltip,
  Progress,
  Tabs,
  Checkbox,
  Row,
  Col,
  Form,
  Input,
  Select,
  AutoComplete,
  Dropdown,
  Menu,
} from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import SearchContainer from "../../../Components/SearchBarHeader/searchBar";
import {
  Styled,
  StyledTab,
  DisabledButtonStyle,
  PaperMachineQualitySelect,
  PaperMachineGradeSelect,
} from "../../pageStyled";
import ViewDeckleOrder from "../DeckleOrderDrawer/viewDeckleOrder";
import moment from "moment";
// import ResendApprovalData from "../../OrderEntry/OrderDetailDrawer/resendApproval";
import ResendApprovalData from "../../OrderEntry/OrderDetailDrawer/resendApprovalNewDrawer";
import {
  getAllOrders,
  getDeckleOrdersList,
  getFilteredDeckleOrders,
  updateOrdersInBulk,
  getSplitGroupOrders,
} from "../../../Services/orderServices";
import { getProductDetailsForSelectedOrders } from "../../../Services/productServices";
import { searchDeckleMatchOrders } from "../../../Services/deckleMatchServices";
import alertBlue from "../../../Assets/Icons/alertBlue.svg";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import { HaberForm } from "../../styledElements";
import { useNavigate } from "react-router";
import { getFormObject, setFormObject } from "../../../Services/formServices";
import { ArrowRightOutlined, LeftCircleFilled } from "@ant-design/icons";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import styled from "styled-components";
import TableShimmer from "../../../Components/TableShimmer/tableShimmer";
import emptyState_Search from "../../../Assets/Images/emptyState_Search.svg";
import emptyState_NoData from "../../../Assets/Images/emptyState_NoData.svg";
import emptyState_ConnectionAPIError from "../../../Assets/Images/emptyState_ConnectionAPIError.svg";
import EmptyState from "../../../Components/EmptyState/emptyState";
import {
  getReelCoreValues,
  setOrderType,
} from "../../../Services/settingsServices";
import {
  orderDim_Rewinder_Unit_Conversion,
  weight_Unit_Conversions,
  CoversionFactorCMToUnits,
  lengthUnit,
  weightUnit,
  CoversionFactorUnitsToCM,
  conversionFactorTonneToUnits,
  conversionFactorUnitsToTonne,
} from "../../../Utils/Constant/MeasurementUnitList";
import { getUnitData } from "../../../Services/measurementService";
import MultiDiaEditOrderDrawer from "../../OrderEntry/OrderDetailDrawer/multiDiaEditOrderDrawer";
import {
  changeOrderPriority,
  updateOrder,
} from "../../../Services/orderServices";
import ConfirmationModal from "../../../Components/Modal/ConfirmationModal";
import warning from "../../../Assets/Icons/warning.png";
import ProductionDetailsDrawer from "../../OrderEntry/OrderDetailDrawer/productionDetailsDrawer";
import ViewProcessedQuantityDrawer from "../../OrderEntry/OrderDetailDrawer/viewProcessedQuantityDrawer";
import ViewPendingQuantityDrawer from "../../OrderEntry/OrderDetailDrawer/PendingQuantityDrawer";
import ReelCoreEditModal from "../../../Components/Modal/ReelCoreEditModal";
import Multiselect from "multiselect-react-dropdown";
import { toHandlePOName } from "../../../Utils/helper/helper";
import { getWorkflowSettings } from "../../../Services/workFlowSettingsServices";

const { Option } = Select;
const Panes = Tabs.TabPane;
const capitalize = (item) => item.charAt(0).toUpperCase() + item.slice(1);

const MultiSelectCard = styled.div`
  .optionContainer li:hover,
  .optionContainer .highlight {
    background: #edebe9;
    color: black;
  }
  .multiSelectContainer input[type="text"] {
    padding-left: 15px !important;
    width: 100%;
  }
  .optionContainer .highlight {
    background: white;
    color: black;
  }
  .optionListContainer {
    z-index: 100;
  }
  li.groupHeading {
    color: black;
    padding: 5px 15px;
    pointer-events: none;
    font-weight: 500;
  }
  .multiSelectContainer ul {
    border-radius: 0px;
    margin-top: 4px;
    width: 102%;
  }
  .multiSelectContainer input[type="checkbox"] {
    accent-color: rgb(234, 101, 91);
  }
`;

const SelectStyle = styled.div`
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border: none;
    margin-top: 10px;
  }
  .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
    padding-left: 3px;
    padding-right: 10px;
  }
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    background: none;
  }
`;

const multiselectStyle = {
  chips: {},
  searchBox: {
    border: "0px solid #dfe1e6",
    "border-radius": "8px",
    width: "102%",
    // "background-color": "var(--form-element-bg)",
  },
  option: {
    // To change css for dropdown options
    //background : "gray"
  },
};

const grainTypeData = ["Long", "Short"];

const OrderRecordsData = (props) => {
  const [userDetails, setUserDetails] = useState(
    JSON.parse(localStorage.getItem("user-details"))
  );
  const [settingsData, setSettingsData] = useState(
    JSON.parse(localStorage.getItem("setting-data"))
  );
  const [viewDeckleOrders, setViewDeckleOrders] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [allOrders, setAllOrders] = useState([]);
  const [totalRecords, setTotalRecords] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [orderState, setOrderState] = useState("pending_for_deckle_match");
  const [paginationParams, setPaginationParams] = useState({
    page: 1,
    size: settingsData?.settings?.default_page_size || 10,
  });
  const [sortParams, setSortParams] = useState({
    sort_by: "po__date",
    sort_type: "ascending",
  });
  const [tableData, setTableData] = useState([]);
  const [appliedFilters, setAppliedFilters] = useState([]);
  const [filterTags, setFilterTags] = useState([]);
  const [clearSearch, setClearSearch] = useState(false);
  const [
    isUpdateOrderDetailsButtonVisible,
    setIsUpdateOrderDetailsButtonVisible,
  ] = useState(true);
  const [isPendingTab, setIsPendingTab] = useState(true);
  const [
    isUpdateOrderDetailsButtonPressed,
    setIsUpdateOrderDetailsButtonPressed,
  ] = useState(false);
  const [isCheckboxClicked, setIsCheckboxClicked] = useState(false);
  const [isShowExportButton, setIsShowExportButton] = useState(
    userDetails.roles.job_cards.view
  );
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedDataRows, setSelectedDataRows] = useState([]);
  const [selectedOrderRows, setSelectedOrderRows] = useState([]);
  const [productDataForSelectedRows, setProductDataForSelectedRows] =
    useState();
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [inputData, setInputData] = useState({ core_id: "", reel_od: "" });
  const [resendApprovalData, setResendApprovalData] = useState(false);
  const [rendering, setRendering] = useState(true);
  const [actionToaster, setActionToaster] = useState({
    error: "",
    msg: "",
  });
  const [visibleToaster, setVisibleToaster] = useState(false);
  const [coreOdValidationError, setCoreOdValidationError] = useState(false);
  const [reelODValidationError, setReelODValidationError] = useState(false);
  const [rangeValidationError, setRangeValidationError] = useState(false);
  const [form] = Form.useForm();
  const [plannedQntyForm] = Form.useForm();
  const navigate = useNavigate();
  const [pendingOrders, setPendingOrders] = useState();
  const [pendingPOSO, setPendingPOSO] = useState();
  const [pendingQuantity, setPendingQuantity] = useState();
  const [searchValue, setSearchValue] = useState("");
  const [loading, setLoading] = useState(true);
  const [allInnerRecords, setAllInnerRecords] = useState({});
  const [nestedLoading, setNestedLoading] = useState(true);
  const [emptyStateLabel, setEmptyStateLabel] = useState();
  const [emptyStatePropsData, setEmptyStatePropsData] = useState();
  const [reelCoreData, setReelCoreData] = useState();
  const [reelValues, setReelvalues] = useState();
  const [coreValues, setCoreValues] = useState();
  const currentState = useRef("pending_for_deckle_match");
  const [isAllOrders, setIsAllOrders] = useState(true);
  const [showBulkOrderUpdate, setShowBulkOrderUpdate] = useState(false);
  const [selectedOrderType, setSelectedOrderType] = useState("reel");
  const [deckleOrderType, setDeckleOrderType] = useState("incomplete_orders");
  const [plannedQuantity, setPlannedQuantity] = useState();
  const [isDataChange, setIsDataChange] = useState(false);
  const updateButtonRef = useRef(false);
  const isAllOrderRef = useRef(true);
  const selectedOrderTypeRef = useRef("reel");
  const deckleOrderTypeRef = useRef("incomplete_orders");
  const paginationRef = useRef({ page: 1, size: settingsData?.settings?.default_page_size || 10 });
  const [pageLoaded, setPageLoaded] = useState(false);
  const [selectedState, setSelectedState] = useState(false);
  const [measurementData, setMeasurementData] = useState();
  const [isVisiblePriorityModal, setIsVisiblePriorityModal] = useState(false);
  const [productionDetailsSideDrawer, setProductionDetailsSideDrawer] =
    useState(false);
  const [processedQtyDetailsSideDrawer, setProcessedQtyDetailsSideDrawer] =
    useState(false);
  const [pendingQtyDetailsSideDrawer, setPendingQtyDetailsSideDrawer] =
    useState(false);
  const [count, setCount] = useState();
  const [plannedQuantityErr, setPlannedQuantityErr] = useState({});
  const [plannedReelsErr, setPlannedReelsErr] = useState({});
  const [plannedQtyRewindingDetErr, setPlannedQtyRewindingDetErr] = useState(
    {}
  );
  const [tableRerender, setTableRerender] = useState(false);
  const [rewindingTableRerender, setRewindingTableRerender] = useState(false);
  const [isEditClicked, setIsEditClicked] = useState({});
  const [isEditClickedForRewinding, setIsEditClickedForRewinding] = useState(
    {}
  );
  const [isEditPlannedReels, setIsEditPlannedReels] = useState({});
  const [editReelCoreModal, setEditReelCoreModal] = useState(false);
  const [selectedRecord, setSelectedReocord] = useState();
  const [selectedType, setSelectedType] = useState();
  const [selectedIndex, setSelectedIndex] = useState();
  const [selectedReelOD, setSelectedReelOD] = useState();
  const [selecteDia, setSelectedDia] = useState("constant");
  const [payload, setPayload] = useState([]);
  const [paginationParamsChange, setPaginationParamsChange] = useState(false);
  const tableDataRef = useRef();
  const tableDataCopyRef = useRef();
  const indexRef = useRef();
  const [grainType, setGrainType] = useState();
  const [searchKey, setSearchKey] = useState(false);
  const [selectedGrainOrderType, setSelectedGrainOrderType] = useState("");
  const [orderManagementSettings, setOrderManagementSettings] = useState(JSON.parse(localStorage.getItem("order-management-settings")));
  const titleRef = useRef(null);
  const tabRef = useRef(null);
  const searchRef = useRef(null);
  const [stickyOffsets, setStickyOffsets] = useState({ title: 58, tabs: 95, search: 140, table: 226 });

  useEffect(() => {
    const observer = new ResizeObserver(() => {
      const baseTop = 58;
      const titleHeight = titleRef.current?.offsetHeight || 0;
      const tabsHeight = tabRef.current?.offsetHeight || 0;
      const searchHeight = searchRef.current?.offsetHeight || 0;

      setStickyOffsets({
        title: baseTop,
        tabs: baseTop + titleHeight,
        search: baseTop + titleHeight + tabsHeight,
        table: baseTop + titleHeight + tabsHeight
      });
    });

    if (titleRef.current) observer.observe(titleRef.current);
    if (tabRef.current) observer.observe(tabRef.current);
    if (searchRef.current) observer.observe(searchRef.current);

    return () => observer.disconnect();
  }, []);

  const diameterType = [
    { label: "Constant", value: "constant" },
    { label: "Range", value: "range" },
  ];
  const columnsHead = useRef([
    {
      // title: "Po/So.No",
      // dataIndex: "pono",
      // width: "6.6%",
      // fixed: "left",
      // // align: "left",
      // sorter: () => {},
      title: "Po/So.No",
      dataIndex: "pono",
      width: "10%",
      fixed: "left",
      key: "pono",
      align: "left",
      sorter: () => { },
      // sorter: (a, b, sortOrder) => a.pono.localeCompare(b.pono),
      render: (text, record) => (
        <>
          {record.isConflictingstate ? (
            <span style={{ paddingBottom: '5px' }}> <Tooltip title={`Conflicting order, part of ${record.jobcards?.length} conflicting job cards`} placement="top" >
              <Iconmoon icon="info_new" size={16} color="#EA655B" />
            </Tooltip>
            </span>
          ) : (
            // Invisible placeholder to maintain layout
            <span style={{ width: "14px" }}></span>
          )}
          <Button
            style={{
              background: "transparent",
              whiteSpace: "normal", // allow wrapping
              textAlign: "left",
              lineHeight: "1.4",

            }}
            className="textTypeBtn textBtnIcon"
            onClick={() => handlePo(record)}
          >
            <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
              {
                `#${(record.category === 'so' ? toHandlePOName(record.sono) : toHandlePOName(record.pono).replaceAll("_", " "))}`
                  .match(/.{1,15}/g)
                  ?.map((chunk, index) => (
                    <span key={index}>
                      {chunk}
                      <br />
                    </span>
                  ))
              }
            </div>
          </Button>
        </>
      ),
    },
    // {
    //   title: "Group No",
    //   dataIndex: "groupno",
    //   width: "6.6%",
    //   fixed: "left",
    //   sorter: () => {},
    // },
    {
      title: "Order No",
      dataIndex: "orderno",
      width: "6.6%",
      fixed: "left",
      sorter: () => { },
      render: (text, record) => (
        <div className="actionBtn2">
          {text != "-" ? (
            <Button
              style={{ background: "transparent" }}
              className="textTypeBtn textBtnIcon"
              onClick={() => handleOrder(record)}
            >
              {`${text}`}
            </Button>
          ) : (
            <span style={{ textAlign: "center" }}>{text}</span>
          )}
        </div>
      ),
    },
    {
      title: "PO Date",
      dataIndex: "podate",
      width: "8%",
      sorter: {
        compare: (a, b) => new Date(a.podate) - new Date(b.podate),
      },
    },
    {
      title: "Customer",
      dataIndex: "customer_alias",
      width: "8%",
      align: "left",
      render: (text, record) => (
        <div className="actionBtn2">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={`${record.customercode}-${record.customerName}`}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {record?.customer_alias || '-'}
            </Tooltip>
          </Styled>
        </div>
      ),
    },
    {
      title: "Consignee",
      dataIndex: "consignee_alias",
      width: "8%",
      align: "left",
      render: (text, record) => (
        <div className="actionBtn2">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={`${record.consignee}-${record.consignee_name}`}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {record?.consignee_alias || '-'}
            </Tooltip>
          </Styled>
        </div>
      ),
    },
    {
      title: (
        <div>
          Product
          <Styled style={{ display: "inline-flex" }}>
            <Tooltip
              placement="bottomRight"
              title={
                "The product specification is in the format of Grade/GSM/BF/Quality/Moisture"
              }
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <span className="infoIcon"></span>
            </Tooltip>
          </Styled>
        </div>
      ),
      // dataIndex: "productcode",
      width: "10.8%",
      render: (text, record) => {
        return (
          <Styled>
            {" "}
            <span style={{ fontSize: "10px" }}>{record.productspec} </span>
            <br />
            <span style={{ textAlign: "center" }}>{record.productcode}</span>
          </Styled>
        );
      },
    },
    // {
    //   title: (
    //     <div>
    //       Product Spec
    //       <Styled style={{ display: "inline-flex" }}>
    //         <Tooltip
    //           placement="bottomRight"
    //           title={
    //             "The product specification is in the format of Grade/GSM/BF/Quality/Moisture"
    //           }
    //           className="edit-tooltip"
    //           getPopupContainer={(triggerNode) => triggerNode}
    //         >
    //           <span className="infoIcon"></span>
    //         </Tooltip>
    //       </Styled>
    //     </div>
    //   ),
    //   dataIndex: "productspec",
    //   width: "10.8%",
    // },
    // {
    //   title: "Type",
    //   dataIndex: "type",
    //   width: "5.8%",
    // },
    {
      title: "Size(WxL)",
      dataIndex: "size",
      width: "8%",
    },
    {
      title: "Grain",
      dataIndex: "grain",
      width: "8%",
      render: (text, record, index) => (
        <Styled>
          {record.type.toLowerCase() == "sheet" ? (
            <div style={{ display: "flex" }}>
              <Row className="centerAlign">
                <div className="boxFormType">
                  <SelectStyle>
                    <Form.Item
                      name={`grain${record.orderno}`}
                      rules={[
                        {
                          required: true,
                          message: "This field is required",
                        },
                      ]}
                      className="selectForm"
                      style={{ marginBottom: 4 }}
                      initialValue={
                        record.grain
                          ? record.grain == "short"
                            ? "Short"
                            : "Long"
                          : null
                      }
                    >
                      <Select
                        placeholder={"Select"}
                        suffixIcon={<DownArrowDraw />}
                        onChange={(e) =>
                          onGrainChange(e, record, index, "complete_order")
                        }
                      >
                        {grainTypeData.map((grainType) => (
                          <Option key={grainType}>{grainType}</Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </SelectStyle>
                </div>
              </Row>
            </div>
          ) : (
            ""
          )}
        </Styled>
      ),
    },
    {
      title: "Order Qty",
      dataIndex: "quantityValue",
      width: "7.4%",
      render: (text, record) => (
        <Styled>
          {" "}
          {record.type.toLowerCase() == "sheet" &&
            record.quantity_type.toLowerCase() == "reel_sheet" ? (
            <>
              <span style={{ textAlign: "center", fontSize: "12px" }}>
                {text}
              </span>
              <br /> <span> {record.no_of_reel_sheet + " Sheets"} </span>
            </>
          ) : (
            `${text} `
          )}
        </Styled>
      ),
    },
    {
      title: "Balance Quantity",
      dataIndex: "balance_qty",
      width: "6%",
    },
    {
      title: "Processed Qty",
      dataIndex: "processQuantity",
      width: "10%",
      render: (text, record) => {
        return (
          <div
            className="actionBtn"
            style={{ marginTop: "14px", justifyContent: "left" }}
          >
            <Col span={12}>
              {parseFloat(text) && record.type
                ? `${text}`
                : parseFloat(text)
                  ? `${text} `
                  : "-"}
            </Col>
            {parseFloat(text) ? (
              <Col span={12}>
                <Styled style={{ marginTop: "-8px" }}>
                  <Tooltip
                    placement="bottomRight"
                    title={"View Processed Quantity Details"}
                    className="edit-tooltip"
                    getPopupContainer={(triggerNode) => triggerNode}
                  >
                    <Button
                      onClick={() => {
                        handleViewProcessedQtyAction(record);
                      }}
                    >
                      <Iconmoon
                        icon="viewPODetails"
                        size={16}
                        color="rgb(96, 94, 92)"
                      />
                    </Button>
                  </Tooltip>
                </Styled>
              </Col>
            ) : (
              ""
            )}
          </div>
        );
      },
    },
    {
      title: "Pending Qty",
      dataIndex: "pendingQuant",
      width: "11%",
      render: (text, record) => {
        if (record.isConflictingstate) {
          return "ND"
        }
        return (

          <div
            className="actionBtn"
            style={{ marginTop: "14px", justifyContent: "left" }}
          >

            <Col span={12}>
              {record.type.toLowerCase() == "sheet" &&
                record.quantity_type.toLowerCase() == "reel_sheet" ? (
                <>
                  <span style={{ textAlign: "center", fontSize: "12px" }}>
                    (
                    {parseFloat(text) && record.type
                      ? `${text}`
                      : parseFloat(text)
                        ? `${text} `
                        : "-"}
                    )
                  </span>
                  <br />{" "}
                  <span>
                    {" "}
                    {record.total_pending_quantity.quantity + " Sheets"}{" "}
                  </span>
                </>
              ) : (
                `${text} `
              )}
            </Col>
            {parseFloat(text) ? (
              <Col span={12}>
                <Styled style={{ marginTop: "-8px" }}>
                  <Tooltip
                    placement="bottomRight"
                    title={"View Pending Quantity Details"}
                    className="edit-tooltip"
                    getPopupContainer={(triggerNode) => triggerNode}
                  >
                    <Button
                      onClick={() => {
                        handleViewPendingQtyAction(record);
                      }}
                    >
                      <Iconmoon
                        icon="viewPODetails"
                        size={16}
                        color="rgb(96, 94, 92)"
                      />
                    </Button>
                  </Tooltip>
                </Styled>
              </Col>
            ) : (
              ""
            )}
          </div>
        );
      },
    },
    {
      title: "Qty to be planned",
      dataIndex: "plannedQuant",
      width: "14%",
      key: "plannedQuant",
      render: (text, record, index) => {
        return (
          <div
            className="actionBtn"
            style={{
              marginTop:
                !isEditClicked?.[record.orderno] ||
                  (isEditClicked?.[record.orderno] &&
                    !isEditClicked?.[record.orderno].isEditable)
                  ? "14px"
                  : "0px",
              justifyContent: "left",
            }}
          >
            {(!isEditClicked?.[record.orderno] ||
              (isEditClicked?.[record.orderno] &&
                !isEditClicked?.[record.orderno].isEditable)) && (
                <Col span={12}>
                  {text} {record.plannedUnit}
                </Col>
              )}
            {userDetails?.roles?.job_cards.edit && (
              <Col span={12}>
                <Styled style={{ marginTop: "-7px" }}>
                  <Tooltip
                    placement="bottomRight"
                    title={"Edit planned quantity"}
                    className="edit-tooltip"
                    getPopupContainer={(triggerNode) => triggerNode}
                  >
                    <Button
                      onClick={() => {
                        handleEditColumn(index, record, true, "complete_order");
                      }}
                    >
                      <Iconmoon icon="edit" size={16} color="#A19F9D" />
                    </Button>
                  </Tooltip>
                </Styled>
              </Col>
            )}
            {/* {isEditClicked && <DetailFields style={{paddingBottom: "0px"}}>
            <Styled>
              <HaberForm>
                <Form
                  id="plannedQntyForm"
                  form={plannedQntyForm}
                  name="basic"
                  autoComplete="off"
                  className="qtyToBePlannedInput"
                  onFinish={onFinish}
                >
                <Row className="centerAlign justifyCSBetween">
                  <Col span={14} style={{ paddingRight: "5px"}}>
                    <div className="boxFormType" >
                    <Form.Item
                      name = {`plannedQuanty${index}`}
                      rules={[
                        {
                          required: true,
                          message: "This field is required."
                        },
                        {
                          pattern: new RegExp(
                            /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
                          ),
                          message:
                            "This value should be a non-zero positive value.",
                        },
                        {
                          validator(_, value) {
                            if (record.pendingQuant && record.pendingQuant?.split(" ")[0] && parseFloat(value) > 0) {
                              if (( parseFloat(value) <= parseFloat(record.pendingQuant?.split(" ")[0])) ){
                                return Promise.resolve();
                              } else {
                                return Promise.reject(
                                  "Quantity to be planned can't be more than the pending quantity."
                                );
                              }
                            }
                            else{
                              return Promise.reject(
                                 ""
                                );
                            }
                          },
                        },
                      ]}
                      className="dBlock"
                      initialValue={text}
                    >
                      <Input
                      onChange={(e) => {
                        onPlannedQuntyChange(e, record, index);
                      }}
                      />
                    </Form.Item>
                    <span className="nonEditable" style={{marginTop:"0px"}}>{record.plannedUnit}</span>
                    </div>
                  </Col>
                  <Col span={10} style={{ paddingRight: "5px",  marginTop:"-8px" }}>
                    <div
                      className="boxFormType"
                      style={{ marginBottom: "0", marginTop:"14px"}}
                    >
                      <Tooltip title={"Save the entered value"}>
                        <Button
                          key="1"
                          className="edit-btn"
                          style={{
                            padding: "0px",
                            margin: "0px",
                            width: "28px",
                            border: "none",
                            display: "inline-block",
                            marginRight: "10px"
                          }}
                          onClick={() =>
                            onActionChange(index, "save", record)
                          }
                        >
                          <Iconmoon icon="check" size={18} color="#3FBD61" />
                        </Button>
                      </Tooltip>

                      <Tooltip title={"Remove the entered value"}>
                        <Button
                          key="2"
                          className="edit-btn"
                          style={{
                            padding: "0px",
                            margin: "0px",
                            width: "28px",
                            border: "none",
                            display: "inline-block",
                          }}
                          onClick={() =>
                            onActionChange(index, "remove", record)
                          }
                        >
                          <Iconmoon icon="cancel" size={18} color="red" />
                        </Button>
                      </Tooltip>
                    </div>
                </Col>
                </Row>
                </Form>
                </HaberForm>
            </Styled>
          </DetailFields>} */}
          </div>
        );
      },
    },
    // {
    //   title: "Pending Reels",
    //   dataIndex: "pendingReels",
    //   width: "7.4%",
    //   render: (text, record) => text ? `${text} Reels` : "-",
    // },
    // {
    //   title: "Pending Weight",
    //   dataIndex: "pendingWeight",
    //   width: "9%",
    // },
    // {
    //   title: "Reel OD",
    //   dataIndex: "reelod",
    //   width: "6%",
    // },
    {
      title: "Reel OD for Rewinding",
      dataIndex: "reelod",
      width: "10%",
      render: (text, record, index) => (
        <Styled>
          <div style={{ display: "flex" }}>
            {record.id_od_type == "range" && (
              <div
                style={{
                  color: "var(--para-text)",
                  display: "flex",
                  width: "70%",
                  alignSelf: "center",
                }}
              >
                {record.minimum_reel_od && record.maximum_reel_od
                  ? record.minimum_reel_od +
                  "-" +
                  record.maximum_reel_od +
                  " " +
                  (record.units.maximum_reel_od
                    ? lengthUnit[record.units.maximum_reel_od].displayName
                    : "")
                  : ""}
              </div>
            )}
            {record.id_od_type == "constant" && (
              <div
                style={{
                  display: "flex",
                  width: "70%",
                  flexDirection: "column",
                  alignSelf: "center",
                }}
              >
                {record?.reelod &&
                  record?.reelod?.map((item, index) => {
                    return (
                      index < 2 && (
                        <div>
                          {item}{" "}
                          {index == 1
                            ? "...,"
                            : record?.reelod?.length > 1
                              ? ","
                              : ""}
                        </div>
                      )
                    );
                  })}

                {record?.reelod &&
                  record?.reelod?.length >= 2 &&
                  record.reelod?.map((item, index) => {
                    let tooltipData = "";
                    for (
                      let index = 2;
                      index < record.reelod?.length;
                      index++
                    ) {
                      const data = record.reelod[index];
                      tooltipData = tooltipData + data + ", ";
                    }
                    tooltipData = tooltipData.substring(
                      0,
                      tooltipData.length - 1
                    );
                    return (
                      index == 2 && (
                        <Tooltip title={tooltipData}>
                          {" "}
                          <span
                            style={{
                              display: "flex",
                              fontSize: "10px",
                              fontWeight: "bold",
                            }}
                          >
                            & {record.reelod.length - 2} More
                          </span>
                        </Tooltip>
                      )
                    );
                  })}
              </div>
            )}
            <div style={{ display: "flex", width: "30%" }}>
              <div className="actionBtn">
                {" "}
                {userDetails?.roles?.job_cards.edit && (
                  <Button
                    onClick={() =>
                      showEditReelCoreModal(
                        record,
                        "reel",
                        index,
                        "complete_order"
                      )
                    }
                    style={{ background: "none" }}
                  >
                    <Iconmoon icon="down" size={30} color="var(--para-text)" />
                  </Button>
                )}{" "}
              </div>
            </div>
          </div>
        </Styled>
      ),
    },
    {
      title: "Core OD for Rewinding",
      dataIndex: "coreid",
      width: "10%",
      render: (text, record, index) => (
        <div className="actionBtn">
          <Styled>
            <div style={{ display: "flex" }}>
              {record.coreid ? (
                <div
                  style={{
                    color: "var(--para-text)",
                    display: "flex",
                    width: "70%",
                    alignSelf: "center",
                  }}
                >
                  {record.coreid}
                </div>
              ) : (
                <div
                  style={{
                    display: "flex",
                    width: "70%",
                    alignSelf: "center",
                    marginLeft: "36px",
                  }}
                ></div>
              )}

              <div style={{ display: "flex", width: "30%" }}>
                <div className="actionBtn">
                  {" "}
                  {userDetails?.roles?.job_cards.edit && (
                    <Button
                      onClick={() =>
                        showEditReelCoreModal(
                          record,
                          "core",
                          index,
                          "complete_order"
                        )
                      }
                      style={{ background: "none" }}
                    >
                      <Iconmoon
                        icon="down"
                        size={30}
                        color="var(--para-text)"
                      />
                    </Button>
                  )}{" "}
                </div>
              </div>
            </div>
          </Styled>
        </div>
      ),
    },
    {
      title: "Delivery Date",
      dataIndex: "deliverydate",
      width: "8%",
      sorter: {
        compare: (a, b) => new Date(a.deliverydate) - new Date(b.deliverydate),
      },
    },
    {
      title: "Created Date",
      dataIndex: "createddate",
      width: "8%",
      sorter: {
        compare: (a, b) => new Date(a.createddate) - new Date(b.createddate),
      },
    },
    // {
    //   title: "Quantity",
    //   dataIndex: "quantity",
    //   width: "7.4%",
    //   render: (text, record) => record.quantity_type === "weight" ? "-" : `${text}`,
    // },
    // {
    //   title: "Order Weight",
    //   dataIndex: "weight",
    //   width: "9%",
    //   render: (text, record) =>
    //     record.quantity_type === "reel_sheet" ? "-" : `${text} ${record.units  && record.item_type !== "split_group" ? weightUnit[record.units.weight]?.displayName?.toUpperCase() : weightUnit[record.units.total_weight].displayName?.toUpperCase()}`,
    // },
    // {
    //   title: "Planned Weight",
    //   dataIndex: "plannedweight",
    //   width: "9%",
    // },
    // {
    //   title: "Rewinder Reels",
    //   dataIndex: "rewinderreels",
    //   width: "9%",
    //   // render: (text, record) => `${text} Reels`,
    // },
    {
      title: "Priority",
      dataIndex: "priority",
      width: "6%",
      render: (text, record) => (
        <div className="actionBtn">
          <Button style={{ cursor: "default" }}>
            <Iconmoon
              icon={record.priority ? "correct" : "wrong"}
              size={16}
              color={record.priority ? "#3FBD61" : "#a19f9d"}
            />
          </Button>
        </div>
      ),
      align: "center",
    },
    // {
    //   title: "Remarks",
    //   dataIndex: "remarks",
    //   width: "6%",
    //   render: (text, record) => (
    //     <div className="actionBtn">
    //       <Styled>
    //         <Tooltip
    //           placement="bottomRight"
    //           title={record.remarks}
    //           className="edit-tooltip"
    //           getPopupContainer={(triggerNode) => triggerNode}
    //         >
    //           <Button style={{ cursor: "default" }}>
    //             <Iconmoon icon="message" size={16} color="#EA655B" />
    //           </Button>
    //         </Tooltip>
    //       </Styled>
    //     </div>
    //   ),
    //   align: "center",
    // },
    {
      title: "Progress",
      dataIndex: "progress",
      width: "6.8%",
      render: (text, record) => {
        if (!record.isConflictingstate) {
          if (
            record?.type.toLowerCase() === "sheet" ||
            (record?.type.toLowerCase() === "reel" &&
              record?.quantity_type.toLowerCase() === "weight")
          ) {
            const totalProd =
              ((record?.progressbar_info?.completed?.weight +
                record?.progressbar_info?.in_production?.weight) /
                (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
              100;
            const totalCompleted =
              (record?.progressbar_info?.completed?.weight /
                (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
              100;
            //const weightUnitKey =  ((record?.units && record?.units?.weight) ? capitalize(weightUnit[record.units.weight]?.displayName) : "T") ;
            return (
              <div className="progressLvl">
                <Styled>
                  <Tooltip
                    placement="bottomRight"
                    title={`${record?.progressbar_info?.completed
                        ? (record?.progressbar_info?.completed?.weight).toFixed(3)
                        : 0.0
                      } ${capitalize(
                        weightUnit[
                          record?.progressbar_info?.completed?.units?.weight
                        ].displayName
                      )} Weight produced
                          ${record?.progressbar_info?.in_production
                        ? (record?.progressbar_info?.in_production?.weight).toFixed(
                          3
                        )
                        : 0.0
                      } ${capitalize(
                        weightUnit[
                          record?.progressbar_info?.in_production?.units?.weight
                        ].displayName
                      )} Weight in production
                        ${record?.progressbar_info?.pending
                        ? (record?.progressbar_info?.pending?.weight).toFixed(
                          3
                        )
                        : 0.0
                      } ${capitalize(
                        weightUnit[record?.progressbar_info?.pending?.units?.weight]
                          .displayName
                      )} Weight pending for deckle match`}
                    className="edit-tooltip"
                    getPopupContainer={(triggerNode) => triggerNode}
                  >
                    <Progress
                      percent={totalProd}
                      success={{
                        percent: totalCompleted,
                      }}
                      strokeColor={"#cbe2cd"}
                    />
                  </Tooltip>
                </Styled>
              </div>
            );
          } else {
            const production =
              ((record?.progressbar_info?.completed?.quantity +
                record?.progressbar_info?.in_production?.quantity) /
                (record?.no_of_reel_sheet -
                  record.cancelled_quantity?.quantity)) *
              100;
            const completed =
              (record?.progressbar_info?.completed?.quantity /
                (record?.no_of_reel_sheet -
                  record.cancelled_quantity?.quantity)) *
              100;

            return (
              <div className="progressLvl">
                <Styled>
                  <Tooltip
                    placement="bottomRight"
                    title={`${record?.progressbar_info?.completed
                        ? record?.progressbar_info?.completed?.quantity
                        : 0
                      } Reels produced
                          ${record?.progressbar_info?.in_production
                        ? record?.progressbar_info?.in_production
                          ?.quantity
                        : 0
                      } Reels in production
                          ${record?.progressbar_info?.pending
                        ? record?.progressbar_info?.pending?.quantity
                        : 0
                      } Reels pending for deckle match`}
                    className="edit-tooltip"
                    getPopupContainer={(triggerNode) => triggerNode}
                  >
                    <Progress
                      percent={production}
                      success={{
                        percent: completed,
                      }}
                      strokeColor={"#cbe2cd"}
                    />
                  </Tooltip>
                </Styled>
              </div>
            );
          }
        }
      },
      align: "center",
    },
    {
      title: "Actions",
      dataIndex: "action",
      width: "6.2%",
      render: (text, record) =>
        record.item_type === "order" ? (
          <div className="actionBtn" style={{ paddingRight: "20px" }}>
            {userDetails?.roles?.job_cards.edit ? (
              <Styled>
                <Tooltip
                  placement="bottomRight"
                  title={"Edit planning details"}
                  className="edit-tooltip"
                  getPopupContainer={(triggerNode) => triggerNode}
                >
                  <Button
                    onClick={() => {
                      handleEditAction(record);
                    }}
                  >
                    <Iconmoon icon="edit" size={16} color="#A19F9D" />
                  </Button>
                </Tooltip>
              </Styled>
            ) : (
              <div style={{ display: "flex" }}>
                <div style={{ width: "38px" }}></div>
              </div>
            )}
            {/* { ((userDetails?.roles?.approve_jobcards.view || userDetails?.roles?.job_cards.view ) && 
            (userDetails?.role_type == 'ADMIN' || userDetails?.role_type == 'SUPER_ADMIN')) && */}
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={"View details of this order"}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button
                  onClick={() => {
                    handleActions(record);
                  }}
                  disabled={
                    !(
                      userDetails?.roles?.approve_jobcards.view ||
                      userDetails?.roles?.job_cards.view ||
                      userDetails?.roles?.job_cards.edit ||
                      userDetails?.role_type == "ADMIN" ||
                      userDetails?.role_type == "SUPER_ADMIN"
                    )
                  }
                >
                  <Iconmoon icon="file-view" size={16} color="#A19F9D" />
                </Button>
              </Tooltip>
            </Styled>
            {/* } */}
            {[
              "Approved",
              "approved",
              "On Hold",
              "on hold",
              "hold",
              "Complete",
              "complete",
            ].includes(record?.state) && userDetails?.roles?.job_cards.edit ? (
              <Dropdown
                className="viewDropdownStyle"
                overlay={
                  <Menu>
                    {record.state === "approved" && (
                      // <Menu.Item key="1" style={{marginTop:"-5px", marginBottom:"-10px"}}>
                      //                 <DisabledButtonStyle>
                      //                   <Button
                      //                     style={{
                      //                       border: "none",
                      //                       background: "none",
                      //                       padding: "0",
                      //                       font: "inherit",
                      //                       textAlign: "left",
                      //                       width: "100%",
                      //                     }}
                      //                     onClick={() => handlePriorityAction(record)}
                      //                   >
                      //                     <span
                      //                       style={{
                      //                         color: "rgba(0, 0, 0, 0.85)"
                      //                       }}
                      //                     >
                      //                       {record?.priority ? "Remove Priority" : "Prioritize this order"}
                      //                     </span>
                      //                   </Button>
                      //                 </DisabledButtonStyle>
                      // </Menu.Item>
                      <Menu.Item
                        key="1"
                        style={{ marginTop: "-5px", marginBottom: "-10px" }}
                      >
                        <Button
                          style={{
                            border: "none",
                            background: "none",
                            padding: "0",
                            font: "inherit",
                            textAlign: "left",
                            width: "100%",
                            color: "black",
                          }}
                          className="themeBtn noBg"
                          onClick={() => {
                            handlePriorityAction(record);
                          }}
                        >
                          <div
                            style={{ display: "flex", flexDirection: "row" }}
                          >
                            <div style={{ marginTop: "8px" }}>
                              <Iconmoon
                                icon={
                                  record.priority
                                    ? "low-priority"
                                    : "high-priority"
                                }
                                size={17}
                                color={record.priority ? "#ea4e2c" : "#3fbd61"}
                              />{" "}
                            </div>
                            <div
                              style={{ marginTop: "5px", marginLeft: "6px" }}
                            >
                              {record.priority
                                ? "Remove Priority"
                                : "Prioritize this order"}
                            </div>
                          </div>
                        </Button>
                      </Menu.Item>
                    )}
                    {(record.state == "approved" || record.state == "hold") && (
                      <Menu.Item key="2" style={{ marginBottom: "-10px" }}>
                        <DisabledButtonStyle>
                          <Button
                            style={{
                              border: "none",
                              background: "none",
                              color: "inherit",
                              padding: "0",
                              font: "inherit",
                              cursor: "pointer",
                              outline: "inherit",
                              textAlign: "left",
                            }}
                            onClick={() => handleViewProdDetails(record)}
                          >
                            <div
                              style={{ display: "flex", flexDirection: "row" }}
                            >
                              <div style={{ marginTop: "8px" }}>
                                <Iconmoon
                                  icon={"production"}
                                  size={17}
                                  color="#605E5C"
                                />{" "}
                              </div>
                              <div
                                style={{ marginTop: "5px", marginLeft: "6px" }}
                              >
                                View Production Details
                              </div>
                            </div>
                          </Button>
                        </DisabledButtonStyle>
                      </Menu.Item>
                    )}
                    {(record.state == "approved" || record.state == "hold") && (
                      <Menu.Item key="3" style={{ marginBottom: "-10px" }}>
                        <DisabledButtonStyle>
                          <Button
                            style={{
                              border: "none",
                              background: "none",
                              color: "inherit",
                              padding: "0",
                              font: "inherit",
                              cursor: "pointer",
                              outline: "inherit",
                              textAlign: "left",
                            }}
                            onClick={() =>
                              handleViewProcessedQtyDetails(record)
                            }
                          >
                            <div
                              style={{ display: "flex", flexDirection: "row" }}
                            >
                              <div style={{ marginTop: "8px" }}>
                                <Iconmoon
                                  icon={"viewPODetails"}
                                  size={17}
                                  color="#605E5C"
                                />{" "}
                              </div>
                              <div
                                style={{ marginTop: "5px", marginLeft: "6px" }}
                              >
                                View Processed Quantity Details
                              </div>
                            </div>
                          </Button>
                        </DisabledButtonStyle>
                      </Menu.Item>
                    )}
                    {(record.state == "approved" ||
                      record.state == "hold" ||
                      record.state == "open" ||
                      record.state == "review" ||
                      record.state == "pending") && (
                        <Menu.Item key="4" style={{ marginBottom: "-10px" }}>
                          <DisabledButtonStyle>
                            <Button
                              style={{
                                border: "none",
                                background: "none",
                                color: "inherit",
                                padding: "0",
                                font: "inherit",
                                cursor: "pointer",
                                outline: "inherit",
                                textAlign: "left",
                              }}
                              onClick={() => handleViewPendingQtyDetails(record)}
                            >
                              <div
                                style={{ display: "flex", flexDirection: "row" }}
                              >
                                <div style={{ marginTop: "8px" }}>
                                  <Iconmoon
                                    icon={"viewPODetails"}
                                    size={17}
                                    color="#605E5C"
                                  />{" "}
                                </div>
                                <div
                                  style={{ marginTop: "5px", marginLeft: "6px" }}
                                >
                                  View Pending Quantity Details
                                </div>
                              </div>
                            </Button>
                          </DisabledButtonStyle>
                        </Menu.Item>
                      )}
                    <Menu.Item
                      key="5"
                      style={{ marginTop: "-5px", marginBottom: "-10px" }}
                    >
                      <DisabledButtonStyle>
                        <Button
                          onClick={() => {
                            onViewPODetailsHandler(record);
                          }}
                          style={{
                            border: "none",
                            background: "none",
                            color: "inherit",
                            padding: "0",
                            font: "inherit",
                            cursor: "pointer",
                            outline: "inherit",
                            textAlign: "left",
                          }}
                        >
                          <div
                            style={{ display: "flex", flexDirection: "row" }}
                          >
                            <div style={{ marginTop: "0px" }}>
                              <Iconmoon
                                icon={"viewPODetails"}
                                size={17}
                                color="#605E5C"
                              />{" "}
                            </div>
                            <div
                              style={{ marginTop: "-2px", marginLeft: "6px" }}
                            >
                              View PO Details
                            </div>
                          </div>
                        </Button>{" "}
                      </DisabledButtonStyle>
                    </Menu.Item>
                    <Menu.Item key="6" style={{ marginBottom: "1px" }}>
                      <DisabledButtonStyle>
                        <Button
                          onClick={() => {
                            onViewChangeHandler(record);
                          }}
                          style={{
                            border: "none",
                            background: "none",
                            color: "inherit",
                            padding: "0",
                            font: "inherit",
                            cursor: "pointer",
                            outline: "inherit",
                            textAlign: "left",
                          }}
                        >
                          <div
                            style={{ display: "flex", flexDirection: "row" }}
                          >
                            <div style={{ marginTop: "0px" }}>
                              <Iconmoon
                                icon={"changeHistory"}
                                size={19}
                                color="#605E5C"
                              />{" "}
                            </div>
                            <div
                              style={{ marginTop: "-2px", marginLeft: "5px" }}
                            >
                              View Change History
                            </div>
                          </div>
                        </Button>{" "}
                      </DisabledButtonStyle>
                    </Menu.Item>
                  </Menu>
                }
                placement="bottom"
                arrow
              >
                <DisabledButtonStyle>
                  <Button>
                    <Iconmoon icon="three-dot-menu" size={16} color="#605E5C" />
                  </Button>
                </DisabledButtonStyle>
              </Dropdown>
            ) : (
              <Dropdown
                className="viewDropdownStyle"
                overlay={
                  <Menu>
                    <Menu.Item
                      key="1"
                      style={{ marginTop: "-5px", marginBottom: "-10px" }}
                    >
                      <DisabledButtonStyle>
                        <Button
                          onClick={() => {
                            onViewPODetailsHandler(record);
                          }}
                          style={{
                            border: "none",
                            background: "none",
                            color: "inherit",
                            padding: "0",
                            font: "inherit",
                            cursor: "pointer",
                            outline: "inherit",
                            textAlign: "left",
                          }}
                        >
                          <div
                            style={{ display: "flex", flexDirection: "row" }}
                          >
                            <div style={{ marginTop: "0px" }}>
                              <Iconmoon
                                icon={"viewPODetails"}
                                size={17}
                                color="#605E5C"
                              />{" "}
                            </div>
                            <div
                              style={{ marginTop: "-2px", marginLeft: "6px" }}
                            >
                              View PO Details
                            </div>
                          </div>
                        </Button>{" "}
                      </DisabledButtonStyle>
                    </Menu.Item>
                    <Menu.Item key="2" style={{ marginBottom: "1px" }}>
                      <DisabledButtonStyle>
                        <Button
                          onClick={() => {
                            onViewChangeHandler(record);
                          }}
                          style={{
                            border: "none",
                            background: "none",
                            color: "inherit",
                            padding: "0",
                            font: "inherit",
                            cursor: "pointer",
                            outline: "inherit",
                            textAlign: "left",
                          }}
                        >
                          <div
                            style={{ display: "flex", flexDirection: "row" }}
                          >
                            <div style={{ marginTop: "0px" }}>
                              <Iconmoon
                                icon={"changeHistory"}
                                size={19}
                                color="#605E5C"
                              />{" "}
                            </div>
                            <div
                              style={{ marginTop: "-2px", marginLeft: "5px" }}
                            >
                              View Change History
                            </div>
                          </div>
                        </Button>{" "}
                      </DisabledButtonStyle>
                    </Menu.Item>
                  </Menu>
                }
                placement="bottom"
                arrow
              >
                <DisabledButtonStyle>
                  <Button>
                    <Iconmoon icon="three-dot-menu" size={16} color="#605E5C" />
                  </Button>
                </DisabledButtonStyle>
              </Dropdown>
            )}
          </div>
        ) : (
          "-"
        ),
      align: "center",
    },
  ]);

  const columnsHeader = useRef([
    {
      title: "Po/So.No",
      dataIndex: "pono",
      width: "10%",
      fixed: "left",
      // align: "left",
      sorter: () => { },
      render: (text, record) => (
        <>
          {record.isConflictingstate ? (
            <span style={{ paddingBottom: '5px' }}> <Tooltip title={`Conflicting order, part of ${record.jobcards?.length} conflicting job cards`} placement="top" >
              <Iconmoon icon="info_new" size={16} color="#EA655B" />
            </Tooltip>
            </span>
          ) : (
            // Invisible placeholder to maintain layout
            <span style={{ width: "14px" }}></span>
          )}
          <span style={{ whiteSpace: 'normal', wordBreak: 'break-word', lineHeight: '1.4' }}>
            {
              `${record.category === "so" ? toHandlePOName(record.sono) : toHandlePOName(record.pono)}`
                .match(/.{1,15}/g)
                ?.map((chunk, index) => (
                  <span key={index}>
                    {chunk}
                    <br />
                  </span>
                ))
            }
          </span>
        </>
      )
    },
    // {
    //   title: "Group No",
    //   dataIndex: "groupno",
    //   width: "10%",
    //   fixed: "left",
    //   sorter: () => {},
    // },
    {
      title: "Order No",
      dataIndex: "orderno",
      width: "6.6%",
      fixed: "left",
      sorter: () => { },
      render: (text, record) => (
        <div className="actionBtn2">
          <span style={{ textAlign: "center" }}>{text}</span>
        </div>
      ),
    },
    {
      title: "PO Date",
      dataIndex: "podate",
      width: "8%",
      sorter: {
        compare: (a, b) => new Date(a.podate) - new Date(b.podate),
      },
    },
    {
      title: "Customer",
      dataIndex: "customer_alias",
      width: "8%",
      align: "left",
      render: (text, record) => (
        <div className="actionBtn2">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={`${record.customercode}-${record.customerName}`}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {record?.customer_alias || '-'}
            </Tooltip>
          </Styled>
        </div>
      ),
    },
    {
      title: "Consignee",
      dataIndex: "consignee_alias",
      width: "8%",
      align: "left",
      render: (text, record) => (
        <div className="actionBtn2">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={`${record.consignee}-${record.consignee_name}`}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {record?.consignee_alias || '-'}
            </Tooltip>
          </Styled>
        </div>
      ),
    },
    // {
    //   title: (
    //     <div>
    //       Product
    //       <Styled style={{ display: "inline-flex" }}>
    //         <Tooltip
    //           placement="bottomRight"
    //           title={
    //             "The product specification is in the format of Grade/GSM/BF/Quality/Moisture"
    //           }
    //           className="edit-tooltip"
    //           getPopupContainer={(triggerNode) => triggerNode}
    //         >
    //           <span className="infoIcon"></span>
    //         </Tooltip>
    //       </Styled>
    //     </div>
    //   ),
    //   dataIndex: "productcode",
    //   width: "10%",
    // },
    // {
    //   title: (
    //     <div>
    //       Product Spec
    //       <Styled style={{ display: "inline-flex" }}>
    //         <Tooltip
    //           placement="bottomRight"
    //           title={
    //             "The product specification is in the format of Grade/GSM/BF/Quality/Moisture"
    //           }
    //           className="edit-tooltip"
    //           getPopupContainer={(triggerNode) => triggerNode}
    //         >
    //           <span className="infoIcon"></span>
    //         </Tooltip>
    //       </Styled>
    //     </div>
    //   ),
    //   dataIndex: "productspec",
    //   width: "10%",
    // },
    {
      title: (
        <div>
          Product
          <Styled style={{ display: "inline-flex" }}>
            <Tooltip
              placement="bottomRight"
              title={
                "The product specification is in the format of Grade/GSM/BF/Quality/Moisture"
              }
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <span className="infoIcon"></span>
            </Tooltip>
          </Styled>
        </div>
      ),
      // dataIndex: "productcode",
      width: "10.8%",
      render: (text, record) => {
        return (
          <Styled>
            {" "}
            <span style={{ fontSize: "10px" }}>{record.productspec} </span>
            <br />
            <span style={{ textAlign: "center" }}>{record.productcode}</span>
          </Styled>
        );
      },
    },
    // {
    //   title: "Type",
    //   dataIndex: "type",
    //   width: "10%",
    // },
    {
      title: "Size(WxL)",
      dataIndex: "size",
      width: "8%",
    },

    // {
    //   title: "Pending Reels",
    //   dataIndex: "pendingReels",
    //   width: "10%",
    //   render: (text, record) => text ? `${text} Reels` : "-",
    // },
    // {
    //   title: "Pending Weight",
    //   dataIndex: "pendingWeight",
    //   width: "10%",
    // },
    // {
    //   title: "Core ID",
    //   dataIndex: "coreid",
    //   width: "10%",
    // },
    // {
    //   // title: "Reel OD",
    //   // dataIndex: "reelod",
    //   // width: "10%",
    //   title: "Reel OD for Rewinding",
    //   dataIndex: "reelod",
    //   width: "10%",
    //   render: (text, record, index) => (
    //     <Styled>
    //       <div style={{ display: "flex" }}>
    //         {record.id_od_type == "range" && (
    //           <div style={{ color: "var(--para-text)",display : 'flex' , width : "70%",alignSelf:'center' }}>
    //             {(record.minimum_reel_od && record.maximum_reel_od) ? (record.minimum_reel_od + "-" + record.maximum_reel_od + " " +
    //                 (record.units.maximum_reel_od ? lengthUnit[record.units.maximum_reel_od].displayName : "")) : ""}
    //           </div>
    //         )}
    //         {record.id_od_type == "constant" && (
    //           <div style={{display : 'flex' , width : "70%",flexDirection : 'column',alignSelf:'center'}}>
    //             {record?.reelod &&
    //               record?.reelod?.map((item, index) => {
    //                 return (
    //                   index < 2 && (
    //                     <div>
    //                       {item}{" "}
    //                       {index == 1
    //                         ? "...,"
    //                         : record?.reelod?.length > 1
    //                         ? ","
    //                         : ""}
    //                     </div>
    //                   )
    //                 );
    //               })}

    //             {record?.reelod &&
    //               record?.reelod?.length >= 2 &&
    //               record.reelod?.map((item, index) => {
    //                 let tooltipData = "";
    //                 for (
    //                   let index = 2;
    //                   index < record.reelod?.length;
    //                   index++
    //                 ) {
    //                   const data = record.reelod[index];
    //                   tooltipData = tooltipData + data + ", ";
    //                 }
    //                 tooltipData = tooltipData.substring(
    //                   0,
    //                   tooltipData.length - 1
    //                 );
    //                 return (
    //                   index == 2 && (
    //                     <Tooltip title={tooltipData}>
    //                       {" "}
    //                       <span
    //                         style={{
    //                           display: "flex",
    //                           fontSize: "10px",
    //                           fontWeight: "bold",
    //                         }}
    //                       >
    //                         & {record.reelod.length - 2} More
    //                       </span>
    //                     </Tooltip>
    //                   )
    //                 );
    //               })}
    //           </div>
    //         )}
    //         {/* <div style={{display : 'flex' , width : "30%"}}>
    //         <div className="actionBtn">
    //           {" "}
    //           {userDetails?.roles?.job_cards.edit && <Button
    //             onClick={() => showEditReelCoreModal(record, "reel", index, "complete_order")}
    //             style={{ background: "none" }}
    //           >
    //             <Iconmoon icon="down" size={30} color="var(--para-text)" />
    //           </Button> }{" "}
    //         </div>
    //         </div> */}
    //       </div>
    //     </Styled>
    //   ),
    // },
    {
      title: "Order Qty",
      dataIndex: "quantityValue",
      width: "6%",
      render: (text, record) => (
        <Styled>
          {" "}
          {record.type.toLowerCase() == "sheet" &&
            record.quantity_type.toLowerCase() == "reel_sheet" ? (
            <>
              <span style={{ textAlign: "center", fontSize: "12px" }}>
                {text}
              </span>
              <br /> <span> {record.no_of_reel_sheet + " Sheets"} </span>
            </>
          ) : (
            `${text} `
          )}
        </Styled>
      ),
    },
    {
      title: "Balance Quantity",
      dataIndex: "balance_qty",
      width: "6%",
    },
    {
      title: "Processed Qty",
      dataIndex: "processQuantity",
      width: "10%",
      render: (text, record) => {
        return (
          <div
            className="actionBtn"
            style={{ marginTop: "14px", justifyContent: "left" }}
          >
            <Col span={12}>
              {parseFloat(text) && record.type
                ? `${text}`
                : parseFloat(text)
                  ? `${text} `
                  : "-"}
            </Col>
            {parseFloat(text) ? (
              <Col span={12}>
                <Styled style={{ marginTop: "-8px" }}>
                  <Tooltip
                    placement="bottomRight"
                    title={"View Processed Quantity Details"}
                    className="edit-tooltip"
                    getPopupContainer={(triggerNode) => triggerNode}
                  >
                    <Button
                      onClick={() => {
                        handleViewProcessedQtyAction(record);
                      }}
                    >
                      <Iconmoon
                        icon="viewPODetails"
                        size={16}
                        color="rgb(96, 94, 92)"
                      />
                    </Button>
                  </Tooltip>
                </Styled>
              </Col>
            ) : (
              ""
            )}
          </div>
        );
      },
    },
    {
      title: "Pending Qty",
      dataIndex: "pendingQuant",
      width: "11%",
      // render: (text, record) =>
      // <Styled>
      //   {" "}
      //   { record.type.toLowerCase() == "sheet" && record.quantity_type.toLowerCase() == "reel_sheet" ?
      //   <><span style={{textAlign:"center", fontSize: "12px"}}>{text}</span><br/> <span> {record.total_pending_quantity.quantity + ' Sheets'} </span>
      //     </> : `${text} `}
      // </Styled>

      render: (text, record) => {
        if (record.isConflictingstate) {
          return "ND"
        }
        return (
          <div
            className="actionBtn"
            style={{ marginTop: "14px", justifyContent: "left" }}
          >
            <Col span={12}>
              {record.type.toLowerCase() == "sheet" &&
                record.quantity_type.toLowerCase() == "reel_sheet" ? (
                <>
                  <span style={{ textAlign: "center", fontSize: "12px" }}>
                    (
                    {parseFloat(text) && record.type
                      ? `${text}`
                      : parseFloat(text)
                        ? `${text} `
                        : "-"}
                    )
                  </span>
                  <br />{" "}
                  <span>
                    {" "}
                    {record.total_pending_quantity.quantity + " Sheets"}{" "}
                  </span>
                </>
              ) : (
                `${text} `
              )}
            </Col>
            {parseFloat(text) ? (
              <Col span={12}>
                <Styled style={{ marginTop: "-8px" }}>
                  <Tooltip
                    placement="bottomRight"
                    title={"View Pending Quantity Details"}
                    className="edit-tooltip"
                    getPopupContainer={(triggerNode) => triggerNode}
                  >
                    <Button
                      onClick={() => {
                        handleViewPendingQtyAction(record);
                      }}
                    >
                      <Iconmoon
                        icon="viewPODetails"
                        size={16}
                        color="rgb(96, 94, 92)"
                      />
                    </Button>
                  </Tooltip>
                </Styled>
              </Col>
            ) : (
              ""
            )}
          </div>
        );
      },
    },
    {
      title: "Delivery Date",
      dataIndex: "deliverydate",
      width: "8%",
      sorter: {
        compare: (a, b) => new Date(a.deliverydate) - new Date(b.deliverydate),
      },
    },
    {
      title: "Created Date",
      dataIndex: "createddate",
      width: "8%",
      sorter: {
        compare: (a, b) => new Date(a.createddate) - new Date(b.createddate),
      },
    },
    // {
    //   title: "Quantity",
    //   dataIndex: "quantity",
    //   width: "10%",
    //   render: (text, record) => record.quantity_type === "weight" ? "-" : `${text}`,
    // },
    // {
    //   title: "Order Weight",
    //   dataIndex: "weight",
    //   width: "9%",
    //   render: (text, record) =>
    //     record.quantity_type === "reel_sheet" ? "-" : `${text} ${record.units  && record.item_type !== "split_group" ? weightUnit[record.units.weight]?.displayName?.toUpperCase() : weightUnit[record.units.total_weight].displayName?.toUpperCase()}`,
    // },
    // {
    //   title: "Planned Weight",
    //   dataIndex: "plannedweight",
    //   width: "10%",
    //   render: (text, record) => `${text}`
    // },
    // {
    //   title: "Rewinder Reels",
    //   dataIndex: "rewinderreels",
    //   width: "10%",
    //   render: (text, record) => `${text} Reels`,
    // },
    {
      title: "Priority",
      dataIndex: "priority",
      width: "5%",
      render: (text, record) => (
        <div className="actionBtn">
          <Button style={{ cursor: "default" }}>
            <Iconmoon
              icon={record.priority ? "correct" : "wrong"}
              size={16}
              color={record.priority ? "#3FBD61" : "#a19f9d"}
            />
          </Button>
        </div>
      ),
      align: "center",
    },
    // {
    //   title: "Remarks",
    //   dataIndex: "remarks",
    //   width: "5%",
    //   render: (text, record) => (
    //     <div className="actionBtn">
    //       <Styled>
    //         <Tooltip
    //           placement="bottomRight"
    //           title={record.remarks}
    //           className="edit-tooltip"
    //           getPopupContainer={(triggerNode) => triggerNode}
    //         >
    //           <Button style={{ cursor: "default" }}>
    //             <Iconmoon icon="message" size={16} color="#EA655B" />
    //           </Button>
    //         </Tooltip>
    //       </Styled>
    //     </div>
    //   ),
    //   align: "center",
    // },
    {
      title: "Progress",
      dataIndex: "progress",
      width: "5.7%",
      render: (text, record) => {
        // if(record.item_type && record.item_type === "order"){
        if (!record.isConflictingstate) {

          if (
            record?.type.toLowerCase() === "sheet" ||
            (record?.type.toLowerCase() === "reel" &&
              record?.quantity_type.toLowerCase() === "weight")
          ) {
            const totalProd =
              ((record?.progressbar_info?.completed?.weight +
                record?.progressbar_info?.in_production?.weight) /
                (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
              100;
            const totalCompleted =
              (record?.progressbar_info?.completed?.weight /
                (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
              100;
            //const weightUnitKey =  ((record?.units && record?.units?.weight) ? capitalize(weightUnit[record.units.weight]?.displayName) : "T") ;
            return (
              <div className="progressLvl">
                <Styled>
                  <Tooltip
                    placement="bottomRight"
                    title={`${record?.progressbar_info?.completed
                        ? (record?.progressbar_info?.completed?.weight).toFixed(3)
                        : 0.0
                      } ${capitalize(
                        weightUnit[
                          record?.progressbar_info?.completed?.units?.weight
                        ].displayName
                      )} Weight produced
                          ${record?.progressbar_info?.in_production
                        ? (record?.progressbar_info?.in_production?.weight).toFixed(
                          3
                        )
                        : 0.0
                      } ${capitalize(
                        weightUnit[
                          record?.progressbar_info?.in_production?.units?.weight
                        ].displayName
                      )} Weight in production
                        ${record?.progressbar_info?.pending
                        ? (record?.progressbar_info?.pending?.weight).toFixed(
                          3
                        )
                        : 0.0
                      } ${capitalize(
                        weightUnit[record?.progressbar_info?.pending?.units?.weight]
                          .displayName
                      )} Weight pending for deckle match`}
                    className="edit-tooltip"
                    getPopupContainer={(triggerNode) => triggerNode}
                  >
                    <Progress
                      percent={totalProd}
                      success={{
                        percent: totalCompleted,
                      }}
                      strokeColor={"#cbe2cd"}
                    />
                  </Tooltip>
                </Styled>
              </div>
            );
          } else {
            const production =
              ((record?.progressbar_info?.completed?.quantity +
                record?.progressbar_info?.in_production?.quantity) /
                (record?.no_of_reel_sheet -
                  record.cancelled_quantity?.quantity)) *
              100;
            const completed =
              (record?.progressbar_info?.completed?.quantity /
                (record?.no_of_reel_sheet -
                  record.cancelled_quantity?.quantity)) *
              100;

            return (
              <div className="progressLvl">
                <Styled>
                  <Tooltip
                    placement="bottomRight"
                    title={`${record?.progressbar_info?.completed
                        ? record?.progressbar_info?.completed?.quantity
                        : 0
                      } Reels produced
                          ${record?.progressbar_info?.in_production
                        ? record?.progressbar_info?.in_production
                          ?.quantity
                        : 0
                      } Reels in production
                          ${record?.progressbar_info?.pending
                        ? record?.progressbar_info?.pending?.quantity
                        : 0
                      } Reels pending for deckle match`}
                    className="edit-tooltip"
                    getPopupContainer={(triggerNode) => triggerNode}
                  >
                    <Progress
                      percent={production}
                      success={{
                        percent: completed,
                      }}
                      strokeColor={"#cbe2cd"}
                    />
                  </Tooltip>
                </Styled>
              </div>
            );
          }
        }
      },
      align: "center",
    },
    {
      title: "Actions",
      dataIndex: "action",
      width: "5%",
      render: (text, record) =>
        record.item_type === "order" ? (
          <div className="actionBtn" style={{ paddingRight: "20px" }}>
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={"View details of this order"}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button
                  onClick={() => {
                    handleActions(record);
                  }}
                  disabled={
                    !(
                      userDetails?.roles?.approve_jobcards.view ||
                      userDetails?.roles?.job_cards.view ||
                      userDetails?.roles?.job_cards.edit ||
                      userDetails?.role_type == "ADMIN" ||
                      userDetails?.role_type == "SUPER_ADMIN"
                    )
                  }
                >
                  <Iconmoon icon="file-view" size={16} color="#A19F9D" />
                </Button>
              </Tooltip>
            </Styled>
            {/* } */}
            {[
              "Approved",
              "approved",
              "On Hold",
              "on hold",
              "hold",
              "Complete",
              "complete",
            ].includes(record?.state) && userDetails?.roles?.job_cards.edit ? (
              <Dropdown
                className="viewDropdownStyle"
                overlay={
                  <Menu>
                    {(record.state == "approved" || record.state == "hold") && (
                      <Menu.Item key="1" style={{ marginBottom: "-10px" }}>
                        <DisabledButtonStyle>
                          <Button
                            style={{
                              border: "none",
                              background: "none",
                              color: "inherit",
                              padding: "0",
                              font: "inherit",
                              cursor: "pointer",
                              outline: "inherit",
                              textAlign: "left",
                            }}
                            onClick={() => handleViewProdDetails(record)}
                          >
                            <div
                              style={{ display: "flex", flexDirection: "row" }}
                            >
                              <div style={{ marginTop: "8px" }}>
                                <Iconmoon
                                  icon={"production"}
                                  size={17}
                                  color="#605E5C"
                                />{" "}
                              </div>
                              <div
                                style={{ marginTop: "5px", marginLeft: "6px" }}
                              >
                                View Production Details
                              </div>
                            </div>
                          </Button>
                        </DisabledButtonStyle>
                      </Menu.Item>
                    )}
                    {(record.state == "approved" || record.state == "hold") && (
                      <Menu.Item key="2" style={{ marginBottom: "-10px" }}>
                        <DisabledButtonStyle>
                          <Button
                            style={{
                              border: "none",
                              background: "none",
                              color: "inherit",
                              padding: "0",
                              font: "inherit",
                              cursor: "pointer",
                              outline: "inherit",
                              textAlign: "left",
                            }}
                            onClick={() =>
                              handleViewProcessedQtyDetails(record)
                            }
                          >
                            <div
                              style={{ display: "flex", flexDirection: "row" }}
                            >
                              <div style={{ marginTop: "8px" }}>
                                <Iconmoon
                                  icon={"viewPODetails"}
                                  size={17}
                                  color="#605E5C"
                                />{" "}
                              </div>
                              <div
                                style={{ marginTop: "5px", marginLeft: "6px" }}
                              >
                                View Processed Quantity Details
                              </div>
                            </div>
                          </Button>
                        </DisabledButtonStyle>
                      </Menu.Item>
                    )}
                    {(record.state == "approved" ||
                      record.state == "hold" ||
                      record.state == "open" ||
                      record.state == "review" ||
                      record.state == "pending") && (
                        <Menu.Item key="3" style={{ marginBottom: "-10px" }}>
                          <DisabledButtonStyle>
                            <Button
                              style={{
                                border: "none",
                                background: "none",
                                color: "inherit",
                                padding: "0",
                                font: "inherit",
                                cursor: "pointer",
                                outline: "inherit",
                                textAlign: "left",
                              }}
                              onClick={() => handleViewPendingQtyDetails(record)}
                            >
                              <div
                                style={{ display: "flex", flexDirection: "row" }}
                              >
                                <div style={{ marginTop: "8px" }}>
                                  <Iconmoon
                                    icon={"viewPODetails"}
                                    size={17}
                                    color="#605E5C"
                                  />{" "}
                                </div>
                                <div
                                  style={{ marginTop: "5px", marginLeft: "6px" }}
                                >
                                  View Pending Quantity Details
                                </div>
                              </div>
                            </Button>
                          </DisabledButtonStyle>
                        </Menu.Item>
                      )}
                    <Menu.Item
                      key="4"
                      style={{ marginTop: "-5px", marginBottom: "-10px" }}
                    >
                      <DisabledButtonStyle>
                        <Button
                          onClick={() => {
                            onViewPODetailsHandler(record);
                          }}
                          style={{
                            border: "none",
                            background: "none",
                            color: "inherit",
                            padding: "0",
                            font: "inherit",
                            cursor: "pointer",
                            outline: "inherit",
                            textAlign: "left",
                          }}
                        >
                          <div
                            style={{ display: "flex", flexDirection: "row" }}
                          >
                            <div style={{ marginTop: "0px" }}>
                              <Iconmoon
                                icon={"viewPODetails"}
                                size={17}
                                color="#605E5C"
                              />{" "}
                            </div>
                            <div
                              style={{ marginTop: "-2px", marginLeft: "6px" }}
                            >
                              View PO Details
                            </div>
                          </div>
                        </Button>{" "}
                      </DisabledButtonStyle>
                    </Menu.Item>
                    <Menu.Item key="5" style={{ marginBottom: "1px" }}>
                      <DisabledButtonStyle>
                        <Button
                          onClick={() => {
                            onViewChangeHandler(record);
                          }}
                          style={{
                            border: "none",
                            background: "none",
                            color: "inherit",
                            padding: "0",
                            font: "inherit",
                            cursor: "pointer",
                            outline: "inherit",
                            textAlign: "left",
                          }}
                        >
                          <div
                            style={{ display: "flex", flexDirection: "row" }}
                          >
                            <div style={{ marginTop: "0px" }}>
                              <Iconmoon
                                icon={"changeHistory"}
                                size={19}
                                color="#605E5C"
                              />{" "}
                            </div>
                            <div
                              style={{ marginTop: "-2px", marginLeft: "5px" }}
                            >
                              View Change History
                            </div>
                          </div>
                        </Button>{" "}
                      </DisabledButtonStyle>
                    </Menu.Item>
                  </Menu>
                }
                placement="bottom"
                arrow
              >
                <DisabledButtonStyle>
                  <Button>
                    <Iconmoon icon="three-dot-menu" size={16} color="#605E5C" />
                  </Button>
                </DisabledButtonStyle>
              </Dropdown>
            ) : (
              <Dropdown
                className="viewDropdownStyle"
                overlay={
                  <Menu>
                    <Menu.Item
                      key="1"
                      style={{ marginTop: "-5px", marginBottom: "-10px" }}
                    >
                      <DisabledButtonStyle>
                        <Button
                          onClick={() => {
                            onViewPODetailsHandler(record);
                          }}
                          style={{
                            border: "none",
                            background: "none",
                            color: "inherit",
                            padding: "0",
                            font: "inherit",
                            cursor: "pointer",
                            outline: "inherit",
                            textAlign: "left",
                          }}
                        >
                          <div
                            style={{ display: "flex", flexDirection: "row" }}
                          >
                            <div style={{ marginTop: "0px" }}>
                              <Iconmoon
                                icon={"viewPODetails"}
                                size={17}
                                color="#605E5C"
                              />{" "}
                            </div>
                            <div
                              style={{ marginTop: "-2px", marginLeft: "6px" }}
                            >
                              View PO Details
                            </div>
                          </div>
                        </Button>{" "}
                      </DisabledButtonStyle>
                    </Menu.Item>
                    <Menu.Item key="2" style={{ marginBottom: "1px" }}>
                      <DisabledButtonStyle>
                        <Button
                          onClick={() => {
                            onViewChangeHandler(record);
                          }}
                          style={{
                            border: "none",
                            background: "none",
                            color: "inherit",
                            padding: "0",
                            font: "inherit",
                            cursor: "pointer",
                            outline: "inherit",
                            textAlign: "left",
                          }}
                        >
                          <div
                            style={{ display: "flex", flexDirection: "row" }}
                          >
                            <div style={{ marginTop: "0px" }}>
                              <Iconmoon
                                icon={"changeHistory"}
                                size={19}
                                color="#605E5C"
                              />{" "}
                            </div>
                            <div
                              style={{ marginTop: "-2px", marginLeft: "5px" }}
                            >
                              View Change History
                            </div>
                          </div>
                        </Button>{" "}
                      </DisabledButtonStyle>
                    </Menu.Item>
                  </Menu>
                }
                placement="bottom"
                arrow
              >
                <DisabledButtonStyle>
                  <Button>
                    <Iconmoon icon="three-dot-menu" size={16} color="#605E5C" />
                  </Button>
                </DisabledButtonStyle>
              </Dropdown>
            )}
          </div>
        ) : (
          "-"
        ),
      // align: "center",
    },
  ]);

  const incompleteOrdersColumnsHead = useRef([
    // {
    //   title: "Select",
    //   dataIndex: "select",
    //   width: "1.8%",
    //   fixed: "left",
    //   align: "center",
    //   render: (value, record, rowIndex) => (
    //     <div>
    //        <Styled>
    //     <Checkbox
    //       checked={value}
    //       onChange={handleCheckboxChangeFactory(rowIndex, "select")}
    //     />
    //     </Styled>
    //     </div>
    //   ),
    // },
    {
      title: "Po/So.No",
      dataIndex: "pono",
      width: "10%",
      fixed: "left",
      key: "pono",
      align: "left",
      sorter: () => { },
      // sorter: (a, b, sortOrder) => a.pono.localeCompare(b.pono),
      render: (text, record) => (
        <>
          {record.isConflictingstate ? (
            <span style={{ paddingBottom: '5px' }}> <Tooltip title={`Conflicting order, part of ${record.jobcards?.length} conflicting job cards`} placement="top" >
              <Iconmoon icon="info_new" size={16} color="#EA655B" />
            </Tooltip>
            </span>
          ) : (
            // Invisible placeholder to maintain layout
            <span style={{ width: "14px" }}></span>
          )}
          <Button
            style={{
              background: "transparent",
              whiteSpace: "normal", // allow wrapping
              textAlign: "left",
              lineHeight: "1.4",

            }}
            className="textTypeBtn textBtnIcon"
            onClick={() => handlePo(record)}
          >
            <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
              {
                `#${(record.category === 'so' ? toHandlePOName(record.sono) : toHandlePOName(record.pono)).replaceAll("_", " ")}`
                  .match(/.{1,15}/g)
                  ?.map((chunk, index) => (
                    <span key={index}>
                      {chunk}
                      <br />
                    </span>
                  ))
              }
            </div>
          </Button>
        </>
      ),
    },
    {
      title: "Order No",
      dataIndex: "orderno",
      width: "6.6%",
      fixed: "left",
      sorter: () => { },
      render: (text, record) => (
        <div className="actionBtn2">
          {text != "-" ? (
            <Button
              style={{ background: "transparent" }}
              className="textTypeBtn textBtnIcon"
              onClick={() => handleOrder(record)}
            >
              {`${text}`}
            </Button>
          ) : (
            <span style={{ textAlign: "center" }}>{text}</span>
          )}
        </div>
      ),
    },
    {
      title: "PO Date",
      dataIndex: "podate",
      width: "8%",
      fixed: "left",
      sorter: {
        compare: (a, b) => new Date(a.podate) - new Date(b.podate),
      },
    },
    {
      title: "Customer",
      dataIndex: "customer_alias",
      width: "8%",
      align: "left",
      render: (text, record) => (
        <div className="actionBtn2">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={`${record.customercode}-${record.customerName}`}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {record?.customer_alias || '-'}
            </Tooltip>
          </Styled>
        </div>
      ),
    },
    {
      title: "Consignee",
      dataIndex: "consignee_alias",
      width: "8%",
      align: "left",
      render: (text, record) => (
        <div className="actionBtn2">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={`${record.consignee}-${record.consignee_name}`}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {record?.consignee_alias || '-'}
            </Tooltip>
          </Styled>
        </div>
      ),
    },
    {
      // title: "Prod. Code",
      // dataIndex: "productcode",
      // width: "2.5%",
      title: (
        <div>
          Product
          <Styled style={{ display: "inline-flex" }}>
            <Tooltip
              placement="bottomRight"
              title={
                "The product specification is in the format of Grade/GSM/BF/Quality/Moisture"
              }
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <span className="infoIcon"></span>
            </Tooltip>
          </Styled>
        </div>
      ),
      // dataIndex: "productcode",
      width: "10.8%",
      render: (text, record) => {
        return (
          <Styled>
            {" "}
            <span style={{ fontSize: "10px" }}>{record.productspec} </span>
            <br />
            <span style={{ textAlign: "center" }}>{record.productcode}</span>
          </Styled>
        );
      },
    },
    // {
    //   title: (
    //     <div>
    //       Product Spec
    //       <Styled style={{ display: "inline-flex" }}>
    //         <Tooltip
    //           placement="bottomRight"
    //           title={
    //             "The product specification is in the format of Grade/GSM/BF/Quality/Moisture"
    //           }
    //           className="edit-tooltip"
    //           getPopupContainer={(triggerNode) => triggerNode}
    //         >
    //           <span className="infoIcon"></span>
    //         </Tooltip>
    //       </Styled>
    //     </div>
    //   ),
    //   dataIndex: "productspec",
    //   width: "4.5%",
    // },
    {
      title: "Size(WxL)",
      dataIndex: "size",
      width: "8%",
    },
    {
      title: "Grain",
      dataIndex: "grain",
      width: "8%",
      render: (text, record, index) => (
        <Styled>
          {record.type.toLowerCase() == "sheet" ? (
            <div style={{ display: "flex" }}>
              <Row className="centerAlign">
                <div className="boxFormType">
                  <SelectStyle>
                    <Form.Item
                      name={`grain${record.orderno}`}
                      rules={[
                        {
                          required: true,
                          message: "This field is required",
                        },
                      ]}
                      className="selectForm"
                      style={{ marginBottom: 4 }}
                      initialValue={
                        record.grain
                          ? record.grain == "short"
                            ? "Short"
                            : "Long"
                          : null
                      }
                    >
                      <Select
                        placeholder={"Select"}
                        suffixIcon={<DownArrowDraw />}
                        onChange={(e) =>
                          onGrainChange(e, record, index, "incomplete_order")
                        }
                      >
                        {grainTypeData.map((grainType) => (
                          <Option key={grainType}>{grainType}</Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </SelectStyle>
                </div>
              </Row>
            </div>
          ) : (
            ""
          )}
        </Styled>
      ),
    },
    {
      title: "Order Qty",
      dataIndex: "quantityValue",
      width: "8%",
      render: (text, record) => (
        <Styled>
          {" "}
          {record.type.toLowerCase() == "sheet" &&
            record.quantity_type.toLowerCase() == "reel_sheet" ? (
            <>
              <span style={{ textAlign: "center", fontSize: "12px" }}>
                {text}
              </span>
              <br /> <span> {record.no_of_reel_sheet + " Sheets"} </span>
            </>
          ) : (
            `${text} `
          )}
        </Styled>
      ),
    },
    {
      title: "Balance Quantity",
      dataIndex: "balance_qty",
      width: "6%",
    },
    {
      title: "Processed Qty",
      dataIndex: "processQuantity",
      width: "10%",
      render: (text, record) => {
        return (
          <div
            className="actionBtn"
            style={{ marginTop: "14px", justifyContent: "left" }}
          >
            <Col span={12}>
              {parseFloat(text) && record.type
                ? `${text}`
                : parseFloat(text)
                  ? `${text} `
                  : "-"}
            </Col>
            {parseFloat(text) ? (
              <Col span={12}>
                <Styled style={{ marginTop: "-8px" }}>
                  <Tooltip
                    placement="bottomRight"
                    title={"View Processed Quantity Details"}
                    className="edit-tooltip"
                    getPopupContainer={(triggerNode) => triggerNode}
                  >
                    <Button
                      onClick={() => {
                        handleViewProcessedQtyAction(record);
                      }}
                    >
                      <Iconmoon
                        icon="viewPODetails"
                        size={16}
                        color="rgb(96, 94, 92)"
                      />
                    </Button>
                  </Tooltip>
                </Styled>
              </Col>
            ) : (
              ""
            )}
          </div>
        );
      },
    },
    {
      title: "Pending Qty",
      dataIndex: "pendingQuant",
      width: "11%",
      // render: (text, record) =>
      // <Styled>
      //   {" "}
      //   { record.type.toLowerCase() == "sheet" && record.quantity_type.toLowerCase() == "reel_sheet" ?
      //   <><span style={{textAlign:"center", fontSize: "12px"}}>{text}</span><br/> <span> {record.total_pending_quantity.quantity + ' Sheets'} </span>
      //     </> : `${text} `}
      // </Styled>

      render: (text, record) => {
        if (record.isConflictingstate) {
          return "ND"
        }
        return (
          <div
            className="actionBtn"
            style={{ marginTop: "14px", justifyContent: "left" }}
          >
            <Col span={12}>
              {record.type.toLowerCase() == "sheet" &&
                record.quantity_type.toLowerCase() == "reel_sheet" ? (
                <>
                  <span style={{ textAlign: "center", fontSize: "12px" }}>
                    (
                    {parseFloat(text) && record.type
                      ? `${text}`
                      : parseFloat(text)
                        ? `${text} `
                        : "-"}
                    )
                  </span>
                  <br />{" "}
                  <span>
                    {" "}
                    {record.total_pending_quantity.quantity + " Sheets"}{" "}
                  </span>
                </>
              ) : (
                `${text} `
              )}
            </Col>
            {parseFloat(text) ? (
              <Col span={12}>
                <Styled style={{ marginTop: "-8px" }}>
                  <Tooltip
                    placement="bottomRight"
                    title={"View Pending Quantity Details"}
                    className="edit-tooltip"
                    getPopupContainer={(triggerNode) => triggerNode}
                  >
                    <Button
                      onClick={() => {
                        handleViewPendingQtyAction(record);
                      }}
                    >
                      <Iconmoon
                        icon="viewPODetails"
                        size={16}
                        color="rgb(96, 94, 92)"
                      />
                    </Button>
                  </Tooltip>
                </Styled>
              </Col>
            ) : (
              ""
            )}
          </div>
        );
      },
    },
    {
      title: "Qty to be planned",
      dataIndex: "plannedQuant",
      width: "14%",
      key: "plannedQuant",
      render: (text, record, index) => {
        return (
          <div
            className="actionBtn"
            style={{
              marginTop:
                !isEditClickedForRewinding?.[record.orderno] ||
                  (isEditClickedForRewinding?.[record.orderno] &&
                    !isEditClickedForRewinding?.[record.orderno].isEditable)
                  ? "14px"
                  : "0px",
              justifyContent: "left",
            }}
          >
            {(!isEditClickedForRewinding?.[record.orderno] ||
              (isEditClickedForRewinding?.[record.orderno] &&
                !isEditClickedForRewinding?.[record.orderno].isEditable)) && (
                <Col span={12}>
                  {text} {record.plannedUnit}
                </Col>
              )}
            {userDetails?.roles?.job_cards.edit && (
              <Col span={12}>
                <Styled style={{ marginTop: "-7px" }}>
                  <Tooltip
                    placement="bottomRight"
                    title={"Edit planned quantity"}
                    className="edit-tooltip"
                    getPopupContainer={(triggerNode) => triggerNode}
                  >
                    <Button
                      onClick={() => {
                        handleEditColumn(
                          index,
                          record,
                          true,
                          "incomplete_order"
                        );
                      }}
                    >
                      <Iconmoon icon="edit" size={16} color="#A19F9D" />
                    </Button>
                  </Tooltip>
                </Styled>
              </Col>
            )}
          </div>
        );
      },
    },
    {
      title: "Reel OD for Rewinding",
      dataIndex: "reelod",
      width: "10%",
      render: (text, record, index) => (
        <Styled>
          <div style={{ display: "flex" }}>
            {record.id_od_type == "range" && (
              <div
                style={{
                  color: "var(--para-text)",
                  display: "flex",
                  width: "70%",
                  alignSelf: "center",
                }}
              >
                {record.minimum_reel_od && record.maximum_reel_od
                  ? record.minimum_reel_od +
                  "-" +
                  record.maximum_reel_od +
                  " " +
                  (record.units.maximum_reel_od
                    ? lengthUnit[record.units.maximum_reel_od].displayName
                    : "")
                  : ""}
              </div>
            )}
            {record.id_od_type == "constant" && (
              <div
                style={{
                  display: "flex",
                  width: "70%",
                  flexDirection: "column",
                  alignSelf: "center",
                }}
              >
                {record?.reelod &&
                  record?.reelod?.map((item, index) => {
                    return (
                      index < 2 && (
                        <div>
                          {item}{" "}
                          {index == 1
                            ? "...,"
                            : record?.reelod?.length > 1
                              ? ","
                              : ""}
                        </div>
                      )
                    );
                  })}

                {record?.reelod &&
                  record?.reelod?.length >= 2 &&
                  record.reelod?.map((item, index) => {
                    let tooltipData = "";
                    for (
                      let index = 2;
                      index < record.reelod?.length;
                      index++
                    ) {
                      const data = record.reelod[index];
                      tooltipData = tooltipData + data + ", ";
                    }
                    tooltipData = tooltipData.substring(
                      0,
                      tooltipData.length - 1
                    );
                    return (
                      index == 2 && (
                        <Tooltip title={tooltipData}>
                          {" "}
                          <span
                            style={{
                              display: "flex",
                              fontSize: "10px",
                              fontWeight: "bold",
                            }}
                          >
                            & {record.reelod.length - 2} More
                          </span>
                        </Tooltip>
                      )
                    );
                  })}
              </div>
            )}
            <div style={{ display: "flex", width: "30%" }}>
              <div className="actionBtn">
                {" "}
                {userDetails?.roles?.job_cards.edit && (
                  <Button
                    onClick={() =>
                      showEditReelCoreModal(
                        record,
                        "reel",
                        index,
                        "incomplete_order"
                      )
                    }
                    style={{ background: "none" }}
                  >
                    <Iconmoon icon="down" size={30} color="var(--para-text)" />
                  </Button>
                )}{" "}
              </div>
            </div>
          </div>
        </Styled>
      ),
    },
    {
      title: "Core OD for Rewinding",
      dataIndex: "coreid",
      width: "10%",
      render: (text, record, index) => (
        <div className="actionBtn">
          <Styled>
            <div style={{ display: "flex" }}>
              {record.coreid ? (
                <div
                  style={{
                    color: "var(--para-text)",
                    display: "flex",
                    width: "70%",
                    alignSelf: "center",
                  }}
                >
                  {record.coreid}
                </div>
              ) : (
                <div
                  style={{
                    display: "flex",
                    width: "70%",
                    alignSelf: "center",
                    marginLeft: "36px",
                  }}
                ></div>
              )}

              <div style={{ display: "flex", width: "30%" }}>
                <div className="actionBtn">
                  {" "}
                  {userDetails?.roles?.job_cards.edit && (
                    <Button
                      onClick={() =>
                        showEditReelCoreModal(
                          record,
                          "core",
                          index,
                          "incomplete_order"
                        )
                      }
                      style={{ background: "none" }}
                    >
                      <Iconmoon
                        icon="down"
                        size={30}
                        color="var(--para-text)"
                      />
                    </Button>
                  )}{" "}
                </div>
              </div>
            </div>
          </Styled>
        </div>
      ),
    },
    {
      title: "Calculated Reels",
      dataIndex: "calculatedreels",
      width: "10%",
      render: (text, record) => `${text}`,
    },
    {
      title: "Planned Reels",
      dataIndex: "rewinderreels",
      width: "16%",
      render: (text, record, index) => {
        return (
          <div
            className="actionBtn"
            style={{
              marginTop:
                !isEditPlannedReels?.[record.orderno] ||
                  (isEditPlannedReels?.[record.orderno] &&
                    !isEditPlannedReels?.[record.orderno].isEditable)
                  ? "14px"
                  : "0px",
              justifyContent: "left",
            }}
          >
            {(!isEditPlannedReels?.[record.orderno] ||
              (isEditPlannedReels?.[record.orderno] &&
                !isEditPlannedReels?.[record.orderno].isEditable)) && (
                <Col span={12}>{text}</Col>
              )}
            {userDetails?.roles?.job_cards.edit &&
              record.reelod?.length === 1 &&
              record.coreid &&
              record.coreid !== "" &&
              record.coreid !== "-" &&
              record.id_od_type != "range" &&
              ((record.type.toLowerCase() == "reel" &&
                record.quantity_type == "weight") ||
                record.type.toLowerCase() == "sheet") && (
                <Col span={12}>
                  <Styled style={{ marginTop: "-7px" }}>
                    <Tooltip
                      placement="bottomRight"
                      title={"Edit planned reels"}
                      className="edit-tooltip"
                      getPopupContainer={(triggerNode) => triggerNode}
                    >
                      <Button
                        onClick={() => {
                          handlePlannedReelsEditColumn(
                            index,
                            record,
                            true,
                            "incomplete_order"
                          );
                        }}
                      >
                        <Iconmoon icon="edit" size={16} color="#A19F9D" />
                      </Button>
                    </Tooltip>
                  </Styled>
                </Col>
              )}
          </div>
        );
      },
    },
    {
      title: "Planned Weight",
      dataIndex: "plannedweight",
      width: "10%",
      render: (text, record) => `${text}`,
    },
    // {
    //   title: "Type",
    //   dataIndex: "type",
    //   width: "2%",
    // },
    // {
    //   title: "Order Weight",
    //   dataIndex: "weight",
    //   width: "3%",
    //   render: (text, record) =>
    //     record.quantity_type === "reel_sheet" ? "-" : `${text} ${record.units  && record.item_type !== "split_group" ? weightUnit[record.units.weight]?.displayName?.toUpperCase() : weightUnit[record.units.total_weight].displayName?.toUpperCase()}`,
    // },
    // {
    //   title: "Quantity",
    //   dataIndex: "quantity",
    //   width: "2.1%",
    //   render: (text, record) => record.quantity_type === "weight" ? "-" : `${text}`,
    // },
    {
      title: "Delivery Date",
      dataIndex: "deliverydate",
      width: "10%",
      sorter: {
        compare: (a, b) => new Date(a.deliverydate) - new Date(b.deliverydate),
      },
    },
    {
      title: "Created Date",
      dataIndex: "createddate",
      width: "10%",
      sorter: {
        compare: (a, b) => new Date(a.createddate) - new Date(b.createddate),
      },
    },
    {
      title: "Priority",
      dataIndex: "priority",
      width: "10%",
      render: (text, record) => (
        <div className="actionBtn">
          <Button style={{ cursor: "default" }}>
            <Iconmoon
              icon={record.priority ? "correct" : "wrong"}
              size={16}
              color={record.priority ? "#3FBD61" : "#a19f9d"}
            />
          </Button>
        </div>
      ),
      align: "center",
    },
    // {
    //   title: "Core ID",
    //   dataIndex: "coreid",
    //   width: "2%",
    //   render: (text, record) => `${text}`,
    // },
    // {
    //   title: "Reel OD",
    //   dataIndex: "reelod",
    //   width: "2%",
    //   render: (text, record) => `${text}`,
    // },
    // {
    //   title: "Calculated Reels",
    //   dataIndex: "calculatedreels",
    //   width: "3%",
    //   render: (text, record) => `${text}`,
    // },
    // {
    //   title: "Rewinder Reels",
    //   dataIndex: "rewinderreels",
    //   width: "3%",
    //   render: (text, record) => `${text}`,
    // },
    // {
    //   title: "Planned Weight",
    //   dataIndex: "plannedweight",
    //   width: "3%",
    //   render: (text, record) => `${text}`,
    // },
    // {
    //   title: "Remarks",
    //   dataIndex: "remarks",
    //   width: "8%",
    //   render: (text, record) => (
    //     <div className="actionBtn">
    //       <Styled>
    //         <Tooltip
    //           placement="bottomRight"
    //           title={record.remarks}
    //           className="edit-tooltip"
    //           getPopupContainer={(triggerNode) => triggerNode}
    //         >
    //           <Button style={{ cursor: "default" }}>
    //             <Iconmoon icon="message" size={16} color="#EA655B" />
    //           </Button>
    //         </Tooltip>
    //       </Styled>
    //     </div>
    //   ),
    //   align: "center",
    // },
    {
      title: "Progress",
      dataIndex: "progress",
      width: "10%",
      render: (text, record) => {
        // if(record.item_type && record.item_type === "order"){
        if (!record.isConflictingstate) {

          if (
            record?.type.toLowerCase() === "sheet" ||
            (record?.type.toLowerCase() === "reel" &&
              record?.quantity_type.toLowerCase() === "weight")
          ) {
            const totalProd =
              ((record?.progressbar_info?.completed?.weight +
                record?.progressbar_info?.in_production?.weight) /
                (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
              100;
            const totalCompleted =
              (record?.progressbar_info?.completed?.weight /
                (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
              100;
            //const weightUnitKey =  ((record?.units && record?.units?.weight) ? capitalize(weightUnit[record.units.weight]?.displayName) : "T") ;
            return (
              <div className="progressLvl">
                <Styled>
                  <Tooltip
                    placement="bottomRight"
                    title={`${record?.progressbar_info?.completed
                        ? (record?.progressbar_info?.completed?.weight).toFixed(3)
                        : 0.0
                      } ${capitalize(
                        weightUnit[
                          record?.progressbar_info?.completed?.units?.weight
                        ].displayName
                      )} Weight produced
                          ${record?.progressbar_info?.in_production
                        ? (record?.progressbar_info?.in_production?.weight).toFixed(
                          3
                        )
                        : 0.0
                      } ${capitalize(
                        weightUnit[
                          record?.progressbar_info?.in_production?.units?.weight
                        ].displayName
                      )} Weight in production
                        ${record?.progressbar_info?.pending
                        ? (record?.progressbar_info?.pending?.weight).toFixed(
                          3
                        )
                        : 0.0
                      } ${capitalize(
                        weightUnit[record?.progressbar_info?.pending?.units?.weight]
                          .displayName
                      )} Weight pending for deckle match`}
                    className="edit-tooltip"
                    getPopupContainer={(triggerNode) => triggerNode}
                  >
                    <Progress
                      percent={totalProd}
                      success={{
                        percent: totalCompleted,
                      }}
                      strokeColor={"#cbe2cd"}
                    />
                  </Tooltip>
                </Styled>
              </div>
            );
          } else {
            const production =
              ((record?.progressbar_info?.completed?.quantity +
                record?.progressbar_info?.in_production?.quantity) /
                (record?.no_of_reel_sheet -
                  record.cancelled_quantity?.quantity)) *
              100;
            const completed =
              (record?.progressbar_info?.completed?.quantity /
                (record?.no_of_reel_sheet -
                  record.cancelled_quantity?.quantity)) *
              100;

            return (
              <div className="progressLvl">
                <Styled>
                  <Tooltip
                    placement="bottomRight"
                    title={`${record?.progressbar_info?.completed
                        ? record?.progressbar_info?.completed?.quantity
                        : 0
                      } Reels produced
                          ${record?.progressbar_info?.in_production
                        ? record?.progressbar_info?.in_production
                          ?.quantity
                        : 0
                      } Reels in production
                          ${record?.progressbar_info?.pending
                        ? record?.progressbar_info?.pending?.quantity
                        : 0
                      } Reels pending for deckle match`}
                    className="edit-tooltip"
                    getPopupContainer={(triggerNode) => triggerNode}
                  >
                    <Progress
                      percent={production}
                      success={{
                        percent: completed,
                      }}
                      strokeColor={"#cbe2cd"}
                    />
                  </Tooltip>
                </Styled>
              </div>
            );
          }
        }
      },
      align: "center",
    },
    {
      title: "Actions",
      dataIndex: "action",
      width: "10%",
      render: (text, record) => (
        <div className="actionBtn">
          {userDetails.roles.job_cards.edit ? (
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={"Edit planning details"}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button
                  onClick={() => {
                    handleEditAction(record);
                  }}
                >
                  <Iconmoon icon="edit" size={16} color="#A19F9D" />
                </Button>
              </Tooltip>
            </Styled>
          ) : (
            <div style={{ display: "flex" }}>
              <div style={{ width: "38px" }}></div>
            </div>
          )}
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={"View details of this order"}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button
                onClick={() => {
                  handleActions(record);
                }}
                // disabled={!userDetails.roles.job_cards.view}
                disabled={
                  !(
                    userDetails?.roles?.approve_jobcards.view ||
                    userDetails?.roles?.job_cards.view ||
                    userDetails?.roles?.job_cards.edit ||
                    userDetails?.role_type == "ADMIN" ||
                    userDetails?.role_type == "SUPER_ADMIN"
                  )
                }
              >
                <Iconmoon icon="file-view" size={16} color="#A19F9D" />
              </Button>
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "center",
    },
  ]);

  const tabHeads = [
    {
      key: 0,
      state: "pending_for_deckle_match",
      title: "Pending for deckle match",
      defaultSort: {
        sort_by: "po__date",
        sort_type: "ascending",
      },
    },
    {
      key: 1,
      state: "completely_matched",
      title: "Completely Matched",
      defaultSort: {
        sort_by: "updated_at",
        sort_type: "descending",
      },
    },
  ];

  const handleOrder = (record) => {
    setSelectedOrder(record);
    showViewDeckleDrawer();
  };

  const handlePo = (record) => {
    setSelectedOrder(record);
    goToPOPage(record);
  };

  const goToPOPage = (record) => {
    record.category === "po"
      ? record
        ? navigate("../po-details", {
          state: {
            poNumber: record.savedPO,
            backKey: "orderRecords",
          },
        })
        : navigate("../po-details", {
          state: {
            poNumber: selectedOrder.savedPO,
            backKey: "orderRecords",
          },
        })
      : record
        ? navigate("../so-details", {
          state: {
            soNumber: record.sono,
            isView: true,
            backKey: "../order-records",
          },
        })
        : navigate("../so-details", {
          state: {
            soNumber: selectedOrder.sono,
            isView: true,
            backKey: "../order-records",
          },
        });
    setViewDeckleOrders(false);
    setResendApprovalData(false);
    setProductionDetailsSideDrawer(false);
    setPendingQtyDetailsSideDrawer(false);
    setProcessedQtyDetailsSideDrawer(false);
  };

  const onGrainChange = (e, { ...record }, index, orderType) => {
    setSelectedReocord({ ...record });
    setGrainType(e);
    setSelectedGrainOrderType(orderType);
    setSelectedIndex(index);
    // let selected = selectedRecord;

    // setTableRerender(true);
  };

  const calculatePlannedWeight = (
    data,
    size,
    bulk,
    reelOd,
    coreOd,
    plannedReels
  ) => {
    const value =
      (3.14 *
        parseFloat(size) *
        (Math.pow(parseFloat(reelOd), 2) - Math.pow(parseFloat(coreOd), 2)) *
        parseFloat(plannedReels)) /
      (1000 * 1000 * parseFloat(bulk) * 4);
    let plannedWeightValue = parseFloat(
      value * conversionFactorTonneToUnits[data?.units?.planned_weight]
    )?.toFixed(3);
    return plannedWeightValue;
  };

  const plannedWeightCalculation = (
    index,
    data,
    orderQuantity,
    reelOd,
    coreOd,
    calculatedReels
  ) => {
    let size;
    if (data.type === "Reel") {
      size = data?.width;
    } else {
      size =
        data?.grain === "Long Grain" ||
          data?.grain === "long" ||
          data?.grain === "long grain" ||
          data?.grain === "Long"
          ? parseFloat(data?.width) > parseFloat(data?.length)
            ? data?.length
            : data?.width
          : parseFloat(data?.length) > parseFloat(data?.width)
            ? data?.length
            : data?.width;
    }

    if (size && coreOd && reelOd && reelOd?.length == 1) {
      let reelConversionValue =
        orderDim_Rewinder_Unit_Conversion[reelOd[0]?.split(" ")[1]];
      let coreConversionValue =
        orderDim_Rewinder_Unit_Conversion[coreOd?.split(" ")[1]];
      let conversionValue =
        orderDim_Rewinder_Unit_Conversion[data?.units?.width];
      return calculatePlannedWeight(
        data,
        size * conversionValue,
        data?.product_info?.bulk,
        reelOd[0]?.split(" ")[0] * reelConversionValue,
        coreOd.split(" ")[0] * coreConversionValue,
        calculatedReels
      );
    } else {
      if (data.type === "Reel") {
        return 0;
      } else {
        if (data.type == "Sheet" && data.quantity_type === "weight") {
          if (orderQuantity) {
            return orderQuantity;
          } else {
            return 0;
          }
        } else {
          let weightUnit = data?.units?.planned_weight;

          let dimensionUnit = data?.units?.width;
          let conversionValue =
            orderDim_Rewinder_Unit_Conversion[dimensionUnit];

          let length_Value = data.length * conversionValue;
          let width_Value = data.width * conversionValue;

          const value =
            (length_Value *
              width_Value *
              orderQuantity *
              data?.product_info?.gsm) /
            (10000 * 1000000);
          let plannedWeightValue =
            value * conversionFactorTonneToUnits[weightUnit];
          let plannedWt = plannedWeightValue
            ? plannedWeightValue.toFixed(3)
            : 0;
          return plannedWt;
        }
      }
    }
  };

  const plannedReelsCalculation = (
    index,
    data,
    size,
    length,
    width,
    orderQuantity,
    bulk,
    gsm,
    coreOd,
    reelOd
  ) => {
    let weightConversionValue =
      weight_Unit_Conversions[data.units?.planned_weight];
    const value =
      data?.quantity_type === "weight"
        ? ((orderQuantity
          ? parseFloat(orderQuantity * weightConversionValue)
          : 0) *
          1000 *
          1000 *
          parseFloat(bulk) *
          4) /
        (3.14 *
          parseFloat(size) *
          (Math.pow(parseFloat(reelOd), 2) - Math.pow(parseFloat(coreOd), 2)))
        : (parseFloat(length) *
          parseFloat(width) *
          parseFloat(orderQuantity) *
          parseFloat(gsm) *
          parseFloat(bulk) *
          4) /
        (3.14 *
          parseFloat(size) *
          (Math.pow(parseFloat(reelOd), 2) -
            Math.pow(parseFloat(coreOd), 2)) *
          10000);
    return value;
  };

  const rewinderReelsCal = (index, data, orderQuantity, reelOd, coreOd) => {
    let size;
    if (data.type === "Reel") {
      size = data.width;
    } else {
      size =
        data.grain === "Long Grain" ||
          data.grain === "long" ||
          data.grain === "long grain" ||
          data?.grain === "Long"
          ? parseFloat(data.width) > parseFloat(data.length)
            ? data.length
            : data.width
          : parseFloat(data.length) > parseFloat(data.width)
            ? data.length
            : data.width;
    }

    if (
      data.type === "Reel" &&
      data.quantity_type === "reel_sheet" &&
      orderQuantity
    ) {
      return orderQuantity;
    } else {
      if (orderQuantity) {
        if (
          size &&
          coreOd &&
          reelOd &&
          reelOd?.length == 1 &&
          data?.product_info?.bulk &&
          size !== 0 &&
          parseFloat(coreOd.split(" ")[0]) !==
          parseFloat(reelOd[0]?.split(" ")[0])
        ) {
          let reelConversionValue =
            orderDim_Rewinder_Unit_Conversion[reelOd[0]?.split(" ")[1]];
          let coreConversionValue =
            orderDim_Rewinder_Unit_Conversion[coreOd?.split(" ")[1]];
          let conversionValue =
            orderDim_Rewinder_Unit_Conversion[data?.units?.width];

          return plannedReelsCalculation(
            index,
            data,
            size * conversionValue,
            data?.length * conversionValue,
            data?.width * conversionValue,
            orderQuantity,
            data?.product_info?.bulk,
            data?.product_info?.gsm,
            coreOd.split(" ")[0] * coreConversionValue,
            reelOd[0]?.split(" ")[0] * reelConversionValue
          );
        } else {
          return 0;
        }
      } else {
        return 0;
      }
    }
  };

  const plannedReelsCaln = (
    index,
    data,
    orderQuantity,
    reelOd,
    coreOd,
    orderType
  ) => {
    let calculatedReels = 0;
    let calculatedPlannedWt;

    if (
      reelOd != "-" &&
      reelOd &&
      reelOd?.length == 1 &&
      coreOd != "-" &&
      coreOd &&
      data.width
    ) {
      calculatedReels = rewinderReelsCal(
        index,
        data,
        orderQuantity,
        reelOd,
        coreOd
      );
      let reels = Math.round(parseFloat(calculatedReels)?.toFixed(3))
        ? Math.round(parseFloat(calculatedReels * 1)?.toFixed(3))
        : 1;
      calculatedPlannedWt = plannedWeightCalculation(
        index,
        data,
        orderQuantity,
        reelOd,
        coreOd,
        reels
      );
    } else if (
      // ((!coreOd || coreOd == "-") || (!reelOd && !reelOd?.length)) && data.type == "Sheet"
      ((coreOd && coreOd != "-" && reelOd && reelOd.length == 1) ||
        ((!coreOd || coreOd == "-") && reelOd && reelOd.length == 0) ||
        ((!coreOd || coreOd == "-") && reelOd && reelOd.length == 1) ||
        (coreOd && coreOd != "-" && reelOd && reelOd.length == 0)) &&
      data.type?.toLowerCase() == "sheet"
    ) {
      if (data.type == "Sheet" && data.quantity_type === "weight") {
        if (orderQuantity) {
          calculatedReels = 0;
          calculatedPlannedWt = parseFloat(orderQuantity).toFixed(3);
        } else {
          calculatedReels = 0;
          calculatedPlannedWt = 0;
        }
      } else {
        let weightUnit = data?.units?.planned_weight;

        let dimensionUnit = data?.units?.width;
        let conversionValue = orderDim_Rewinder_Unit_Conversion[dimensionUnit];

        let length_Value = data.length * conversionValue;
        let width_Value = data.width * conversionValue;

        if (selecteDia == "constant") {
          const value =
            (length_Value *
              width_Value *
              orderQuantity *
              data?.product_info?.gsm) /
            (10000 * 1000000);
          let plannedWeightValue =
            value * conversionFactorTonneToUnits[weightUnit];
          calculatedReels = 0;
          calculatedPlannedWt = plannedWeightValue
            ? plannedWeightValue.toFixed(3)
            : 0;
        } else {
          calculatedReels = 0;
          calculatedPlannedWt = 0;
        }
      }
    } else {
      if (data.type == "Reel" && data.quantity_type === "reel_sheet") {
        calculatedReels = orderQuantity;
      } else {
        calculatedReels = 0;
      }
      calculatedPlannedWt = 0;
    }

    let dataSourceCopy = [...tableData];
    let record = dataSourceCopy[index];
    let calculatedNetPrice;
    let requiredWeightValue;
    if (data?.product_info) {
      let plannedWtConversion;
      let unitPlaceholder = data.units?.planned_weight;
      let priceUnit = data?.units?.per_weight_unit;
      if (data.quantity_type == "weight") {
        requiredWeightValue = data.weight;
      } else {
        requiredWeightValue = calculatedPlannedWt ? calculatedPlannedWt : 0;
      }
      if (unitPlaceholder?.toLowerCase() !== priceUnit?.toLowerCase()) {
        let unitToTonneConv =
          requiredWeightValue * weight_Unit_Conversions[unitPlaceholder];
        plannedWtConversion =
          unitToTonneConv * conversionFactorTonneToUnits[priceUnit];
      } else {
        plannedWtConversion = requiredWeightValue;
      }
      calculatedNetPrice =
        parseFloat(data.price) * parseFloat(plannedWtConversion)
          ? (parseFloat(data.price) * parseFloat(plannedWtConversion))?.toFixed(
            3
          )
          : "";
    }

    if (coreOd && reelOd && reelOd.length == 1) {
      record["calculatedreels"] = parseFloat(calculatedReels)?.toFixed(3);
      record.rewinderreels = Math.round(parseFloat(calculatedReels)?.toFixed(3))
        ? Math.round(parseFloat(calculatedReels * 1)?.toFixed(3))
        : 1;
    } else {
      if (data.type == "Reel" && data.quantity_type === "reel_sheet") {
        record["calculatedreels"] = calculatedReels;
        record.rewinderreels = calculatedReels;
      } else {
        record["calculatedreels"] = 0;
        record.rewinderreels = 0;
      }
    }
    record.plannedweight =
      parseFloat(calculatedPlannedWt) +
      " " +
      weightUnit[record?.units?.planned_weight]?.displayName?.toUpperCase();
    record.plannedQuant = parseFloat(orderQuantity);
    if (data.id_od_type == "constant") {
      record.reelod = reelOd;
      record.outer_dia = reelOd;
      record.coreid = coreOd;
      record.inner_dia = coreOd;
    } else {
      record.minimum_reel_od = data.minimum_reel_od;
      record.maximum_reel_od = data.maximum_reel_od;
    }
    record.net_price = calculatedNetPrice;
    dataSourceCopy[index] = { ...record };

    if (orderType != "complete_order") {
      let selectedDataCopy = [...selectedDataRows];
      let selectedDataIndex = selectedDataRows?.findIndex(
        (ele) => ele.orderno == data.orderno
      );
      let selectedOrderRow = selectedDataCopy[selectedDataIndex];
      if (selectedOrderRow) {
        selectedOrderRow.plannedQuant = parseFloat(orderQuantity);

        if (data.id_od_type == "constant") {
          selectedOrderRow.reelod = reelOd;
          selectedOrderRow.outer_dia = reelOd;
          selectedOrderRow.coreid = coreOd;
          selectedOrderRow.inner_dia = coreOd;
        } else {
          selectedOrderRow.minimum_reel_od = data.minimum_reel_od;
          selectedOrderRow.maximum_reel_od = data.maximum_reel_od;
        }

        if (coreOd && reelOd && reelOd.length == 1) {
          selectedOrderRow["calculatedreels"] =
            parseFloat(calculatedReels)?.toFixed(3);
          selectedOrderRow.rewinderreels = Math.round(
            parseFloat(calculatedReels)?.toFixed(3)
          )
            ? Math.round(parseFloat(calculatedReels * 1)?.toFixed(3))
            : 1;
        } else {
          if (data.type == "Reel" && data.quantity_type === "reel_sheet") {
            selectedOrderRow["calculatedreels"] = calculatedReels;
            selectedOrderRow.rewinderreels = calculatedReels;
          } else {
            selectedOrderRow["calculatedreels"] = 0;
            selectedOrderRow.rewinderreels = 0;
          }
        }
        selectedOrderRow.plannedweight =
          parseFloat(calculatedPlannedWt) +
          " " +
          weightUnit[record?.units?.planned_weight]?.displayName?.toUpperCase();
        selectedOrderRow.plannedQuant = parseFloat(orderQuantity);
        selectedOrderRow.net_price = calculatedNetPrice;
        selectedDataCopy[selectedDataIndex] = { ...selectedOrderRow };
        setSelectedDataRows([...selectedDataCopy]);
      }
    }

    setTableData([...dataSourceCopy]);
    tableDataRef.current = [...dataSourceCopy];
    if (orderType == "complete_order") {
      saveOrder(index, record);
    } else {
      saveIncompleteOrder();
    }
    setTableRerender(true);
  };

  const onActionChange = (index, action, data, type) => {
    if (action == "remove") {
      if (type == "complete_order") {
        plannedQntyForm.setFieldsValue({
          [`plannedQuanty${data.orderno}`]: data.plannedQuant,
        });
      } else {
        plannedQntyForm.setFieldsValue({
          [`plannedQtyRewindingDetails${data.orderno}`]: data.plannedQuant,
        });
      }
      let dataSourceCopy = tableData;
      let record = dataSourceCopy[index];
      record.plannedQuant = data.plannedQuant;
      dataSourceCopy[index] = record;
      setTableData([...dataSourceCopy]);
      tableDataRef.current = [...dataSourceCopy];
    } else {
      let enteredQuantity;
      if (type == "complete_order") {
        enteredQuantity = plannedQntyForm.getFieldValue(
          `plannedQuanty${data.orderno}`
        );
      } else {
        enteredQuantity = plannedQntyForm.getFieldValue(
          `plannedQtyRewindingDetails${data.orderno}`
        );
      }
      plannedReelsCaln(
        index,
        data,
        enteredQuantity,
        data.reelod,
        data.coreid,
        type
      );
    }
    if (type == "complete_order") {
      if (!isEditClicked.hasOwnProperty(data?.orderno)) {
        isEditClicked[data?.orderno] = {};
      }
      isEditClicked[data?.orderno].isEditable = false;
      setIsEditClicked(isEditClicked);
    } else {
      if (!isEditClickedForRewinding.hasOwnProperty(data?.orderno)) {
        isEditClickedForRewinding[data?.orderno] = {};
      }
      isEditClickedForRewinding[data?.orderno].isEditable = false;
      setIsEditClickedForRewinding(isEditClickedForRewinding);
    }
    setTableRerender(true);
  };

  const onPlannedReelsButtonChange = (index, action, data, type) => {
    let dataSourceCopy = [...tableData];
    let record = dataSourceCopy[index];
    if (action == "remove") {
      plannedQntyForm.setFieldsValue({
        [`plannedReel${data.orderno}`]: data.rewinderreels,
      });
      record.rewinderreels = data.rewinderreels;
      dataSourceCopy[index] = { ...record };
      setTableData([...dataSourceCopy]);
      tableDataRef.current = [...dataSourceCopy];
    } else {
      let enteredPlannedReels = plannedQntyForm.getFieldValue(
        `plannedReel${data.orderno}`
      );
      if (enteredPlannedReels) {
        let calculatedPlannedWt = plannedWeightCalculation(
          index,
          data,
          data.plannedQuant,
          data.reelod,
          data.coreid,
          enteredPlannedReels
        );
        let calculatedNetPrice;
        let requiredWeightValue;
        if (data?.product_info) {
          let plannedWtConversion;
          let unitPlaceholder = data.units?.planned_weight;
          let priceUnit = data?.units?.per_weight_unit;
          if (data.quantity_type == "weight") {
            requiredWeightValue = data.weight;
          } else {
            requiredWeightValue = calculatedPlannedWt ? calculatedPlannedWt : 0;
          }
          if (unitPlaceholder?.toLowerCase() !== priceUnit?.toLowerCase()) {
            let unitToTonneConv =
              requiredWeightValue * weight_Unit_Conversions[unitPlaceholder];
            plannedWtConversion =
              unitToTonneConv * conversionFactorTonneToUnits[priceUnit];
          } else {
            plannedWtConversion = requiredWeightValue;
          }
          calculatedNetPrice =
            parseFloat(data.price) * parseFloat(plannedWtConversion)
              ? (
                parseFloat(data.price) * parseFloat(plannedWtConversion)
              )?.toFixed(3)
              : "";
        }
        record.rewinderreels = enteredPlannedReels;
        record.plannedweight =
          parseFloat(calculatedPlannedWt) +
          " " +
          weightUnit[record?.units?.planned_weight]?.displayName?.toUpperCase();
        record.plannedQuant = parseFloat(data.plannedQuant);
        record.net_price = calculatedNetPrice;
        dataSourceCopy[index] = { ...record };

        //if its selected order update selected data
        let selectedDataCopy = [...selectedDataRows];
        let selectedDataIndex = selectedDataRows?.findIndex(
          (ele) => ele.orderno == data.orderno
        );
        let selectedOrderRow = selectedDataCopy[selectedDataIndex];
        // if(selectedOrderRow){
        //   selectedOrderRow.rewinderreels = enteredPlannedReels;
        //   selectedOrderRow.plannedweight = parseFloat(calculatedPlannedWt) + " " + weightUnit[record?.units?.planned_weight]?.displayName?.toUpperCase();
        //   selectedOrderRow.plannedQuant = parseFloat(data.plannedQuant);
        //   selectedOrderRow.net_price = calculatedNetPrice;
        //   selectedDataCopy[selectedDataIndex] = {...selectedOrderRow};
        //   setSelectedDataRows([...selectedDataCopy]);
        // }

        if (selectedOrderRow) {
          if (data.coreid && data.reelod && data.reelod.length == 1) {
            // selectedOrderRow.calculatedreels = parseFloat(calculatedReels)?.toFixed(3);
            selectedOrderRow.rewinderreels = enteredPlannedReels;
          } else {
            if (data.type == "Reel" && data.quantity_type === "reel_sheet") {
              // selectedOrderRow.calculatedreels = calculatedReels;
              selectedOrderRow.rewinderreels = enteredPlannedReels;
            } else {
              // selectedOrderRow.calculatedReels = 0;
              selectedOrderRow.rewinderreels = 0;
            }
          }
          selectedOrderRow.plannedweight =
            parseFloat(calculatedPlannedWt) +
            " " +
            weightUnit[
              record?.units?.planned_weight
            ]?.displayName?.toUpperCase();
          selectedOrderRow.plannedQuant = parseFloat(data.plannedQuant);
          selectedOrderRow.net_price = calculatedNetPrice;
          selectedDataCopy[selectedDataIndex] = { ...selectedOrderRow };
          setSelectedDataRows([...selectedDataCopy]);
        }

        setTableData([...dataSourceCopy]);
        tableDataRef.current = [...dataSourceCopy];
        if (type == "incomplete_order") {
          saveIncompleteOrder();
        } else {
          saveOrder(index, record);
        }
      }
    }
    if (!isEditPlannedReels.hasOwnProperty(record?.orderno)) {
      isEditPlannedReels[record?.orderno] = {};
    }
    isEditPlannedReels[record?.orderno].isEditable = false;
    setIsEditPlannedReels(isEditPlannedReels);
    setTableRerender(true);
  };

  const saveOrder = (index, data) => {
    let quantityKey = 0;
    let plannedSheetsValue = 0;
    let reelODArr = [];
    if (
      (data.reelod && data.reelod.length == 1) ||
      (data.type?.toLowerCase() == "reel" && data.quantity_type == "reel_sheet")
    ) {
      quantityKey = parseFloat(data?.rewinderreels);
    }
    if (
      data.quantity_type == "reel_sheet" &&
      data.type.toLowerCase() == "sheet"
    ) {
      plannedSheetsValue = parseFloat(data.plannedQuant);
    }

    let plannedWeightValue = 0;
    if (
      ((((data.coreid &&
        data.coreid != "-" &&
        data.reelod &&
        data.reelod.length == 1) ||
        ((!data.coreid || data.coreid == "-") &&
          data.reelod &&
          data.reelod.length == 0) ||
        ((!data.coreid || data.coreid == "-") &&
          data.reelod &&
          data.reelod.length == 1) ||
        (data.coreid &&
          data.coreid != "-" &&
          data.reelod &&
          data.reelod.length == 0)) &&
        data.type?.toLowerCase() == "sheet") ||
        (((data.coreid &&
          data.coreid != "-" &&
          ((data.reelod && data.reelod.length == 1) ||
            (data.reelod &&
              data.quantity_type == "reel_sheet" &&
              data.type?.toLowerCase() == "reel"))) ||
          ((!data.coreid || data.coreid == "-") &&
            ((data.reelod && data.reelod.length == 0) ||
              (!data.reelod &&
                data.quantity_type == "reel_sheet" &&
                data.type?.toLowerCase() == "reel")) &&
            data.quantity_type != "weight") ||
          ((!data.coreid || data.coreid == "-") &&
            ((data.reelod && data.reelod.length == 0) ||
              (!data.reelod &&
                data.quantity_type == "reel_sheet" &&
                data.type?.toLowerCase() == "reel")) &&
            data.quantity_type != "weight")) &&
          data.type?.toLowerCase() == "reel")) &&
      data.id_od_type == "constant"
    ) {
      plannedWeightValue = parseFloat(data?.plannedweight?.split(" ")[0]);
    } else if (
      (((data.reelod && data.reelod.length > 1) ||
        (data.coreid && data.coreid != "-")) &&
        data.quantity_type == "weight" &&
        data.id_od_type == "constant") ||
      (data.quantity_type == "weight" && data.id_od_type == "range")
    ) {
      plannedWeightValue = data.plannedQuant
        ? parseFloat(data.plannedQuant)
        : 0;
    } else if (
      (data.id_od_type == "range" && data.quantity_type != "weight") ||
      (data.reelod &&
        data.reelod.length > 1 &&
        data.quantity_type == "reel_sheet" &&
        data.id_od_type == "constant" &&
        data.type?.toLowerCase() == "sheet")
    ) {
      plannedWeightValue = 0;
    }

    let body = {
      type: data.type?.toLowerCase(),
      length: data?.length ? parseFloat(data.length) : 0,
      width: data?.width ? parseFloat(data.width) : 0,
      ...(data.quantity_type === "weight" && {
        weight: parseFloat(data.weight),
      }),
      product: data?.productcode,
      quantity_type: data.quantity_type === "weight" ? "weight" : "reel_sheet",
      ...(data.quantity_type !== "weight" && {
        no_of_reel_sheet:
          data.no_of_reel_sheet && data.no_of_reel_sheet != "-"
            ? parseFloat(data.no_of_reel_sheet)
            : 0,
      }),
      planned_weight: plannedWeightValue,
      // planned_weight: (data.reelod && data.reelod.length == 1 && data.id_od_type == "constant") ?  parseFloat(data?.plannedweight.split(" ")[0]) : (data.quantity_type === "weight" ?  parseFloat(data.plannedQuant) : 0),
      quantity: quantityKey,
      ...(data.quantity_type === "weight" && {
        planning_weight: data.plannedQuant ? parseFloat(data.plannedQuant) : 0,
      }),
      ...(data.quantity_type !== "weight" && {
        planning_quantity: data.plannedQuant
          ? parseFloat(data.plannedQuant)
          : 0,
      }),
      planned_sheets: plannedSheetsValue,
      net_price: data.net_price ? parseFloat(data.net_price) : 0,
      dealer_price: data.price ? parseFloat(data.price) : 0,
      customer_price: data?.customer_price
        ? parseFloat(data.customer_price)
        : 0,
      id_od_type: data.id_od_type,
      inner_dia: data.coreid && data.coreid != "-" ? data.coreid : "",
      ...(data.id_od_type == "constant" && {
        outer_dia: data.reelod && data.reelod != "-" ? data.reelod : reelODArr,
      }),
      ...(data.id_od_type == "range" && {
        minimum_reel_od: data.minimum_reel_od
          ? parseFloat(data.minimum_reel_od)
          : 0,
      }),
      ...(data.id_od_type == "range" && {
        maximum_reel_od: data.maximum_reel_od
          ? parseFloat(data.maximum_reel_od)
          : 0,
      }),
      units: {
        ...data?.units,
        ...(data.id_od_type == "range" && {
          minimum_reel_od: data.units?.minimum_reel_od,
        }),
        ...(data.id_od_type == "range" && {
          maximum_reel_od: data.units?.maximum_reel_od,
        }),
      },
      grain: data.grain
        ? data.grain == "Short" || data.grain == "short"
          ? "short"
          : "long"
        : null,
    };
    // console.log({body: body});

    updateOrder(data.orderno, body, "deckleRecord")
      .then((response) => {
        setActionToaster({
          error: response.error,
          msg: `Changes are successfully saved to Order ${data.orderno}`,
        });
        setRendering(true);
        showToaster();
      })
      .catch((error) => {
        console.log("Error in updating order:", error?.response?.data);
        setActionToaster({
          error: error.response.data.error,
          msg: error.response.data.msg,
        });
        setRendering(true);
        showToaster();
      });
  };

  const saveIncompleteOrder = () => {
    let selectedOrdersData = [...selectedDataRows];
    let requestOrdersArray = [];
    for (let i = 0; i < selectedOrdersData?.length; i++) {
      let record = selectedOrdersData[i];
      // console.log(record);
      let quantityKey = 0;
      let plannedSheetsValue = 0;
      let reelODArr = [];
      if (
        (record.reelod && record.reelod.length == 1) ||
        (record.quantity_type == "reel_sheet" &&
          record.type.toLowerCase() == "reel")
      ) {
        quantityKey = parseFloat(record.rewinderreels);
      }
      if (
        record.quantity_type == "reel_sheet" &&
        record.type.toLowerCase() == "sheet"
      ) {
        plannedSheetsValue = parseFloat(record.plannedQuant);
      }

      let plannedWeightValue = 0;
      if (
        ((((record.coreid &&
          record.coreid != "-" &&
          record.reelod &&
          record.reelod.length == 1) ||
          ((!record.coreid || record.coreid == "-") &&
            record.reelod &&
            record.reelod.length == 0) ||
          ((!record.coreid || record.coreid == "-") &&
            record.reelod &&
            record.reelod.length == 1) ||
          (record.coreid &&
            record.coreid != "-" &&
            record.reelod &&
            record.reelod.length == 0)) &&
          record.type?.toLowerCase() == "sheet") ||
          (((record.coreid &&
            record.coreid != "-" &&
            ((record.reelod && record.reelod.length == 1) ||
              (record.reelod &&
                record.quantity_type == "reel_sheet" &&
                record.type?.toLowerCase() == "reel"))) ||
            ((!record.coreid || record.coreid == "-") &&
              ((record.reelod && record.reelod.length == 0) ||
                (!record.reelod &&
                  record.quantity_type == "reel_sheet" &&
                  record.type?.toLowerCase() == "reel")) &&
              record.quantity_type != "weight") ||
            ((!record.coreid || record.coreid == "-") &&
              ((record.reelod && record.reelod.length == 0) ||
                (!record.reelod &&
                  record.quantity_type == "reel_sheet" &&
                  record.type?.toLowerCase() == "reel")) &&
              record.quantity_type != "weight")) &&
            record.type?.toLowerCase() == "reel")) &&
        record.id_od_type == "constant"
      ) {
        plannedWeightValue = parseFloat(record?.plannedweight?.split(" ")[0]);
      } else if (
        (((record.reelod && record.reelod.length > 1) ||
          (record.coreid && record.coreid != "-")) &&
          record.quantity_type == "weight" &&
          record.id_od_type == "constant") ||
        (record.quantity_type == "weight" && record.id_od_type == "range")
      ) {
        plannedWeightValue = record.plannedQuant
          ? parseFloat(record.plannedQuant)
          : 0;
      } else if (
        (record.id_od_type == "range" && record.quantity_type != "weight") ||
        (record.reelod &&
          record.reelod.length > 1 &&
          record.quantity_type == "reel_sheet" &&
          record.id_od_type == "constant" &&
          record.type?.toLowerCase() == "sheet")
      ) {
        plannedWeightValue = 0;
      }

      let requestPayload = {
        order: record.orderno,
        id_od_type: record.id_od_type,
        quantity_type:
          record.quantity_type === "weight" ? "weight" : "reel_sheet",
        inner_dia: record.coreid && record.coreid != "-" ? record.coreid : "",
        ...(record.id_od_type == "constant" && {
          outer_dia:
            record.reelod && record.reelod != "-" ? record.reelod : reelODArr,
        }),
        ...(record.quantity_type === "weight" && {
          planning_weight: record.plannedQuant
            ? parseFloat(record.plannedQuant)
            : 0,
        }),
        ...(record.quantity_type !== "weight" && {
          planning_quantity: record.plannedQuant
            ? parseFloat(record.plannedQuant)
            : 0,
        }),
        planned_sheets: plannedSheetsValue,
        type: record.type.toLowerCase(),
        quantity: quantityKey,
        ...(record.quantity_type !== "weight" && {
          no_of_reel_sheet:
            record.no_of_reel_sheet && record.no_of_reel_sheet != "-"
              ? parseFloat(record.no_of_reel_sheet)
              : 0,
        }),
        // planned_weight: (record.reelod && record.reelod.length == 1 && record.id_od_type == "constant") ?  parseFloat(record?.plannedweight.split(" ")[0]) : (record.quantity_type === "weight" ?  parseFloat(record.plannedQuant) : 0),
        planned_weight: plannedWeightValue,
        net_price: record.net_price ? parseFloat(record.net_price) : 0,
        dealer_price: record.price ? parseFloat(record.price) : 0,
        ...(record.id_od_type == "range" && {
          minimum_reel_od: record.minimum_reel_od
            ? parseFloat(record.minimum_reel_od)
            : 0,
        }),
        ...(record.id_od_type == "range" && {
          maximum_reel_od: record.maximum_reel_od
            ? parseFloat(record.maximum_reel_od)
            : 0,
        }),
        units: {
          ...record?.units,
          ...(record.id_od_type == "range" && {
            minimum_reel_od: record.units?.minimum_reel_od
              ? record.units?.minimum_reel_od
              : "cm",
          }),
          ...(record.id_od_type == "range" && {
            maximum_reel_od: record.units?.maximum_reel_od
              ? record.units?.maximum_reel_od
              : "cm",
          }),
        },
        length: record?.length,
        width: record?.width,
        grain: record.grain
          ? record.grain == "Short" || record.grain == "short"
            ? "short"
            : "long"
          : null,
      };
      requestOrdersArray.push(requestPayload);
    }
    setPayload([...requestOrdersArray]);
  };

  const handleEditColumn = (index, record, value, type) => {
    if (type == "complete_order") {
      if (!isEditClicked.hasOwnProperty(record?.orderno)) {
        isEditClicked[record?.orderno] = {};
      }
      isEditClicked[record?.orderno].isEditable = true;
      setIsEditClicked(isEditClicked);
    } else {
      if (!isEditClickedForRewinding.hasOwnProperty(record?.orderno)) {
        isEditClickedForRewinding[record?.orderno] = {};
      }
      isEditClickedForRewinding[record?.orderno].isEditable = true;
      setIsEditClickedForRewinding(isEditClickedForRewinding);
    }
    indexRef.current = index;
    setTableRerender(true);
  };

  const handlePlannedReelsEditColumn = (index, record, value, type) => {
    if (!isEditPlannedReels.hasOwnProperty(record?.orderno)) {
      isEditPlannedReels[record?.orderno] = {};
    }
    isEditPlannedReels[record?.orderno].isEditable = true;
    setIsEditPlannedReels(isEditPlannedReels);
    setTableRerender(true);
  };

  const onPlannedQuntyChange = (e, record, index, type) => {
    const pendingQty =
      record.pendingQuant?.split(" ")[0] !== ""
        ? parseFloat(record.pendingQuant?.split(" ")[0])
        : record.pendingQuant?.split(" ")[0];
    let inputValue;
    if (record?.quantity_type == "reel_sheet" && record?.type == "Sheet") {
      let enteredSheets =
        e.target.value !== "" ? parseFloat(e.target.value) : e.target.value;
      let weightOfSheets = 0;
      let dimConversion = CoversionFactorUnitsToCM[record.units.width];
      weightOfSheets =
        (record?.length *
          dimConversion *
          (record?.width * dimConversion) *
          record.product_info.gsm *
          enteredSheets) /
        (10000 * 1000000);
      let weightInTonne =
        weightOfSheets *
        conversionFactorUnitsToTonne[
        record.total_pending_quantity.units.weight
        ];
      inputValue = weightInTonne;
    } else {
      inputValue =
        e.target.value !== "" ? parseFloat(e.target.value) : e.target.value;
    }
    const hasError =
      isNaN(inputValue) ||
      inputValue === 0 ||
      inputValue === "" ||
      (inputValue > 0 && inputValue > pendingQty);
    const orderno = record?.orderno;
    if (type == "incomplete_order") {
      if ((plannedQtyRewindingDetErr[orderno]?.error || false) !== hasError) {
        const tempPlannedQuntyErr = { ...plannedQtyRewindingDetErr };
        tempPlannedQuntyErr[orderno] = { error: hasError };
        setPlannedQtyRewindingDetErr(tempPlannedQuntyErr);
      }
    } else {
      if ((plannedQuantityErr[orderno]?.error || false) !== hasError) {
        const tempPlannedQuntyErr = { ...plannedQuantityErr };
        tempPlannedQuntyErr[orderno] = { error: hasError };
        setPlannedQuantityErr(tempPlannedQuntyErr);
      }
    }
    setTableRerender(true);
  };

  const onPlannedReelsChange = (e, record, index, type) => {
    let inputValue =
      e.target.value !== "" ? parseFloat(e.target.value) : e.target.value;
    const hasError = isNaN(inputValue) || inputValue === 0 || inputValue === "";
    const orderno = record?.orderno;
    if ((plannedReelsErr[orderno]?.error || false) !== hasError) {
      const tempPlannedReelsErr = { ...plannedReelsErr };
      tempPlannedReelsErr[orderno] = { error: hasError };
      setPlannedReelsErr(tempPlannedReelsErr);
    }
    setTableRerender(true);
  };

  const onValitdateQtyChange = (e, record, index) => {
    let inputValue;
    if (record?.quantity_type == "reel_sheet" && record?.type == "Sheet") {
      let enteredSheets = e !== "" ? parseFloat(e) : e;
      let weightOfSheets = 0;
      let dimConversion = CoversionFactorUnitsToCM[record.units.width];
      weightOfSheets =
        (record?.length *
          dimConversion *
          (record?.width * dimConversion) *
          record.product_info.gsm *
          enteredSheets) /
        (10000 * 1000000);
      let weightInTonne =
        weightOfSheets *
        conversionFactorUnitsToTonne[
        record.total_pending_quantity.units.weight
        ];
      inputValue = parseFloat(weightInTonne?.toFixed(3));
    } else {
      inputValue = e !== "" ? parseFloat(e) : e;
    }
    return inputValue;
  };

  const showEditReelCoreModal = (record, type, index, orderType) => {
    setSelectedReocord(record);
    setSelectedType(type);
    setSelectedIndex(index);
    setEditReelCoreModal(true);
  };

  const closeEditReelCoreModal = () => {
    setEditReelCoreModal(false);
  };

  const confirmEditReelCoreModal = (e) => {
    setEditReelCoreModal(false);
    let orderType;
    if (
      currentState.current === "pending_for_deckle_match" &&
      !isUpdateOrderDetailsButtonPressed
    ) {
      orderType = "complete_order";
    }
    if (e.type === "reel") {
      let selected = selectedRecord;
      setSelectedReocord({ ...selected });
      let dataSourceCopy = tableData;
      let selectedDataCopy = [...selectedDataRows];
      let selectedDataIndex = selectedDataRows?.findIndex(
        (ele) => ele.orderno == e?.orderData?.orderno
      );
      let selectedRowData = selectedDataCopy[selectedDataIndex];
      if (e.reel_type == "constant") {
        selected.reelod = e.outer_dia;
        selected.outer_dia = e.outer_dia;
        if (selectedDataIndex == 0 || selectedDataIndex != -1) {
          selectedRowData.reelod = e.outer_dia;
          selectedRowData.outer_dia = e.outer_dia;
        }
      } else {
        selected.minimum_reel_od = e.minimum_reel_od;
        selected.maximum_reel_od = e.maximum_reel_od;
        selected.units["minimum_reel_od"] = e.units.minimum_reel_od;
        selected.units["maximum_reel_od"] = e.units.maximum_reel_od;
        selected.id_od_type = "range";
        selected.outer_dia = [];
        selected.reelod = [];

        if (selectedDataIndex == 0 || selectedDataIndex != -1) {
          selectedRowData.minimum_reel_od = e.minimum_reel_od;
          selectedRowData.maximum_reel_od = e.maximum_reel_od;
          selectedRowData.units["minimum_reel_od"] = e.units.minimum_reel_od;
          selectedRowData.units["maximum_reel_od"] = e.units.maximum_reel_od;
          selectedRowData.id_od_type = "range";
          selectedRowData.outer_dia = [];
          selectedRowData.reelod = [];
        }
      }
      selected.id_od_type = e.reel_type;
      if (selectedDataIndex == 0 || selectedDataIndex != -1) {
        selectedRowData.id_od_type = e.reel_type;
      }
      dataSourceCopy[selectedIndex] = { ...selected };
      setTableData([...dataSourceCopy]);
      tableDataRef.current = [...dataSourceCopy];

      selectedDataCopy[selectedDataIndex] = { ...selectedRowData };
      setSelectedDataRows([...selectedDataCopy]);
      plannedReelsCaln(
        selectedIndex,
        selected,
        selected.plannedQuant,
        e.outer_dia,
        selected.coreid,
        orderType
      );
    }
    if (e.type == "core") {
      // let selected = selectedRecord;
      let selected = JSON.parse(JSON.stringify(selectedRecord));
      setSelectedReocord({ ...selected });
      let dataSourceCopy = tableData;
      let selectedDataCopy = [...selectedDataRows];
      let selectedDataIndex = selectedDataRows?.findIndex(
        (ele) => ele.orderno == e?.orderData?.orderno
      );
      let selectedRowData;
      if (selectedDataIndex == 0 || selectedDataIndex != -1)
        selectedRowData = JSON.parse(
          JSON.stringify(selectedDataCopy[selectedDataIndex])
        );

      selected.coreid = e.inner_dia;
      selected.inner_dia = e.inner_dia;
      if (selectedDataIndex == 0 || selectedDataIndex != -1) {
        selectedRowData.coreid = e.inner_dia;
        selectedRowData.inner_dia = e.inner_dia;
        if (e?.orderData.id_od_type == "range") {
          selectedRowData.outer_dia = [];
          selectedRowData.reelod = [];
        }
      }
      if (e?.orderData.id_od_type == "range") {
        selected.outer_dia = [];
        selected.reelod = [];
      }

      dataSourceCopy[selectedIndex] = { ...selected };
      setTableData([...dataSourceCopy]);
      tableDataRef.current = [...dataSourceCopy];
      if (selectedDataIndex == 0 || selectedDataIndex != -1)
        selectedDataCopy[selectedDataIndex] = { ...selectedRowData };

      setSelectedDataRows([...selectedDataCopy]);

      plannedReelsCaln(
        selectedIndex,
        selected,
        selected.plannedQuant,
        selected.reelod,
        e.inner_dia,
        orderType
      );
    }
    // setSelectedState(true);
    // setTableRerender(true);
  };

  const handlePriorityAction = (record) => {
    setIsVisiblePriorityModal(true);
    setSelectedOrder(record);
  };

  const priorityModalConfirm = async (value) => {
    await prioritizeOrder(value);
    setIsVisiblePriorityModal(false);
    setRendering(true);
    showToaster();
  };

  const prioritizeOrder = async (record) => {
    await changeOrderPriority({
      order: record.orderno,
      prioritize: !record.priority,
    })
      .then((response) => {
        setActionToaster({ error: response.error, msg: response.msg });
      })
      .catch((error) => {
        setActionToaster({
          error: error.response.data.error,
          msg: error.response.data.msg,
        });
      });
  };

  const priorityModalClose = () => {
    setIsVisiblePriorityModal(false);
  };

  const handleViewProdDetails = (record) => {
    if (record) {
      setSelectedOrder(record);
    }
    setViewDeckleOrders(false);
    showProductionDetailsDrawer();
  };

  const handleViewProcessedQtyDetails = (record) => {
    if (record) {
      setSelectedOrder(record);
    }
    setViewDeckleOrders(false);
    showProcessedQtyDrawer();
  };

  const handleViewProcessedQtyAction = (record) => {
    if (record) {
      setSelectedOrder(record);
    }
    setViewDeckleOrders(false);
    showProcessedQtyDrawer();
  };

  const handleViewPendingQtyAction = (record) => {
    if (record) {
      setSelectedOrder(record);
    }
    setViewDeckleOrders(false);
    showPendingQtyDrawer();
  };

  const handleViewPendingQtyDetails = (record) => {
    if (record) {
      setSelectedOrder(record);
    }
    setViewDeckleOrders(false);
    showPendingQtyDrawer();
  };

  const showPendingQtyDrawer = () => {
    setPendingQtyDetailsSideDrawer(true);
  };

  const showProcessedQtyDrawer = () => {
    setProcessedQtyDetailsSideDrawer(true);
  };

  const showProductionDetailsDrawer = () => {
    setProductionDetailsSideDrawer(true);
  };

  const onViewPODetailsHandler = (data) => {
    navigate("/order-entry/po-details", {
      state: {
        poNumber: data?.pono,
      },
    });
  };

  const onViewChangeHandler = (data) => {
    navigate("../history", {
      state: {
        deckleOrder: {
          orderDetails: data,
          backKey: "/deckle-matching/order-records/",
        },
        logType: "Order",
        name: data.orderno,
        searchText: "Search change in order property",
      },
    });
  };

  const refresh = () => {
    setLoading(true);
    setPageLoaded(false);
    setTableData();
    setSearchValue("");
    setSearchKey(false);
    setClearSearch(true);
    setRendering(true);
    setIsUpdateOrderDetailsButtonPressed(false);
  };
  const PendingDetails = styled.div`
    .pendingDetailsStyle {
      display: block;
      text-align: right;
      padding-bottom: 16px;
      font-size: 14px;
      font-family: var(--sf-pro-display-m);
      color: var(--theme-color);
      line-height: 16px;
    }
    .pendingOrderStyle {
      padding-right: 20px;
    }
  `;

  function onChange(pagination, filters, sorter, extra) {
    setLoading(true);
    // console.log(selectedDataRows);
    // console.log(selectedRowKeys);
    // console.log(tableData);
    // setPaginationParamsChange(true);
    // setClearSearch(true);
    if (
      currentState.current === "pending_for_deckle_match" &&
      isUpdateOrderDetailsButtonPressed
    ) {
      incompleteOrdersColumnsHead.current?.map((item) => {
        if (item.dataIndex !== sorter?.field) {
          item["sortOrder"] = null;
        }
        if (item.dataIndex == sorter?.field) {
          item["sortOrder"] = sorter ? sorter.order : "";
        }
      });
    } else {
      if (currentState.current == "pending_for_deckle_match") {
        columnsHead.current?.map((item) => {
          if (item.dataIndex !== sorter?.field) {
            item["sortOrder"] = null;
          }
          if (item.dataIndex == sorter?.field) {
            item["sortOrder"] = sorter ? sorter.order : "";
          }
        });
      } else {
        columnsHeader.current?.map((item) => {
          if (item.dataIndex !== sorter?.field) {
            item["sortOrder"] = null;
          }
          if (item.dataIndex == sorter?.field) {
            item["sortOrder"] = sorter ? sorter.order : "";
          }
        });
      }
    }
    const currentSorter = sorter.order
      ? {
        sort_by:
          sorter.field === "pono"
            ? "po"
            : sorter.field === "orderno"
              ? "id"
              : sorter.field === "createddate"
                ? "created_at"
                : sorter.field === "deliverydate"
                  ? "delivery_date"
                  : "updated_at",
        sort_type: sorter.order === "ascend" ? "ascending" : "descending",
      }
      : orderState === "pending_for_deckle_match"
        ? {
          sort_by: "po__date",
          sort_type: "ascending",
        }
        : {
          sort_by: "updated_at",
          sort_type: "descending",
        };
    if (
      sorter.field &&
      (currentSorter.sort_type !== sortParams.sort_type ||
        currentSorter.sort_by !== sortParams.sort_by)
    ) {
      setSortParams(currentSorter);
      setCurrentPage(1);
      setPaginationParams({
        page: 1,
        size: pagination.pageSize,
      });
      paginationRef.current = {
        page: 1,
        size: pagination.pageSize,
      };
    } else {
      setCurrentPage(pagination.current);
      setPaginationParams({
        page: pagination.current,
        size: pagination.pageSize,
      });
      paginationRef.current = {
        page: pagination.current,
        size: pagination.pageSize,
      };
    }

    for (let i = 0; i < tableDataRef.current?.length; i++) {
      if (isEditClicked[tableDataRef.current[i]?.orderno]?.isEditable) {
        plannedQntyForm.setFieldsValue({
          [`plannedQuanty${tableDataRef.current[i]?.orderno}`]:
            tableDataRef.current[i]?.plannedQuant,
        });
      }
    }
    setIsEditClicked({});
    setIsEditClickedForRewinding({});
    setPlannedQuantityErr({});
    setPlannedQtyRewindingDetErr({});
    setTableRerender(true);
    setRendering(!appliedFilters.length);
    // setRendering(true);
  }

  const applyfilter = (filter) => {
    setLoading(true);
    form.setFieldsValue({ min_reel: "" });
    form.setFieldsValue({ max_reel: "" });
    if (
      currentState.current === "pending_for_deckle_match" &&
      isUpdateOrderDetailsButtonPressed
    ) {
      incompleteOrdersColumnsHead.current?.map((item) => {
        item["sortOrder"] = null;
      });
    } else {
      if (currentState.current === "pending_for_deckle_match") {
        columnsHead.current?.map((item) => {
          item["sortOrder"] = null;
        });
      } else {
        columnsHeader.current?.map((item) => {
          item["sortOrder"] = null;
        });
      }
    }

    let temp = appliedFilters;
    let alreadySetFilter = false;
    for (let i = 0; i < temp.length; i++) {
      if (temp[i].type === filter.type) {
        temp[i] = filter;
        alreadySetFilter = true;
      }
    }

    paginationRef.current = {
      page: 1,
      size: settingsData?.settings?.default_page_size || 10,
    };

    // setPaginationParams({
    //   page: 1,
    //   size: settingsData?.settings?.default_page_size || 10,
    // });
    // setCurrentPage(1);
    const tempVar = alreadySetFilter ? [...temp] : temp.concat(filter);
    setAppliedFilters(tempVar);
    setFilterTags(tempVar.map(formatFilters));
    setPaginationParams({
      page: 1,
      size: settingsData?.settings?.default_page_size || 10,
    });
    setCurrentPage(1);
  };

  const formatFilters = (item) => {
    switch (item.type) {
      case "customer":
        const value =
          item.names.length > 1
            ? `${item.names[0]} or ${item.names.length - 1} others`
            : `${item.names[0]}`;
        // const concatString = item.names.join(" or ");
        // const customerToolTip = `Country equals ${concatString}`;
        return {
          type: item.type,
          formattedType: "Customer",
          operand: "equals",
          value,
          // tooltip: customerToolTip,
        };
      case "consignee":
        const consigneeValue =
          item.names.length > 1
            ? `${item.names[0]} or ${item.names.length - 1} others`
            : `${item.names[0]}`;
        // const concatString = item.names.join(" or ");
        // const customerToolTip = `Country equals ${concatString}`;
        return {
          type: item.type,
          formattedType: "Consignee",
          operand: "equals",
          value: consigneeValue,
          // tooltip: customerToolTip,
        };
      case "order_type":
        const typeValue =
          item.order_type === "reel"
            ? "Reel"
            : item.order_type === "sheet"
              ? "Sheet"
              : "Reel or Sheet";
        return {
          type: item.type,
          formattedType: "Order Type",
          operand: "equals",
          value: typeValue,
          // tooltip: `Order Type equals ${typeValue}`,
        };
      case "created_date":
        let dateOperand = "";
        let dateValue = "";
        if (item.start_date === item.end_date) {
          dateOperand = "-";
          dateValue = moment(item.start_date).format("DD MMMM YY");
        } else {
          dateOperand = "between";
          dateValue = `${moment(item.start_date).format(
            "DD MMMM YY"
          )} - ${moment(item.end_date).format("DD MMMM YY")}`;
        }
        return {
          type: item.type,
          formattedType: "Created date",
          operand: dateOperand,
          value: dateValue,
        };
      case "po_date":
        let poDateOperand = "";
        let poDateValue = "";
        if (item.start_date === item.end_date) {
          poDateOperand = "-";
          poDateValue = moment(item.start_date).format("DD MMMM YY");
        } else {
          poDateOperand = "between";
          poDateValue = `${moment(item.start_date).format(
            "DD MMMM YY"
          )} - ${moment(item.end_date).format("DD MMMM YY")}`;
        }
        return {
          type: item.type,
          formattedType: "PO date",
          operand: poDateOperand,
          value: poDateValue,
        };
      case "delivery_date":
        let deliveryDateOperand = "";
        let deliveryDateValue = "";
        if (item.start_date === item.end_date) {
          deliveryDateOperand = "-";
          deliveryDateValue = moment(item.start_date).format("DD MMMM YY");
        } else {
          deliveryDateOperand = "between";
          deliveryDateValue = `${moment(item.start_date).format(
            "DD MMMM YY"
          )} - ${moment(item.end_date).format("DD MMMM YY")}`;
        }
        return {
          type: item.type,
          formattedType: "Delivery date",
          operand: deliveryDateOperand,
          value: deliveryDateValue,
        };
      case "gsm":
        const gsmValue =
          item.operator === "in_range"
            ? `${item.min_gsm} and ${item.max_gsm}`
            : `${item.gsm}`;
        const gsmOperand =
          item.operator === "in_range"
            ? "between"
            : item.operator === "equal_to"
              ? "equals"
              : item.operator === "less_than"
                ? "less than"
                : item.operator === "greater_than"
                  ? "greater than"
                  : "";
        return {
          type: item.type,
          formattedType: "GSM",
          operand: gsmOperand,
          value: gsmValue,
          // tooltip: `GSM ${gsmOperand} ${gsmValue}`,
        };
      case "burst_factor":
        const bfValue =
          item.operator === "in_range"
            ? `${item.min_burst_factor} and ${item.max_burst_factor}`
            : `${item.burst_factor}`;
        const bfOperand =
          item.operator === "in_range"
            ? "between"
            : item.operator === "equal_to"
              ? "equals"
              : item.operator === "less_than"
                ? "less than"
                : item.operator === "greater_than"
                  ? "greater than"
                  : "";
        return {
          type: item.type,
          formattedType: "Burst factor",
          operand: bfOperand,
          value: bfValue,
          // tooltip: `Burst factor ${bfOperand} ${bfValue}`,
        };
      case "reel_od":
        const reelOdValue =
          item.operator === "in_range"
            ? `${item.min_reel_od} and ${item.max_reel_od}`
            : `${item.reel_od}`;
        const reelOdOperand =
          item.operator === "in_range"
            ? "between"
            : item.operator === "equal_to"
              ? "equals"
              : item.operator === "less_than"
                ? "less than"
                : item.operator === "greater_than"
                  ? "greater than"
                  : "";
        return {
          type: item.type,
          formattedType: "Reel OD",
          operand: reelOdOperand,
          value: reelOdValue,
          // tooltip: `Reel OD ${reelOdOperand} ${reelOdValue}`,
        };
      case "core_id":
        const coreIdValue =
          item.operator === "in_range"
            ? `${item.min_core_id} and ${item.max_core_id}`
            : `${item.core_id}`;
        const coreIdOperand =
          item.operator === "in_range"
            ? "between"
            : item.operator === "equal_to"
              ? "equals"
              : item.operator === "less_than"
                ? "less than"
                : item.operator === "greater_than"
                  ? "greater than"
                  : "";
        return {
          type: item.type,
          formattedType: "Core ID",
          operand: coreIdOperand,
          value: coreIdValue,
          // tooltip: `Core ID ${coreIdOperand} ${coreIdValue}`,
        };
      case "grade_quality":
        const gradeValue =
          item.grades.length > 1
            ? `${item.grades[0].grade}(${item.grades[0].qualities.join()}) or ${item.grades.length - 1
            } others`
            : `${item.grades[0].grade}` +
            (item.grades[0].qualities?.length
              ? `"(${item.grades[0].qualities.join()})"`
              : ``);
        return {
          type: item.type,
          formattedType: "Grade",
          operand: "-",
          value: gradeValue,
          // tooltip: `Core ID ${coreIdOperand} ${coreIdValue}`
        };
      case "size":
        const sizeValue =
          item.operator === "in_range"
            ? `${item.min_size} and ${item.max_size}`
            : `${item.size}`;
        const sizetype =
          item.size_type === "width"
            ? "Width"
            : item.size_type === "length"
              ? "Length"
              : "Width / Length";
        const sizeOperand =
          item.operator === "in_range"
            ? "between"
            : item.operator === "equal_to"
              ? "equals"
              : item.operator === "less_than"
                ? "less than"
                : item.operator === "greater_than"
                  ? "greater than"
                  : "";
        return {
          type: item.type,
          formattedType: sizetype,
          operand: sizeOperand,
          value: sizeValue,
          // tooltip: `${sizetype} ${sizeOperand} ${sizeValue}`,
        };
    }
    console.log("Item in format", item);
  };

  const removeFilter = (filter) => {
    setLoading(true);
    form.setFieldsValue({ min_reel: "" });
    form.setFieldsValue({ max_reel: "" });
    if (
      currentState.current === "pending_for_deckle_match" &&
      isUpdateOrderDetailsButtonPressed
    ) {
      incompleteOrdersColumnsHead.current?.map((item) => {
        item["sortOrder"] = null;
      });
    } else {
      if (currentState.current === "pending_for_deckle_match") {
        columnsHead.current?.map((item) => {
          item["sortOrder"] = null;
        });
      } else {
        columnsHeader.current?.map((item) => {
          item["sortOrder"] = null;
        });
      }
    }

    for (let i = 0; i < tableDataRef.current?.length; i++) {
      if (isEditClicked[tableDataRef.current[i]?.orderno]?.isEditable) {
        plannedQntyForm.setFieldsValue({
          [`plannedQuanty${tableDataRef.current[i]?.orderno}`]:
            tableDataRef.current[i]?.plannedQuant,
        });
      }
    }
    setIsEditClicked({});
    setIsEditClickedForRewinding({});
    setPlannedQuantityErr({});
    setPlannedQtyRewindingDetErr({});
    setTableRerender(true);

    const filterList = appliedFilters.filter((item) => {
      return item.type !== filter.type;
    });
    const formattedFilterList = filterTags.filter((item) => {
      return item.type !== filter.type;
    });
    setFilterTags(formattedFilterList);
    //setRendering(true);
    setAppliedFilters(filterList);
    setSearchValue("");
    setSearchKey(false);
    setClearSearch(true);
    setLoading(true);
    setPageLoaded(false);
    setTableData();
    setRendering(true);
  };

  const showToaster = () => {
    setVisibleToaster(true);
    setTimeout(() => setVisibleToaster(false), 3000);
  };

  const handleTabChange = (key) => {
    if (
      currentState.current === "pending_for_deckle_match" &&
      isUpdateOrderDetailsButtonPressed
    ) {
      incompleteOrdersColumnsHead.current?.map((item) => {
        item["sortOrder"] = null;
      });
    } else {
      if (currentState.current === "pending_for_deckle_match") {
        columnsHead.current?.map((item) => {
          item["sortOrder"] = null;
        });
      } else {
        columnsHeader.current?.map((item) => {
          item["sortOrder"] = null;
        });
      }
    }
    setShowBulkOrderUpdate(false);
    updateButtonRef.current = false;
    currentState.current = tabHeads[key].state;
    setLoading(true);
    setPageLoaded(false);
    setTableData();
    setSearchValue("");
    setSearchKey(false);
    setClearSearch(true);
    setSelectedRowKeys([]);
    setSelectedDataRows([]);
    setIsAllSelected(false);
    setIsCheckboxClicked(false);
    form.resetFields();
    setIsUpdateOrderDetailsButtonPressed(false);
    setIsAllOrders(true);
    isAllOrderRef.current = true;
    setFilterTags([]);
    setAppliedFilters([]);
    setSelectedOrderType("reel");
    setDeckleOrderType("incomplete_orders");
    selectedOrderTypeRef.current = "reel";
    deckleOrderTypeRef.current = "incomplete_orders";
    if (key === "0") {
      setIsPendingTab(true);
      setSortParams({
        sort_by: "po__date",
        sort_type: "ascending",
      });
    } else {
      setIsPendingTab(false);
      setSortParams({
        sort_by: "updated_at",
        sort_type: "descending",
      });
      setIsUpdateOrderDetailsButtonVisible(true);
    }

    setClearSearch(true);
    setOrderState(tabHeads[key].state);
    setPaginationParams({
      page: 1,
      size: settingsData?.settings?.default_page_size || 10,
    });
    paginationRef.current = {
      page: 1,
      size: settingsData?.settings?.default_page_size || 10,
    };
    setCurrentPage(1);
    setTotalRecords();
    setSortParams(tabHeads[key].defaultSort);
    setRendering(true);
    setEmptyStateLabel();
  };

  const fetchAllOrders = async (params, sort, state) => {
    try {
      let orderType =
        state === "incomplete_orders" &&
          !isAllOrderRef.current &&
          !showBulkOrderUpdate
          ? "reel"
          : showBulkOrderUpdate
            ? selectedOrderTypeRef.current
            : "";
      const allOrdersData = await getDeckleOrdersList(
        params,
        sort,
        state,
        undefined,
        orderType
      );
      setCount(allOrdersData?.total_orders);
      if (
        Object.keys(allOrdersData.orders).includes(currentState.current) ||
        !isAllOrderRef.current
      ) {
        if (!allOrdersData.orders[state].length) {
          setEmptyStateLabel("noData");
        }
        setTotalRecords(
          allOrdersData.page_size
            ? allOrdersData.page_size
            : allOrdersData.total_orders
        );
        setAllOrders(allOrdersData.orders[state]);
        if (state === "pending_for_deckle_match") {
          setPendingOrders(allOrdersData.total_orders);
          setPendingPOSO(allOrdersData?.total_po);
          setPendingQuantity(allOrdersData.total_pending_weight);
          setPlannedQuantity(allOrdersData.planned_orders_count);
        }
        setLoading(false);
        setPageLoaded(false);
      }
    } catch (error) {
      setLoading(false);
      setEmptyStateLabel("connectionAPIError");
      console.log(error);
    }
  };

  const fetchFilteredOrders = () => {
    // paginationRef.current = {
    //   page: 1,
    //   size: 10,
    // };
    let state =
      (isAllOrderRef.current &&
        orderState === "pending_for_deckle_match" &&
        !updateButtonRef.current) ||
        orderState === "completely_matched"
        ? orderState
        : deckleOrderTypeRef.current;
    let allAppliedFilter = [...appliedFilters];
    if (
      !isAllOrderRef.current &&
      (state === "incomplete_orders" || state === "planned_orders") &&
      !updateButtonRef.current
    ) {
      allAppliedFilter.push({ type: "order_type", order_type: "reel" });
    }
    if (updateButtonRef.current) {
      allAppliedFilter.push({
        type: "order_type",
        order_type: selectedOrderTypeRef.current,
      });
    }
    allAppliedFilter = [...new Set(allAppliedFilter)];

    getFilteredDeckleOrders(
      allAppliedFilter,
      // paginationParams
      paginationRef.current,
      sortParams,
      state
    )
      .then((response) => {
        setCount(response.data.total_orders);
        setEmptyStateLabel("filter");
        setTotalRecords(
          response.data.page_size
            ? response.data.page_size
            : response.data.total_orders
        );
        setAllOrders(response.data.orders[state]);
        setLoading(false);
        if (state === "pending_for_deckle_match") {
          setPendingOrders(response.data.total_orders);
          setPendingPOSO(response?.data?.total_po);
          setPendingQuantity(response.data.total_pending_weight);
          //setPlannedQuantity(response.data.planned_orders_count);
        }
        console.log("filter", response);
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
        setEmptyStateLabel("connectionAPIError");
      });
  };

  const searchDeckle = async (value = "") => {
    setSearchKey(true);
    paginationRef.current = {
      page: 1,
      size: settingsData?.settings?.default_page_size || 10,
    };

    form.setFieldsValue({ min_reel: "" });
    form.setFieldsValue({ max_reel: "" });
    if (
      currentState.current === "pending_for_deckle_match" &&
      isUpdateOrderDetailsButtonPressed
    ) {
      incompleteOrdersColumnsHead.current?.map((item) => {
        item["sortOrder"] = null;
      });
    } else {
      if (currentState.current === "pending_for_deckle_match") {
        columnsHead.current?.map((item) => {
          item["sortOrder"] = null;
        });
      } else {
        columnsHeader.current?.map((item) => {
          item["sortOrder"] = null;
        });
      }
    }

    for (let i = 0; i < tableDataRef.current?.length; i++) {
      if (isEditClicked[tableDataRef.current[i]?.orderno]?.isEditable) {
        plannedQntyForm.setFieldsValue({
          [`plannedQuanty${tableDataRef.current[i]?.orderno}`]:
            tableDataRef.current[i]?.plannedQuant,
        });
      }
    }
    setIsEditClicked({});
    setIsEditClickedForRewinding({});
    setPlannedQuantityErr({});
    setPlannedQtyRewindingDetErr({});
    setTableRerender(true);
    setLoading(true);
    setSearchValue(value);
    setCurrentPage(1);
    let state =
      (isAllOrderRef.current &&
        orderState === "pending_for_deckle_match" &&
        !updateButtonRef.current) ||
        orderState === "completely_matched"
        ? orderState
        : deckleOrderTypeRef.current;
    if (value === "" || value === null) {
      setAppliedFilters([]);
      setFilterTags([]);
      let orderType =
        state === "incomplete_orders" &&
          !isAllOrderRef.current &&
          !updateButtonRef.current
          ? "reel"
          : updateButtonRef.current
            ? selectedOrderTypeRef.current
            : "";
      getDeckleOrdersList(
        paginationRef.current,
        sortParams,
        state,
        undefined,
        orderType
      )
        .then((response) => {
          setLoading(false);
          // console.log("1", response);
          setAllOrders(response.orders[state]);
          setTotalRecords(
            response.page_size ? response.page_size : response.total_orders
          );
          if (state === "pending_for_deckle_match") {
            setPendingOrders(response.total_orders);
            setPendingPOSO(response?.total_po);
            setPendingQuantity(response.total_pending_weight);
            setPlannedQuantity(response.data.planned_orders_count);
          }
        })
        .catch((error) => {
          console.log("error", error);
          setEmptyStateLabel("connectionAPIError");
        });
    } else {
      // setLoading(false);
      setClearSearch(false);
      let orderType =
        state === "incomplete_orders" &&
          !isAllOrderRef.current &&
          !updateButtonRef.current
          ? "reel"
          : updateButtonRef.current
            ? selectedOrderTypeRef.current
            : "";
      searchDeckleMatchOrders(
        value,
        undefined,
        state,
        undefined,
        sortParams,
        orderType,
        paginationRef.current
      )
        .then((response) => {
          setCount(response.total_orders);
          setLoading(false);
          setEmptyStateLabel("search");
          // console.log("2", response, response.data[state].length);
          setAllOrders(response.data[state]);
          setTotalRecords(response.total_orders);
          if (state === "pending_for_deckle_match") {
            setPendingOrders(response.data.pending_for_deckle_match.length);
            setPendingPOSO(response?.total_po);
            setPendingQuantity(response.total_pending_weight);
            //setPlannedQuantity(response.data.planned_orders_count);
          }
        })
        .catch((error) => {
          console.log("Error in deckle search:", error);
          setEmptyStateLabel("connectionAPIError");
        });
    }
    setPaginationParams({
      page: 1,
      size: settingsData?.settings?.default_page_size || 10,
    });
  };

  const getData = () => {
    const data = allOrders?.map((item) => {
      let processQuantity;
      let pendingQuant;
      let cancelledQuantity;
      let plannedQuant;
      let quantityValue;
      let rewinderReels;

      if (item.type == "reel" && item.quantity_type == "reel_sheet") {
        processQuantity =
          item.this_item_type == "order"
            ? Math.round(item.total_processed_quantity.quantity) + " Reels"
            : Math.round(item.total_processed_quantity.quantity) + " Reels";
        pendingQuant =
          item.this_item_type == "order"
            ? Math.round(item.total_pending_quantity.quantity) + " Reels"
            : Math.round(item.total_pending_quantity.quantity) + " Reels";
        cancelledQuantity =
          item.this_item_type == "order"
            ? Math.round(item.cancelled_quantity.quantity) + " Reels"
            : Math.round(item.total_cancelled_quantity.quantity) + " Reels";
        quantityValue =
          item.this_item_type == "order"
            ? Math.round(item.no_of_reel_sheet) + " Reels"
            : Math.round(item.total_quantity) + " Reels";
        rewinderReels =
          item.this_item_type == "order"
            ? Math.round(item.planning_quantity)
            : Math.round(item.total_quantity);
        plannedQuant = item.planning_quantity;
        // quantityValue = item.this_item_type == 'order' ? Math.round(item.no_of_reel_sheet) : Math.round(item.total_quantity);
        // rewinderReels = item.this_item_type == 'order' ? Math.round(item.quantity) : Math.round(item.total_quantity);
      } else if (item.type == "sheet" && item.quantity_type == "reel_sheet") {
        // quantityValue = item.this_item_type == 'order' ? Math.round(item.no_of_reel_sheet) : Math.round(item.total_no_of_reel_sheet);
        // rewinderReels = item.this_item_type == 'order' ? Math.round(item.quantity) : Math.round(item.total_quantity);
        quantityValue =
          item.this_item_type == "order"
            ? item?.weight
              ? item.weight +
              " " +
              capitalize(weightUnit[item?.units?.planned_weight].displayName)
              : "-"
            : item.total_weight
              ? item.total_weight +
              " " +
              capitalize(weightUnit[item.units?.total_weight].displayName)
              : "-";
        rewinderReels =
          item.this_item_type == "order"
            ? Math.round(item.quantity)
            : Math.round(item.total_quantity);
        processQuantity =
          item.this_item_type == "order"
            ? item.total_processed_quantity.weight +
            " " +
            capitalize(
              weightUnit[item.total_processed_quantity.units?.weight]
                .displayName
            )
            : item.total_processed_quantity.weight +
            " " +
            capitalize(
              weightUnit[item.total_processed_quantity.units?.weight]
                .displayName
            );
        pendingQuant =
          item.this_item_type == "order"
            ? item.total_pending_quantity.weight +
            " " +
            capitalize(
              weightUnit[item.total_pending_quantity.units?.weight]
                .displayName
            )
            : item.total_pending_quantity.weight +
            " " +
            capitalize(
              weightUnit[item.total_pending_quantity.units?.weight]
                .displayName
            );
        cancelledQuantity =
          item.this_item_type == "order"
            ? item.cancelled_quantity.weight +
            " " +
            capitalize(weightUnit[item.cancelled_quantity.units].displayName)
            : item.total_cancelled_quantity.weight +
            " " +
            capitalize(
              weightUnit[item.total_cancelled_quantity.units.weight]
                .displayName
            );
        plannedQuant = item.planning_quantity;
      } else if (
        (item.type == "reel" || item.type == "sheet") &&
        item.quantity_type == "weight"
      ) {
        // quantityValue = "-";
        // rewinderReels = item.this_item_type == 'order' ? Math.round(item.quantity) : Math.round(item.total_quantity);
        quantityValue =
          item.this_item_type == "order"
            ? item.weight
              ? item.weight +
              " " +
              capitalize(weightUnit[item.units?.weight].displayName)
              : "-"
            : item.total_weight
              ? item.total_weight +
              " " +
              capitalize(weightUnit[item.units?.total_weight].displayName)
              : "-";
        rewinderReels =
          item.this_item_type == "order"
            ? Math.round(item.quantity)
            : Math.round(item.total_quantity);
        processQuantity =
          item.this_item_type == "order"
            ? item.total_processed_quantity.weight +
            " " +
            capitalize(
              weightUnit[item.total_processed_quantity.units?.weight]
                .displayName
            )
            : item.total_processed_quantity.weight +
            " " +
            capitalize(
              weightUnit[item.total_processed_quantity.units?.weight]
                .displayName
            );
        pendingQuant =
          item.this_item_type == "order"
            ? item.total_pending_quantity.weight +
            " " +
            capitalize(
              weightUnit[item.total_pending_quantity.units?.weight]
                .displayName
            )
            : item.total_pending_quantity.weight +
            " " +
            capitalize(
              weightUnit[item.total_pending_quantity.units?.weight]
                .displayName
            );
        cancelledQuantity =
          item.this_item_type == "order"
            ? item.cancelled_quantity.weight +
            " " +
            capitalize(weightUnit[item.cancelled_quantity.units].displayName)
            : item.total_cancelled_quantity.weight +
            " " +
            capitalize(
              weightUnit[item.total_cancelled_quantity.units.weight]
                .displayName
            );
        plannedQuant = item.planning_weight;
      }

      // let coreid = item.core_id ? `${item.core_id} ${lengthUnit[item.units.core_id]?.displayName?.toUpperCase()}`: "-";
      // let reelod= item.reel_od ? `${item.reel_od} ${lengthUnit[item.units.reel_od]?.displayName?.toUpperCase()}`: "-";
      let coreid = item.inner_dia;
      let reelod = item.outer_dia;
      let calculatedreels = "";
      let plannedweight;
      if (item.this_item_type == "order") {
        plannedweight = item.planned_weight
          ? `${item.planned_weight?.toFixed(3)} ${weightUnit[
            item.units.planned_weight
          ]?.displayName?.toUpperCase()}`
          : `0 ${weightUnit[
            item.units.planned_weight
          ]?.displayName?.toUpperCase()}`;
      } else {
        plannedweight = item?.total_planned_weight
          ? `${item?.total_planned_weight !== 0
            ? item?.total_planned_weight?.toFixed(3)
            : 0
          } ${weightUnit[
            item.units.total_weight
          ]?.displayName?.toUpperCase()}`
          : "-";
      }

      if (
        selectedDataRows.length &&
        form.getFieldValue("reel_od") &&
        form.getFieldValue("core_od")
      ) {
        let filterSelectedOrder = selectedDataRows.filter(
          (data) => data.orderno === item.number
        );
        if (filterSelectedOrder.length) {
          rewinderReels = filterSelectedOrder[0].rewinderreels;
          plannedweight = filterSelectedOrder[0].plannedweight;
          reelod = filterSelectedOrder[0].reelod;
          coreid = filterSelectedOrder[0].coreid;
          calculatedreels = filterSelectedOrder[0].calculatedreels;
        }
      }
      let pendingValue;
      if (item.type === "sheet" && !item.core_id && !item.reel_od) {
        pendingValue =
          item.this_item_type == "order"
            ? item.pending_quantity_weight
            : item.total_planned_weight -
            item.total_weight_completed -
            item.total_weight_in_production -
            item.total_weight_in_process;
      } else {
        pendingValue =
          item.this_item_type == "order"
            ? item.quantity -
            item.completed -
            item.in_production -
            item.in_process
            : item.total_quantity -
            item.total_weight_completed -
            item.total_weight_in_production -
            item.total_weight_in_process;
      }
      const balance_qty = (item.balance_weight == 0) ? "-" : item.balance_weight + " " + capitalize(item.units.weight);
      let jobID = []
      if (item?.jobcards?.jobcards) {
        item?.jobcards?.jobcards.map((item, index) => {
          jobID.push(item.jobcard)
        })
      }
      return {
        key: item.uuid,
        select: false,
        isConflictingstate: item.conflicting_state === "non_conflicting" ? false : true,
        jobcards: item.jobID,
        pono:
          item.po && typeof item.po === "string"
            ? item.po.toUpperCase()
            : item.po,
        sono: item.so && typeof item.so === "string"
          ? item.so.toUpperCase()
          : item.so,
        category: item.category,
        savedPO: item.po,
        orderno: item.number ? item.number : "-",
        createddate: moment(item.created_at).format("DD MMM YYYY"),
        podate: moment(item.category === 'so' ? item.so_date : item.po_date).format("DD MMM YYYY"),
        customercode: item.customer,
        productcode: item.product,
        productspec: item.product_spec,
        type: item.type ? capitalize(item.type) : "-",
        plannedUnit:
          item.quantity_type == "reel_sheet"
            ? capitalize(item.type) + "s"
            : `${weightUnit[item.units.weight]?.displayName?.toUpperCase()}`,
        size: item.width
          ? `${item.width}${item.length ? ` x ${item.length}` : ""
          } ${lengthUnit[item.units.width]?.displayName?.toUpperCase()}`
          : "-",
        length: item.length,
        width: item.width,
        grain: item.grain,
        pendingReels:
          item.this_item_type !== "split_group"
            ? item.quantity -
            item.completed -
            item.in_production -
            item.in_process
            : item.total_quantity -
            item.total_completed -
            item.total_in_production -
            item.total_in_process,
        pendingWeight: item.pending_quantity_weight
          ? item.pending_quantity_weight.toFixed(3) +
          ` ${weightUnit[
            item.units.planned_weight
          ]?.displayName?.toUpperCase()}`
          : "-",
        coreid: coreid,
        reelod: reelod,
        deliverydate: item.delivery_date
          ? moment(item.delivery_date).format("DD MMM YYYY")
          : "-",
        quantity: quantityValue ? quantityValue : "-",
        quantityValue: quantityValue,
        cancelledQuantity,
        pendingQuant,
        processQuantity,
        plannedQuant,
        minimum_reel_od: item.minimum_reel_od,
        maximum_reel_od: item.maximum_reel_od,
        // item.this_item_type !== 'split_group' ? quantityValue ? quantityValue + " "+ item.type +"s" : "-"
        // : item.total_quantity  + " "+ item.type +"s",
        weight:
          item.this_item_type !== "split_group"
            ? `${item.weight?.toFixed(3)}`
            : item.total_weight?.toFixed(3),
        // rewinderreels: `${
        //   item.type === "reel" ? "NA" : `${item.no_of_reel_sheet} Reels`
        // }`,
        calculatedreels: calculatedreels ? calculatedreels : "",
        // rewinderreels: item.this_item_type !== 'split_group' ?
        // rewinderReels ? `${rewinderReels} Reels` : "-"
        // : `${item.total_quantity} Reels`,
        rewinderreels: rewinderReels ? rewinderReels : "",
        priority: item.forced,
        remarks: item.remarks ? item.remarks : "-",
        completed:
          item.this_item_type !== "split_group"
            ? item.completed
            : item.total_completed,
        in_production:
          item.this_item_type !== "split_group"
            ? item.in_production + item.in_process
            : item.total_in_production + item.total_in_process,
        // pending: item.this_item_type !== 'split_group' ?
        //   item.quantity - item.completed - item.in_production - item.in_process
        // : item.total_quantity - item.total_completed - item.total_in_production - item.total_in_process,
        pending: pendingValue,
        id_od_type: item.id_od_type,
        customerName: item.customer_name,
        quantity_type: item.quantity_type ? item.quantity_type : "-",
        no_of_reel_sheet: item.no_of_reel_sheet
          ? `${item.no_of_reel_sheet}`
          : "-",
        plannedweight: plannedweight,
        showPendingToolTip: true,
        item_type: item.this_item_type,
        groupno: item.this_item_type !== "split_group" ? "-" : item.id,
        customer_alias: item.customer_alias,
        consignee_alias: item.consignee_alias,
        consignee: item.consignee,
        consignee_name: item.consignee_name,
        sheet_completed_weight: item.sheet_completed_weight
          ? item.sheet_completed_weight
          : 0,
        sheet_processed_weight: item.sheet_processed_weight
          ? item.sheet_processed_weight
          : 0,
        sheet_production_weight: item.sheet_production_weight
          ? item.sheet_production_weight
          : 0,
        pending_quantity_weight: item.pending_quantity_weight,
        price: item.dealer_price ? item.dealer_price : 0,
        customer_price: item.customer_price ? item.customer_price : 0,
        net_price: item.net_price ? item.net_price : 0,
        units: item.units,
        total_weight_in_process: item.total_weight_in_process
          ? item.total_weight_in_process
          : 0,
        total_weight_in_production: item.total_weight_in_production
          ? item.total_weight_in_production
          : 0,
        total_weight_completed: item.total_weight_completed
          ? item.total_weight_completed
          : 0,
        state: item.state,
        progressbar_info: item.progressbar_info,
        product_info: item.product_info,
        total_pending_quantity: item.total_pending_quantity,
        inner_dia: item.inner_dia,
        outer_dia: item.outer_dia,
        cancelled_quantity: item.cancelled_quantity,
        balance_qty: balance_qty,
      };
    });

    const result = selectedDataRows.filter((f) =>
      data.some((d) => d.key == f.key)
    );
    setSelectedRowKeys(result.map((r) => r.key));
    if (result.length == data.length && result.length) {
      setIsAllSelected(true);
    } else {
      setIsAllSelected(false);
    }
    return data;
  };

  const showViewDeckleDrawer = () => {
    setViewDeckleOrders(true);
  };

  const showNewResendApproval = () => {
    setResendApprovalData(true);
  };

  const onCloseFullViewDrawer = () => {
    setViewDeckleOrders(false);
    setResendApprovalData(false);
    setProductionDetailsSideDrawer(false);
    setPendingQtyDetailsSideDrawer(false);
    setProcessedQtyDetailsSideDrawer(false);
  };

  const onCloseViewDrawer = () => {
    setViewDeckleOrders(false);
    setResendApprovalData(false);
    setProductionDetailsSideDrawer(false);
    setPendingQtyDetailsSideDrawer(false);
    setProcessedQtyDetailsSideDrawer(false);
  };

  const handleActions = (record) => {
    setSelectedOrder(record);
    showViewDeckleDrawer();
  };

  const handleEditAction = (record) => {
    setSelectedOrder(record);
    showNewResendApproval();
  };

  const exportHandler = () => {
    const currentDate = new Date();
    const today =
      currentDate.getDate() +
      "/" +
      currentDate.toLocaleString("default", { month: "long" }) +
      "/" +
      currentDate.getFullYear();
    const fileName =
      (!isAllOrderRef.current ? "incomplete_orders" : orderState) +
      "_Kaiznn_" +
      today;
    let tabName;
    if (orderState === "completely_matched") {
      tabName = "completely_matched";
    } else {
      tabName = "pending_for_deckle_match";
    }

    if (appliedFilters.length) {
      navigate("../order-records/export-orders", {
        state: {
          body: {
            status: !isAllOrderRef.current ? "incomplete_orders" : orderState,
            appliedFilters: appliedFilters,
            sortParams: sortParams,
            page: "deckle order records",
            type: "Filter",
            tabName: tabName,
          },
          rootPage: "../order-records",
          fileName: fileName,
          count: count,
        },
      });
    } else if (!clearSearch && searchValue) {
      navigate("../order-records/export-orders", {
        state: {
          body: {
            status: !isAllOrderRef.current ? "incomplete_orders" : orderState,
            page: "deckle order records",
            type: "Search",
            tabName: tabName,
            searchValue: searchValue,
          },
          rootPage: "../order-records",
          fileName: fileName,
          count: count,
        },
      });
    } else {
      let state = !isAllOrderRef.current ? "incomplete_orders" : orderState;
      let orderType =
        state === "incomplete_orders" &&
          !isAllOrderRef.current &&
          !showBulkOrderUpdate
          ? "reel"
          : showBulkOrderUpdate
            ? selectedOrderTypeRef.current
            : "";
      navigate("../order-records/export-orders", {
        state: {
          body: {
            status: !isAllOrderRef.current ? "incomplete_orders" : orderState,
            page: "deckle order records",
            type: "All Data",
            tabName: tabName,
            orderType: orderType,
          },
          rootPage: "../order-records",
          fileName: fileName,
          count: count,
        },
      });
    }
  };

  const onUpdateButtonClick = async () => {
    setPageLoaded(false);
    setLoading(true);
    if (
      currentState.current === "pending_for_deckle_match" &&
      !isUpdateOrderDetailsButtonPressed
    ) {
      incompleteOrdersColumnsHead.current?.map((item) => {
        item["sortOrder"] = null;
      });
    } else {
      if (currentState.current === "pending_for_deckle_match") {
        columnsHead.current?.map((item) => {
          item["sortOrder"] = null;
        });
      } else {
        columnsHeader.current?.map((item) => {
          item["sortOrder"] = null;
        });
      }
    }
    setShowBulkOrderUpdate(true);
    updateButtonRef.current = true;
    setPaginationParams({
      page: 1,
      size: settingsData?.settings?.default_page_size || 10,
    });
    paginationRef.current = {
      page: 1,
      size: settingsData?.settings?.default_page_size || 10,
    };
    setSortParams({
      sort_by: "po__date",
      sort_type: "ascending",
    });

    setCurrentPage(1);
    setSearchValue("");
    setSearchKey(false);
    setClearSearch(true);
    setAppliedFilters([]);
    setFilterTags([]);
    setIsUpdateOrderDetailsButtonVisible(false);
    setIsUpdateOrderDetailsButtonPressed(true);

    for (let i = 0; i < tableDataRef.current?.length; i++) {
      if (isEditClicked[tableDataRef.current[i]?.orderno]?.isEditable) {
        plannedQntyForm.setFieldsValue({
          [`plannedQuanty${tableDataRef.current[i]?.orderno}`]:
            tableDataRef.current[i]?.plannedQuant,
        });
      }
    }

    setIsEditClicked({});
    setIsEditClickedForRewinding({});
    setPlannedQuantityErr({});
    setPlannedQtyRewindingDetErr({});
    setTableRerender(true);

    setIsAllOrders(false);
    isAllOrderRef.current = false;
    // const productCodes = [
    //   ...new Set(selectedDataRows.map((r) => r.productcode)),
    // ];

    // await getProductDetailsForSelectedOrders(productCodes)
    //   .then((response) => {
    //     setProductDataForSelectedRows(response);
    //   })
    //   .catch((error) => {
    //     console.log("Error in getting product specification list");
    //   });

    // setTotalRecords(selectedDataRows.length);
    // setCurrentPage(1);
    // setIsShowExportButton(false);
  };

  const onCancelButtonPress = () => {
    // key: 1,
    //   state: "incomplete_orders",
    //   title: "Incomplete orders",
    //   defaultSort: {
    //     sort_by: "delivery_date",
    //     sort_type: "ascending",
    //   }
    if (
      currentState.current === "pending_for_deckle_match" &&
      !isUpdateOrderDetailsButtonPressed
    ) {
      incompleteOrdersColumnsHead.current?.map((item) => {
        item["sortOrder"] = null;
      });
    } else {
      if (currentState.current === "pending_for_deckle_match") {
        columnsHead.current?.map((item) => {
          item["sortOrder"] = null;
        });
      } else {
        columnsHeader.current?.map((item) => {
          item["sortOrder"] = null;
        });
      }
    }
    plannedQntyForm.resetFields();
    setLoading(true);
    setPageLoaded(false);
    setTableData([]);
    setSelectedRowKeys([]);
    setSelectedDataRows([]);
    setIsAllSelected(false);
    setIsCheckboxClicked(false);
    setSelectedOrderType("reel");
    setDeckleOrderType("incomplete_orders");
    selectedOrderTypeRef.current = "reel";
    deckleOrderTypeRef.current = "incomplete_orders";
    setIsShowExportButton(true);
    //setIsUpdateOrderDetailsButtonVisible(true);
    setIsUpdateOrderDetailsButtonPressed(false);
    setIsUpdateOrderDetailsButtonVisible(true);
    setShowBulkOrderUpdate(false);
    updateButtonRef.current = false;
    setClearSearch(true);
    setPaginationParams({
      page: 1,
      size: settingsData?.settings?.default_page_size || 10,
    });
    paginationRef.current = {
      page: 1,
      size: settingsData?.settings?.default_page_size || 10,
    };
    form.resetFields();
    form.setFieldsValue({
      coreDia: reelCoreData.default_core_id
        ? reelCoreData.default_core_id + " " + reelCoreData.default_core_unit
        : "",
    });
    form.setFieldsValue({
      core_Dia: reelCoreData.default_core_id
        ? reelCoreData.default_core_id + " " + reelCoreData.default_core_unit
        : "",
    });
    form.setFieldsValue({
      range_unit: measurementData.data.units_management.length.default,
    });
    form.setFieldsValue({ diameter_type: "constant" });
    reelCoreData?.default_reel_od
      ? setSelectedReelOD([
        {
          value:
            reelCoreData?.default_reel_od +
            " " +
            reelCoreData?.default_reel_unit,
        },
      ])
      : setSelectedReelOD([]);
    setRendering(true);
    setIsAllOrders(true);
    isAllOrderRef.current = true;
    setPaginationParams({
      page: 1,
      size: settingsData?.settings?.default_page_size || 10,
    });
    paginationRef.current = {
      page: 1,
      size: settingsData?.settings?.default_page_size || 10,
    };
    setSortParams({
      sort_by: "po__date",
      sort_type: "ascending",
    });

    setCurrentPage(1);
    setSearchValue("");
    setSearchKey(false);
    setClearSearch(true);
    setAppliedFilters([]);
    setFilterTags([]);

    for (let i = 0; i < tableDataRef.current?.length; i++) {
      if (
        isEditClickedForRewinding[tableDataRef.current[i]?.orderno]?.isEditable
      ) {
        plannedQntyForm.setFieldsValue({
          [`plannedQtyRewindingDetails${tableDataRef.current[i]?.orderno}`]:
            tableDataRef.current[i]?.plannedQuant,
        });
      }
      plannedQntyForm.setFieldsValue({
        [`grain${tableDataCopyRef.current[i]?.orderno}`]: capitalize(
          tableDataCopyRef.current[i]?.grain
        ),
      });
    }
    setSelectedState(false);
    setCoreOdValidationError(false);
    setReelODValidationError(false);
    setSelectedDia("constant");
    setIsEditClicked({});
    setIsEditClickedForRewinding({});
    setPlannedQuantityErr({});
    setPlannedQtyRewindingDetErr({});
    setTableRerender(true);
  };

  const onFinish = () => {
    let minValue = form.getFieldValue("min_reel");
    let maxValue = form.getFieldValue("max_reel");
    let coreValue = form.getFieldValue("core_Dia");
    let rangeUnit = form.getFieldValue("range_unit");
    let coreodValue = form.getFieldValue("coreDia");

    if (
      ((!coreOdValidationError &&
        !reelODValidationError &&
        selectedReelOD?.length &&
        coreodValue) ||
        (minValue &&
          maxValue &&
          coreValue &&
          rangeUnit &&
          !rangeValidationError)) &&
      payload.length
    ) {
      let requestArray = [...payload];
      // console.log(requestArray);
      updateOrdersInBulk(requestArray)
        .then((response) => {
          setLoading(true);
          setPageLoaded(false);
          setTableData([]);
          setIsUpdateOrderDetailsButtonPressed(false);
          setIsShowExportButton(true);
          // setReelCoreData();
          setIsUpdateOrderDetailsButtonVisible(true);
          setClearSearch(true);
          setSearchValue("");
          setSearchKey(false);
          setPaginationParams({
            page: 1,
            size: settingsData?.settings?.default_page_size || 10,
          });
          paginationRef.current = {
            page: 1,
            size: settingsData?.settings?.default_page_size || 10,
          };
          setCurrentPage(1);
          setSortParams({
            sort_by: "po__date",
            sort_type: "ascending",
          });
          setSelectedRowKeys([]);
          setSelectedDataRows([]);
          setFilterTags([]);
          setAppliedFilters([]);
          setIsAllOrders(true);
          isAllOrderRef.current = true;
          setShowBulkOrderUpdate(false);
          updateButtonRef.current = false;
          setIsAllSelected(false);
          setIsCheckboxClicked(false);
          setSelectedOrderType("reel");
          setSelectedState(false);
          setCoreOdValidationError(false);
          setReelODValidationError(false);
          setSelectedDia("constant");
          setDeckleOrderType("incomplete_orders");
          selectedOrderTypeRef.current = "reel";
          setIsUpdateOrderDetailsButtonPressed(false);
          form.resetFields();
          form.setFieldsValue({
            coreDia: reelCoreData.default_core_id
              ? reelCoreData.default_core_id +
              " " +
              reelCoreData.default_core_unit
              : "",
          });
          form.setFieldsValue({
            core_Dia: reelCoreData.default_core_id
              ? reelCoreData.default_core_id +
              " " +
              reelCoreData.default_core_unit
              : "",
          });
          form.setFieldsValue({
            range_unit: measurementData.data.units_management.length.default,
          });
          reelCoreData?.default_reel_od
            ? setSelectedReelOD([
              {
                value:
                  reelCoreData?.default_reel_od +
                  " " +
                  reelCoreData?.default_reel_unit,
              },
            ])
            : setSelectedReelOD([]);
          setActionToaster({
            error: response.error,
            msg: "Orders are successfully updated",
          });
          showToaster();
          setRendering(true);
        })
        .catch((error) => {
          setActionToaster({
            error: error.response.data.error,
            msg: error.response.data.msg,
          });
          showToaster();
        });
    }
  };

  const onFinishPlannedQtyForm = (e) => { };

  const onReviewAndUpdateClick = () => {
    form.submit();
  };

  const onCoreODChange = (e) => {
    let core_value;
    if (e === "") {
      core_value = "";
    } else {
      let coreUnit = e.split(" ")[1];
      if (coreUnit) {
        let conversionInCM =
          e.split(" ")[0] * orderDim_Rewinder_Unit_Conversion[coreUnit];
        let rewinderDimUnit = form.getFieldValue("unit");
        core_value =
          conversionInCM * CoversionFactorCMToUnits[rewinderDimUnit] &&
          (conversionInCM * CoversionFactorCMToUnits[rewinderDimUnit]).toFixed(
            3
          );
      } else {
        core_value = e;
      }
    }
    form.setFieldsValue({ core_od: core_value });
    calculatePlannedReels();
  };

  const onReelODChange = (e) => {
    let reel_value;
    if (e === "") {
      reel_value = "";
    } else {
      let reelUnit = e.split(" ")[1];
      if (reelUnit) {
        let conversionInCM =
          e.split(" ")[0] * orderDim_Rewinder_Unit_Conversion[reelUnit];
        let rewinderDimUnit = form.getFieldValue("unit");
        reel_value =
          conversionInCM * CoversionFactorCMToUnits[rewinderDimUnit] &&
          (conversionInCM * CoversionFactorCMToUnits[rewinderDimUnit]).toFixed(
            3
          );
      } else {
        reel_value = e;
      }
    }
    form.setFieldsValue({ reel_od: reel_value });
    calculatePlannedReels();
  };

  const calculatePlannedReels = async () => {
    if (
      form.getFieldValue("reel_od") &&
      form.getFieldValue("core_od") &&
      parseFloat(form.getFieldValue("reel_od")) <
      parseFloat(form.getFieldValue("core_od"))
    ) {
      setCoreOdValidationError(true);
    } else {
      setPageLoaded(false);
      setCoreOdValidationError(false);
      const unit = form.getFieldValue("unit");
      const updatedData = [];
      const selectedData = [...selectedDataRows];
      selectedDataRows.forEach((item) => {
        const productData = productDataForSelectedRows[item.productcode];
        const divisorCore = CoversionFactorUnitsToCM[unit];
        const reelOD = form.getFieldValue("reel_od") * divisorCore;
        const coreOD = form.getFieldValue("core_od") * divisorCore;
        let weightConversionValue =
          weight_Unit_Conversions[item.units.planned_weight];
        let weightValue = item.weight * weightConversionValue;
        let sizeConversion = CoversionFactorUnitsToCM[item.units.width];
        let noOfReelSheet;
        let calculatedValue;
        setInputData({ core_id: coreOD, reel_od: reelOD });
        var item1 = selectedData.find((x) => x.key === item.key);
        if (item.type === "Reel" && item.quantity_type === "reel_sheet") {
          if (item1) {
            item1.rewinderreels = item.quantity;
            item1.calculatedreels = item.quantity;
            noOfReelSheet = item.quantityValue;
            item1.coreid =
              form.getFieldValue("core_od") + " " + unit.toUpperCase();
            item1.reelod =
              form.getFieldValue("reel_od") + " " + unit.toUpperCase();
          }
        } else {
          let size = item.width;
          if (item.quantity_type === "weight") {
            if (item.type === "Reel") {
              size = item.width;
            } else {
              size =
                item.grain === "Short Grain" ||
                  item.grain === "short" ||
                  item.grain === "Short"
                  ? parseFloat(item.length) > parseFloat(item.width)
                    ? item.length
                    : item.width
                  : parseFloat(item.width) > parseFloat(item.length)
                    ? item.length
                    : item.width;
            }
          } else {
            size =
              item.grain === "Short Grain" ||
                item.grain === "short" ||
                item.grain === "Short"
                ? parseFloat(item.length) > parseFloat(item.width)
                  ? item.length
                  : item.width
                : parseFloat(item.width) > parseFloat(item.length)
                  ? item.length
                  : item.width;
          }
          const value =
            item.quantity_type === "weight"
              ? (parseFloat(weightValue) *
                1000 *
                1000 *
                parseFloat(productData.bulk) *
                4) /
              (3.14 *
                parseFloat(size * sizeConversion) *
                (Math.pow(parseFloat(reelOD), 2) -
                  Math.pow(parseFloat(coreOD), 2)))
              : (parseFloat(item.length) *
                parseFloat(item.width) *
                parseFloat(item.quantityValue) *
                parseFloat(productData.gsm) *
                parseFloat(productData.bulk) *
                4) /
              (3.14 *
                parseFloat(size * sizeConversion) *
                (Math.pow(parseFloat(reelOD), 2) -
                  Math.pow(parseFloat(coreOD), 2)) *
                10000);

          noOfReelSheet =
            value <= 1 && value > 0
              ? 1
              : Math.round(value.toFixed(2)) && value > 0 && isFinite(value)
                ? Math.round(value.toFixed(2))
                : 0;
          calculatedValue = value;
          if (item1) {
            item1.rewinderreels = noOfReelSheet + " Reels";
            item1.calculatedreels =
              value && value > 0 && isFinite(value) ? value.toFixed(2) : 0;
            item1.coreid =
              form.getFieldValue("core_od") + " " + unit.toUpperCase();
            item1.reelod =
              form.getFieldValue("reel_od") + " " + unit.toUpperCase();
          }
        }

        let plannedWeight;
        if (item.type === "Sheet") {
          let size =
            item.grain === "Short Grain" ||
              item.grain === "short" ||
              item.grain === "Short"
              ? parseFloat(item.length) > parseFloat(item.width)
                ? item.length
                : item.width
              : parseFloat(item.width) > parseFloat(item.length)
                ? item.length
                : item.width;
          plannedWeight =
            (3.14 *
              parseFloat(size * sizeConversion) *
              (Math.pow(parseFloat(reelOD), 2) -
                Math.pow(parseFloat(coreOD), 2)) *
              parseFloat(noOfReelSheet)) /
            (1000 * 1000 * parseFloat(productData.bulk) * 4);
        } else {
          plannedWeight =
            (3.14 *
              parseFloat(item.width * sizeConversion) *
              (Math.pow(parseFloat(reelOD), 2) -
                Math.pow(parseFloat(coreOD), 2)) *
              parseFloat(noOfReelSheet)) /
            (1000 * 1000 * parseFloat(productData.bulk) * 4);
        }

        if (item1) {
          item1.plannedweight = plannedWeight
            ? (
              plannedWeight *
              conversionFactorTonneToUnits[item.units.planned_weight]
            ).toFixed(3) +
            " " +
            item.units.planned_weight.toUpperCase()
            : 0 + " " + item.units.planned_weight.toUpperCase();
        }
        updatedData.push(item1);
      });
      let updatedTableData = tableData;
      for (let index = 0; index < tableData.length; index++) {
        const tableorder = tableData[index];
        let filterorder = selectedData.filter(
          (data) => data.orderno === tableorder.orderno
        );

        if (filterorder.length) {
          updatedTableData[index] = filterorder[0];
        } else {
          updatedTableData[index].coreid = "-";
          updatedTableData[index].reelod = "-";
          updatedTableData[index].plannedweight = "-";
          updatedTableData[index].rewinderreels = "-";
          updatedTableData[index].calculatedreels = "-";
        }
      }
      setTableData(updatedTableData);
      tableDataRef.current = updatedTableData;

      setSelectedDataRows(selectedData);
      setPageLoaded(false);
    }
  };

  //M code
  const plannedReelsCalnForIncompleteOrder = (
    index,
    data,
    orderQuantity,
    reelOd,
    coreOd,
    orderType
  ) => {
    let calculatedReels = 0;
    let calculatedPlannedWt;

    if (
      reelOd != "-" &&
      reelOd &&
      reelOd?.length == 1 &&
      coreOd != "-" &&
      coreOd &&
      data.width
    ) {
      calculatedReels = rewinderReelsCal(
        index,
        data,
        orderQuantity,
        reelOd,
        coreOd
      );
      let reels = Math.round(parseFloat(calculatedReels)?.toFixed(3))
        ? Math.round(parseFloat(calculatedReels * 1)?.toFixed(3))
        : 1;
      calculatedPlannedWt = plannedWeightCalculation(
        index,
        data,
        orderQuantity,
        reelOd,
        coreOd,
        reels
      );
    } else if (
      // ((!coreOd || coreOd == "-") || (!reelOd && !reelOd?.length)) && data.type == "Sheet"
      ((coreOd && coreOd != "-" && reelOd && reelOd.length == 1) ||
        ((!coreOd || coreOd == "-") && reelOd && reelOd.length == 0) ||
        ((!coreOd || coreOd == "-") && reelOd && reelOd.length == 1) ||
        (coreOd && coreOd != "-" && reelOd && reelOd.length == 0)) &&
      data.type?.toLowerCase() == "sheet"
    ) {
      if (data.type == "Sheet" && data.quantity_type === "weight") {
        if (orderQuantity) {
          calculatedReels = 0;
          calculatedPlannedWt = parseFloat(orderQuantity).toFixed(3);
        } else {
          calculatedReels = 0;
          calculatedPlannedWt = 0;
        }
      } else {
        let weightUnit = data?.units?.planned_weight;

        let dimensionUnit = data?.units?.width;
        let conversionValue = orderDim_Rewinder_Unit_Conversion[dimensionUnit];

        let length_Value = data.length * conversionValue;
        let width_Value = data.width * conversionValue;

        if (selecteDia == "constant") {
          const value =
            (length_Value *
              width_Value *
              orderQuantity *
              data?.product_info?.gsm) /
            (10000 * 1000000);
          let plannedWeightValue =
            value * conversionFactorTonneToUnits[weightUnit];
          calculatedReels = 0;
          calculatedPlannedWt = plannedWeightValue
            ? plannedWeightValue.toFixed(3)
            : 0;
        } else {
          calculatedReels = 0;
          calculatedPlannedWt = 0;
        }
      }
    } else {
      if (data.type == "Reel" && data.quantity_type === "reel_sheet") {
        calculatedReels = orderQuantity;
      } else {
        calculatedReels = 0;
      }
      calculatedPlannedWt = 0;
    }

    let dataSourceCopy = [...selectedDataRows];
    let record = dataSourceCopy[index];
    let calculatedNetPrice;
    let requiredWeightValue;
    if (data?.product_info) {
      let plannedWtConversion;
      let unitPlaceholder = data.units?.planned_weight;
      let priceUnit = data?.units?.per_weight_unit;
      if (data.quantity_type == "weight") {
        requiredWeightValue = data.weight;
      } else {
        requiredWeightValue = calculatedPlannedWt ? calculatedPlannedWt : 0;
      }
      if (unitPlaceholder?.toLowerCase() !== priceUnit?.toLowerCase()) {
        let unitToTonneConv =
          requiredWeightValue * weight_Unit_Conversions[unitPlaceholder];
        plannedWtConversion =
          unitToTonneConv * conversionFactorTonneToUnits[priceUnit];
      } else {
        plannedWtConversion = requiredWeightValue;
      }
      calculatedNetPrice =
        parseFloat(data.price) * parseFloat(plannedWtConversion)
          ? (parseFloat(data.price) * parseFloat(plannedWtConversion))?.toFixed(
            3
          )
          : "";
    }

    if (coreOd && reelOd && reelOd.length == 1) {
      record["calculatedreels"] = parseFloat(calculatedReels)?.toFixed(3);
      record.rewinderreels = Math.round(parseFloat(calculatedReels)?.toFixed(3))
        ? Math.round(parseFloat(calculatedReels * 1)?.toFixed(3))
        : 1;
    } else {
      if (data.type == "Reel" && data.quantity_type === "reel_sheet") {
        record["calculatedreels"] = calculatedReels;
        record.rewinderreels = calculatedReels;
      } else {
        record["calculatedreels"] = 0;
        record.rewinderreels = 0;
      }
    }
    record.plannedweight =
      parseFloat(calculatedPlannedWt) +
      " " +
      weightUnit[record?.units?.planned_weight]?.displayName?.toUpperCase();
    record.plannedQuant = parseFloat(orderQuantity);
    if (data.id_od_type == "constant") {
      record.reelod = reelOd;
      record.outer_dia = reelOd;
      record.coreid = coreOd;
      record.inner_dia = coreOd;
    } else {
      record.minimum_reel_od = data.minimum_reel_od;
      record.maximum_reel_od = data.maximum_reel_od;
    }
    record.net_price = calculatedNetPrice;
    dataSourceCopy[index] = { ...record };

    if (orderType != "complete_order") {
      let selectedDataCopy = [...selectedDataRows];
      let selectedDataIndex = selectedDataRows?.findIndex(
        (ele) => ele.orderno == data.orderno
      );
      let selectedOrderRow = selectedDataCopy[selectedDataIndex];
      if (selectedOrderRow) {
        selectedOrderRow.plannedQuant = parseFloat(orderQuantity);

        if (data.id_od_type == "constant") {
          selectedOrderRow.reelod = reelOd;
          selectedOrderRow.outer_dia = reelOd;
          selectedOrderRow.coreid = coreOd;
          selectedOrderRow.inner_dia = coreOd;
        } else {
          selectedOrderRow.minimum_reel_od = data.minimum_reel_od;
          selectedOrderRow.maximum_reel_od = data.maximum_reel_od;
        }

        if (coreOd && reelOd && reelOd.length == 1) {
          selectedOrderRow["calculatedreels"] =
            parseFloat(calculatedReels)?.toFixed(3);
          selectedOrderRow.rewinderreels = Math.round(
            parseFloat(calculatedReels)?.toFixed(3)
          )
            ? Math.round(parseFloat(calculatedReels * 1)?.toFixed(3))
            : 1;
        } else {
          if (data.type == "Reel" && data.quantity_type === "reel_sheet") {
            selectedOrderRow["calculatedreels"] = calculatedReels;
            selectedOrderRow.rewinderreels = calculatedReels;
          } else {
            selectedOrderRow["calculatedreels"] = 0;
            selectedOrderRow.rewinderreels = 0;
          }
        }
        selectedOrderRow.plannedweight =
          parseFloat(calculatedPlannedWt) +
          " " +
          weightUnit[record?.units?.planned_weight]?.displayName?.toUpperCase();
        selectedOrderRow.plannedQuant = parseFloat(orderQuantity);
        selectedOrderRow.net_price = calculatedNetPrice;
        selectedDataCopy[selectedDataIndex] = { ...selectedOrderRow };
        setSelectedDataRows([...selectedDataCopy]);
      }
    }

    // setTableData([...dataSourceCopy]);
    // tableDataRef.current = ([...dataSourceCopy]);
    if (orderType == "complete_order") {
      saveOrder(index, record);
    } else {
      saveIncompleteOrder();
    }
    setTableRerender(true);
  };

  const onCloseNewGrade = () => {
    setSelectedOrder();
    setResendApprovalData(false);
    let state =
      (isAllOrderRef.current &&
        orderState === "pending_for_deckle_match" &&
        !updateButtonRef.current) ||
        orderState === "completely_matched"
        ? orderState
        : deckleOrderTypeRef.current;
    if (appliedFilters.length) {
      setLoading(true);
      // setSelectedRowKeys([]);
      //setSelectedDataRows([]);
      setIsAllSelected(false);
      setIsCheckboxClicked(false);
      fetchFilteredOrders();
      setRendering(false);
    } else if (searchValue !== "") {
      searchDeckleMatchOrders(
        searchValue,
        undefined,
        state,
        undefined,
        sortParams
      )
        .then((response) => {
          setCount(response.total_orders);
          setLoading(false);
          setEmptyStateLabel("search");
          setAllOrders(response.data[state]);
          setTotalRecords(response.data[orderState].length);
          if (state === "pending_for_deckle_match") {
            setPendingOrders(response.data.pending_for_deckle_match.length);
            setPendingPOSO(response.data?.total_po);
            setPendingQuantity(response.total_pending_weight);
            setPlannedQuantity(response.data.planned_orders_count);
          }
          setRendering(false);
        })
        .catch((error) => {
          console.log("Error in deckle search:", error);
          setEmptyStateLabel("connectionAPIError");
          setRendering(false);
        });
    } else if (
      (appliedFilters.length || searchValue !== "") &&
      !isUpdateOrderDetailsButtonPressed &&
      rendering
    ) {
      fetchAllOrders(paginationRef.current, sortParams, orderState);
      setRendering(false);
    } else {
      fetchAllOrders(paginationRef.current, sortParams, state);
    }
  };

  const onShowOrders = () => {
    setLoading(true);
    setIsAllOrders(!isAllOrders);
    isAllOrderRef.current = !isAllOrderRef.current;
    setPaginationParams({
      page: 1,
      size: settingsData?.settings?.default_page_size || 10,
    });
    paginationRef.current = {
      page: 1,
      size: settingsData?.settings?.default_page_size || 10,
    };
    setSortParams({
      sort_by: "po__date",
      sort_type: "ascending",
    });

    setCurrentPage(1);
    setSearchValue("");
    setSearchKey(false);
    setClearSearch(true);
    setAppliedFilters([]);
    setFilterTags([]);
    setRendering(true);
  };

  useEffect(() => {
    (async () => {
      setShowBulkOrderUpdate(false);
      updateButtonRef.current = false;
      let measurement_data;
      try {
        const unitData = await getUnitData();
        if (!unitData.error) {
          measurement_data = unitData;
          setMeasurementData(unitData);
        }
      } catch (err) {
        console.log(err);
      }

      try {
        const response = await getReelCoreValues();
        if (!response.error) {
          setReelCoreData(response);
          const reelData = response.reel_data.map((item) => {
            return {
              value: item[0] + " " + item[1],
            };
          });
          const coreData = response.core_data.map((item) => {
            return {
              value: item[0] + " " + item[1],
            };
          });
          setCoreValues(coreData);
          setReelvalues(reelData);

          form.setFieldsValue({
            coreDia: response.default_core_id
              ? response.default_core_id + " " + response.default_core_unit
              : "",
          });
          form.setFieldsValue({
            core_Dia: response.default_core_id
              ? response.default_core_id + " " + response.default_core_unit
              : "",
          });
          form.setFieldsValue({
            range_unit: measurement_data.data.units_management.length.default,
          });
          response?.default_reel_od
            ? setSelectedReelOD([
              {
                value:
                  response?.default_reel_od +
                  " " +
                  response?.default_reel_unit,
              },
            ])
            : setSelectedReelOD([]);

          if (
            response.default_core_id &&
            response.default_reel_od &&
            measurement_data
          ) {
            let coreODConversionInCM =
              response.default_core_id *
              orderDim_Rewinder_Unit_Conversion[response.default_core_unit];
            let reelODConversionInCM =
              response.default_reel_od *
              orderDim_Rewinder_Unit_Conversion[response.default_reel_unit];
            if (
              parseFloat(coreODConversionInCM) >
              parseFloat(reelODConversionInCM)
            ) {
              setCoreOdValidationError(true);
            }
          } else {
            setCoreOdValidationError(false);
          }

          let onlyDefaultCoreDia = false;
          let defaultUnitSet = false;

          if (
            (response.default_reel_od && response.default_core_id) ||
            (response.default_reel_od && !response.default_core_id)
          ) {
            form.setFieldsValue({ unit: response.default_reel_unit });
          } else if (
            !response.default_reel_od &&
            response.default_core_id &&
            form.getFieldValue("type")?.toLowerCase() === "reel"
          ) {
            form.setFieldsValue({ unit: response.default_core_unit });
            onlyDefaultCoreDia = true;
          } else if (
            !response.default_reel_od &&
            !response.default_core_id &&
            form.getFieldValue("type")?.toLowerCase() === "reel"
          ) {
            form.setFieldsValue({
              unit: measurement_data.data.units_management.length.default,
            });
            defaultUnitSet = true;
          }

          if (response.default_core_id) {
            let coreDiaValue;
            if (onlyDefaultCoreDia) {
              let conversionInCM =
                response.default_core_id *
                orderDim_Rewinder_Unit_Conversion[response.default_core_unit];
              coreDiaValue =
                conversionInCM *
                CoversionFactorCMToUnits[response.default_core_unit];
            } else if (defaultUnitSet) {
              let conversionInCM =
                response.default_core_id *
                orderDim_Rewinder_Unit_Conversion[response.default_core_unit];
              coreDiaValue =
                conversionInCM *
                CoversionFactorCMToUnits[
                measurement_data.data.units_management.length.default
                ];
            } else {
              let conversionInCM =
                response.default_core_id *
                orderDim_Rewinder_Unit_Conversion[response.default_core_unit];
              coreDiaValue =
                conversionInCM *
                CoversionFactorCMToUnits[response.default_reel_unit];
            }
            form.setFieldsValue({ core_od: coreDiaValue?.toFixed(3) });
          }

          if (response.default_reel_od) {
            let reelDiaValue;
            if (defaultUnitSet) {
              let conversionInCM =
                response.default_reel_od *
                orderDim_Rewinder_Unit_Conversion[response.default_reel_unit];
              reelDiaValue =
                conversionInCM *
                CoversionFactorCMToUnits[
                measurement_data.data.units_management.length.default
                ];
            } else {
              let conversionInCM =
                response.default_reel_od *
                orderDim_Rewinder_Unit_Conversion[response.default_reel_unit];
              reelDiaValue =
                conversionInCM *
                CoversionFactorCMToUnits[response.default_reel_unit];
            }
            form.setFieldsValue({ reel_od: reelDiaValue?.toFixed(3) });
          }
        }
      } catch (error) {
        console.log(error);
      }

      let orderMangtSettings = await getWorkflowSettings("order_management");
      setOrderManagementSettings(orderMangtSettings?.data);
    })();
  }, []);

  useEffect(() => {
    if (
      (!isAllOrderRef.current || updateButtonRef.current) &&
      !appliedFilters.length &&
      reelCoreData &&
      searchValue == "" &&
      !searchKey
    ) {
      // fetchAllOrders(paginationRef.current, sortParams, "incomplete_orders");
      fetchAllOrders(
        paginationRef.current,
        sortParams,
        deckleOrderTypeRef.current
      );
    }
  }, [
    isAllOrders,
    appliedFilters,
    showBulkOrderUpdate,
    paginationRef.current,
    selectedOrderType,
    deckleOrderType,
  ]);

  //M code
  useEffect(() => {
    if (selectedDataRows && selectedDataRows?.length && selectedState) {
      let coreIDValue = form.getFieldValue("coreDia");
      if (
        selecteDia == "constant" &&
        selectedReelOD &&
        selectedReelOD?.length &&
        coreIDValue
      ) {
        let selectedRowIndex;

        for (let i = 0; i < selectedDataRows?.length; i++) {
          let record = selectedDataRows[i];
          let reelArr = [];
          if (record.type == "Reel" && record.quantity_type == "reel_sheet") {
            reelArr.push(selectedReelOD[0].value);
          } else {
            for (let j = 0; j < selectedReelOD.length; j++) {
              reelArr.push(selectedReelOD[j].value);
            }
          }

          selectedRowIndex = tableData?.findIndex(
            (ele) => ele.orderno == record.orderno
          );
          if (
            (selectedRowIndex == 0 || selectedRowIndex) &&
            selectedRowIndex != -1
          ) {
            plannedReelsCaln(
              selectedRowIndex,
              { ...record },
              record.plannedQuant,
              reelArr,
              coreIDValue,
              "incomplete_orders"
            );
          } else {
            plannedReelsCalnForIncompleteOrder(
              i,
              { ...record },
              record.plannedQuant,
              reelArr,
              coreIDValue,
              "incomplete_orders"
            );
          }
        }
        setPageLoaded(false);
      }
      if (
        selecteDia == "constant" &&
        (selectedReelOD?.length == 0 || !coreIDValue)
      ) {
        for (let i = 0; i < selectedDataRows?.length; i++) {
          let record = selectedDataRows[i];
          let selectedRowIndex = tableData?.findIndex(
            (ele) => ele.orderno == record.orderno
          );
          if (
            (selectedRowIndex == 0 || selectedRowIndex) &&
            selectedRowIndex != -1
          ) {
            plannedReelsCaln(
              selectedRowIndex,
              { ...record },
              record.plannedQuant,
              record.outer_dia,
              record.inner_dia,
              "incomplete_orders"
            );
          } else {
            plannedReelsCalnForIncompleteOrder(
              i,
              { ...record },
              record.plannedQuant,
              record.outer_dia,
              record.inner_dia,
              "incomplete_orders"
            );
          }
        }
      }
      if (selecteDia == "range") {
        for (let i = 0; i < selectedDataRows?.length; i++) {
          let record = selectedDataRows[i];
          let selectedRowIndex = tableData?.findIndex(
            (ele) => ele.orderno == record.orderno
          );
          if (
            (record.type?.toLowerCase() == "reel" &&
              record.quantity_type != "reel_sheet") ||
            record.type?.toLowerCase() == "sheet"
          ) {
            record.outer_dia = [];
            record.reelod = "";
            if (
              (selectedRowIndex == 0 || selectedRowIndex) &&
              selectedRowIndex != -1
            ) {
              plannedReelsCaln(
                selectedRowIndex,
                { ...record },
                record.plannedQuant,
                record.outer_dia,
                record.inner_dia,
                "incomplete_orders"
              );
            } else {
              plannedReelsCalnForIncompleteOrder(
                i,
                { ...record },
                record.plannedQuant,
                record.outer_dia,
                record.inner_dia,
                "incomplete_orders"
              );
            }
          }
        }
      }
      setSelectedState(false);
    }
    setSelectedState(false);
  }, [selectedState]);

  useEffect(() => {
    if (
      grainType &&
      selectedRecord &&
      (selectedIndex != "" || selectedIndex != undefined) &&
      selectedGrainOrderType
    ) {
      let selected = JSON.parse(JSON.stringify(selectedRecord));
      //setSelectedReocord({ ...selected });
      let dataSourceCopy = tableData;
      let selectedDataCopy = [...selectedDataRows];
      let selectedDataIndex = selectedDataRows?.findIndex(
        (ele) => ele.id == selectedRecord.id
      );
      let selectedRowData;
      if (selectedDataIndex == 0 || selectedDataIndex != -1) {
        selectedRowData = JSON.parse(
          JSON.stringify(selectedDataCopy[selectedDataIndex])
        );
        selectedRowData.grain = grainType;
      }
      selected.grain = grainType;

      dataSourceCopy[selectedIndex] = { ...selected };
      setTableData([...dataSourceCopy]);
      tableDataRef.current = [...dataSourceCopy];
      if (selectedDataIndex == 0 || selectedDataIndex != -1)
        selectedDataCopy[selectedDataIndex] = { ...selectedRowData };

      setSelectedDataRows([...selectedDataCopy]);

      plannedReelsCaln(
        selectedIndex,
        selected,
        selected.plannedQuant,
        selected.reelod,
        selected.inner_dia,
        selectedGrainOrderType
      );
      setGrainType("");
      setSelectedGrainOrderType("");
      setTableRerender(true);
    }
  }, [selectedIndex, selectedRecord, grainType, selectedGrainOrderType]);

  //D code
  // useEffect(() => {
  //   if (selectedDataRows && selectedDataRows?.length && selectedState) {
  //     let coreIDValue = form.getFieldValue("coreDia");
  //     if (
  //       selecteDia == "constant" &&
  //       selectedReelOD &&
  //       selectedReelOD?.length &&
  //       coreIDValue
  //     ) {
  //       let selectedRowIndex;

  //       for (let i = 0; i < selectedDataRows?.length; i++) {
  //         let record = selectedDataRows[i];
  //         let reelArr = [];
  //         if (record.type == "Reel" && record.quantity_type == "reel_sheet") {
  //           reelArr.push(selectedReelOD[0].value);
  //         } else {
  //           for (let j = 0; j < selectedReelOD.length; j++) {
  //             reelArr.push(selectedReelOD[j].value);
  //           }
  //         }

  //         selectedRowIndex = tableData?.findIndex(
  //           (ele) => ele.orderno == record.orderno
  //         );
  //         if (
  //           (selectedRowIndex == 0 || selectedRowIndex) &&
  //           selectedRowIndex != -1
  //         ) {
  //           plannedReelsCaln(
  //             selectedRowIndex,
  //             { ...record },
  //             record.plannedQuant,
  //             reelArr,
  //             coreIDValue,
  //             "incomplete_orders"
  //           );
  //         }
  //       }
  //       setPageLoaded(false);
  //     }
  //     if (
  //       selecteDia == "constant" &&
  //       (selectedReelOD?.length == 0 || !coreIDValue)
  //     ) {
  //       for (let i = 0; i < selectedDataRows?.length; i++) {
  //         let record = selectedDataRows[i];
  //         let selectedRowIndex = tableData?.findIndex(
  //           (ele) => ele.orderno == record.orderno
  //         );
  //         if (
  //           (selectedRowIndex == 0 || selectedRowIndex) &&
  //           selectedRowIndex != -1
  //         ) {
  //           plannedReelsCaln(
  //             selectedRowIndex,
  //             { ...record },
  //             record.plannedQuant,
  //             record.outer_dia,
  //             record.inner_dia,
  //             "incomplete_orders"
  //           );
  //         }
  //       }
  //     }
  //     if (selecteDia == "range") {
  //       for (let i = 0; i < selectedDataRows?.length; i++) {
  //         let record = selectedDataRows[i];
  //         let selectedRowIndex = tableData?.findIndex(
  //           (ele) => ele.orderno == record.orderno
  //         );
  //         if (
  //           (record.type?.toLowerCase() == "reel" &&
  //             record.quantity_type != "reel_sheet") ||
  //           record.type?.toLowerCase() == "sheet"
  //         ) {
  //           record.outer_dia = [];
  //           record.reelod = "";
  //           if (
  //             (selectedRowIndex == 0 || selectedRowIndex) &&
  //             selectedRowIndex != -1
  //           ) {
  //             plannedReelsCaln(
  //               selectedRowIndex,
  //               { ...record },
  //               record.plannedQuant,
  //               record.outer_dia,
  //               record.inner_dia,
  //               "incomplete_orders"
  //             );
  //           }
  //         }
  //       }
  //     }
  //     setSelectedState(false);
  //   } else {
  //     setSelectedState(false);
  //   }
  // }, [selectedState]);

  useEffect(() => {
    let state =
      (isAllOrderRef.current &&
        orderState === "pending_for_deckle_match" &&
        !updateButtonRef.current) ||
        orderState === "completely_matched"
        ? orderState
        : deckleOrderTypeRef.current;
    if (!appliedFilters.length && searchValue == "" && rendering) {
      setIsAllSelected(false);
      fetchAllOrders(paginationRef.current, sortParams, state);
    } else if (searchValue && rendering) {
      let orderType =
        state === "incomplete_orders" &&
          !isAllOrderRef.current &&
          !updateButtonRef.current
          ? "reel"
          : updateButtonRef.current
            ? selectedOrderTypeRef.current
            : "";
      searchDeckleMatchOrders(
        searchValue,
        undefined,
        state,
        undefined,
        sortParams,
        orderType,
        paginationRef.current
      )
        .then((response) => {
          setCount(response.total_orders);
          setLoading(false);
          setEmptyStateLabel("search");
          // console.log("2", response, response.data[state].length);
          setAllOrders(response.data[state]);
          setTotalRecords(response.total_orders);
          if (state === "pending_for_deckle_match") {
            setPendingOrders(response.data.pending_for_deckle_match.length);
            setPendingPOSO(response.data.total_po);
            setPendingQuantity(response.total_pending_weight);
            //setPlannedQuantity(response.data.planned_orders_count);
          }
        })
        .catch((error) => {
          console.log("Error in deckle search:", error);
          setEmptyStateLabel("connectionAPIError");
        });
    } else if ((appliedFilters.length || searchValue !== "") && rendering) {
      // fetchAllOrders(paginationRef.current, sortParams, state);
      fetchFilteredOrders();
    }
    setRendering(false);
  }, [rendering, orderState, sortParams, paginationParams, isAllOrders]);

  useEffect(() => {
    let state =
      (isAllOrderRef.current &&
        orderState === "pending_for_deckle_match" &&
        !updateButtonRef.current) ||
        orderState === "completely_matched"
        ? orderState
        : deckleOrderTypeRef.current;
    if (appliedFilters.length) {
      setLoading(true);
      // setSelectedRowKeys([]);
      //setSelectedDataRows([]);
      setIsAllSelected(false);
      setIsCheckboxClicked(false);
      fetchFilteredOrders();
      setRendering(false);
    } else if (searchValue !== "") {
      searchDeckleMatchOrders(
        searchValue,
        undefined,
        state,
        undefined,
        sortParams
      )
        .then((response) => {
          setCount(response.total_orders);
          setLoading(false);
          setEmptyStateLabel("search");
          setAllOrders(response.data[state]);
          setTotalRecords(response.data[orderState].length);
          if (state === "pending_for_deckle_match") {
            setPendingOrders(response.data.pending_for_deckle_match.length);
            setPendingPOSO(response.data.total_po);
            setPendingQuantity(response.total_pending_weight);
            setPlannedQuantity(response.data.planned_orders_count);
          }
          setRendering(false);
        })
        .catch((error) => {
          console.log("Error in deckle search:", error);
          setEmptyStateLabel("connectionAPIError");
          setRendering(false);
        });
    } else if (
      (appliedFilters.length || searchValue !== "") &&
      !isUpdateOrderDetailsButtonPressed &&
      rendering
    ) {
      fetchAllOrders(paginationRef.current, sortParams, orderState);
      setRendering(false);
    }
  }, [appliedFilters, sortParams, paginationParams]);

  useEffect(() => {
    //D code
    // setPageLoaded(false);
    // setTableData(allOrders.length > 0 ? getData() : []);
    // tableDataRef.current = allOrders.length > 0 ? getData() : [];
    // let temp = allOrders.length > 0 ? getData() : [];
    // tableDataCopyRef.current = JSON.parse(JSON.stringify(temp));

    //M code
    if (allOrders && allOrders.length) {
      setLoading(false);
      let orders = getData();
      let updateSelectedTableData = [...orders];
      if (isUpdateOrderDetailsButtonPressed)
        for (let index = 0; index < updateSelectedTableData.length; index++) {
          //const order = updateSelectedTableData[index];
          var indexValue = selectedDataRows.findIndex(
            (obj) => obj.key == updateSelectedTableData[index].key
          );
          if (indexValue != -1) {
            updateSelectedTableData[index] = JSON.parse(
              JSON.stringify(selectedDataRows[indexValue])
            );
          }
        }
      setTableData(updateSelectedTableData);
      // setTableData(orders);
      tableDataCopyRef.current = JSON.parse(JSON.stringify([...orders]));
      const result = selectedRowKeys.filter((f) =>
        orders.some((d) => d.key == f)
      );

      if (result.length === orders.length) setIsAllSelected(true);
      else setIsAllSelected(false);
      if (isUpdateOrderDetailsButtonPressed) setPaginationParamsChange(true);
    } else {
      setTableData([]);
      tableDataCopyRef.current = [];
    }
  }, [allOrders]);

  // useEffect(() => {
  //  if(isDataChange)
  //  {
  //   if(selectedDataRows.length && showBulkOrderUpdate)
  //   {
  //     calculatePlannedReels();
  //   }
  //   setIsDataChange(false);
  // }
  // }, [isDataChange]);

  useEffect(() => {
    let propsData = {};
    if (emptyStateLabel === "noData") {
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "No records in this list";
      propsData["subHeading"] =
        "There are no records to show in this list. Add your first record to view details here";
    } else if (emptyStateLabel === "search") {
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "No records found";
      propsData["subHeading"] =
        "There is no record matching your search keyword. Try adjusting your search to find what you are looking for.";
    } else if (emptyStateLabel === "filter") {
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "No records found";
      propsData["subHeading"] =
        "There is no record matching your filter. Try changing your filter to find what you are looking for.";
    } else {
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "Something went wrong";
      propsData["subHeading"] =
        "Check your internet connection or try reloading the page.";
    }
    setEmptyStatePropsData(propsData);
  }, [emptyStateLabel]);
  // console.log(allOrders, tableData);
  // UseEffect for the working of search
  // useEffect(() => {
  //   getAllOrders()
  //     .then((response) => {
  //       setAllOrders(response);
  //     })
  //     .catch((error) => console.log("Error in getting all orders:", error));
  // }, [activeTab]);

  useEffect(() => {
    if (!pageLoaded && tableData?.length) {
      incompleteOrdersColumnsHead.current = [
        {
          title: "Po/So.No",
          dataIndex: "pono",
          width: "11.5%",
          fixed: "left",
          key: "pono",
          // align: "left",
          sorter: () => { },
          // sorter: (a, b, sortOrder) => a.pono.localeCompare(b.pono),
          render: (text, record) => (
            <>
              {record.isConflictingstate ? (
                <span style={{ paddingBottom: '5px' }}> <Tooltip title={`Conflicting order, part of ${record.jobcards?.length} conflicting job cards`} placement="top" >
                  <Iconmoon icon="info_new" size={16} color="#EA655B" />
                </Tooltip>
                </span>
              ) : (
                // Invisible placeholder to maintain layout
                <span style={{ width: "14px" }}></span>
              )}
              <Button
                style={{
                  background: "transparent",
                  whiteSpace: "normal", // allow wrapping
                  textAlign: "left",
                  lineHeight: "1.4",

                }}
                className="textTypeBtn textBtnIcon"
                onClick={() => handlePo(record)}
              >
                <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
                  {
                    `#${(record.category === 'so' ? toHandlePOName(record.sono) : toHandlePOName(record.pono)).replaceAll("_", " ")}`
                      .match(/.{1,15}/g)
                      ?.map((chunk, index) => (
                        <span key={index}>
                          {chunk}
                          <br />
                        </span>
                      ))
                  }
                </div>
              </Button>
            </>
          ),
        },
        {
          title: "Order No",
          dataIndex: "orderno",
          width: "7%",
          fixed: "left",
          sorter: () => { },
          render: (text, record) => (
            <div className="actionBtn2">
              {text != "-" ? (
                <Button
                  style={{ background: "transparent" }}
                  className="textTypeBtn textBtnIcon"
                  onClick={() => handleOrder(record)}
                >
                  {`${text}`}
                </Button>
              ) : (
                <span style={{ textAlign: "center" }}>{text}</span>
              )}
            </div>
          ),
        },
        {
          title: "PO Date",
          dataIndex: "podate",
          width: "8%",
          fixed: "left",
          sorter: {
            compare: (a, b) => new Date(a.podate) - new Date(b.podate),
          },
        },
        {
          title: "Customer",
          dataIndex: "customer_alias",
          width: "8%",
          align: "left",
          render: (text, record) => (
            <div className="actionBtn2">
              <Styled>
                <Tooltip
                  placement="bottomRight"
                  title={`${record.customercode}-${record.customerName}`}
                  className="edit-tooltip"
                  getPopupContainer={(triggerNode) => triggerNode}
                >
                  {record?.customer_alias || '-'}
                </Tooltip>
              </Styled>
            </div>
          ),
        },
        {
          title: "Consignee",
          dataIndex: "consignee_alias",
          width: "8%",
          align: "left",
          render: (text, record) => (
            <div className="actionBtn2">
              <Styled>
                <Tooltip
                  placement="bottomRight"
                  title={`${record.consignee}-${record.consignee_name}`}
                  className="edit-tooltip"
                  getPopupContainer={(triggerNode) => triggerNode}
                >
                  {record?.consignee_alias || '-'}
                </Tooltip>
              </Styled>
            </div>
          ),
        },
        {
          // title: "Prod. Code",
          // dataIndex: "productcode",
          // width: "2.5%",
          title: (
            <div>
              Product
              <Styled style={{ display: "inline-flex" }}>
                <Tooltip
                  placement="bottomRight"
                  title={
                    "The product specification is in the format of Grade/GSM/BF/Quality/Moisture"
                  }
                  className="edit-tooltip"
                  getPopupContainer={(triggerNode) => triggerNode}
                >
                  <span className="infoIcon"></span>
                </Tooltip>
              </Styled>
            </div>
          ),
          // dataIndex: "productcode",
          width: "10.8%",
          render: (text, record) => {
            return (
              <Styled>
                {" "}
                <span style={{ fontSize: "10px" }}>{record.productspec} </span>
                <br />
                <span style={{ textAlign: "center" }}>
                  {record.productcode}
                </span>
              </Styled>
            );
          },
        },
        {
          title: "Size(WxL)",
          dataIndex: "size",
          width: "8%",
        },
        {
          title: "Grain",
          dataIndex: "grain",
          width: "8%",
          render: (text, record, index) => (
            <Styled>
              {record.type.toLowerCase() == "sheet" ? (
                <div style={{ display: "flex" }}>
                  <Row className="centerAlign">
                    <div className="boxFormType">
                      <SelectStyle>
                        <Form.Item
                          name={`grain${record.orderno}`}
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                          ]}
                          className="selectForm"
                          style={{ marginBottom: 4 }}
                          initialValue={
                            record.grain
                              ? record.grain == "short"
                                ? "Short"
                                : "Long"
                              : null
                          }
                        >
                          <Select
                            placeholder={"Select"}
                            suffixIcon={<DownArrowDraw />}
                            onChange={(e) =>
                              onGrainChange(
                                e,
                                record,
                                index,
                                "incomplete_order"
                              )
                            }
                          >
                            {grainTypeData.map((grainType) => (
                              <Option key={grainType}>{grainType}</Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </SelectStyle>
                    </div>
                  </Row>
                </div>
              ) : (
                ""
              )}
            </Styled>
          ),
        },
        {
          title: "Order Qty",
          dataIndex: "quantityValue",
          width: "8%",
          render: (text, record) => (
            <Styled>
              {" "}
              {record.type.toLowerCase() == "sheet" &&
                record.quantity_type.toLowerCase() == "reel_sheet" ? (
                <>
                  <span style={{ textAlign: "center", fontSize: "12px" }}>
                    {text}
                  </span>
                  <br /> <span> {record.no_of_reel_sheet + " Sheets"} </span>
                </>
              ) : (
                `${text} `
              )}
            </Styled>
          ),
        },
        {
          title: "Processed Qty",
          dataIndex: "processQuantity",
          width: "10%",
          render: (text, record) => {
            return (
              <div
                className="actionBtn"
                style={{ marginTop: "14px", justifyContent: "left" }}
              >
                <Col span={12}>
                  {parseFloat(text) && record.type
                    ? `${text}`
                    : parseFloat(text)
                      ? `${text} `
                      : "-"}
                </Col>
                {parseFloat(text) ? (
                  <Col span={12}>
                    <Styled style={{ marginTop: "-8px" }}>
                      <Tooltip
                        placement="bottomRight"
                        title={"View Processed Quantity Details"}
                        className="edit-tooltip"
                        getPopupContainer={(triggerNode) => triggerNode}
                      >
                        <Button
                          onClick={() => {
                            handleViewProcessedQtyAction(record);
                          }}
                        >
                          <Iconmoon
                            icon="viewPODetails"
                            size={16}
                            color="rgb(96, 94, 92)"
                          />
                        </Button>
                      </Tooltip>
                    </Styled>
                  </Col>
                ) : (
                  ""
                )}
              </div>
            );
          },
        },
        {
          title: "Pending Qty",
          dataIndex: "pendingQuant",
          width: "11%",
          render: (text, record) => {
            if (record.isConflictingstate) {
              return "ND"
            }
            return (
              <div
                className="actionBtn"
                style={{ marginTop: "14px", justifyContent: "left" }}
              >
                <Col span={12}>
                  {record.type.toLowerCase() == "sheet" &&
                    record.quantity_type.toLowerCase() == "reel_sheet" ? (
                    <>
                      <span style={{ textAlign: "center", fontSize: "12px" }}>
                        (
                        {parseFloat(text) && record.type
                          ? `${text}`
                          : parseFloat(text)
                            ? `${text} `
                            : "-"}
                        )
                      </span>
                      <br />{" "}
                      <span>
                        {" "}
                        {record.total_pending_quantity.quantity +
                          " Sheets"}{" "}
                      </span>
                    </>
                  ) : (
                    `${text} `
                  )}
                </Col>
                {parseFloat(text) ? (
                  <Col span={12}>
                    <Styled style={{ marginTop: "-8px" }}>
                      <Tooltip
                        placement="bottomRight"
                        title={"View Pending Quantity Details"}
                        className="edit-tooltip"
                        getPopupContainer={(triggerNode) => triggerNode}
                      >
                        <Button
                          onClick={() => {
                            handleViewPendingQtyAction(record);
                          }}
                        >
                          <Iconmoon
                            icon="viewPODetails"
                            size={16}
                            color="rgb(96, 94, 92)"
                          />
                        </Button>
                      </Tooltip>
                    </Styled>
                  </Col>
                ) : (
                  ""
                )}
              </div>
            );
          },
        },
        {
          title: "Qty to be planned",
          dataIndex: "plannedQuant",
          width: "14%",
          key: "plannedQuant",
          render: (text, record, index) => {
            return (
              <div
                className="actionBtn"
                style={{
                  marginTop:
                    !isEditClickedForRewinding?.[record.orderno] ||
                      (isEditClickedForRewinding?.[record.orderno] &&
                        !isEditClickedForRewinding?.[record.orderno].isEditable)
                      ? "14px"
                      : "0px",
                  justifyContent: "left",
                }}
              >
                {(!isEditClickedForRewinding?.[record.orderno] ||
                  (isEditClickedForRewinding?.[record.orderno] &&
                    !isEditClickedForRewinding?.[record.orderno]
                      .isEditable)) && (
                    <Col span={12}>
                      {text} {record.plannedUnit}
                    </Col>
                  )}
                {userDetails?.roles?.job_cards.edit && (
                  <Col span={12}>
                    <Styled style={{ marginTop: "-7px" }}>
                      <Tooltip
                        placement="bottomRight"
                        title={"Edit planned quantity"}
                        className="edit-tooltip"
                        getPopupContainer={(triggerNode) => triggerNode}
                      >
                        <Button
                          onClick={() => {
                            handleEditColumn(
                              index,
                              record,
                              true,
                              "incomplete_order"
                            );
                          }}
                        >
                          <Iconmoon icon="edit" size={16} color="#A19F9D" />
                        </Button>
                      </Tooltip>
                    </Styled>
                  </Col>
                )}
              </div>
            );
          },
        },
        {
          title: "Reel OD for Rewinding",
          dataIndex: "reelod",
          width: "10%",
          render: (text, record, index) => (
            <Styled>
              <div style={{ display: "flex" }}>
                {record.id_od_type == "range" && (
                  <div
                    style={{
                      color: "var(--para-text)",
                      display: "flex",
                      width: "70%",
                      alignSelf: "center",
                    }}
                  >
                    {record.minimum_reel_od && record.maximum_reel_od
                      ? record.minimum_reel_od +
                      "-" +
                      record.maximum_reel_od +
                      " " +
                      (record.units.maximum_reel_od
                        ? lengthUnit[record.units.maximum_reel_od].displayName
                        : "")
                      : ""}
                  </div>
                )}
                {record.id_od_type == "constant" && (
                  <div
                    style={{
                      display: "flex",
                      width: "70%",
                      flexDirection: "column",
                      alignSelf: "center",
                    }}
                  >
                    {record?.reelod &&
                      record?.reelod?.map((item, index) => {
                        return (
                          index < 2 && (
                            <div>
                              {item}{" "}
                              {index == 1
                                ? "...,"
                                : record?.reelod?.length > 1
                                  ? ","
                                  : ""}
                            </div>
                          )
                        );
                      })}

                    {record?.reelod &&
                      record?.reelod?.length >= 2 &&
                      record?.reelod?.map((item, index) => {
                        let tooltipData = "";
                        for (
                          let index = 2;
                          index < record.reelod?.length;
                          index++
                        ) {
                          const data = record.reelod[index];
                          tooltipData = tooltipData + data + ", ";
                        }
                        tooltipData = tooltipData.substring(
                          0,
                          tooltipData.length - 1
                        );
                        return (
                          index == 2 && (
                            <Tooltip title={tooltipData}>
                              {" "}
                              <span
                                style={{
                                  display: "flex",
                                  fontSize: "10px",
                                  fontWeight: "bold",
                                }}
                              >
                                & {record?.reelod?.length - 2} More
                              </span>
                            </Tooltip>
                          )
                        );
                      })}
                  </div>
                )}
                <div style={{ display: "flex", width: "30%" }}>
                  <div className="actionBtn">
                    {" "}
                    {userDetails?.roles?.job_cards.edit && (
                      <Button
                        onClick={() =>
                          showEditReelCoreModal(
                            record,
                            "reel",
                            index,
                            "incomplete_order"
                          )
                        }
                        style={{ background: "none" }}
                      >
                        <Iconmoon
                          icon="down"
                          size={30}
                          color="var(--para-text)"
                        />
                      </Button>
                    )}{" "}
                  </div>
                </div>
              </div>
            </Styled>
          ),
        },
        {
          title: "Core OD for Rewinding",
          dataIndex: "coreid",
          width: "10%",
          render: (text, record, index) => (
            <div className="actionBtn">
              <Styled>
                <div style={{ display: "flex" }}>
                  {record.coreid ? (
                    <div
                      style={{
                        color: "var(--para-text)",
                        display: "flex",
                        width: "70%",
                        alignSelf: "center",
                      }}
                    >
                      {record.coreid}
                    </div>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        width: "70%",
                        alignSelf: "center",
                        marginLeft: "36px",
                      }}
                    ></div>
                  )}

                  <div style={{ display: "flex", width: "30%" }}>
                    <div className="actionBtn">
                      {" "}
                      {userDetails?.roles?.job_cards.edit && (
                        <Button
                          onClick={() =>
                            showEditReelCoreModal(
                              record,
                              "core",
                              index,
                              "incomplete_order"
                            )
                          }
                          style={{ background: "none" }}
                        >
                          <Iconmoon
                            icon="down"
                            size={30}
                            color="var(--para-text)"
                          />
                        </Button>
                      )}{" "}
                    </div>
                  </div>
                </div>
              </Styled>
            </div>
          ),
        },
        {
          title: "Calculated Reels",
          dataIndex: "calculatedreels",
          width: "10%",
          render: (text, record) => `${text}`,
        },
        {
          title: "Planned Reels",
          dataIndex: "rewinderreels",
          width: "16%",
          render: (text, record, index) => {
            return (
              <div
                className="actionBtn"
                style={{
                  marginTop:
                    !isEditPlannedReels?.[record.orderno] ||
                      (isEditPlannedReels?.[record.orderno] &&
                        !isEditPlannedReels?.[record.orderno].isEditable)
                      ? "14px"
                      : "0px",
                  justifyContent: "left",
                }}
              >
                {(!isEditPlannedReels?.[record.orderno] ||
                  (isEditPlannedReels?.[record.orderno] &&
                    !isEditPlannedReels?.[record.orderno].isEditable)) && (
                    <Col span={12}>{text}</Col>
                  )}
                {userDetails?.roles?.job_cards.edit &&
                  record.reelod?.length === 1 &&
                  record.coreid &&
                  record.coreid !== "" &&
                  record.coreid !== "-" &&
                  record.id_od_type != "range" &&
                  ((record.type.toLowerCase() == "reel" &&
                    record.quantity_type == "weight") ||
                    record.type.toLowerCase() == "sheet") && (
                    <Col span={12}>
                      <Styled style={{ marginTop: "-7px" }}>
                        <Tooltip
                          placement="bottomRight"
                          title={"Edit planned reels"}
                          className="edit-tooltip"
                          getPopupContainer={(triggerNode) => triggerNode}
                        >
                          <Button
                            onClick={() => {
                              handlePlannedReelsEditColumn(
                                index,
                                record,
                                true,
                                "incomplete_order"
                              );
                            }}
                          >
                            <Iconmoon icon="edit" size={16} color="#A19F9D" />
                          </Button>
                        </Tooltip>
                      </Styled>
                    </Col>
                  )}
              </div>
            );
          },
        },
        {
          title: "Planned Weight",
          dataIndex: "plannedweight",
          width: "10%",
          render: (text, record) => `${text}`,
        },
        {
          title: "Delivery Date",
          dataIndex: "deliverydate",
          width: "10%",
          sorter: {
            compare: (a, b) =>
              new Date(a.deliverydate) - new Date(b.deliverydate),
          },
        },
        {
          title: "Created Date",
          dataIndex: "createddate",
          width: "10%",
          sorter: {
            compare: (a, b) =>
              new Date(a.createddate) - new Date(b.createddate),
          },
        },
        {
          title: "Priority",
          dataIndex: "priority",
          width: "10%",
          render: (text, record) => (
            <div className="actionBtn">
              <Button style={{ cursor: "default" }}>
                <Iconmoon
                  icon={record.priority ? "correct" : "wrong"}
                  size={16}
                  color={record.priority ? "#3FBD61" : "#a19f9d"}
                />
              </Button>
            </div>
          ),
          align: "center",
        },
        // {
        //   title: "Remarks",
        //   dataIndex: "remarks",
        //   width: "8%",
        //   render: (text, record) => (
        //     <div className="actionBtn">
        //       <Styled>
        //         <Tooltip
        //           placement="bottomRight"
        //           title={record.remarks}
        //           className="edit-tooltip"
        //           getPopupContainer={(triggerNode) => triggerNode}
        //         >
        //           <Button style={{ cursor: "default" }}>
        //             <Iconmoon icon="message" size={16} color="#EA655B" />
        //           </Button>
        //         </Tooltip>
        //       </Styled>
        //     </div>
        //   ),
        //   align: "center",
        // },
        {
          title: "Progress",
          dataIndex: "progress",
          width: "10%",
          render: (text, record) => {
            // if(record.item_type && record.item_type === "order"){
            if (!record.isConflictingstate) {

              if (
                record?.type.toLowerCase() === "sheet" ||
                (record?.type.toLowerCase() === "reel" &&
                  record?.quantity_type.toLowerCase() === "weight")
              ) {
                const totalProd =
                  ((record?.progressbar_info?.completed?.weight +
                    record?.progressbar_info?.in_production?.weight) /
                    (parseFloat(record.weight) -
                      record.cancelled_quantity?.weight)) *
                  100;
                const totalCompleted =
                  (record?.progressbar_info?.completed?.weight /
                    (parseFloat(record.weight) -
                      record.cancelled_quantity?.weight)) *
                  100;
                //const weightUnitKey =  ((record?.units && record?.units?.weight) ? capitalize(weightUnit[record.units.weight]?.displayName) : "T") ;
                return (
                  <div className="progressLvl">
                    <Styled>
                      <Tooltip
                        placement="bottomRight"
                        title={`${record?.progressbar_info?.completed
                            ? (record?.progressbar_info?.completed?.weight).toFixed(
                              3
                            )
                            : 0.0
                          } ${capitalize(
                            weightUnit[
                              record?.progressbar_info?.completed?.units?.weight
                            ].displayName
                          )} Weight produced
                              ${record?.progressbar_info?.in_production
                            ? (record?.progressbar_info?.in_production?.weight).toFixed(
                              3
                            )
                            : 0.0
                          } ${capitalize(
                            weightUnit[
                              record?.progressbar_info?.in_production?.units?.weight
                            ].displayName
                          )} Weight in production
                            ${record?.progressbar_info?.pending
                            ? (record?.progressbar_info?.pending?.weight).toFixed(
                              3
                            )
                            : 0.0
                          } ${capitalize(
                            weightUnit[
                              record?.progressbar_info?.pending?.units?.weight
                            ].displayName
                          )} Weight pending for deckle match`}
                        className="edit-tooltip"
                        getPopupContainer={(triggerNode) => triggerNode}
                      >
                        <Progress
                          percent={totalProd}
                          success={{
                            percent: totalCompleted,
                          }}
                          strokeColor={"#cbe2cd"}
                        />
                      </Tooltip>
                    </Styled>
                  </div>
                );
              } else {
                const production =
                  ((record?.progressbar_info?.completed?.quantity +
                    record?.progressbar_info?.in_production?.quantity) /
                    (record?.no_of_reel_sheet -
                      record.cancelled_quantity?.quantity)) *
                  100;
                const completed =
                  (record?.progressbar_info?.completed?.quantity /
                    (record?.no_of_reel_sheet -
                      record.cancelled_quantity?.quantity)) *
                  100;

                return (
                  <div className="progressLvl">
                    <Styled>
                      <Tooltip
                        placement="bottomRight"
                        title={`${record?.progressbar_info?.completed
                            ? record?.progressbar_info?.completed?.quantity
                            : 0
                          } Reels produced
                              ${record?.progressbar_info?.in_production
                            ? record?.progressbar_info?.in_production
                              ?.quantity
                            : 0
                          } Reels in production
                              ${record?.progressbar_info?.pending
                            ? record?.progressbar_info?.pending?.quantity
                            : 0
                          } Reels pending for deckle match`}
                        className="edit-tooltip"
                        getPopupContainer={(triggerNode) => triggerNode}
                      >
                        <Progress
                          percent={production}
                          success={{
                            percent: completed,
                          }}
                          strokeColor={"#cbe2cd"}
                        />
                      </Tooltip>
                    </Styled>
                  </div>
                );
              }
            }
          },
          align: "center",
        },
        {
          title: "Actions",
          dataIndex: "action",
          width: "10%",
          render: (text, record) => (
            <div className="actionBtn">
              {userDetails.roles.job_cards.edit ? (
                <Styled>
                  <Tooltip
                    placement="bottomRight"
                    title={"Edit planning details"}
                    className="edit-tooltip"
                    getPopupContainer={(triggerNode) => triggerNode}
                  >
                    <Button
                      onClick={() => {
                        handleEditAction(record);
                      }}
                    >
                      <Iconmoon icon="edit" size={16} color="#A19F9D" />
                    </Button>
                  </Tooltip>
                </Styled>
              ) : (
                <div style={{ display: "flex" }}>
                  <div style={{ width: "38px" }}></div>
                </div>
              )}
              <Styled>
                <Tooltip
                  placement="bottomRight"
                  title={"View details of this order"}
                  className="edit-tooltip"
                  getPopupContainer={(triggerNode) => triggerNode}
                >
                  <Button
                    onClick={() => {
                      handleActions(record);
                    }}
                    // disabled={!userDetails.roles.job_cards.view}
                    disabled={
                      !(
                        userDetails?.roles?.approve_jobcards.view ||
                        userDetails?.roles?.job_cards.view ||
                        userDetails?.roles?.job_cards.edit ||
                        userDetails?.role_type == "ADMIN" ||
                        userDetails?.role_type == "SUPER_ADMIN"
                      )
                    }
                  >
                    <Iconmoon icon="file-view" size={16} color="#A19F9D" />
                  </Button>
                </Tooltip>
              </Styled>
            </div>
          ),
          align: "center",
        },
      ];
      setPageLoaded(true);
    }
  }, [tableData, pageLoaded]);

  useEffect(() => {
    if (tableRerender) {
      // columnsHead.current = [
      //   {
      //     title: "Po/So.No",
      //     dataIndex: "pono",
      //     width: "11.5%",
      //     fixed: "left",
      //     key: "pono",
      //     align: "left",
      //     sorter: () => {},
      //     // sorter: (a, b, sortOrder) => a.pono.localeCompare(b.pono),
      //     render: (text, record) => (
      //       <div className="">
      //         <Button
      //           style={{ background: "transparent" }}
      //           className="textTypeBtn textBtnIcon"
      //           onClick={() => handlePo(record)}
      //         >
      //           {`#${record.pono}`}
      //         </Button>
      //       </div>
      //     ),
      //   },
      //   {
      //     title: "Order No",
      //     dataIndex: "orderno",
      //     width: "6.6%",
      //     fixed: "left",
      //     sorter: () => {},
      //     render: (text, record) => (
      //       <div className="actionBtn2">
      //         {text != "-" ? (
      //           <Button
      //             style={{ background: "transparent" }}
      //             className="textTypeBtn textBtnIcon"
      //             onClick={() => handleOrder(record)}
      //           >
      //             {`${text}`}
      //           </Button>
      //         ) : (
      //           <span style={{ textAlign: "center" }}>{text}</span>
      //         )}
      //       </div>
      //     ),
      //   },
      //   {
      //     title: "PO Date",
      //     dataIndex: "podate",
      //     width: "8%",
      //     sorter: {
      //       compare: (a, b) => new Date(a.podate) - new Date(b.podate),
      //     },
      //   },
      //   {
      //     title: "Customer",
      //     dataIndex: "customer_alias",
      //     width: "8%",
      //     align: "left",
      //     render: (text, record) => (
      //       <div className="actionBtn2">
      //         <Styled>
      //           <Tooltip
      //             placement="bottomRight"
      //             title={`${record.customercode}-${record.customerName}`}
      //             className="edit-tooltip"
      //             getPopupContainer={(triggerNode) => triggerNode}
      //           >
      //             {record?.customer_alias||'-'}
      //           </Tooltip>
      //         </Styled>
      //       </div>
      //     ),
      //   },
      //   {
      //     title: "Consignee",
      //     dataIndex: "consignee_alias",
      //     width: "8%",
      //     align: "left",
      //     render: (text, record) => (
      //       <div className="actionBtn2">
      //         <Styled>
      //           <Tooltip
      //             placement="bottomRight"
      //             title={`${record.consignee}-${record.consignee_name}`}
      //             className="edit-tooltip"
      //             getPopupContainer={(triggerNode) => triggerNode}
      //           >
      //             {record?.consignee_alias||'-'}
      //           </Tooltip>
      //         </Styled>
      //       </div>
      //     ),
      //   },
      //   {
      //     title: (
      //       <div>
      //         Product
      //         <Styled style={{ display: "inline-flex" }}>
      //           <Tooltip
      //             placement="bottomRight"
      //             title={
      //               "The product specification is in the format of Grade/GSM/BF/Quality/Moisture"
      //             }
      //             className="edit-tooltip"
      //             getPopupContainer={(triggerNode) => triggerNode}
      //           >
      //             <span className="infoIcon"></span>
      //           </Tooltip>
      //         </Styled>
      //       </div>
      //     ),
      //     // dataIndex: "productcode",
      //     width: "10.8%",
      //     render: (text, record) => {
      //       return (
      //         <Styled>
      //           {" "}
      //           <span style={{ fontSize: "10px" }}>{record.productspec} </span>
      //           <br />
      //           <span style={{ textAlign: "center" }}>
      //             {record.productcode}
      //           </span>
      //         </Styled>
      //       );
      //     },
      //   },
      //   {
      //     title: "Size(WxL)",
      //     dataIndex: "size",
      //     width: "8%",
      //   },
      //   {
      //     title: "Order Qty",
      //     dataIndex: "quantityValue",
      //     width: "7.4%",
      //     render: (text, record) => (
      //       <Styled>
      //         {" "}
      //         {record.type.toLowerCase() == "sheet" &&
      //         record.quantity_type.toLowerCase() == "reel_sheet" ? (
      //           <>
      //             <span style={{ textAlign: "center", fontSize: "12px" }}>{text}</span>
      //             <br /> <span> {record.no_of_reel_sheet + " Sheets"} </span>
      //           </>
      //         ) : (
      //           `${text} `
      //         )}
      //       </Styled>
      //     ),
      //   },
      //   {
      //     title: "Processed Qty",
      //     dataIndex: "processQuantity",
      //     width: "7.4%",
      //   },
      //   {
      //     title: "Pending Qty",
      //     dataIndex: "pendingQuant",
      //     width: "7.4%",
      //     render: (text, record) =>
      //     <Styled>
      //       {" "}
      //       { record.type.toLowerCase() == "sheet" && record.quantity_type.toLowerCase() == "reel_sheet" ?
      //       <><span style={{textAlign:"center", fontSize: "12px"}}>{text}</span><br/> <span> {record.total_pending_quantity.quantity + ' Sheets'} </span>
      //         </> : `${text} `}
      //     </Styled>
      //   },
      //   {
      //     title: "Qty to be planned",
      //     dataIndex: "plannedQuant",
      //     width: "14%",
      //     render: (text, record, index) => (
      //       <div
      //         className="actionBtn"
      //         style={{
      //           marginTop:
      //             isEditClicked?.[record.orderno] &&
      //             isEditClicked?.[record.orderno].isEditable
      //               ? "10px"
      //               : "5px",
      //           justifyContent: "left",
      //         }}
      //       >
      //         {(!isEditClicked?.[record.orderno] ||
      //           (isEditClicked?.[record.orderno] &&
      //             !isEditClicked?.[record.orderno].isEditable)) && (
      //           <Col span={12}>
      //             {" "}
      //             {text} {record.plannedUnit}{" "}
      //           </Col>
      //         )}
      //         {(!isEditClicked?.[record.orderno] ||
      //           (isEditClicked?.[record.orderno] &&
      //             !isEditClicked?.[record.orderno].isEditable &&
      //             userDetails?.roles?.job_cards.edit)) && (
      //           <Col span={12}>
      //             <Styled style={{ marginTop: "-7px" }}>
      //               <Tooltip
      //                 placement="bottomRight"
      //                 title={"Edit planned quantity"}
      //                 className="edit-tooltip"
      //                 getPopupContainer={(triggerNode) => triggerNode}
      //               >
      //                 <Button
      //                   onClick={() => {
      //                     handleEditColumn(
      //                       index,
      //                       record,
      //                       true,
      //                       "complete_order"
      //                     );
      //                   }}
      //                 >
      //                   <Iconmoon icon="edit" size={16} color="#A19F9D" />
      //                 </Button>
      //               </Tooltip>
      //             </Styled>
      //           </Col>
      //         )}
      //         {isEditClicked?.[record.orderno] &&
      //           isEditClicked?.[record.orderno].isEditable && (
      //             <DetailFields style={{ paddingBottom: "0px" }}>
      //               <Styled>
      //                 <HaberForm>
      //                   {/* <Form
      //                 id="plannedQntyForm"
      //                 form={plannedQntyForm}
      //                 name="basic"
      //                 autoComplete="off"
      //                 className="qtyToBePlannedInput"
      //                 onFinish={onFinish}
      //               > */}
      //                   <Row className="centerAlign justifyCSBetween">
      //                     <Col span={14} style={{ paddingRight: "5px" }}>
      //                       <div className="boxFormType">
      //                         <Form.Item
      //                           name={`plannedQuanty${record?.orderno}`}
      //                           rules={[
      //                             {
      //                               required: true,
      //                               message: "This field is required.",
      //                             },
      //                             {
      //                               pattern: new RegExp(
      //                                 /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
      //                               ),
      //                               message:
      //                                 "This value should be a non-zero positive value.",
      //                             },
      //                             {
      //                               validator(_, value) {
      //                                 if (
      //                                   record.pendingQuant &&
      //                                   record.pendingQuant?.split(" ")[0] &&
      //                                   parseFloat(value) > 0
      //                                 ) {
      //                                   if (
      //                                     parseFloat(
      //                                       onValitdateQtyChange(
      //                                         value,
      //                                         record,
      //                                         index
      //                                       )
      //                                     ) <=
      //                                     parseFloat(
      //                                       record.pendingQuant?.split(" ")[0]
      //                                     )
      //                                   ) {
      //                                     return Promise.resolve();
      //                                   } else {
      //                                     // return Promise.reject(
      //                                     //   (record?.quantity_type == 'reel_sheet' && record?.type == "Sheet") ?
      //                                     //  `The weight of ${value} sheets (${parseFloat(onValitdateQtyChange(value, record, index))} ${capitalize(weightUnit[record.total_pending_quantity.units.weight]?.displayName)}), can't be more than pending quantity.` : "Quantity to be planned can't be more than the pending quantity."
      //                                     // );
      //                                     return Promise.reject(
      //                                       "Quantity to be planned can't be more than the pending quantity."
      //                                     );
      //                                   }
      //                                 } else {
      //                                   return Promise.reject("");
      //                                 }
      //                               },
      //                             },
      //                           ]}
      //                           className="dBlock"
      //                           initialValue={text}
      //                         >
      //                           <Input
      //                             onChange={(e) => {
      //                               onPlannedQuntyChange(
      //                                 e,
      //                                 record,
      //                                 index,
      //                                 "complete_order"
      //                               );
      //                             }}
      //                           />
      //                         </Form.Item>
      //                         <span
      //                           className="nonEditable"
      //                           style={{
      //                             marginTop: "3px",
      //                             right: "10px",
      //                             fontSize: "11px",
      //                           }}
      //                         >
      //                           {record.plannedUnit}
      //                         </span>
      //                       </div>
      //                     </Col>
      //                     <Col
      //                       span={10}
      //                       style={{ paddingRight: "5px", marginTop: "0px" }}
      //                     >
      //                       <div
      //                         className="boxFormType"
      //                         style={{ marginBottom: "0", marginTop: "7px" }}
      //                       >
      //                         {(!plannedQuantityErr?.[record.orderno] ||
      //                           (plannedQuantityErr?.[record.orderno] &&
      //                             !plannedQuantityErr?.[record.orderno]
      //                               .error)) && (
      //                           <Tooltip title={"Save the entered value"}>
      //                             <Button
      //                               key="1"
      //                               className="edit-btn"
      //                               style={{
      //                                 padding: "0px",
      //                                 margin: "0px",
      //                                 width: "28px",
      //                                 border: "none",
      //                                 display: "inline-block",
      //                                 marginRight: "10px",
      //                               }}
      //                               onClick={() =>
      //                                 onActionChange(
      //                                   index,
      //                                   "save",
      //                                   record,
      //                                   "complete_order"
      //                                 )
      //                               }
      //                             >
      //                               <Iconmoon
      //                                 icon="check"
      //                                 size={18}
      //                                 color="#3FBD61"
      //                               />
      //                             </Button>
      //                           </Tooltip>
      //                         )}

      //                         <Tooltip title={"Remove the entered value"}>
      //                           <Button
      //                             key="2"
      //                             className="edit-btn"
      //                             style={{
      //                               padding: "0px",
      //                               margin: "0px",
      //                               width: "28px",
      //                               border: "none",
      //                               display: "inline-block",
      //                             }}
      //                             onClick={() =>
      //                               onActionChange(
      //                                 index,
      //                                 "remove",
      //                                 record,
      //                                 "complete_order"
      //                               )
      //                             }
      //                           >
      //                             <Iconmoon
      //                               icon="cancel"
      //                               size={18}
      //                               color="red"
      //                             />
      //                           </Button>
      //                         </Tooltip>
      //                       </div>
      //                     </Col>
      //                   </Row>
      //                   {/* </Form> */}
      //                 </HaberForm>
      //               </Styled>
      //             </DetailFields>
      //           )}
      //       </div>
      //     ),
      //   },
      //   {
      //     title: "Reel OD for Rewinding",
      //     dataIndex: "reelod",
      //     width: "10%",
      //     render: (text, record, index) => (
      //       <Styled>
      //         <div style={{ display: "flex" }}>
      //           {record.id_od_type == "range" && (
      //             <div
      //               style={{
      //                 color: "var(--para-text)",
      //                 display: "flex",
      //                 width: "70%",
      //                 alignSelf: "center",
      //               }}
      //             >
      //               {record.minimum_reel_od && record.maximum_reel_od
      //                 ? record.minimum_reel_od +
      //                   "-" +
      //                   record.maximum_reel_od +
      //                   " " +
      //                   (record.units.maximum_reel_od
      //                     ? lengthUnit[record.units.maximum_reel_od].displayName
      //                     : "")
      //                 : ""}
      //             </div>
      //           )}
      //           {record.id_od_type == "constant" && (
      //             <div
      //               style={{
      //                 display: "flex",
      //                 width: "70%",
      //                 flexDirection: "column",
      //                 alignSelf: "center",
      //               }}
      //             >
      //               {record?.reelod &&
      //                 record?.reelod?.map((item, index) => {
      //                   return (
      //                     index < 2 && (
      //                       <div>
      //                         {item}{" "}
      //                         {index == 1
      //                           ? "...,"
      //                           : record?.reelod?.length > 1
      //                           ? ","
      //                           : ""}
      //                       </div>
      //                     )
      //                   );
      //                 })}

      //               {record?.reelod &&
      //                 record?.reelod?.length >= 2 &&
      //                 record?.reelod?.map((item, index) => {
      //                   let tooltipData = "";
      //                   for (
      //                     let index = 2;
      //                     index < record.reelod?.length;
      //                     index++
      //                   ) {
      //                     const data = record.reelod[index];
      //                     tooltipData = tooltipData + data + ", ";
      //                   }
      //                   tooltipData = tooltipData.substring(
      //                     0,
      //                     tooltipData.length - 1
      //                   );
      //                   return (
      //                     index == 2 && (
      //                       <Tooltip title={tooltipData}>
      //                         {" "}
      //                         <span
      //                           style={{
      //                             display: "flex",
      //                             fontSize: "10px",
      //                             fontWeight: "bold",
      //                           }}
      //                         >
      //                           & {record?.reelod?.length - 2} More
      //                         </span>
      //                       </Tooltip>
      //                     )
      //                   );
      //                 })}
      //             </div>
      //           )}
      //           <div style={{ display: "flex", width: "30%" }}>
      //             <div className="actionBtn">
      //               {" "}
      //               {userDetails?.roles?.job_cards.edit && (
      //                 <Button
      //                   onClick={() =>
      //                     showEditReelCoreModal(
      //                       record,
      //                       "reel",
      //                       index,
      //                       "complete_order"
      //                     )
      //                   }
      //                   style={{ background: "none" }}
      //                 >
      //                   <Iconmoon
      //                     icon="down"
      //                     size={30}
      //                     color="var(--para-text)"
      //                   />
      //                 </Button>
      //               )}{" "}
      //             </div>
      //           </div>
      //         </div>
      //       </Styled>
      //     ),
      //   },
      //   {
      //     title: "Core OD for Rewinding",
      //     dataIndex: "coreid",
      //     width: "10%",
      //     render: (text, record, index) => (
      //       <div className="actionBtn">
      //         <Styled>
      //           <div style={{ display: "flex" }}>
      //             {record.coreid ? (
      //               <div
      //                 style={{
      //                   color: "var(--para-text)",
      //                   display: "flex",
      //                   width: "70%",
      //                   alignSelf: "center",
      //                 }}
      //               >
      //                 {record.coreid}
      //               </div>
      //             ) : (
      //               <div
      //                 style={{
      //                   display: "flex",
      //                   width: "70%",
      //                   alignSelf: "center",
      //                   marginLeft: "36px",
      //                 }}
      //               ></div>
      //             )}

      //             <div style={{ display: "flex", width: "30%" }}>
      //               <div className="actionBtn">
      //                 {" "}
      //                 {userDetails?.roles?.job_cards.edit && (
      //                   <Button
      //                     onClick={() =>
      //                       showEditReelCoreModal(
      //                         record,
      //                         "core",
      //                         index,
      //                         "complete_order"
      //                       )
      //                     }
      //                     style={{ background: "none" }}
      //                   >
      //                     <Iconmoon
      //                       icon="down"
      //                       size={30}
      //                       color="var(--para-text)"
      //                     />
      //                   </Button>
      //                 )}{" "}
      //               </div>
      //             </div>
      //           </div>
      //         </Styled>
      //       </div>
      //     ),
      //   },
      //   {
      //     title: "Delivery Date",
      //     dataIndex: "deliverydate",
      //     width: "8%",
      //     sorter: {
      //       compare: (a, b) =>
      //         new Date(a.deliverydate) - new Date(b.deliverydate),
      //     },
      //   },
      //   {
      //     title: "Created Date",
      //     dataIndex: "createddate",
      //     width: "8%",
      //     sorter: {
      //       compare: (a, b) =>
      //         new Date(a.createddate) - new Date(b.createddate),
      //     },
      //   },
      //   {
      //     title: "Priority",
      //     dataIndex: "priority",
      //     width: "6%",
      //     render: (text, record) => (
      //       <div className="actionBtn">
      //         <Button style={{ cursor: "default" }}>
      //           <Iconmoon
      //             icon={record.priority ? "correct" : "wrong"}
      //             size={16}
      //             color={record.priority ? "#3FBD61" : "#a19f9d"}
      //           />
      //         </Button>
      //       </div>
      //     ),
      //     align: "center",
      //   },
      //   {
      //     title: "Remarks",
      //     dataIndex: "remarks",
      //     width: "6%",
      //     render: (text, record) => (
      //       <div className="actionBtn">
      //         <Styled>
      //           <Tooltip
      //             placement="bottomRight"
      //             title={record.remarks}
      //             className="edit-tooltip"
      //             getPopupContainer={(triggerNode) => triggerNode}
      //           >
      //             <Button style={{ cursor: "default" }}>
      //               <Iconmoon icon="message" size={16} color="#EA655B" />
      //             </Button>
      //           </Tooltip>
      //         </Styled>
      //       </div>
      //     ),
      //     align: "center",
      //   },
      //   {
      //     title: "Progress",
      //     dataIndex: "progress",
      //     width: "6.8%",
      //     render: (text, record) => {
      //       if (
      //         record?.type === "Sheet" ||
      //         (record?.type === "Reel" && record?.quantity_type === "weight")
      //       ) {
      //         const totalProd =
      //           ((record?.progressbar_info?.completed?.weight +
      //             record?.progressbar_info?.in_production?.weight) /
      //             parseFloat(record.weight)) *
      //           100;
      //         const totalCompleted =
      //           (record?.progressbar_info?.completed?.weight /
      //             parseFloat(record.weight)) *
      //           100;
      //         return (
      //           <div className="progressLvl">
      //             <Styled>
      //               <Tooltip
      //                 placement="bottomRight"
      //                 title={`${
      //                   record?.progressbar_info?.completed
      //                     ? (record?.progressbar_info?.completed?.weight).toFixed(
      //                         3
      //                       )
      //                     : 0.0
      //                 } ${capitalize(
      //                   weightUnit[
      //                     record?.progressbar_info?.completed?.units?.weight
      //                   ].displayName
      //                 )} Weight produced
      //                         ${
      //                           record?.progressbar_info?.in_production
      //                             ? (record?.progressbar_info?.in_production?.weight).toFixed(
      //                                 3
      //                               )
      //                             : 0.0
      //                         } ${capitalize(
      //                   weightUnit[
      //                     record?.progressbar_info?.in_production?.units?.weight
      //                   ].displayName
      //                 )} Weight in production
      //                       ${
      //                         record?.progressbar_info?.pending
      //                           ? (record?.progressbar_info?.pending?.weight).toFixed(
      //                               3
      //                             )
      //                           : 0.0
      //                       } ${capitalize(
      //                   weightUnit[
      //                     record?.progressbar_info?.pending?.units?.weight
      //                   ].displayName
      //                 )} Weight pending for deckle match`}
      //                 className="edit-tooltip"
      //                 getPopupContainer={(triggerNode) => triggerNode}
      //               >
      //                 <Progress
      //                   percent={totalProd}
      //                   success={{
      //                     percent: totalCompleted,
      //                   }}
      //                   strokeColor={"#cbe2cd"}
      //                 />
      //               </Tooltip>
      //             </Styled>
      //           </div>
      //         );
      //       } else {
      //         const production =
      //           ((record?.progressbar_info?.completed?.quantity +
      //             record?.progressbar_info?.in_production?.quantity) /
      //             record.no_of_reel_sheet) *
      //           100;
      //         const completed =
      //           (record?.progressbar_info?.completed?.quantity /
      //             record.no_of_reel_sheet) *
      //           100;
      //         return (
      //           <div className="progressLvl">
      //             <Styled>
      //               <Tooltip
      //                 placement="bottomRight"
      //                 title={`${
      //                   record?.progressbar_info?.completed
      //                     ? record?.progressbar_info?.completed?.quantity
      //                     : 0
      //                 } Reels produced
      //                         ${
      //                           record?.progressbar_info?.in_production
      //                             ? record?.progressbar_info?.in_production
      //                                 ?.quantity
      //                             : 0
      //                         } Reels in production
      //                         ${
      //                           record?.progressbar_info?.pending
      //                             ? record?.progressbar_info?.pending?.quantity
      //                             : 0
      //                         } Reels pending for deckle match`}
      //                 className="edit-tooltip"
      //                 getPopupContainer={(triggerNode) => triggerNode}
      //               >
      //                 <Progress
      //                   percent={production}
      //                   success={{
      //                     percent: completed,
      //                   }}
      //                   strokeColor={"#cbe2cd"}
      //                 />
      //               </Tooltip>
      //             </Styled>
      //           </div>
      //         );
      //       }
      //     },
      //     align: "center",
      //   },
      //   {
      //     title: "Actions",
      //     dataIndex: "action",
      //     width: "6.2%",
      //     render: (text, record) =>
      //       record.item_type === "order" ? (
      //         <div className="actionBtn" style={{ paddingRight: "20px" }}>
      //           {userDetails?.roles?.job_cards.edit ? (
      //             <Styled>
      //               <Tooltip
      //                 placement="bottomRight"
      //                 title={"Edit planning details"}
      //                 className="edit-tooltip"
      //                 getPopupContainer={(triggerNode) => triggerNode}
      //               >
      //                 <Button
      //                   onClick={() => {
      //                     handleEditAction(record);
      //                   }}
      //                 >
      //                   <Iconmoon icon="edit" size={16} color="#A19F9D" />
      //                 </Button>
      //               </Tooltip>
      //             </Styled>
      //           ) : (
      //             <div style={{ display: "flex" }}>
      //               <div style={{ width: "38px" }}></div>
      //             </div>
      //           )}
      //           {/* { ((userDetails?.roles?.approve_jobcards.view || userDetails?.roles?.job_cards.view ) &&
      //           (userDetails?.role_type == 'ADMIN' || userDetails?.role_type == 'SUPER_ADMIN')) && */}
      //           <Styled>
      //             <Tooltip
      //               placement="bottomRight"
      //               title={"View details of this order"}
      //               className="edit-tooltip"
      //               getPopupContainer={(triggerNode) => triggerNode}
      //             >
      //               <Button
      //                 onClick={() => {
      //                   handleActions(record);
      //                 }}
      //                 disabled={
      //                   !(
      //                     userDetails?.roles?.approve_jobcards.view ||
      //                     userDetails?.roles?.job_cards.view ||
      //                     userDetails?.roles?.job_cards.edit ||
      //                     userDetails?.role_type == "ADMIN" ||
      //                     userDetails?.role_type == "SUPER_ADMIN"
      //                   )
      //                 }
      //               >
      //                 <Iconmoon icon="file-view" size={16} color="#A19F9D" />
      //               </Button>
      //             </Tooltip>
      //           </Styled>
      //           {/* } */}
      //           {[
      //             "Approved",
      //             "approved",
      //             "On Hold",
      //             "on hold",
      //             "hold",
      //             "Complete",
      //             "complete",
      //           ].includes(record?.state) &&
      //           userDetails?.roles?.job_cards.edit ? (
      //             <Dropdown
      //               className="viewDropdownStyle"
      //               overlay={
      //                 <Menu>
      //                   {record.state === "approved" && (
      //                     <Menu.Item
      //                       key="1"
      //                       style={{ marginTop: "-5px", marginBottom: "-10px" }}
      //                     >
      //                       <DisabledButtonStyle>
      //                         <Button
      //                           style={{
      //                             border: "none",
      //                             background: "none",
      //                             padding: "0",
      //                             font: "inherit",
      //                             textAlign: "left",
      //                             width: "100%",
      //                           }}
      //                           onClick={() => handlePriorityAction(record)}
      //                         >
      //                           <span
      //                             style={{
      //                               color: "rgba(0, 0, 0, 0.85)",
      //                             }}
      //                           >
      //                             {record?.priority
      //                               ? "Remove Priority"
      //                               : "Prioritize this order"}
      //                           </span>
      //                         </Button>
      //                       </DisabledButtonStyle>
      //                     </Menu.Item>
      //                   )}
      //                   {(record.state == "approved" ||
      //                     record.state == "hold") && (
      //                     <Menu.Item key="2" style={{ marginBottom: "-10px" }}>
      //                       <DisabledButtonStyle>
      //                         <Button
      //                           style={{
      //                             border: "none",
      //                             background: "none",
      //                             padding: "0",
      //                             font: "inherit",
      //                             textAlign: "left",
      //                             width: "100%",
      //                           }}
      //                           onClick={() => handleViewProdDetails(record)}
      //                         >
      //                           <span
      //                             style={{
      //                               color: "rgba(0, 0, 0, 0.85)",
      //                             }}
      //                           >
      //                             View Production Details
      //                           </span>
      //                         </Button>
      //                       </DisabledButtonStyle>
      //                     </Menu.Item>
      //                   )}
      //                   <Menu.Item
      //                     key="3"
      //                     style={{ marginTop: "-5px", marginBottom: "-10px" }}
      //                   >
      //                     <DisabledButtonStyle>
      //                       <Button
      //                         onClick={() => {
      //                           onViewPODetailsHandler(record);
      //                         }}
      //                         style={{
      //                           border: "none",
      //                           background: "none",
      //                           color: "inherit",
      //                           padding: "0",
      //                           font: "inherit",
      //                           cursor: "pointer",
      //                           outline: "inherit",
      //                           textAlign: "left",
      //                         }}
      //                       >
      //                         View PO Details
      //                       </Button>{" "}
      //                     </DisabledButtonStyle>
      //                   </Menu.Item>
      //                   <Menu.Item key="4" style={{ marginBottom: "1px" }}>
      //                     <DisabledButtonStyle>
      //                       <Button
      //                         onClick={() => {
      //                           onViewChangeHandler(record);
      //                         }}
      //                         style={{
      //                           border: "none",
      //                           background: "none",
      //                           color: "inherit",
      //                           padding: "0",
      //                           font: "inherit",
      //                           cursor: "pointer",
      //                           outline: "inherit",
      //                           textAlign: "left",
      //                         }}
      //                       >
      //                         View Change History
      //                       </Button>{" "}
      //                     </DisabledButtonStyle>
      //                   </Menu.Item>
      //                 </Menu>
      //               }
      //               placement="bottom"
      //               arrow
      //             >
      //               <DisabledButtonStyle>
      //                 <Button>
      //                   <Iconmoon
      //                     icon="three-dot-menu"
      //                     size={16}
      //                     color="#605E5C"
      //                   />
      //                 </Button>
      //               </DisabledButtonStyle>
      //             </Dropdown>
      //           ) : (
      //             <Dropdown
      //               className="viewDropdownStyle"
      //               overlay={
      //                 <Menu>
      //                   <Menu.Item
      //                     key="1"
      //                     style={{ marginTop: "-5px", marginBottom: "-10px" }}
      //                   >
      //                     <DisabledButtonStyle>
      //                       <Button
      //                         onClick={() => {
      //                           onViewPODetailsHandler(record);
      //                         }}
      //                         style={{
      //                           border: "none",
      //                           background: "none",
      //                           color: "inherit",
      //                           padding: "0",
      //                           font: "inherit",
      //                           cursor: "pointer",
      //                           outline: "inherit",
      //                           textAlign: "left",
      //                         }}
      //                       >
      //                         View PO Details
      //                       </Button>{" "}
      //                     </DisabledButtonStyle>
      //                   </Menu.Item>
      //                   <Menu.Item key="2" style={{ marginBottom: "1px" }}>
      //                     <DisabledButtonStyle>
      //                       <Button
      //                         onClick={() => {
      //                           onViewChangeHandler(record);
      //                         }}
      //                         style={{
      //                           border: "none",
      //                           background: "none",
      //                           color: "inherit",
      //                           padding: "0",
      //                           font: "inherit",
      //                           cursor: "pointer",
      //                           outline: "inherit",
      //                           textAlign: "left",
      //                         }}
      //                       >
      //                         View Change History
      //                       </Button>{" "}
      //                     </DisabledButtonStyle>
      //                   </Menu.Item>
      //                 </Menu>
      //               }
      //               placement="bottom"
      //               arrow
      //             >
      //               <DisabledButtonStyle>
      //                 <Button>
      //                   <Iconmoon
      //                     icon="three-dot-menu"
      //                     size={16}
      //                     color="#605E5C"
      //                   />
      //                 </Button>
      //               </DisabledButtonStyle>
      //             </Dropdown>
      //           )}
      //         </div>
      //       ) : (
      //         "-"
      //       ),
      //     align: "center",
      //   },
      // ];

      // incompleteOrdersColumnsHead.current = [
      //   {
      //     title: "Po/So.No",
      //     dataIndex: "pono",
      //     width: "11.5%",
      //     fixed: "left",
      //     key: "pono",
      //     align: "left",
      //     sorter: () => {},
      //     render: (text, record) => (
      //       <div className="">
      //         <Button
      //           style={{ background: "transparent" }}
      //           className="textTypeBtn textBtnIcon"
      //           onClick={() => handlePo(record)}
      //         >
      //           {`#${record.pono}`}
      //         </Button>
      //       </div>
      //     ),
      //   },
      //   {
      //     title: "Order No",
      //     dataIndex: "orderno",
      //     width: "6.6%",
      //     fixed: "left",
      //     sorter: () => {},
      //     render: (text, record) => (
      //       <div className="actionBtn2">
      //         {text != "-" ? (
      //           <Button
      //             style={{ background: "transparent" }}
      //             className="textTypeBtn textBtnIcon"
      //             onClick={() => handleOrder(record)}
      //           >
      //             {`${text}`}
      //           </Button>
      //         ) : (
      //           <span style={{ textAlign: "center" }}>{text}</span>
      //         )}
      //       </div>
      //     ),
      //   },
      //   {
      //     title: "PO Date",
      //     dataIndex: "podate",
      //     width: "8%",
      //     fixed: "left",
      //     sorter: {
      //       compare: (a, b) => new Date(a.podate) - new Date(b.podate),
      //     },
      //   },
      //   {
      //     title: "Customer",
      //     dataIndex: "customer_alias",
      //     width: "8%",
      //     align: "left",
      //     render: (text, record) => (
      //       <div className="actionBtn2">
      //         <Styled>
      //           <Tooltip
      //             placement="bottomRight"
      //             title={`${record.customercode}-${record.customerName}`}
      //             className="edit-tooltip"
      //             getPopupContainer={(triggerNode) => triggerNode}
      //           >
      //             {record?.customer_alias||'-'}
      //           </Tooltip>
      //         </Styled>
      //       </div>
      //     ),
      //   },
      //   {
      //     title: "Consignee",
      //     dataIndex: "consignee_alias",
      //     width: "9%",
      //     align: "left",
      //     render: (text, record) => (
      //       <div className="actionBtn2">
      //         <Styled>
      //           <Tooltip
      //             placement="bottomRight"
      //             title={`${record.consignee}-${record.consignee_name}`}
      //             className="edit-tooltip"
      //             getPopupContainer={(triggerNode) => triggerNode}
      //           >
      //             {record?.consignee_alias||'-'}
      //           </Tooltip>
      //         </Styled>
      //       </div>
      //     ),
      //   },
      //   {
      //     title: (
      //       <div>
      //         Product
      //         <Styled style={{ display: "inline-flex" }}>
      //           <Tooltip
      //             placement="bottomRight"
      //             title={
      //               "The product specification is in the format of Grade/GSM/BF/Quality/Moisture"
      //             }
      //             className="edit-tooltip"
      //             getPopupContainer={(triggerNode) => triggerNode}
      //           >
      //             <span className="infoIcon"></span>
      //           </Tooltip>
      //         </Styled>
      //       </div>
      //     ),
      //     width: "10.8%",
      //     render: (text, record) => {
      //       return (
      //         <Styled>
      //           {" "}
      //           <span style={{ fontSize: "10px" }}>{record.productspec} </span>
      //           <br />
      //           <span style={{ textAlign: "center" }}>
      //             {record.productcode}
      //           </span>
      //         </Styled>
      //       );
      //     },
      //   },
      //   {
      //     title: "Size(WxL)",
      //     dataIndex: "size",
      //     width: "8%",
      //   },
      //   {
      //     title: "Order Qty",
      //     dataIndex: "quantityValue",
      //     width: "8%",
      //     render: (text, record) => (
      //       <Styled>
      //         {" "}
      //         {record.type.toLowerCase() == "sheet" &&
      //         record.quantity_type.toLowerCase() == "reel_sheet" ? (
      //           <>
      //             <span style={{ textAlign: "center", fontSize: "12px" }}>{text}</span>
      //             <br /> <span> {record.no_of_reel_sheet + " Sheets"} </span>
      //           </>
      //         ) : (
      //           `${text} `
      //         )}
      //       </Styled>
      //     ),
      //   },
      //   {
      //     title: "Processed Qty",
      //     dataIndex: "processQuantity",
      //     width: "9%",
      //   },
      //   {
      //     title: "Pending Qty",
      //     dataIndex: "pendingQuant",
      //     width: "9%",
      //     render: (text, record) =>
      //     <Styled>
      //       {" "}
      //       { record.type.toLowerCase() == "sheet" && record.quantity_type.toLowerCase() == "reel_sheet" ?
      //       <><span style={{textAlign:"center", fontSize: "12px"}}>{text}</span><br/> <span> {record.total_pending_quantity.quantity + ' Sheets'} </span>
      //         </> : `${text} `}
      //     </Styled>
      //   },
      //   {
      //     title: "Qty to be planned",
      //     dataIndex: "plannedQuant",
      //     width: "17%",
      //     key: "plannedQuant",
      //     render: (text, record, index) => (
      //       <div
      //         className="actionBtn"
      //         style={{
      //           marginTop:
      //             isEditClickedForRewinding?.[record.orderno] &&
      //             isEditClickedForRewinding?.[record.orderno].isEditable
      //               ? "10px"
      //               : "5px",
      //           justifyContent: "left",
      //         }}
      //       >
      //         {(!isEditClickedForRewinding?.[record.orderno] ||
      //           (isEditClickedForRewinding?.[record.orderno] &&
      //             !isEditClickedForRewinding?.[record.orderno].isEditable)) && (
      //           <Col span={12}>
      //             {" "}
      //             {text} {record.plannedUnit}{" "}
      //           </Col>
      //         )}
      //         {(!isEditClickedForRewinding?.[record.orderno] ||
      //           (isEditClickedForRewinding?.[record.orderno] &&
      //             !isEditClickedForRewinding?.[record.orderno].isEditable &&
      //             userDetails?.roles?.job_cards.edit)) && (
      //           <Col span={12}>
      //             <Styled style={{ marginTop: "-7px" }}>
      //               <Tooltip
      //                 placement="bottomRight"
      //                 title={"Edit planned quantity"}
      //                 className="edit-tooltip"
      //                 getPopupContainer={(triggerNode) => triggerNode}
      //               >
      //                 <Button
      //                   onClick={() => {
      //                     handleEditColumn(
      //                       index,
      //                       record,
      //                       true,
      //                       "incomplete_order"
      //                     );
      //                   }}
      //                 >
      //                   <Iconmoon icon="edit" size={16} color="#A19F9D" />
      //                 </Button>
      //               </Tooltip>
      //             </Styled>
      //           </Col>
      //         )}
      //         {isEditClickedForRewinding?.[record.orderno] &&
      //           isEditClickedForRewinding?.[record.orderno].isEditable && (
      //             <DetailFields style={{ paddingBottom: "0px" }}>
      //               <Styled>
      //                 <HaberForm>
      //                   <Row className="centerAlign justifyCSBetween">
      //                     <Col span={14} style={{ paddingRight: "5px" }}>
      //                       <div className="boxFormType">
      //                         <Form.Item
      //                           name={`plannedQtyRewindingDetails${record?.orderno}`}
      //                           rules={[
      //                             {
      //                               required: true,
      //                               message: "This field is required.",
      //                             },
      //                             {
      //                               pattern: new RegExp(
      //                                 /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
      //                               ),
      //                               message:
      //                                 "This value should be a non-zero positive value.",
      //                             },
      //                             {
      //                               validator(_, value) {
      //                                 if (
      //                                   record.pendingQuant &&
      //                                   record.pendingQuant?.split(" ")[0] &&
      //                                   parseFloat(value) > 0
      //                                 ) {
      //                                   if (
      //                                     parseFloat(
      //                                       onValitdateQtyChange(
      //                                         value,
      //                                         record,
      //                                         index
      //                                       )
      //                                     ) <=
      //                                     parseFloat(
      //                                       record.pendingQuant?.split(" ")[0]
      //                                     )
      //                                   ) {
      //                                     return Promise.resolve();
      //                                   } else {
      //                                     //   return Promise.reject((record?.quantity_type == 'reel_sheet' && record?.type == "Sheet") ?
      //                                     //    `The weight of ${value} sheets (${parseFloat(onValitdateQtyChange(value, record, index))} ${capitalize(weightUnit[record.total_pending_quantity.units.weight]?.displayName)}), can't be more than pending quantity.` : "Quantity to be planned can't be more than the pending quantity."
      //                                     // );
      //                                     return Promise.reject(
      //                                       "Quantity to be planned can't be more than the pending quantity."
      //                                     );
      //                                   }
      //                                 } else {
      //                                   return Promise.reject("");
      //                                 }
      //                               },
      //                             },
      //                           ]}
      //                           className="dBlock"
      //                           initialValue={text}
      //                         >
      //                           <Input
      //                             onChange={(e) => {
      //                               onPlannedQuntyChange(
      //                                 e,
      //                                 record,
      //                                 index,
      //                                 "incomplete_order"
      //                               );
      //                             }}
      //                           />
      //                         </Form.Item>
      //                         <span
      //                           className="nonEditable"
      //                           style={{
      //                             marginTop: "3px",
      //                             right: "10px",
      //                             fontSize: "11px",
      //                           }}
      //                         >
      //                           {record.plannedUnit}
      //                         </span>
      //                       </div>
      //                     </Col>
      //                     <Col
      //                       span={10}
      //                       style={{ paddingRight: "5px", marginTop: "0px" }}
      //                     >
      //                       <div
      //                         className="boxFormType"
      //                         style={{ marginBottom: "0", marginTop: "7px" }}
      //                       >
      //                         {(!plannedQtyRewindingDetErr?.[record.orderno] ||
      //                           (plannedQtyRewindingDetErr?.[record.orderno] &&
      //                             !plannedQtyRewindingDetErr?.[record.orderno]
      //                               .error)) && (
      //                           <Tooltip title={"Save the entered value"}>
      //                             <Button
      //                               key="1"
      //                               className="edit-btn"
      //                               style={{
      //                                 padding: "0px",
      //                                 margin: "0px",
      //                                 width: "28px",
      //                                 border: "none",
      //                                 display: "inline-block",
      //                                 marginRight: "10px",
      //                               }}
      //                               onClick={() =>
      //                                 onActionChange(
      //                                   index,
      //                                   "save",
      //                                   record,
      //                                   "incomplete_order"
      //                                 )
      //                               }
      //                             >
      //                               <Iconmoon
      //                                 icon="check"
      //                                 size={18}
      //                                 color="#3FBD61"
      //                               />
      //                             </Button>
      //                           </Tooltip>
      //                         )}

      //                         <Tooltip title={"Remove the entered value"}>
      //                           <Button
      //                             key="2"
      //                             className="edit-btn"
      //                             style={{
      //                               padding: "0px",
      //                               margin: "0px",
      //                               width: "28px",
      //                               border: "none",
      //                               display: "inline-block",
      //                             }}
      //                             onClick={() =>
      //                               onActionChange(
      //                                 index,
      //                                 "remove",
      //                                 record,
      //                                 "incomplete_order"
      //                               )
      //                             }
      //                           >
      //                             <Iconmoon
      //                               icon="cancel"
      //                               size={18}
      //                               color="red"
      //                             />
      //                           </Button>
      //                         </Tooltip>
      //                       </div>
      //                     </Col>
      //                   </Row>
      //                   {/* </Form> */}
      //                 </HaberForm>
      //               </Styled>
      //             </DetailFields>
      //           )}
      //       </div>
      //     ),
      //   },
      //   {
      //     title: "Reel OD for Rewinding",
      //     dataIndex: "reelod",
      //     width: "10%",
      //     render: (text, record, index) => (
      //       <Styled>
      //         <div style={{ display: "flex" }}>
      //           {record.id_od_type == "range" && (
      //             <div
      //               style={{
      //                 color: "var(--para-text)",
      //                 display: "flex",
      //                 width: "70%",
      //                 alignSelf: "center",
      //               }}
      //             >
      //               {record.minimum_reel_od && record.maximum_reel_od
      //                 ? record.minimum_reel_od +
      //                   "-" +
      //                   record.maximum_reel_od +
      //                   " " +
      //                   (record.units.maximum_reel_od
      //                     ? lengthUnit[record.units.maximum_reel_od].displayName
      //                     : "")
      //                 : ""}
      //             </div>
      //           )}
      //           {record.id_od_type == "constant" && (
      //             <div
      //               style={{
      //                 display: "flex",
      //                 width: "70%",
      //                 flexDirection: "column",
      //                 alignSelf: "center",
      //               }}
      //             >
      //               {record?.reelod &&
      //                 record?.reelod?.map((item, index) => {
      //                   return (
      //                     index < 2 && (
      //                       <div>
      //                         {item}{" "}
      //                         {index == 1
      //                           ? "...,"
      //                           : record?.reelod?.length > 1
      //                           ? ","
      //                           : ""}
      //                       </div>
      //                     )
      //                   );
      //                 })}

      //               {record?.reelod &&
      //                 record?.reelod?.length >= 2 &&
      //                 record?.reelod?.map((item, index) => {
      //                   let tooltipData = "";
      //                   for (
      //                     let index = 2;
      //                     index < record.reelod?.length;
      //                     index++
      //                   ) {
      //                     const data = record.reelod[index];
      //                     tooltipData = tooltipData + data + ", ";
      //                   }
      //                   tooltipData = tooltipData.substring(
      //                     0,
      //                     tooltipData.length - 1
      //                   );
      //                   return (
      //                     index == 2 && (
      //                       <Tooltip title={tooltipData}>
      //                         {" "}
      //                         <span
      //                           style={{
      //                             display: "flex",
      //                             fontSize: "10px",
      //                             fontWeight: "bold",
      //                           }}
      //                         >
      //                           & {record?.reelod?.length - 2} More
      //                         </span>
      //                       </Tooltip>
      //                     )
      //                   );
      //                 })}
      //             </div>
      //           )}
      //           <div style={{ display: "flex", width: "30%" }}>
      //             <div className="actionBtn">
      //               {" "}
      //               {userDetails?.roles?.job_cards.edit && (
      //                 <Button
      //                   onClick={() =>
      //                     showEditReelCoreModal(
      //                       record,
      //                       "reel",
      //                       index,
      //                       "incomplete_order"
      //                     )
      //                   }
      //                   style={{ background: "none" }}
      //                 >
      //                   <Iconmoon
      //                     icon="down"
      //                     size={30}
      //                     color="var(--para-text)"
      //                   />
      //                 </Button>
      //               )}{" "}
      //             </div>
      //           </div>
      //         </div>
      //       </Styled>
      //     ),
      //   },
      //   {
      //     title: "Core OD for Rewinding",
      //     dataIndex: "coreid",
      //     width: "10%",
      //     render: (text, record, index) => (
      //       <div className="actionBtn">
      //         <Styled>
      //           <div style={{ display: "flex" }}>
      //             {record.coreid ? (
      //               <div
      //                 style={{
      //                   color: "var(--para-text)",
      //                   display: "flex",
      //                   width: "70%",
      //                   alignSelf: "center",
      //                 }}
      //               >
      //                 {record.coreid}
      //               </div>
      //             ) : (
      //               <div
      //                 style={{
      //                   display: "flex",
      //                   width: "70%",
      //                   alignSelf: "center",
      //                   marginLeft: "36px",
      //                 }}
      //               ></div>
      //             )}

      //             <div style={{ display: "flex", width: "30%" }}>
      //               <div className="actionBtn">
      //                 {" "}
      //                 {userDetails?.roles?.job_cards.edit && (
      //                   <Button
      //                     onClick={() =>
      //                       showEditReelCoreModal(
      //                         record,
      //                         "core",
      //                         index,
      //                         "incomplete_order"
      //                       )
      //                     }
      //                     style={{ background: "none" }}
      //                   >
      //                     <Iconmoon
      //                       icon="down"
      //                       size={30}
      //                       color="var(--para-text)"
      //                     />
      //                   </Button>
      //                 )}{" "}
      //               </div>
      //             </div>
      //           </div>
      //         </Styled>
      //       </div>
      //     ),
      //   },
      //   {
      //     title: "Calculated Reels",
      //     dataIndex: "calculatedreels",
      //     width: "10%",
      //     render: (text, record) => `${text}`,
      //   },
      //   {
      //     title: "Planned Reels",
      //     dataIndex: "rewinderreels",
      //     width: "17%",
      //     render: (text, record, index) => (
      //       <div
      //         className="actionBtn"
      //         style={{
      //           marginTop:
      //             isEditPlannedReels?.[record.orderno] &&
      //             isEditPlannedReels?.[record.orderno].isEditable
      //               ? "10px"
      //               : "5px",
      //           justifyContent: "left",
      //         }}
      //       >
      //         {(!isEditPlannedReels?.[record.orderno] ||
      //           (isEditPlannedReels?.[record.orderno] &&
      //             !isEditPlannedReels?.[record.orderno].isEditable)) && (
      //           <Col span={12}> {text}</Col>
      //         )}
      //         {(!isEditPlannedReels?.[record.orderno] ||
      //           (isEditPlannedReels?.[record.orderno] &&
      //             !isEditPlannedReels?.[record.orderno].isEditable)) &&
      //           userDetails?.roles?.job_cards.edit && record.reelod?.length === 1 &&
      //           record.coreid && record.coreid !== "" && record.coreid !== "-" &&
      //           record.id_od_type != "range" && (record.type.toLowerCase() == "reel" || record.type.toLowerCase() == "sheet") && (
      //             <Col span={12}>
      //               <Styled style={{ marginTop: "-7px" }}>
      //                 <Tooltip
      //                   placement="bottomRight"
      //                   title={"Edit planned reels"}
      //                   className="edit-tooltip"
      //                   getPopupContainer={(triggerNode) => triggerNode}
      //                 >
      //                   <Button
      //                     onClick={() => {
      //                       handlePlannedReelsEditColumn(
      //                         index,
      //                         record,
      //                         true,
      //                         "incomplete_order"
      //                       );
      //                     }}
      //                   >
      //                     <Iconmoon icon="edit" size={16} color="#A19F9D" />
      //                   </Button>
      //                 </Tooltip>
      //               </Styled>
      //             </Col>
      //           )}
      //         {isEditPlannedReels?.[record.orderno] &&
      //           isEditPlannedReels?.[record.orderno].isEditable && (
      //             <DetailFields style={{ paddingBottom: "0px" }}>
      //               <Styled>
      //                 <HaberForm>
      //                   <Row className="centerAlign justifyCSBetween">
      //                     <Col span={14} style={{ paddingRight: "5px" }}>
      //                       <div className="boxFormType">
      //                         <Form.Item
      //                           name={`plannedReel${record?.orderno}`}
      //                           rules={[
      //                             {
      //                               required: true,
      //                               message: "This field is required.",
      //                             },
      //                             {
      //                               pattern: new RegExp(
      //                                 /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
      //                               ),
      //                               message:
      //                                 "This value should be a non-zero positive value.",
      //                             },
      //                           ]}
      //                           className="dBlock"
      //                           initialValue={text}
      //                         >
      //                           <Input
      //                             onChange={(e) => {
      //                               onPlannedReelsChange(
      //                                 e,
      //                                 record,
      //                                 index,
      //                                 "incomplete_orders"
      //                               );
      //                             }}
      //                           />
      //                         </Form.Item>
      //                         {/* <span className="nonEditable" style={{marginTop:"3px", right:"10px", fontSize:"11px"}}>{record.plannedUnit}</span> */}
      //                       </div>
      //                     </Col>
      //                     <Col
      //                       span={10}
      //                       style={{ paddingRight: "5px", marginTop: "0px" }}
      //                     >
      //                       <div
      //                         className="boxFormType"
      //                         style={{ marginBottom: "0", marginTop: "7px" }}
      //                       >
      //                         {(!plannedReelsErr?.[record.orderno] ||
      //                           (plannedReelsErr?.[record.orderno] &&
      //                             !plannedReelsErr?.[record.orderno]
      //                               .error)) && (
      //                           <Tooltip title={"Save the entered value"}>
      //                             <Button
      //                               key="1"
      //                               className="edit-btn"
      //                               style={{
      //                                 padding: "0px",
      //                                 margin: "0px",
      //                                 width: "28px",
      //                                 border: "none",
      //                                 display: "inline-block",
      //                                 marginRight: "10px",
      //                               }}
      //                               onClick={() =>
      //                                 onPlannedReelsButtonChange(
      //                                   index,
      //                                   "save",
      //                                   record,
      //                                   "incomplete_order"
      //                                 )
      //                               }
      //                             >
      //                               <Iconmoon
      //                                 icon="check"
      //                                 size={18}
      //                                 color="#3FBD61"
      //                               />
      //                             </Button>
      //                           </Tooltip>
      //                         )}

      //                         <Tooltip title={"Remove the entered value"}>
      //                           <Button
      //                             key="2"
      //                             className="edit-btn"
      //                             style={{
      //                               padding: "0px",
      //                               margin: "0px",
      //                               width: "28px",
      //                               border: "none",
      //                               display: "inline-block",
      //                             }}
      //                             onClick={() =>
      //                               onPlannedReelsButtonChange(
      //                                 index,
      //                                 "remove",
      //                                 record,
      //                                 "incomplete_order"
      //                               )
      //                             }
      //                           >
      //                             <Iconmoon
      //                               icon="cancel"
      //                               size={18}
      //                               color="red"
      //                             />
      //                           </Button>
      //                         </Tooltip>
      //                       </div>
      //                     </Col>
      //                   </Row>
      //                   {/* </Form> */}
      //                 </HaberForm>
      //               </Styled>
      //             </DetailFields>
      //           )}
      //       </div>
      //     ),
      //   },
      //   {
      //     title: "Planned Weight",
      //     dataIndex: "plannedweight",
      //     width: "10%",
      //     render: (text, record) => `${text}`,
      //   },
      //   {
      //     title: "Delivery Date",
      //     dataIndex: "deliverydate",
      //     width: "10%",
      //     sorter: {
      //       compare: (a, b) =>
      //         new Date(a.deliverydate) - new Date(b.deliverydate),
      //     },
      //   },
      //   {
      //     title: "Created Date",
      //     dataIndex: "createddate",
      //     width: "10%",
      //     sorter: {
      //       compare: (a, b) =>
      //         new Date(a.createddate) - new Date(b.createddate),
      //     },
      //   },
      //   {
      //     title: "Priority",
      //     dataIndex: "priority",
      //     width: "10%",
      //     render: (text, record) => (
      //       <div className="actionBtn">
      //         <Button style={{ cursor: "default" }}>
      //           <Iconmoon
      //             icon={record.priority ? "correct" : "wrong"}
      //             size={16}
      //             color={record.priority ? "#3FBD61" : "#a19f9d"}
      //           />
      //         </Button>
      //       </div>
      //     ),
      //     align: "center",
      //   },
      //   {
      //     title: "Remarks",
      //     dataIndex: "remarks",
      //     width: "8%",
      //     render: (text, record) => (
      //       <div className="actionBtn">
      //         <Styled>
      //           <Tooltip
      //             placement="bottomRight"
      //             title={record.remarks}
      //             className="edit-tooltip"
      //             getPopupContainer={(triggerNode) => triggerNode}
      //           >
      //             <Button style={{ cursor: "default" }}>
      //               <Iconmoon icon="message" size={16} color="#EA655B" />
      //             </Button>
      //           </Tooltip>
      //         </Styled>
      //       </div>
      //     ),
      //     align: "center",
      //   },
      //   {
      //     title: "Progress",
      //     dataIndex: "progress",
      //     width: "10%",
      //     render: (text, record) => {
      //       if (
      //         record?.type === "Sheet" ||
      //         (record?.type === "Reel" && record?.quantity_type === "weight")
      //       ) {
      //         const totalProd =
      //           ((record?.progressbar_info?.completed?.weight +
      //             record?.progressbar_info?.in_production?.weight) /
      //             parseFloat(record.weight)) *
      //           100;
      //         const totalCompleted =
      //           (record?.progressbar_info?.completed?.weight /
      //             parseFloat(record.weight)) *
      //           100;
      //         return (
      //           <div className="progressLvl">
      //             <Styled>
      //               <Tooltip
      //                 placement="bottomRight"
      //                 title={`${
      //                   record?.progressbar_info?.completed
      //                     ? (record?.progressbar_info?.completed?.weight).toFixed(
      //                         3
      //                       )
      //                     : 0.0
      //                 } ${capitalize(
      //                   weightUnit[
      //                     record?.progressbar_info?.completed?.units?.weight
      //                   ].displayName
      //                 )} Weight produced
      //                         ${
      //                           record?.progressbar_info?.in_production
      //                             ? (record?.progressbar_info?.in_production?.weight).toFixed(
      //                                 3
      //                               )
      //                             : 0.0
      //                         } ${capitalize(
      //                   weightUnit[
      //                     record?.progressbar_info?.in_production?.units?.weight
      //                   ].displayName
      //                 )} Weight in production
      //                       ${
      //                         record?.progressbar_info?.pending
      //                           ? (record?.progressbar_info?.pending?.weight).toFixed(
      //                               3
      //                             )
      //                           : 0.0
      //                       } ${capitalize(
      //                   weightUnit[
      //                     record?.progressbar_info?.pending?.units?.weight
      //                   ].displayName
      //                 )} Weight pending for deckle match`}
      //                 className="edit-tooltip"
      //                 getPopupContainer={(triggerNode) => triggerNode}
      //               >
      //                 <Progress
      //                   percent={totalProd}
      //                   success={{
      //                     percent: totalCompleted,
      //                   }}
      //                   strokeColor={"#cbe2cd"}
      //                 />
      //               </Tooltip>
      //             </Styled>
      //           </div>
      //         );
      //       } else {
      //         const production =
      //           ((record?.progressbar_info?.completed?.quantity +
      //             record?.progressbar_info?.in_production?.quantity) /
      //             record.no_of_reel_sheet) *
      //           100;
      //         const completed =
      //           (record?.progressbar_info?.completed?.quantity /
      //             record.no_of_reel_sheet) *
      //           100;
      //         return (
      //           <div className="progressLvl">
      //             <Styled>
      //               <Tooltip
      //                 placement="bottomRight"
      //                 title={`${
      //                   record?.progressbar_info?.completed
      //                     ? record?.progressbar_info?.completed?.quantity
      //                     : 0
      //                 } Reels produced
      //                         ${
      //                           record?.progressbar_info?.in_production
      //                             ? record?.progressbar_info?.in_production
      //                                 ?.quantity
      //                             : 0
      //                         } Reels in production
      //                         ${
      //                           record?.progressbar_info?.pending
      //                             ? record?.progressbar_info?.pending?.quantity
      //                             : 0
      //                         } Reels pending for deckle match`}
      //                 className="edit-tooltip"
      //                 getPopupContainer={(triggerNode) => triggerNode}
      //               >
      //                 <Progress
      //                   percent={production}
      //                   success={{
      //                     percent: completed,
      //                   }}
      //                   strokeColor={"#cbe2cd"}
      //                 />
      //               </Tooltip>
      //             </Styled>
      //           </div>
      //         );
      //       }
      //     },
      //     align: "center",
      //   },
      //   {
      //     title: "Actions",
      //     dataIndex: "action",
      //     width: "10%",
      //     render: (text, record) => (
      //       <div className="actionBtn">
      //         {userDetails.roles.job_cards.edit ? (
      //           <Styled>
      //             <Tooltip
      //               placement="bottomRight"
      //               title={"Edit planning details"}
      //               className="edit-tooltip"
      //               getPopupContainer={(triggerNode) => triggerNode}
      //             >
      //               <Button
      //                 onClick={() => {
      //                   handleEditAction(record);
      //                 }}
      //               >
      //                 <Iconmoon icon="edit" size={16} color="#A19F9D" />
      //               </Button>
      //             </Tooltip>
      //           </Styled>
      //         ) : (
      //           <div style={{ display: "flex" }}>
      //             <div style={{ width: "38px" }}></div>
      //           </div>
      //         )}
      //         <Styled>
      //           <Tooltip
      //             placement="bottomRight"
      //             title={"View details of this order"}
      //             className="edit-tooltip"
      //             getPopupContainer={(triggerNode) => triggerNode}
      //           >
      //             <Button
      //               onClick={() => {
      //                 handleActions(record);
      //               }}
      //               // disabled={!userDetails.roles.job_cards.view}
      //               disabled={
      //                 !(
      //                   userDetails?.roles?.approve_jobcards.view ||
      //                   userDetails?.roles?.job_cards.view ||
      //                   userDetails?.roles?.job_cards.edit ||
      //                   userDetails?.role_type == "ADMIN" ||
      //                   userDetails?.role_type == "SUPER_ADMIN"
      //                 )
      //               }
      //             >
      //               <Iconmoon icon="file-view" size={16} color="#A19F9D" />
      //             </Button>
      //           </Tooltip>
      //         </Styled>
      //       </div>
      //     ),
      //     align: "center",
      //   },
      // ];

      columnsHead.current = columnsHead.current.map((ele) => {
        if (ele.dataIndex == "plannedQuant") {
          ele = {
            title: "Qty to be planned",
            dataIndex: "plannedQuant",
            width: "14%",
            render: (text, record, index) => (
              <div
                className="actionBtn"
                style={{
                  marginTop:
                    isEditClicked?.[record.orderno] &&
                      isEditClicked?.[record.orderno].isEditable
                      ? "10px"
                      : "5px",
                  justifyContent: "left",
                }}
              >
                {(!isEditClicked?.[record.orderno] ||
                  (isEditClicked?.[record.orderno] &&
                    !isEditClicked?.[record.orderno].isEditable)) && (
                    <Col span={12}>
                      {" "}
                      {text} {record.plannedUnit}{" "}
                    </Col>
                  )}
                {(!isEditClicked?.[record.orderno] ||
                  (isEditClicked?.[record.orderno] &&
                    !isEditClicked?.[record.orderno].isEditable &&
                    userDetails?.roles?.job_cards.edit)) && (
                    <Col span={12}>
                      <Styled style={{ marginTop: "-7px" }}>
                        <Tooltip
                          placement="bottomRight"
                          title={"Edit planned quantity"}
                          className="edit-tooltip"
                          getPopupContainer={(triggerNode) => triggerNode}
                        >
                          <Button
                            onClick={() => {
                              handleEditColumn(
                                index,
                                record,
                                true,
                                "complete_order"
                              );
                            }}
                          >
                            <Iconmoon icon="edit" size={16} color="#A19F9D" />
                          </Button>
                        </Tooltip>
                      </Styled>
                    </Col>
                  )}
                {isEditClicked?.[record.orderno] &&
                  isEditClicked?.[record.orderno].isEditable && (
                    <DetailFields style={{ paddingBottom: "0px" }}>
                      <Styled>
                        <HaberForm>
                          {/* <Form
                        id="plannedQntyForm"
                        form={plannedQntyForm}
                        name="basic"
                        autoComplete="off"
                        className="qtyToBePlannedInput"
                        onFinish={onFinish}
                      > */}
                          <Row className="centerAlign justifyCSBetween">
                            <Col span={14} style={{ paddingRight: "5px" }}>
                              <div className="boxFormType">
                                <Form.Item
                                  name={`plannedQuanty${record?.orderno}`}
                                  rules={[
                                    {
                                      required: true,
                                      message: "This field is required.",
                                    },
                                    {
                                      pattern: new RegExp((record?.quantity_type == "reel_sheet") ? /^[1-9][0-9]*$/ : /^(?!0+(\.0+)?$)\d+(\.\d+)?$/),
                                      message:
                                        `This value should be a non-zero Positive ${(record?.quantity_type == "reel_sheet") ? "Integer" : ""} value.`,
                                    },
                                    {
                                      validator(_, value) {
                                        if (
                                          record.pendingQuant &&
                                          record.pendingQuant?.split(" ")[0] &&
                                          parseFloat(value) > 0
                                        ) {
                                          if (
                                            parseFloat(
                                              onValitdateQtyChange(
                                                value,
                                                record,
                                                index
                                              )
                                            ) <=
                                            parseFloat(
                                              record.pendingQuant?.split(" ")[0]
                                            )
                                          ) {
                                            return Promise.resolve();
                                          } else {
                                            //   return Promise.reject((record?.quantity_type == 'reel_sheet' && record?.type == "Sheet") ?
                                            //     `The weight of ${value} sheets (${parseFloat(onValitdateQtyChange(value, record, index))} ${capitalize(weightUnit[record.total_pending_quantity.units.weight]?.displayName)}), can't be more than pending quantity.` : "Quantity to be planned can't be more than the pending quantity."
                                            // );
                                            return Promise.reject(
                                              "Quantity to be planned can't be more than the pending quantity."
                                            );
                                          }
                                        } else {
                                          return Promise.reject("");
                                        }
                                      },
                                    },
                                  ]}
                                  className="dBlock"
                                  initialValue={text}
                                >
                                  <Input
                                    onChange={(e) => {
                                      onPlannedQuntyChange(
                                        e,
                                        record,
                                        index,
                                        "complete_order"
                                      );
                                    }}
                                  />
                                </Form.Item>
                                <span
                                  className="nonEditable"
                                  style={{
                                    marginTop: "3px",
                                    right: "10px",
                                    fontSize: "11px",
                                  }}
                                >
                                  {record.plannedUnit}
                                </span>
                              </div>
                            </Col>
                            <Col
                              span={10}
                              style={{ paddingRight: "5px", marginTop: "0px" }}
                            >
                              <div
                                className="boxFormType"
                                style={{ marginBottom: "0", marginTop: "7px" }}
                              >
                                {(!plannedQuantityErr?.[record.orderno] ||
                                  (plannedQuantityErr?.[record.orderno] &&
                                    !plannedQuantityErr?.[record.orderno]
                                      .error)) && (
                                    <Tooltip title={"Save the entered value"}>
                                      <Button
                                        key="1"
                                        className="edit-btn"
                                        style={{
                                          padding: "0px",
                                          margin: "0px",
                                          width: "28px",
                                          border: "none",
                                          display: "inline-block",
                                          marginRight: "10px",
                                        }}
                                        onClick={() =>
                                          onActionChange(
                                            index,
                                            "save",
                                            record,
                                            "complete_order"
                                          )
                                        }
                                      >
                                        <Iconmoon
                                          icon="check"
                                          size={18}
                                          color="#3FBD61"
                                        />
                                      </Button>
                                    </Tooltip>
                                  )}

                                <Tooltip title={"Remove the entered value"}>
                                  <Button
                                    key="2"
                                    className="edit-btn"
                                    style={{
                                      padding: "0px",
                                      margin: "0px",
                                      width: "28px",
                                      border: "none",
                                      display: "inline-block",
                                    }}
                                    onClick={() =>
                                      onActionChange(
                                        index,
                                        "remove",
                                        record,
                                        "complete_order"
                                      )
                                    }
                                  >
                                    <Iconmoon
                                      icon="cancel"
                                      size={18}
                                      color="red"
                                    />
                                  </Button>
                                </Tooltip>
                              </div>
                            </Col>
                          </Row>
                          {/* </Form> */}
                        </HaberForm>
                      </Styled>
                    </DetailFields>
                  )}
              </div>
            ),
          };
        } else if (ele.dataIndex == "reelod") {
          ele = {
            title: "Reel OD for Rewinding",
            dataIndex: "reelod",
            width: "10%",
            render: (text, record, index) => (
              <Styled>
                <div style={{ display: "flex" }}>
                  {record.id_od_type == "range" && (
                    <div
                      style={{
                        color: "var(--para-text)",
                        display: "flex",
                        width: "70%",
                        alignSelf: "center",
                      }}
                    >
                      {record.minimum_reel_od && record.maximum_reel_od
                        ? record.minimum_reel_od +
                        "-" +
                        record.maximum_reel_od +
                        " " +
                        (record.units.maximum_reel_od
                          ? lengthUnit[record.units.maximum_reel_od]
                            .displayName
                          : "")
                        : ""}
                    </div>
                  )}
                  {record.id_od_type == "constant" && (
                    <div
                      style={{
                        display: "flex",
                        width: "70%",
                        flexDirection: "column",
                        alignSelf: "center",
                      }}
                    >
                      {record?.reelod &&
                        record?.reelod?.map((item, index) => {
                          return (
                            index < 2 && (
                              <div>
                                {item}{" "}
                                {index == 1
                                  ? "...,"
                                  : record?.reelod?.length > 1
                                    ? ","
                                    : ""}
                              </div>
                            )
                          );
                        })}

                      {record?.reelod &&
                        record?.reelod?.length >= 2 &&
                        record?.reelod?.map((item, index) => {
                          let tooltipData = "";
                          for (
                            let index = 2;
                            index < record.reelod?.length;
                            index++
                          ) {
                            const data = record.reelod[index];
                            tooltipData = tooltipData + data + ", ";
                          }
                          tooltipData = tooltipData.substring(
                            0,
                            tooltipData.length - 1
                          );
                          return (
                            index == 2 && (
                              <Tooltip title={tooltipData}>
                                {" "}
                                <span
                                  style={{
                                    display: "flex",
                                    fontSize: "10px",
                                    fontWeight: "bold",
                                  }}
                                >
                                  & {record?.reelod?.length - 2} More
                                </span>
                              </Tooltip>
                            )
                          );
                        })}
                    </div>
                  )}
                  <div style={{ display: "flex", width: "30%" }}>
                    <div className="actionBtn">
                      {" "}
                      {userDetails?.roles?.job_cards.edit && (
                        <Button
                          onClick={() =>
                            showEditReelCoreModal(
                              record,
                              "reel",
                              index,
                              "complete_order"
                            )
                          }
                          style={{ background: "none" }}
                        >
                          <Iconmoon
                            icon="down"
                            size={30}
                            color="var(--para-text)"
                          />
                        </Button>
                      )}{" "}
                    </div>
                  </div>
                </div>
              </Styled>
            ),
          };
        } else if (ele.dataIndex == "coreid") {
          ele = {
            title: "Core OD for Rewinding",
            dataIndex: "coreid",
            width: "10%",
            render: (text, record, index) => (
              <div className="actionBtn">
                <Styled>
                  <div style={{ display: "flex" }}>
                    {record.coreid ? (
                      <div
                        style={{
                          color: "var(--para-text)",
                          display: "flex",
                          width: "70%",
                          alignSelf: "center",
                        }}
                      >
                        {record.coreid}
                      </div>
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          width: "70%",
                          alignSelf: "center",
                          marginLeft: "36px",
                        }}
                      ></div>
                    )}

                    <div style={{ display: "flex", width: "30%" }}>
                      <div className="actionBtn">
                        {" "}
                        {userDetails?.roles?.job_cards.edit && (
                          <Button
                            onClick={() =>
                              showEditReelCoreModal(
                                record,
                                "core",
                                index,
                                "complete_order"
                              )
                            }
                            style={{ background: "none" }}
                          >
                            <Iconmoon
                              icon="down"
                              size={30}
                              color="var(--para-text)"
                            />
                          </Button>
                        )}{" "}
                      </div>
                    </div>
                  </div>
                </Styled>
              </div>
            ),
          };
        } else if (ele.dataIndex == "grain") {
          ele = {
            title: "Grain",
            dataIndex: "grain",
            width: "8%",
            render: (text, record, index) => (
              <Styled>
                {record.type.toLowerCase() == "sheet" ? (
                  <div style={{ display: "flex" }}>
                    <Row className="centerAlign">
                      <div className="boxFormType">
                        <SelectStyle>
                          <Form.Item
                            name={`grain${record.orderno}`}
                            rules={[
                              {
                                required: true,
                                message: "This field is required",
                              },
                            ]}
                            className="selectForm"
                            style={{ marginBottom: 4 }}
                            initialValue={
                              record.grain
                                ? record.grain == "short"
                                  ? "Short"
                                  : "Long"
                                : null
                            }
                          >
                            <Select
                              placeholder={"Select"}
                              suffixIcon={<DownArrowDraw />}
                              onChange={(e) =>
                                onGrainChange(
                                  e,
                                  record,
                                  index,
                                  "complete_order"
                                )
                              }
                            >
                              {grainTypeData.map((grainType) => (
                                <Option key={grainType}>{grainType}</Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </SelectStyle>
                      </div>
                    </Row>
                  </div>
                ) : (
                  ""
                )}
              </Styled>
            ),
          };
        }
        return ele;
      });

      incompleteOrdersColumnsHead.current =
        incompleteOrdersColumnsHead.current.map((item) => {
          if (item.dataIndex === "plannedQuant") {
            item = {
              title: "Qty to be planned",
              dataIndex: "plannedQuant",
              width: "17%",
              key: "plannedQuant",
              render: (text, record, index) => (
                <div
                  className="actionBtn"
                  style={{
                    marginTop:
                      isEditClickedForRewinding?.[record.orderno] &&
                        isEditClickedForRewinding?.[record.orderno].isEditable
                        ? "10px"
                        : "5px",
                    justifyContent: "left",
                  }}
                >
                  {(!isEditClickedForRewinding?.[record.orderno] ||
                    (isEditClickedForRewinding?.[record.orderno] &&
                      !isEditClickedForRewinding?.[record.orderno]
                        .isEditable)) && (
                      <Col span={12}>
                        {" "}
                        {text} {record.plannedUnit}{" "}
                      </Col>
                    )}
                  {(!isEditClickedForRewinding?.[record.orderno] ||
                    (isEditClickedForRewinding?.[record.orderno] &&
                      !isEditClickedForRewinding?.[record.orderno].isEditable &&
                      userDetails?.roles?.job_cards.edit)) && (
                      <Col span={12}>
                        <Styled style={{ marginTop: "-7px" }}>
                          <Tooltip
                            placement="bottomRight"
                            title={"Edit planned quantity"}
                            className="edit-tooltip"
                            getPopupContainer={(triggerNode) => triggerNode}
                          >
                            <Button
                              onClick={() => {
                                handleEditColumn(
                                  index,
                                  record,
                                  true,
                                  "incomplete_order"
                                );
                              }}
                            >
                              <Iconmoon icon="edit" size={16} color="#A19F9D" />
                            </Button>
                          </Tooltip>
                        </Styled>
                      </Col>
                    )}
                  {isEditClickedForRewinding?.[record.orderno] &&
                    isEditClickedForRewinding?.[record.orderno].isEditable && (
                      <DetailFields style={{ paddingBottom: "0px" }}>
                        <Styled>
                          <HaberForm>
                            <Row className="centerAlign justifyCSBetween">
                              <Col span={14} style={{ paddingRight: "5px" }}>
                                <div className="boxFormType">
                                  <Form.Item
                                    name={`plannedQtyRewindingDetails${record?.orderno}`}
                                    rules={[
                                      {
                                        required: true,
                                        message: "This field is required.",
                                      },
                                      {
                                        pattern: new RegExp(
                                          /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
                                        ),
                                        message:
                                          "This value should be a non-zero positive value.",
                                      },
                                      {
                                        validator(_, value) {
                                          if (
                                            record.pendingQuant &&
                                            record.pendingQuant?.split(
                                              " "
                                            )[0] &&
                                            parseFloat(value) > 0
                                          ) {
                                            if (
                                              parseFloat(
                                                onValitdateQtyChange(
                                                  value,
                                                  record,
                                                  index
                                                )
                                              ) <=
                                              parseFloat(
                                                record.pendingQuant?.split(
                                                  " "
                                                )[0]
                                              )
                                            ) {
                                              return Promise.resolve();
                                            } else {
                                              //   return Promise.reject((record?.quantity_type == 'reel_sheet' && record?.type == "Sheet") ?
                                              //    `The weight of ${value} sheets (${parseFloat(onValitdateQtyChange(value, record, index))} ${capitalize(weightUnit[record.total_pending_quantity.units.weight]?.displayName)}), can't be more than pending quantity.` : "Quantity to be planned can't be more than the pending quantity."
                                              // );
                                              return Promise.reject(
                                                "Quantity to be planned can't be more than the pending quantity."
                                              );
                                            }
                                          } else {
                                            return Promise.reject("");
                                          }
                                        },
                                      },
                                    ]}
                                    className="dBlock"
                                    initialValue={text}
                                  >
                                    <Input
                                      onChange={(e) => {
                                        onPlannedQuntyChange(
                                          e,
                                          record,
                                          index,
                                          "incomplete_order"
                                        );
                                      }}
                                    />
                                  </Form.Item>
                                  <span
                                    className="nonEditable"
                                    style={{
                                      marginTop: "3px",
                                      right: "10px",
                                      fontSize: "11px",
                                    }}
                                  >
                                    {record.plannedUnit}
                                  </span>
                                </div>
                              </Col>
                              <Col
                                span={10}
                                style={{
                                  paddingRight: "5px",
                                  marginTop: "0px",
                                }}
                              >
                                <div
                                  className="boxFormType"
                                  style={{
                                    marginBottom: "0",
                                    marginTop: "7px",
                                  }}
                                >
                                  {(!plannedQtyRewindingDetErr?.[
                                    record.orderno
                                  ] ||
                                    (plannedQtyRewindingDetErr?.[
                                      record.orderno
                                    ] &&
                                      !plannedQtyRewindingDetErr?.[
                                        record.orderno
                                      ].error)) && (
                                      <Tooltip title={"Save the entered value"}>
                                        <Button
                                          key="1"
                                          className="edit-btn"
                                          style={{
                                            padding: "0px",
                                            margin: "0px",
                                            width: "28px",
                                            border: "none",
                                            display: "inline-block",
                                            marginRight: "10px",
                                          }}
                                          onClick={() =>
                                            onActionChange(
                                              index,
                                              "save",
                                              record,
                                              "incomplete_order"
                                            )
                                          }
                                        >
                                          <Iconmoon
                                            icon="check"
                                            size={18}
                                            color="#3FBD61"
                                          />
                                        </Button>
                                      </Tooltip>
                                    )}

                                  <Tooltip title={"Remove the entered value"}>
                                    <Button
                                      key="2"
                                      className="edit-btn"
                                      style={{
                                        padding: "0px",
                                        margin: "0px",
                                        width: "28px",
                                        border: "none",
                                        display: "inline-block",
                                      }}
                                      onClick={() =>
                                        onActionChange(
                                          index,
                                          "remove",
                                          record,
                                          "incomplete_order"
                                        )
                                      }
                                    >
                                      <Iconmoon
                                        icon="cancel"
                                        size={18}
                                        color="red"
                                      />
                                    </Button>
                                  </Tooltip>
                                </div>
                              </Col>
                            </Row>
                            {/* </Form> */}
                          </HaberForm>
                        </Styled>
                      </DetailFields>
                    )}
                </div>
              ),
            };
          } else if (item.dataIndex === "reelod") {
            item = {
              title: "Reel OD for Rewinding",
              dataIndex: "reelod",
              width: "10%",
              render: (text, record, index) => (
                <Styled>
                  <div style={{ display: "flex" }}>
                    {record.id_od_type == "range" && (
                      <div
                        style={{
                          color: "var(--para-text)",
                          display: "flex",
                          width: "70%",
                          alignSelf: "center",
                        }}
                      >
                        {record.minimum_reel_od && record.maximum_reel_od
                          ? record.minimum_reel_od +
                          "-" +
                          record.maximum_reel_od +
                          " " +
                          (record.units.maximum_reel_od
                            ? lengthUnit[record.units.maximum_reel_od]
                              .displayName
                            : "")
                          : ""}
                      </div>
                    )}
                    {record.id_od_type == "constant" && (
                      <div
                        style={{
                          display: "flex",
                          width: "70%",
                          flexDirection: "column",
                          alignSelf: "center",
                        }}
                      >
                        {record?.reelod &&
                          record?.reelod?.map((item, index) => {
                            return (
                              index < 2 && (
                                <div>
                                  {item}{" "}
                                  {index == 1
                                    ? "...,"
                                    : record?.reelod?.length > 1
                                      ? ","
                                      : ""}
                                </div>
                              )
                            );
                          })}

                        {record?.reelod &&
                          record?.reelod?.length >= 2 &&
                          record?.reelod?.map((item, index) => {
                            let tooltipData = "";
                            for (
                              let index = 2;
                              index < record.reelod?.length;
                              index++
                            ) {
                              const data = record.reelod[index];
                              tooltipData = tooltipData + data + ", ";
                            }
                            tooltipData = tooltipData.substring(
                              0,
                              tooltipData.length - 1
                            );
                            return (
                              index == 2 && (
                                <Tooltip title={tooltipData}>
                                  {" "}
                                  <span
                                    style={{
                                      display: "flex",
                                      fontSize: "10px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    & {record?.reelod?.length - 2} More
                                  </span>
                                </Tooltip>
                              )
                            );
                          })}
                      </div>
                    )}
                    <div style={{ display: "flex", width: "30%" }}>
                      <div className="actionBtn">
                        {" "}
                        {userDetails?.roles?.job_cards.edit && (
                          <Button
                            onClick={() =>
                              showEditReelCoreModal(
                                record,
                                "reel",
                                index,
                                "incomplete_order"
                              )
                            }
                            style={{ background: "none" }}
                          >
                            <Iconmoon
                              icon="down"
                              size={30}
                              color="var(--para-text)"
                            />
                          </Button>
                        )}{" "}
                      </div>
                    </div>
                  </div>
                </Styled>
              ),
            };
          } else if (item.dataIndex === "coreid") {
            item = {
              title: "Core OD for Rewinding",
              dataIndex: "coreid",
              width: "10%",
              render: (text, record, index) => (
                <div className="actionBtn">
                  <Styled>
                    <div style={{ display: "flex" }}>
                      {record.coreid ? (
                        <div
                          style={{
                            color: "var(--para-text)",
                            display: "flex",
                            width: "70%",
                            alignSelf: "center",
                          }}
                        >
                          {record.coreid}
                        </div>
                      ) : (
                        <div
                          style={{
                            display: "flex",
                            width: "70%",
                            alignSelf: "center",
                            marginLeft: "36px",
                          }}
                        ></div>
                      )}

                      <div style={{ display: "flex", width: "30%" }}>
                        <div className="actionBtn">
                          {" "}
                          {userDetails?.roles?.job_cards.edit && (
                            <Button
                              onClick={() =>
                                showEditReelCoreModal(
                                  record,
                                  "core",
                                  index,
                                  "incomplete_order"
                                )
                              }
                              style={{ background: "none" }}
                            >
                              <Iconmoon
                                icon="down"
                                size={30}
                                color="var(--para-text)"
                              />
                            </Button>
                          )}{" "}
                        </div>
                      </div>
                    </div>
                  </Styled>
                </div>
              ),
            };
          } else if (item.dataIndex === "rewinderreels") {
            item = {
              title: "Planned Reels",
              dataIndex: "rewinderreels",
              width: "17%",
              render: (text, record, index) => (
                <div
                  className="actionBtn"
                  style={{
                    marginTop:
                      isEditPlannedReels?.[record.orderno] &&
                        isEditPlannedReels?.[record.orderno].isEditable
                        ? "10px"
                        : "5px",
                    justifyContent: "left",
                  }}
                >
                  {(!isEditPlannedReels?.[record.orderno] ||
                    (isEditPlannedReels?.[record.orderno] &&
                      !isEditPlannedReels?.[record.orderno].isEditable)) && (
                      <Col span={12}> {text}</Col>
                    )}
                  {(!isEditPlannedReels?.[record.orderno] ||
                    (isEditPlannedReels?.[record.orderno] &&
                      !isEditPlannedReels?.[record.orderno].isEditable)) &&
                    userDetails?.roles?.job_cards.edit &&
                    record.reelod?.length === 1 &&
                    record.coreid &&
                    record.coreid !== "" &&
                    record.coreid !== "-" &&
                    record.id_od_type != "range" &&
                    ((record.type.toLowerCase() == "reel" &&
                      record.quantity_type == "weight") ||
                      record.type.toLowerCase() == "sheet") && (
                      <Col span={12}>
                        <Styled style={{ marginTop: "-7px" }}>
                          <Tooltip
                            placement="bottomRight"
                            title={"Edit planned reels"}
                            className="edit-tooltip"
                            getPopupContainer={(triggerNode) => triggerNode}
                          >
                            <Button
                              onClick={() => {
                                handlePlannedReelsEditColumn(
                                  index,
                                  record,
                                  true,
                                  "incomplete_order"
                                );
                              }}
                            >
                              <Iconmoon icon="edit" size={16} color="#A19F9D" />
                            </Button>
                          </Tooltip>
                        </Styled>
                      </Col>
                    )}
                  {isEditPlannedReels?.[record.orderno] &&
                    isEditPlannedReels?.[record.orderno].isEditable && (
                      <DetailFields style={{ paddingBottom: "0px" }}>
                        <Styled>
                          <HaberForm>
                            <Row className="centerAlign justifyCSBetween">
                              <Col span={14} style={{ paddingRight: "5px" }}>
                                <div className="boxFormType">
                                  <Form.Item
                                    name={`plannedReel${record?.orderno}`}
                                    rules={[
                                      {
                                        required: true,
                                        message: "This field is required.",
                                      },
                                      {
                                        pattern: new RegExp(
                                          /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
                                        ),
                                        message:
                                          "This value should be a non-zero positive value.",
                                      },
                                    ]}
                                    className="dBlock"
                                    initialValue={text}
                                  >
                                    <Input
                                      onChange={(e) => {
                                        onPlannedReelsChange(
                                          e,
                                          record,
                                          index,
                                          "incomplete_orders"
                                        );
                                      }}
                                    />
                                  </Form.Item>
                                  {/* <span className="nonEditable" style={{marginTop:"3px", right:"10px", fontSize:"11px"}}>{record.plannedUnit}</span> */}
                                </div>
                              </Col>
                              <Col
                                span={10}
                                style={{
                                  paddingRight: "5px",
                                  marginTop: "0px",
                                }}
                              >
                                <div
                                  className="boxFormType"
                                  style={{
                                    marginBottom: "0",
                                    marginTop: "7px",
                                  }}
                                >
                                  {(!plannedReelsErr?.[record.orderno] ||
                                    (plannedReelsErr?.[record.orderno] &&
                                      !plannedReelsErr?.[record.orderno]
                                        .error)) && (
                                      <Tooltip title={"Save the entered value"}>
                                        <Button
                                          key="1"
                                          className="edit-btn"
                                          style={{
                                            padding: "0px",
                                            margin: "0px",
                                            width: "28px",
                                            border: "none",
                                            display: "inline-block",
                                            marginRight: "10px",
                                          }}
                                          onClick={() =>
                                            onPlannedReelsButtonChange(
                                              index,
                                              "save",
                                              record,
                                              "incomplete_order"
                                            )
                                          }
                                        >
                                          <Iconmoon
                                            icon="check"
                                            size={18}
                                            color="#3FBD61"
                                          />
                                        </Button>
                                      </Tooltip>
                                    )}

                                  <Tooltip title={"Remove the entered value"}>
                                    <Button
                                      key="2"
                                      className="edit-btn"
                                      style={{
                                        padding: "0px",
                                        margin: "0px",
                                        width: "28px",
                                        border: "none",
                                        display: "inline-block",
                                      }}
                                      onClick={() =>
                                        onPlannedReelsButtonChange(
                                          index,
                                          "remove",
                                          record,
                                          "incomplete_order"
                                        )
                                      }
                                    >
                                      <Iconmoon
                                        icon="cancel"
                                        size={18}
                                        color="red"
                                      />
                                    </Button>
                                  </Tooltip>
                                </div>
                              </Col>
                            </Row>
                            {/* </Form> */}
                          </HaberForm>
                        </Styled>
                      </DetailFields>
                    )}
                </div>
              ),
            };
          } else if (item.dataIndex == "grain") {
            item = {
              title: "Grain",
              dataIndex: "grain",
              width: "8%",
              render: (text, record, index) => (
                <Styled>
                  {record.type.toLowerCase() == "sheet" ? (
                    <div style={{ display: "flex" }}>
                      <Row className="centerAlign">
                        <div className="boxFormType">
                          <SelectStyle>
                            <Form.Item
                              name={`grain${record.orderno}`}
                              rules={[
                                {
                                  required: true,
                                  message: "This field is required",
                                },
                              ]}
                              className="selectForm"
                              style={{ marginBottom: 4 }}
                              initialValue={
                                record.grain
                                  ? record.grain == "short"
                                    ? "Short"
                                    : "Long"
                                  : null
                              }
                            >
                              <Select
                                placeholder={"Select"}
                                suffixIcon={<DownArrowDraw />}
                                onChange={(e) =>
                                  onGrainChange(
                                    e,
                                    record,
                                    index,
                                    "incomplete_order"
                                  )
                                }
                              >
                                {grainTypeData.map((grainType) => (
                                  <Option key={grainType}>{grainType}</Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </SelectStyle>
                        </div>
                      </Row>
                    </div>
                  ) : (
                    ""
                  )}
                </Styled>
              ),
            };
          }

          return item;
        });

      setTableRerender(false);
    }
  }, [tableRerender]);

  //M code
  // useEffect(() => {
  //   if(tableData && tableData.length && paginationParamsChange)
  //   {
  //     for (let index = 0; index < tableData.length; index++) {
  //       const order = tableData[index];
  //       var indexValue = selectedDataRows.findIndex((obj) => obj.id == order.id);
  //       if(indexValue != -1)
  //       {
  //         handleSelectRewinderOnpagination({...order},true,true);
  //       }
  //     }
  //     setPaginationParamsChange(false);
  //   }

  // },[tableData, paginationParamsChange]);

  const handleSelect = async (record, selected) => {
    setPageLoaded(false);
    setSelectedState(true);

    var array = [...selectedDataRows];
    let selectedRowIndex = tableData?.findIndex(
      (ele) => ele.orderno == record.orderno
    );
    let coreIDValue = form.getFieldValue("coreDia");

    if (selected) {
      if (
        (selecteDia == "range" &&
          ((record.type == "Reel" && record.quantity_type != "reel_sheet") ||
            record.type == "Sheet")) ||
        (selecteDia == "constant" &&
          record.type == "Reel" &&
          record.quantity_type == "reel_sheet" &&
          (selectedReelOD.length == 1 || selectedReelOD.length == 0)) ||
        (selecteDia == "constant" &&
          ((record.type == "Reel" && record.quantity_type != "reel_sheet") ||
            record.type == "Sheet"))
      ) {
        setSelectedRowKeys((keys) => [...keys, record.key]);
      }

      let dataCopy = [...tableData];
      if (selecteDia == "constant") {
        let reelODArr = [];
        for (let i = 0; i < selectedReelOD?.length; i++) {
          reelODArr.push(selectedReelOD[i]?.value);
        }
        if (
          (selecteDia == "constant" &&
            record.type == "Reel" &&
            record.quantity_type == "reel_sheet" &&
            (selectedReelOD.length == 1 || selectedReelOD.length == 0)) ||
          (selecteDia == "constant" &&
            ((record.type == "Reel" && record.quantity_type != "reel_sheet") ||
              record.type == "Sheet"))
        ) {
          record.reelod = reelODArr;
          record.coreid = coreIDValue;
          record.outer_dia = reelODArr;
          record.inner_dia = coreIDValue;
          dataCopy[selectedRowIndex].reelod = reelODArr;
          dataCopy[selectedRowIndex].coreid = coreIDValue;
          dataCopy[selectedRowIndex].outer_dia = reelODArr;
          dataCopy[selectedRowIndex].inner_dia = coreIDValue;
        }
      } else {
        if (
          selecteDia == "range" &&
          ((record.type == "Reel" && record.quantity_type != "reel_sheet") ||
            record.type == "Sheet")
        ) {
          let minValue = form.getFieldValue("min_reel");
          let maxValue = form.getFieldValue("max_reel");
          record.minimum_reel_od = minValue ? minValue : "";
          record.maximum_reel_od = maxValue ? maxValue : "";
          record.units["minimum_reel_od"] = minValue
            ? form.getFieldValue("range_unit")
            : "";
          record.units["maximum_reel_od"] = maxValue
            ? form.getFieldValue("range_unit")
            : "";
          record.coreid = form.getFieldValue("core_Dia");
          record.inner_dia = form.getFieldValue("core_Dia");
          dataCopy[selectedRowIndex].minimum_reel_od = minValue
            ? form.getFieldValue("min_reel")
            : "";
          dataCopy[selectedRowIndex].maximum_reel_od = maxValue
            ? form.getFieldValue("max_reel")
            : "";
          dataCopy[selectedRowIndex].units["minimum_reel_od"] = minValue
            ? form.getFieldValue("range_unit")
            : "";
          dataCopy[selectedRowIndex].units["maximum_reel_od"] = maxValue
            ? form.getFieldValue("range_unit")
            : "";
          dataCopy[selectedRowIndex].coreid = form.getFieldValue("core_Dia");
          dataCopy[selectedRowIndex].inner_dia = form.getFieldValue("core_Dia");
        }
      }
      if (
        (selecteDia == "range" &&
          ((record.type == "Reel" && record.quantity_type != "reel_sheet") ||
            record.type == "Sheet")) ||
        (selecteDia == "constant" &&
          record.type == "Reel" &&
          record.quantity_type == "reel_sheet" &&
          (selectedReelOD.length == 1 || selectedReelOD.length == 0)) ||
        (selecteDia == "constant" &&
          ((record.type == "Reel" && record.quantity_type != "reel_sheet") ||
            record.type == "Sheet"))
      ) {
        record.id_od_type = selecteDia;
        dataCopy[selectedRowIndex].id_od_type = selecteDia;
      }

      // array.push(record);
      if (
        (selecteDia == "range" &&
          ((record.type == "Reel" && record.quantity_type != "reel_sheet") ||
            record.type == "Sheet")) ||
        (selecteDia == "constant" &&
          record.type == "Reel" &&
          record.quantity_type == "reel_sheet" &&
          (selectedReelOD.length == 1 || selectedReelOD.length == 0)) ||
        (selecteDia == "constant" &&
          ((record.type == "Reel" && record.quantity_type != "reel_sheet") ||
            record.type == "Sheet"))
      ) {
        array.push(record);
        setSelectedDataRows([...selectedDataRows, record]);
      }

      setTableData([...dataCopy]);
      tableDataRef.current = [...dataCopy];
    } else {
      setSelectedRowKeys((keys) => {
        const index = keys.indexOf(record.key);
        return [...keys.slice(0, index), ...keys.slice(index + 1)];
      });

      var index = array.findIndex((obj) => obj.key == record.key);
      if (index !== -1) {
        array.splice(index, 1);
        setSelectedDataRows(array);
      }
      //update deselected table data row
      let dataCopy = [...tableData];
      dataCopy[selectedRowIndex] = JSON.parse(
        JSON.stringify(tableDataCopyRef.current[selectedRowIndex])
      );
      setTableData([...dataCopy]);
      tableDataRef.current = [...dataCopy];
      setSelectedState(false);
    }

    if (array.length > 0) setIsCheckboxClicked(true);
    else setIsCheckboxClicked(false);

    const productCodes = [...new Set(array.map((r) => r.productcode))];
    const result = array.filter((f) => tableData.some((d) => d.key == f.key));
    if (result.length == tableData.length) {
      setIsAllSelected(true);
    } else {
      setIsAllSelected(false);
    }
    // await getProductDetailsForSelectedOrders(productCodes)
    //   .then((response) => {
    //     setProductDataForSelectedRows(response);
    //   })
    //   .catch((error) => {
    //     console.log("Error in getting product specification list");
    //   });

    // const result = array.filter((f) => tableData.some((d) => d.key == f.key));
    // // setSelectedRowKeys(result.map((r) => r.key));
    // if (result.length == tableData.length) {
    //   setIsAllSelected(true);
    // } else {
    //   setIsAllSelected(false);
    // }
  };

  //M code
  const toggleSelectAll = async (e) => {
    let selectedOrders = [...selectedDataRows];
    let selectedOrderKeys = [...selectedRowKeys];
    let currentTableData = [...tableData];
    let currentSelectedRows = [];
    setSelectedState(true);
    let tempSelectedRowKeys = selectedRowKeys;
    let keys = [];
    let tempTableData = [];
    // if(tempSelectedRowKeys?.length == tableData.length){
    //   setSelectedRowKeys([]);
    //   tempTableData = tableData;
    // } else{
    tableData.map((r) => {
      if (
        (selecteDia == "range" &&
          ((r.type == "Reel" && r.quantity_type != "reel_sheet") ||
            r.type == "Sheet")) ||
        (selecteDia == "constant" &&
          r.type == "Reel" &&
          r.quantity_type == "reel_sheet" &&
          (selectedReelOD.length == 1 || selectedReelOD.length == 0)) ||
        (selecteDia == "constant" &&
          ((r.type == "Reel" && r.quantity_type != "reel_sheet") ||
            r.type == "Sheet"))
      ) {
        keys.push(r.key);
        tempTableData.push(r);
      }
    });

    //setSelectedRowKeys([...new Set(keys)]);
    // }
    // setSelectedRowKeys((keys) => keys.length === tableData.length ? [] : tableData.map((r) => r.key);

    const newCheckboxState = [...tableData];
    const newCheckboxStateTableRef = [...tableDataCopyRef.current];
    if (!e.target.checked) {
      setIsAllSelected(false);
      newCheckboxState.forEach((item) => {
        item.select = false;
      });

      tableData.forEach((item) => {
        item.select = false;
      });
      //const intersection = tempTableData.filter(element => !selectedRowKeys.includes(element.id));
      //setSelectedRowKeys([...new Set(intersection)]);

      setSelectedDataRows(
        selectedDataRows.filter((f) => !tableData.some((d) => d.key == f.key))
      );
      currentSelectedRows = selectedDataRows.filter(
        (f) => !tableData.some((d) => d.key == f.key)
      );
      setTableData(JSON.parse(JSON.stringify(newCheckboxStateTableRef)));
      tableDataRef.current = JSON.parse(
        JSON.stringify(tableDataCopyRef.current)
      );
      setSelectedState(false);
      // removeDeslectedQuantity(newCheckboxState);
    } else {
      setIsAllSelected(true);
      newCheckboxState.forEach((item) => {
        if (
          (selecteDia == "range" &&
            ((item.type == "Reel" && item.quantity_type != "reel_sheet") ||
              item.type == "Sheet")) ||
          (selecteDia == "constant" &&
            item.type == "Reel" &&
            item.quantity_type == "reel_sheet" &&
            (selectedReelOD.length == 1 || selectedReelOD.length == 0)) ||
          (selecteDia == "constant" &&
            ((item.type == "Reel" && item.quantity_type != "reel_sheet") ||
              item.type == "Sheet"))
        ) {
          item.select = true;
        }
      });
      let unique = [...new Set([...selectedDataRows, ...tempTableData])];
      currentSelectedRows = [
        ...new Map(unique.map((item) => [item["key"], item])).values(),
      ];
      let coreIDValue = form.getFieldValue("coreDia");
      if (currentSelectedRows && currentSelectedRows?.length) {
        for (let i = 0; i < currentSelectedRows?.length; i++) {
          if (selecteDia == "constant") {
            let reelODArr = [];
            for (let j = 0; j < selectedReelOD?.length; j++) {
              reelODArr.push(selectedReelOD[j]?.value);
            }
            if (
              (selecteDia == "constant" &&
                currentSelectedRows[i].type == "Reel" &&
                currentSelectedRows[i].quantity_type == "reel_sheet" &&
                (selectedReelOD.length == 1 || selectedReelOD.length == 0)) ||
              (selecteDia == "constant" &&
                ((currentSelectedRows[i].type == "Reel" &&
                  currentSelectedRows[i].quantity_type != "reel_sheet") ||
                  currentSelectedRows[i].type == "Sheet"))
            ) {
              currentSelectedRows[i].reelod = reelODArr;
              currentSelectedRows[i].coreid = coreIDValue;
              currentSelectedRows[i].outer_dia = reelODArr;
              currentSelectedRows[i].inner_dia = coreIDValue;
            }
          } else {
            if (
              selecteDia == "range" &&
              ((currentSelectedRows[i].type == "Reel" &&
                currentSelectedRows[i].quantity_type != "reel_sheet") ||
                currentSelectedRows[i].type == "Sheet")
            ) {
              currentSelectedRows[i].minimum_reel_od =
                form.getFieldValue("min_reel");
              currentSelectedRows[i].maximum_reel_od =
                form.getFieldValue("max_reel");
              currentSelectedRows[i].units["minimum_reel_od"] =
                form.getFieldValue("range_unit");
              currentSelectedRows[i].units["maximum_reel_od"] =
                form.getFieldValue("range_unit");
              currentSelectedRows[i].coreid = form.getFieldValue("core_Dia");
              currentSelectedRows[i].inner_dia = form.getFieldValue("core_Dia");
            }
          }
          if (
            (selecteDia == "range" &&
              ((currentSelectedRows[i].type == "Reel" &&
                currentSelectedRows[i].quantity_type != "reel_sheet") ||
                currentSelectedRows[i].type == "Sheet")) ||
            (selecteDia == "constant" &&
              currentSelectedRows[i].type == "Reel" &&
              currentSelectedRows[i].quantity_type == "reel_sheet" &&
              (selectedReelOD.length == 1 || selectedReelOD.length == 0)) ||
            (selecteDia == "constant" &&
              ((currentSelectedRows[i].type == "Reel" &&
                currentSelectedRows[i].quantity_type != "reel_sheet") ||
                currentSelectedRows[i].type == "Sheet"))
          ) {
            currentSelectedRows[i].id_od_type = selecteDia;
          }
        }
        // console.log(currentSelectedRows);
        let selectedDataRowsCopy = [];
        for (let ele = 0; ele < currentSelectedRows?.length; ele++) {
          if (
            (((currentSelectedRows[ele].type == "Reel" &&
              currentSelectedRows[ele].quantity_type != "reel_sheet") ||
              currentSelectedRows[ele].type == "Sheet") &&
              selecteDia == "range") ||
            (selecteDia == "constant" &&
              currentSelectedRows[ele].type == "Reel" &&
              currentSelectedRows[ele].quantity_type == "reel_sheet" &&
              (selectedReelOD.length == 1 || selectedReelOD.length == 0)) ||
            (selecteDia == "constant" &&
              ((currentSelectedRows[ele].type == "Reel" &&
                currentSelectedRows[ele].quantity_type != "reel_sheet") ||
                currentSelectedRows[ele].type == "Sheet"))
          ) {
            selectedDataRowsCopy.push(currentSelectedRows[ele]);
          }
        }
        setSelectedDataRows([...selectedDataRowsCopy]);

        let updatedTableData = [...tableData];

        for (let j = 0; j < updatedTableData?.length; j++) {
          if (selecteDia == "constant") {
            let reelODArr = [];
            for (let k = 0; k < selectedReelOD?.length; k++) {
              reelODArr.push(selectedReelOD[k]?.value);
            }
            if (
              (selecteDia == "constant" &&
                updatedTableData[j].type == "Reel" &&
                updatedTableData[j].quantity_type == "reel_sheet" &&
                (selectedReelOD.length == 1 || selectedReelOD.length == 0)) ||
              (selecteDia == "constant" &&
                ((updatedTableData[j].type == "Reel" &&
                  updatedTableData[j].quantity_type != "reel_sheet") ||
                  updatedTableData[j].type == "Sheet"))
            ) {
              updatedTableData[j].reelod = reelODArr;
              updatedTableData[j].coreid = coreIDValue;
              updatedTableData[j].outer_dia = reelODArr;
              updatedTableData[j].inner_dia = coreIDValue;
            }
          } else {
            if (
              selecteDia == "range" &&
              ((updatedTableData[j].type == "Reel" &&
                updatedTableData[j].quantity_type != "reel_sheet") ||
                updatedTableData[j].type == "Sheet")
            ) {
              updatedTableData[j].minimum_reel_od =
                form.getFieldValue("min_reel");
              updatedTableData[j].maximum_reel_od =
                form.getFieldValue("max_reel");
              updatedTableData[j].units["minimum_reel_od"] =
                form.getFieldValue("range_unit");
              updatedTableData[j].units["maximum_reel_od"] =
                form.getFieldValue("range_unit");
              updatedTableData[j].coreid = form.getFieldValue("core_Dia");
              updatedTableData[j].inner_dia = form.getFieldValue("core_Dia");
            }
          }
          if (
            (selecteDia == "range" &&
              ((updatedTableData[j].type == "Reel" &&
                updatedTableData[j].quantity_type != "reel_sheet") ||
                updatedTableData[j].type == "Sheet")) ||
            (selecteDia == "constant" &&
              updatedTableData[j].type == "Reel" &&
              updatedTableData[j].quantity_type == "reel_sheet" &&
              (selectedReelOD.length == 1 || selectedReelOD.length == 0)) ||
            (selecteDia == "constant" &&
              ((updatedTableData[j].type == "Reel" &&
                updatedTableData[j].quantity_type != "reel_sheet") ||
                updatedTableData[j].type == "Sheet"))
          ) {
            updatedTableData[j].id_od_type = selecteDia;
          }
        }
        // addSelectedQuantity(updatedTableData);
        setTableData([...updatedTableData]);
        tableDataRef.current = [...updatedTableData];
      }
    }

    if (!e.target.checked) {
      setIsAllSelected(false);
      // newCheckboxState.forEach((item) => {
      //   item.select = false;
      // });
      let newData = currentTableData.filter((item) => {
        if (
          (selecteDia == "range" &&
            ((item.type == "Reel" && item.quantity_type != "reel_sheet") ||
              item.type == "Sheet")) ||
          (selecteDia == "constant" &&
            item.type == "Reel" &&
            item.quantity_type == "reel_sheet" &&
            (selectedReelOD.length == 1 || selectedReelOD.length == 0)) ||
          (selecteDia == "constant" &&
            ((item.type == "Reel" && item.quantity_type != "reel_sheet") ||
              item.type == "Sheet"))
        ) {
          return item;
        }
      });
      // removeDeslectedQuantity(newData);
      // setSelectedDataRows(
      //   selectedDataRows.filter((f) => !tableData.some((d) => d.key == f.id))
      // );
      setSelectedRowKeys(
        selectedRowKeys.filter((f) => !tableData.some((d) => d.key == f))
      );
      // if(!selectedRowKeys.filter((f) => !tableData.some((d) => d.key == f)).length)
      // setTotalWeight(0);
    } else {
      setIsAllSelected(true);
      // newCheckboxState.forEach((item) => {
      //   item.select = true;
      // });
      let newData = currentTableData.filter((item) => {
        if (
          (selecteDia == "range" &&
            ((item.type == "Reel" && item.quantity_type != "reel_sheet") ||
              item.type == "Sheet")) ||
          (selecteDia == "constant" &&
            item.type == "Reel" &&
            item.quantity_type == "reel_sheet" &&
            (selectedReelOD.length == 1 || selectedReelOD.length == 0)) ||
          (selecteDia == "constant" &&
            ((item.type == "Reel" && item.quantity_type != "reel_sheet") ||
              item.type == "Sheet"))
        ) {
          return item;
        }
      });
      // const uniqueArr = newData.filter(
      //   (
      //     (set) => (a) =>
      //       false === set.has(a.id)
      //   )(new Set(selectedOrders.map((b) => b.id)))
      // );
      // let unique = [...new Set([...selectedDataRows, ...tableData])];
      // unique = [
      //   ...new Map(unique.map((item) => [item["orderno"], item])).values(),
      // ];

      let uniqueKeys = [
        ...new Set([...selectedOrderKeys, ...newData.map((item) => item.key)]),
      ];
      let dataToAdd = newData.filter(
        (f) => !selectedOrders.some((d) => d.orderno == f.orderno)
      );
      setSelectedRowKeys(uniqueKeys);
      // if(!uniqueKeys.length)
      // setTotalWeight(0);
      // addSelectedQuantity(dataToAdd);
      //setSelectedDataRows(unique);
    }

    const productCodes = [
      ...new Set(currentSelectedRows.map((r) => r.productcode)),
    ];

    // await getProductDetailsForSelectedOrders(productCodes)
    //   .then((response) => {
    //     setProductDataForSelectedRows(response);
    //   })
    //   .catch((error) => {
    //     console.log("Error in getting product specification list");
    //   });

    //setTableData(newCheckboxState);
    const temp = newCheckboxState.filter((item) => item.select === true);
    if (temp.length > 0) setIsCheckboxClicked(true);
    else setIsCheckboxClicked(false);
    // setPageRerender(true);
    setTableRerender(true);
    //setPageLoaded(false);
  };

  // const toggleSelectAll = async () => {
  //   let currentSelectedRows = [];
  //   setSelectedState(true);
  //   let tempSelectedRowKeys = selectedRowKeys;
  //   let keys = [];
  //   let tempTableData = [];
  //   if (tempSelectedRowKeys?.length == tableData?.length) {
  //     setSelectedRowKeys([]);
  //     tempTableData = tableData;
  //   } else {
  //     tableData.map((r) => {
  //       if (
  //         (selecteDia == "range" &&
  //           ((r.type == "Reel" && r.quantity_type != "reel_sheet") ||
  //             r.type == "Sheet")) ||
  //         (selecteDia == "constant" &&
  //           r.type == "Reel" &&
  //           r.quantity_type == "reel_sheet" &&
  //           (selectedReelOD.length == 1 || selectedReelOD.length == 0)) ||
  //         (selecteDia == "constant" &&
  //           ((r.type == "Reel" && r.quantity_type != "reel_sheet") ||
  //             r.type == "Sheet"))
  //       ) {
  //         keys.push(r.key);
  //         tempTableData.push(r);
  //       }
  //     });
  //     setSelectedRowKeys(keys);
  //   }
  //   // setSelectedRowKeys((keys) => keys.length === tableData.length ? [] : tableData.map((r) => r.key);

  //   const newCheckboxState = [...tableData];

  //   if (selectedRowKeys?.length === tempTableData?.length) {
  //     setIsAllSelected(false);
  //     newCheckboxState.forEach((item) => {
  //       item.select = false;
  //     });

  //     const intersection = tempTableData.filter(
  //       (element) => !selectedRowKeys?.includes(element.key)
  //     );
  //     setSelectedRowKeys(intersection);

  //     setSelectedDataRows(
  //       selectedDataRows.filter(
  //         (f) => !tempTableData.some((d) => d.key == f.key)
  //       )
  //     );
  //     currentSelectedRows = selectedDataRows.filter(
  //       (f) => !tempTableData.some((d) => d.key == f.key)
  //     );
  //     setTableData(JSON.parse(JSON.stringify(tableDataCopyRef.current)));
  //     tableDataRef.current = JSON.parse(
  //       JSON.stringify(tableDataCopyRef.current)
  //     );
  //     setSelectedState(false);
  //   } else {
  //     setIsAllSelected(true);
  //     newCheckboxState.forEach((item) => {
  //       if (
  //         (selecteDia == "range" &&
  //           ((item.type == "Reel" && item.quantity_type != "reel_sheet") ||
  //             item.type == "Sheet")) ||
  //         (selecteDia == "constant" &&
  //           item.type == "Reel" &&
  //           item.quantity_type == "reel_sheet" &&
  //           (selectedReelOD.length == 1 || selectedReelOD.length == 0)) ||
  //         (selecteDia == "constant" &&
  //           ((item.type == "Reel" && item.quantity_type != "reel_sheet") ||
  //             item.type == "Sheet"))
  //       ) {
  //         item.select = true;
  //       }
  //     });
  //     let unique = [...new Set([...selectedDataRows, ...tableData])];
  //     currentSelectedRows = [
  //       ...new Map(unique.map((item) => [item["key"], item])).values(),
  //     ];
  //     let coreIDValue = form.getFieldValue("coreDia");
  //     if (currentSelectedRows && currentSelectedRows?.length) {
  //       for (let i = 0; i < currentSelectedRows?.length; i++) {
  //         if (selecteDia == "constant") {
  //           let reelODArr = [];
  //           for (let j = 0; j < selectedReelOD?.length; j++) {
  //             reelODArr.push(selectedReelOD[j]?.value);
  //           }
  //           if (
  //             (selecteDia == "constant" &&
  //               currentSelectedRows[i].type == "Reel" &&
  //               currentSelectedRows[i].quantity_type == "reel_sheet" &&
  //               (selectedReelOD.length == 1 || selectedReelOD.length == 0)) ||
  //             (selecteDia == "constant" &&
  //               ((currentSelectedRows[i].type == "Reel" &&
  //                 currentSelectedRows[i].quantity_type != "reel_sheet") ||
  //                 currentSelectedRows[i].type == "Sheet"))
  //           ) {
  //             currentSelectedRows[i].reelod = reelODArr;
  //             currentSelectedRows[i].coreid = coreIDValue;
  //             currentSelectedRows[i].outer_dia = reelODArr;
  //             currentSelectedRows[i].inner_dia = coreIDValue;
  //           }
  //         } else {
  //           if (
  //             selecteDia == "range" &&
  //             ((currentSelectedRows[i].type == "Reel" &&
  //               currentSelectedRows[i].quantity_type != "reel_sheet") ||
  //               currentSelectedRows[i].type == "Sheet")
  //           ) {
  //             currentSelectedRows[i].minimum_reel_od =
  //               form.getFieldValue("min_reel");
  //             currentSelectedRows[i].maximum_reel_od =
  //               form.getFieldValue("max_reel");
  //             currentSelectedRows[i].units["minimum_reel_od"] =
  //               form.getFieldValue("range_unit");
  //             currentSelectedRows[i].units["maximum_reel_od"] =
  //               form.getFieldValue("range_unit");
  //           }
  //         }
  //         if (
  //           (selecteDia == "range" &&
  //             ((currentSelectedRows[i].type == "Reel" &&
  //               currentSelectedRows[i].quantity_type != "reel_sheet") ||
  //               currentSelectedRows[i].type == "Sheet")) ||
  //           (selecteDia == "constant" &&
  //             currentSelectedRows[i].type == "Reel" &&
  //             currentSelectedRows[i].quantity_type == "reel_sheet" &&
  //             (selectedReelOD.length == 1 || selectedReelOD.length == 0)) ||
  //           (selecteDia == "constant" &&
  //             ((currentSelectedRows[i].type == "Reel" &&
  //               currentSelectedRows[i].quantity_type != "reel_sheet") ||
  //               currentSelectedRows[i].type == "Sheet"))
  //         ) {
  //           currentSelectedRows[i].id_od_type = selecteDia;
  //         }
  //       }
  //       // console.log(currentSelectedRows);
  //       let selectedDataRowsCopy = [];
  //       for (let ele = 0; ele < currentSelectedRows?.length; ele++) {
  //         if (
  //           (((currentSelectedRows[ele].type == "Reel" &&
  //             currentSelectedRows[ele].quantity_type != "reel_sheet") ||
  //             currentSelectedRows[ele].type == "Sheet") &&
  //             selecteDia == "range") ||
  //           (selecteDia == "constant" &&
  //             currentSelectedRows[ele].type == "Reel" &&
  //             currentSelectedRows[ele].quantity_type == "reel_sheet" &&
  //             (selectedReelOD.length == 1 || selectedReelOD.length == 0)) ||
  //           (selecteDia == "constant" &&
  //             ((currentSelectedRows[ele].type == "Reel" &&
  //               currentSelectedRows[ele].quantity_type != "reel_sheet") ||
  //               currentSelectedRows[ele].type == "Sheet"))
  //         ) {
  //           selectedDataRowsCopy.push(currentSelectedRows[ele]);
  //         }
  //       }
  //       setSelectedDataRows([...selectedDataRowsCopy]);

  //       let updatedTableData = [...tableData];

  //       for (let j = 0; j < updatedTableData?.length; j++) {
  //         if (selecteDia == "constant") {
  //           let reelODArr = [];
  //           for (let k = 0; k < selectedReelOD?.length; k++) {
  //             reelODArr.push(selectedReelOD[k]?.value);
  //           }
  //           if (
  //             (selecteDia == "constant" &&
  //               updatedTableData[j].type == "Reel" &&
  //               updatedTableData[j].quantity_type == "reel_sheet" &&
  //               (selectedReelOD.length == 1 || selectedReelOD.length == 0)) ||
  //             (selecteDia == "constant" &&
  //               ((updatedTableData[j].type == "Reel" &&
  //                 updatedTableData[j].quantity_type != "reel_sheet") ||
  //                 updatedTableData[j].type == "Sheet"))
  //           ) {
  //             updatedTableData[j].reelod = reelODArr;
  //             updatedTableData[j].coreid = coreIDValue;
  //             updatedTableData[j].outer_dia = reelODArr;
  //             updatedTableData[j].inner_dia = coreIDValue;
  //           }
  //         } else {
  //           if (
  //             selecteDia == "range" &&
  //             ((updatedTableData[j].type == "Reel" &&
  //               updatedTableData[j].quantity_type != "reel_sheet") ||
  //               updatedTableData[j].type == "Sheet")
  //           ) {
  //             updatedTableData[j].minimum_reel_od =
  //               form.getFieldValue("min_reel");
  //             updatedTableData[j].maximum_reel_od =
  //               form.getFieldValue("max_reel");
  //             updatedTableData[j].units["minimum_reel_od"] =
  //               form.getFieldValue("range_unit");
  //             updatedTableData[j].units["maximum_reel_od"] =
  //               form.getFieldValue("range_unit");
  //           }
  //         }
  //         if (
  //           (selecteDia == "range" &&
  //             ((updatedTableData[j].type == "Reel" &&
  //               updatedTableData[j].quantity_type != "reel_sheet") ||
  //               updatedTableData[j].type == "Sheet")) ||
  //           (selecteDia == "constant" &&
  //             updatedTableData[j].type == "Reel" &&
  //             updatedTableData[j].quantity_type == "reel_sheet" &&
  //             (selectedReelOD.length == 1 || selectedReelOD.length == 0)) ||
  //           (selecteDia == "constant" &&
  //             ((updatedTableData[j].type == "Reel" &&
  //               updatedTableData[j].quantity_type != "reel_sheet") ||
  //               updatedTableData[j].type == "Sheet"))
  //         ) {
  //           updatedTableData[j].id_od_type = selecteDia;
  //         }
  //       }
  //       console.log(updatedTableData);
  //       setTableData([...updatedTableData]);
  //       tableDataRef.current = [...updatedTableData];
  //     }
  //   }

  //   const productCodes = [
  //     ...new Set(currentSelectedRows.map((r) => r.productcode)),
  //   ];

  //   // await getProductDetailsForSelectedOrders(productCodes)
  //   //   .then((response) => {
  //   //     setProductDataForSelectedRows(response);
  //   //   })
  //   //   .catch((error) => {
  //   //     console.log("Error in getting product specification list");
  //   //   });

  //   //setTableData(newCheckboxState);
  //   const temp = newCheckboxState?.filter((item) => item.select === true);
  //   if (temp.length > 0) setIsCheckboxClicked(true);
  //   else setIsCheckboxClicked(false);
  //   setPageLoaded(false);
  // };

  const handleOrderType = (type) => {
    setLoading(true);
    setSelectedRowKeys([]);
    setSelectedDataRows([]);
    setPaginationParams({
      page: 1,
      size: settingsData?.settings?.default_page_size || 10,
    });
    paginationRef.current = {
      page: 1,
      size: settingsData?.settings?.default_page_size || 10,
    };
    setSortParams({
      sort_by: "po__date",
      sort_type: "ascending",
    });

    setCurrentPage(1);
    setSearchValue("");
    setSearchKey(false);
    setClearSearch(true);
    setAppliedFilters([]);
    setFilterTags([]);
    selectedOrderTypeRef.current = type;
    setSelectedOrderType(type);
    setRendering(true);
  };

  const handleDeckleOrderType = (type) => {
    setLoading(true);
    setSelectedRowKeys([]);
    setSelectedDataRows([]);
    setPaginationParams({
      page: 1,
      size: settingsData?.settings?.default_page_size || 10,
    });
    paginationRef.current = {
      page: 1,
      size: settingsData?.settings?.default_page_size || 10,
    };
    setSortParams({
      sort_by: "po__date",
      sort_type: "ascending",
    });
    setCurrentPage(1);
    setSearchValue("");
    setSearchKey(false);
    setClearSearch(true);
    setAppliedFilters([]);
    setFilterTags([]);
    deckleOrderTypeRef.current =
      type == "both" ? "pending_for_deckle_match" : type;
    setDeckleOrderType(type == "both" ? "pending_for_deckle_match" : type);
    setRendering(true);
  };

  const headerCheckbox = (
    <div style={{ paddingBottom: "4px" }}>
      <Styled>
        <Checkbox
          checked={isAllSelected}
          indeterminate={
            selectedRowKeys.length > 0 && selectedRowKeys.length < tableData
          }
          onChange={toggleSelectAll}
        >
        </Checkbox>
      </Styled>
    </div>
  );

  const expandedRowRender = (row) => {
    return !allInnerRecords[row.key]?.length ? (
      <TableShimmer
        header={columnsHeader.current}
        showHeader={false}
        scroll={2450}
        rows={3}
        minHeight={"0px"}
      />
    ) : (
      <Table
        style={{ minHeight: "0px", paddingBottom: "8px", paddingTop: "10px" }}
        columns={columnsHeader.current}
        dataSource={
          allInnerRecords[row.key].length ? allInnerRecords[row.key] : []
        }
        pagination={false}
        showHeader={true}
        scroll={{ x: 3000 }}
        size="small"
      />
    );
  };

  const rowExpandable = (record) => {
    if (record.item_type === "split_group") {
      return true;
    } else {
      return false;
    }
  };

  const onExpand = async (expanded, record) => {
    if (expanded) {
      setNestedLoading(true);
      const allInnerRecordObj = allInnerRecords;
      const groupedOrders = await getSplitGroupOrders(record.groupno);
      const mappedGroupOrders = await mapInnerRecordsToColumns(groupedOrders);
      allInnerRecordObj[record.key] = mappedGroupOrders;
      setAllInnerRecords(allInnerRecordObj);
      setNestedLoading(false);
    } else {
      setNestedLoading(true);
    }
  };

  const mapInnerRecordsToColumns = (groupedOrders) => {
    const data = groupedOrders?.map((item) => {
      let quantityValue;
      let rewinderReels;
      if (item.type == "reel" && item.quantity_type == "reel_sheet") {
        quantityValue =
          item.this_item_type == "order"
            ? Math.round(item.quantity)
            : Math.round(item.no_of_reel_sheet);
        rewinderReels =
          item.this_item_type == "order"
            ? Math.round(item.no_of_reel_sheet)
            : Math.round(item.total_quantity);
      } else if (item.type == "sheet" && item.quantity_type == "reel_sheet") {
        quantityValue =
          item.this_item_type == "order"
            ? Math.round(item.no_of_reel_sheet)
            : Math.round(item.no_of_reel_sheet);
        rewinderReels =
          item.this_item_type == "order"
            ? Math.round(item.quantity)
            : Math.round(item.total_quantity);
      } else if (
        (item.type == "reel" || item.type == "sheet") &&
        item.quantity_type == "weight"
      ) {
        quantityValue = "-";
        rewinderReels =
          item.this_item_type == "order"
            ? Math.round(item.quantity)
            : Math.round(item.total_quantity);
      }
      let jobID = []
      if (item?.jobcards?.jobcards) {
        item?.jobcards?.jobcards.map((item, index) => {
          jobID.push(item.jobcard)
        })
      }
      return {
        key: item.uuid,
        select: false,
        isConflictingstate: item.conflicting_state,
        jobcards: item.jobID,
        pono:
          item.po && typeof item.po === "string"
            ? item.po.toUpperCase()
            : item.po,
        sono: item.so && typeof item.so === "string"
          ? item.so.toUpperCase()
          : item.so,
        category: item.category,
        savedPO: item.po,
        orderno: item.number ? item.number : "-",
        createddate: moment(item.created_at).format("DD MMM YYYY"),
        podate: moment(item.category === 'so' ? item.so_date : item.po_date).format("DD MMM YYYY"),
        customercode: item.customer,
        productcode: item.product,
        productspec: item.product_spec,
        type: item.type ? capitalize(item.type) : "-",
        size: item.width
          ? `${item.width}${item.length ? `x${item.length}` : ""} ${lengthUnit[
            item.units.width
          ]?.displayName?.toUpperCase()}`
          : "-",
        pendingReels:
          item.this_item_type == "order"
            ? item.quantity -
            item.completed -
            item.in_production -
            item.in_process
            : item.total_quantity -
            item.total_completed -
            item.total_in_production -
            item.total_in_process,
        pendingWeight: item.pending_quantity_weight
          ? item.pending_quantity_weight.toFixed(3) +
          ` ${weightUnit[item.units.weight]?.display?.toUpperCase()}`
          : "-",
        coreid: item.core_id
          ? `${item.core_id} ${lengthUnit[
            item.units.core_id
          ]?.displayName?.toUpperCase()}`
          : "-",
        reelod: item.reel_od
          ? `${item.reel_od} ${lengthUnit[
            item.units.reel_od
          ]?.displayName?.toUpperCase()}`
          : "-",
        deliverydate: item.delivery_date
          ? moment(item.delivery_date).format("DD MMM YYYY")
          : "-",
        quantity:
          item.this_item_type == "order"
            ? quantityValue
              ? quantityValue + " " + item.type + "s"
              : "-"
            : item.total_quantity,
        weight:
          item.this_item_type == "order"
            ? `${parseFloat(item.weight).toFixed(3)}`
            : parseFloat(item.total_weight).toFixed(3),
        // rewinderreels: `${
        //   item.type === "reel" ? "NA" : `${item.no_of_reel_sheet} Reels`
        // }`,
        calculatedreels: "-",
        rewinderreels:
          item.this_item_type == "order"
            ? rewinderReels
              ? `${rewinderReels} Reels`
              : "-"
            : `${item.total_quantity} Reels`,
        priority: item.forced ? item.forced : "-",
        remarks: item.remarks ? item.remarks : "-",
        completed:
          item.this_item_type == "order"
            ? item.completed
            : item.total_completed,
        in_production:
          item.this_item_type == "order"
            ? item.in_production + item.in_process
            : item.total_in_production + item.total_in_process,
        pending:
          item.this_item_type == "order"
            ? item.quantity -
            item.completed -
            item.in_production -
            item.in_process
            : item.total_quantity -
            item.total_completed -
            item.total_in_production -
            item.total_in_process,
        customerName: item.customer_name,
        quantity_type: item.quantity_type ? item.quantity_type : "-",
        no_of_reel_sheet: item.no_of_reel_sheet
          ? `${item.no_of_reel_sheet}`
          : "-",
        plannedweight: item.planned_weight
          ? `${item.planned_weight !== 0 ? item.planned_weight?.toFixed(3) : 0
          } ${weightUnit[
            item.units.planned_weight
          ]?.displayName?.toUpperCase()}`
          : "-",
        showPendingToolTip: true,
        item_type: item.this_item_type,
        groupno: item.split_group ? item.split_group : "-",
        customer_alias: item.customer_alias,
        consignee_alias: item.consignee_alias,
        consignee: item.consignee,
        consignee_name: item.consignee_name,
        sheet_completed_weight: item.sheet_completed_weight
          ? item.sheet_completed_weight
          : 0,
        sheet_processed_weight: item.sheet_processed_weight
          ? item.sheet_processed_weight
          : 0,
        sheet_production_weight: item.sheet_production_weight
          ? item.sheet_production_weight
          : 0,
        pending_quantity_weight: item.pending_quantity_weight,
        units: item.units,
      };
    });

    const result = selectedDataRows.filter((f) =>
      data.some((d) => d.key == f.key)
    );
    setSelectedRowKeys(result.map((r) => r.key));
    if (result.length == data.length && result.length) {
      setIsAllSelected(true);
    } else {
      setIsAllSelected(false);
    }
    return data;
  };

  //M code
  const handleSelectRewinderOnpagination = async (
    record,
    selected,
    isPagination
  ) => {
    //setPageLoaded(false);
    setSelectedState(false);
    var array = [...selectedDataRows];
    let selectedRowIndex = tableData?.findIndex((ele) => ele.key == record.key);
    let coreIDValue = form.getFieldValue("coreDia");

    if (selected) {
      if (
        (selecteDia == "range" &&
          ((record.type == "Reel" && record.quantity_type != "reel_sheet") ||
            record.type == "Sheet")) ||
        (selecteDia == "constant" &&
          record.type == "Reel" &&
          record.quantity_type == "reel_sheet" &&
          (selectedReelOD.length == 1 || selectedReelOD.length == 0)) ||
        (selecteDia == "constant" &&
          ((record.type == "Reel" && record.quantity_type != "reel_sheet") ||
            record.type == "Sheet"))
      ) {
        if (!isPagination) setSelectedRowKeys((keys) => [...keys, record.key]);
      }

      let dataCopy = [...tableData];
      if (selecteDia == "constant") {
        let reelODArr = [];
        for (let i = 0; i < selectedReelOD?.length; i++) {
          reelODArr.push(selectedReelOD[i]?.value);
        }
        if (
          (selecteDia == "constant" &&
            record.type == "Reel" &&
            record.quantity_type == "reel_sheet" &&
            (selectedReelOD.length == 1 || selectedReelOD.length == 0)) ||
          (selecteDia == "constant" &&
            ((record.type == "Reel" && record.quantity_type != "reel_sheet") ||
              record.type == "Sheet"))
        ) {
          record.reelod = reelODArr;
          record.coreid = coreIDValue;
          record.outer_dia = reelODArr;
          record.inner_dia = coreIDValue;
          dataCopy[selectedRowIndex].reelod = reelODArr;
          dataCopy[selectedRowIndex].coreid = coreIDValue;
          dataCopy[selectedRowIndex].outer_dia = reelODArr;
          dataCopy[selectedRowIndex].inner_dia = coreIDValue;
        }
      } else {
        if (
          selecteDia == "range" &&
          ((record.type == "Reel" && record.quantity_type != "reel_sheet") ||
            record.type == "Sheet")
        ) {
          let minValue = form.getFieldValue("min_reel");
          let maxValue = form.getFieldValue("max_reel");
          record.minimum_reel_od = minValue ? minValue : "";
          record.maximum_reel_od = maxValue ? maxValue : "";
          record.units["minimum_reel_od"] = minValue
            ? form.getFieldValue("range_unit")
            : "";
          record.units["maximum_reel_od"] = maxValue
            ? form.getFieldValue("range_unit")
            : "";
          record.coreid = form.getFieldValue("core_Dia");
          record.inner_dia = form.getFieldValue("core_Dia");
          dataCopy[selectedRowIndex].minimum_reel_od = minValue
            ? form.getFieldValue("min_reel")
            : "";
          dataCopy[selectedRowIndex].maximum_reel_od = maxValue
            ? form.getFieldValue("max_reel")
            : "";
          dataCopy[selectedRowIndex].units["minimum_reel_od"] = minValue
            ? form.getFieldValue("range_unit")
            : "";
          dataCopy[selectedRowIndex].units["maximum_reel_od"] = maxValue
            ? form.getFieldValue("range_unit")
            : "";
          dataCopy[selectedRowIndex].coreid = form.getFieldValue("core_Dia");
          dataCopy[selectedRowIndex].inner_dia = form.getFieldValue("core_Dia");
        }
      }
      if (
        (selecteDia == "range" &&
          ((record.type == "Reel" && record.quantity_type != "reel_sheet") ||
            record.type == "Sheet")) ||
        (selecteDia == "constant" &&
          record.type == "Reel" &&
          record.quantity_type == "reel_sheet" &&
          (selectedReelOD.length == 1 || selectedReelOD.length == 0)) ||
        (selecteDia == "constant" &&
          ((record.type == "Reel" && record.quantity_type != "reel_sheet") ||
            record.type == "Sheet"))
      ) {
        record.id_od_type = selecteDia;
        dataCopy[selectedRowIndex].id_od_type = selecteDia;
      }

      // array.push(record);
      if (
        (selecteDia == "range" &&
          ((record.type == "Reel" && record.quantity_type != "reel_sheet") ||
            record.type == "Sheet")) ||
        (selecteDia == "constant" &&
          record.type == "Reel" &&
          record.quantity_type == "reel_sheet" &&
          (selectedReelOD.length == 1 || selectedReelOD.length == 0)) ||
        (selecteDia == "constant" &&
          ((record.type == "Reel" && record.quantity_type != "reel_sheet") ||
            record.type == "Sheet"))
      ) {
        if (!isPagination) {
          setSelectedDataRows([...selectedDataRows, record]);
          array.push(record);
        }
      }

      setTableData([...dataCopy]);
      tableDataRef.current = [...dataCopy];
      setSelectedState(true);
    } else {
      setSelectedRowKeys((keys) => {
        const index = keys.indexOf(record.key);
        return [...keys.slice(0, index), ...keys.slice(index + 1)];
      });

      var index = array.findIndex((obj) => obj.key == record.key);
      if (index !== -1) {
        array.splice(index, 1);
        setSelectedDataRows(array);
      }
      //update deselected table data row
      // console.log(dataCopy);
      let dataCopy = [...tableData];
      dataCopy[selectedRowIndex] = JSON.parse(
        JSON.stringify(tableDataCopyRef.current[selectedRowIndex])
      );
      setTableData([...dataCopy]);
      tableDataRef.current = [...dataCopy];
      setSelectedState(false);
    }

    if (array.length > 0) setIsCheckboxClicked(true);
    else setIsCheckboxClicked(false);

    const productCodes = [...new Set(array.map((r) => r.productcode))];
    const result = array.filter((f) => tableData.some((d) => d.key == f.key));
    if (result.length == tableData.length) {
      setIsAllSelected(true);
    } else {
      setIsAllSelected(false);
    }
    // await getProductDetailsForSelectedOrders(productCodes)
    //   .then((response) => {
    //     setProductDataForSelectedRows(response);
    //   })
    //   .catch((error) => {
    //     console.log("Error in getting product specification list");
    //   });

    // const result = array.filter((f) => tableData.some((d) => d.key == f.key));
    // // setSelectedRowKeys(result.map((r) => r.key));
    // if (result.length == tableData.length) {
    //   setIsAllSelected(true);
    // } else {
    //   setIsAllSelected(false);
    // }
    // setPageRerender(true);
    setTableRerender(true);
  };

  //M code
  useEffect(() => {
    if (tableData && tableData.length && paginationParamsChange) {
      for (let index = 0; index < tableData.length; index++) {
        const order = tableData[index];
        var indexValue = selectedDataRows.findIndex(
          (obj) => obj.key == order.key
        );
        if (indexValue != -1) {
          handleSelectRewinderOnpagination({ ...order }, true, true);
        }
      }
      setPaginationParamsChange(false);
    }
  }, [tableData, paginationParamsChange]);

  const onDiameterChange = (e) => {
    setSelectedDia(e);
  };

  //D code
  // const onChangeReelOdSelect = (data) => {
  //   setSelectedReelOD(data);

  //   let coreid = form.getFieldValue("coreDia");
  //   let coreodConversion =
  //     orderDim_Rewinder_Unit_Conversion[coreid.split(" ")[1]];
  //   let reelodConversion =
  //     orderDim_Rewinder_Unit_Conversion[data[0]?.value?.split(" ")[1]];
  //   let coreOD = coreid?.split(" ")[0] * coreodConversion;
  //   let reelOD = data[0]?.value?.split(" ")[0] * reelodConversion;
  //   if (data.length == 1) {
  //     if ((coreOD && parseFloat(coreOD)) > (reelOD && parseFloat(reelOD))) {
  //       setCoreOdValidationError(true);
  //     } else {
  //       if (selectedDataRows && selectedDataRows?.length) {
  //         for (let i = 0; i < selectedDataRows?.length; i++) {
  //           let tableRecordIndx = tableData.findIndex(
  //             (ele) => ele.orderno == selectedDataRows[i].orderno
  //           );
  //           let tableDataRecord = tableData[tableRecordIndx];
  //           let record = selectedDataRows[i];
  //           if (tableDataRecord) {
  //             let reelData =
  //               data[0]?.value?.split(" ")[0] +
  //               " " +
  //               data[0]?.value?.split(" ")[1];
  //             record.reelod = [reelData];
  //             record.outer_dia = [reelData];
  //             tableDataRecord.reelod = [reelData];
  //             tableDataRecord.outer_dia = [reelData];

  //             record.coreid = coreid;
  //             record.inner_dia = coreid;
  //             tableDataRecord.coreid = coreid;
  //             tableDataRecord.inner_dia = coreid;

  //             record.id_od_type = selecteDia;
  //             tableDataRecord.id_od_type = selecteDia;

  //             selectedDataRows[i] = { ...record };
  //             tableData[tableRecordIndx] = { ...tableDataRecord };
  //           }
  //         }
  //         setSelectedDataRows([...selectedDataRows]);
  //         setTableData([...tableData]);
  //       }
  //       setCoreOdValidationError(false);
  //       setSelectedState(true);
  //     }
  //   }

  //   if (data.length > 1) {
  //     let dataArr = [];
  //     for (let ind = 0; ind < data.length; ind++) {
  //       let convertedValue =
  //         data[ind]?.value?.split(" ")[0] *
  //         orderDim_Rewinder_Unit_Conversion[data[ind]?.value?.split(" ")[1]];
  //       dataArr.push(convertedValue);
  //     }
  //     let minValue = Math.min(...dataArr);

  //     if ((coreOD && parseFloat(coreOD)) > (minValue && parseFloat(minValue))) {
  //       setCoreOdValidationError(true);
  //     } else {
  //       if (selectedDataRows && selectedDataRows?.length) {
  //         for (let i = 0; i < selectedDataRows?.length; i++) {
  //           let tableRecordIndx = tableData.findIndex(
  //             (ele) => ele.orderno == selectedDataRows[i].orderno
  //           );
  //           let tableDataRecord = tableData[tableRecordIndx];
  //           let record = selectedDataRows[i];
  //           if (
  //             tableDataRecord &&
  //             ((selecteDia == "constant" &&
  //               record.type == "Reel" &&
  //               record.quantity_type == "reel_sheet" &&
  //               data.length == 1) ||
  //               (selecteDia == "constant" &&
  //                 ((record.type == "Reel" &&
  //                   record.quantity_type == "weight") ||
  //                   record.type == "Sheet")))
  //           ) {
  //             let reelDataArr = [];
  //             for (let k = 0; k < data.length; k++) {
  //               let reelData =
  //                 data[k]?.value?.split(" ")[0] +
  //                 " " +
  //                 data[k]?.value?.split(" ")[1];
  //               reelDataArr.push(reelData);
  //             }
  //             record.reelod = reelDataArr;
  //             record.outer_dia = reelDataArr;
  //             tableDataRecord.reelod = reelDataArr;
  //             tableDataRecord.outer_dia = reelDataArr;

  //             record.coreid = coreid;
  //             record.inner_dia = coreid;
  //             tableDataRecord.coreid = coreid;
  //             tableDataRecord.inner_dia = coreid;

  //             record.id_od_type = selecteDia;
  //             tableDataRecord.id_od_type = selecteDia;

  //             selectedDataRows[i] = { ...record };
  //             tableData[tableRecordIndx] = { ...tableDataRecord };
  //           }
  //         }
  //         setSelectedDataRows([...selectedDataRows]);
  //         setTableData([...tableData]);
  //         setSelectedState(true);
  //       }
  //       setCoreOdValidationError(false);
  //     }
  //   }

  //   if (data.length == 0) {
  //     if (selectedDataRows && selectedDataRows?.length) {
  //       for (let i = 0; i < selectedDataRows?.length; i++) {
  //         let tableRecordIndx = tableData.findIndex(
  //           (ele) => ele.orderno == selectedDataRows[i].orderno
  //         );
  //         let tableDataRecord = tableData[tableRecordIndx];
  //         let record = selectedDataRows[i];
  //         if (tableDataRecord) {
  //           record.reelod = JSON.parse(
  //             JSON.stringify(tableDataCopyRef.current[tableRecordIndx].reelod)
  //           );
  //           record.outer_dia = JSON.parse(
  //             JSON.stringify(
  //               tableDataCopyRef.current[tableRecordIndx].outer_dia
  //             )
  //           );
  //           tableDataRecord.reelod = JSON.parse(
  //             JSON.stringify(tableDataCopyRef.current[tableRecordIndx].reelod)
  //           );
  //           tableDataRecord.outer_dia = JSON.parse(
  //             JSON.stringify(
  //               tableDataCopyRef.current[tableRecordIndx].outer_dia
  //             )
  //           );

  //           selectedDataRows[i] = { ...record };
  //           tableData[tableRecordIndx] = { ...tableDataRecord };
  //         }
  //       }
  //       setSelectedDataRows([...selectedDataRows]);
  //       setTableData([...tableData]);
  //       setSelectedState(true);
  //     }
  //   }
  //   setTableRerender(true);
  // };

  // const onCoreodChange = (e) => {
  //   let coreodConversion = orderDim_Rewinder_Unit_Conversion[e?.split(" ")[1]];
  //   let reelodConversion =
  //     orderDim_Rewinder_Unit_Conversion[
  //       selectedReelOD[0]?.value?.split(" ")[1]
  //     ];
  //   let coreOD = e?.split(" ")[0] * coreodConversion;
  //   let reelOD = selectedReelOD[0]?.value?.split(" ")[0] * reelodConversion;

  //   let dataArr = [];
  //   for (let ind = 0; ind < selectedReelOD.length; ind++) {
  //     let convertedValue =
  //       selectedReelOD[ind]?.value?.split(" ")[0] *
  //       orderDim_Rewinder_Unit_Conversion[
  //         selectedReelOD[ind]?.value?.split(" ")[1]
  //       ];
  //     dataArr.push(convertedValue);
  //   }
  //   let minValue = Math.min(...dataArr);

  //   if (
  //     ((coreOD && parseFloat(coreOD)) > (reelOD && parseFloat(reelOD)) &&
  //       selectedReelOD.length == 1) ||
  //     ((coreOD && parseFloat(coreOD)) > (minValue && parseFloat(minValue)) &&
  //       selectedReelOD.length > 1)
  //   ) {
  //     setCoreOdValidationError(true);
  //   } else {
  //     if (selectedDataRows && selectedDataRows?.length) {
  //       for (let i = 0; i < selectedDataRows?.length; i++) {
  //         let tableRecordIndx = tableData.findIndex(
  //           (ele) => ele.orderno == selectedDataRows[i].orderno
  //         );
  //         let tableDataRecord = tableData[tableRecordIndx];
  //         let record = selectedDataRows[i];
  //         if (tableDataRecord) {
  //           record.coreid = e;
  //           record.inner_dia = e;
  //           tableDataRecord.coreid = e;
  //           tableDataRecord.inner_dia = e;

  //           let reelDataArr = [];
  //           if (
  //             record.type.toLowerCase() == "reel" &&
  //             record.quantity_type == "reel_sheet" &&
  //             selectedReelOD?.length
  //           ) {
  //             reelDataArr.push(selectedReelOD[0]?.value);
  //           } else {
  //             for (let k = 0; k < selectedReelOD.length; k++) {
  //               let reelData =
  //                 selectedReelOD[k]?.value?.split(" ")[0] +
  //                 " " +
  //                 selectedReelOD[k]?.value?.split(" ")[1];
  //               reelDataArr.push(reelData);
  //             }
  //           }

  //           record.reelod = reelDataArr;
  //           record.outer_dia = reelDataArr;
  //           tableDataRecord.reelod = reelDataArr;
  //           tableDataRecord.outer_dia = reelDataArr;

  //           record.id_od_type = selecteDia;
  //           tableDataRecord.id_od_type = selecteDia;

  //           selectedDataRows[i] = { ...record };
  //           tableData[tableRecordIndx] = { ...tableDataRecord };
  //         }
  //       }
  //       setSelectedDataRows([...selectedDataRows]);
  //       setTableData([...tableData]);
  //     }
  //     setCoreOdValidationError(false);
  //     setSelectedState(true);
  //   }
  //   setTableRerender(true);
  // };

  // const onCoreDiaChange = (e) => {
  //   let rangeUnit = form.getFieldValue("range_unit");
  //   let minReel = form.getFieldValue("min_reel");
  //   let maxReel = form.getFieldValue("max_reel");

  //   let coreodConversion = orderDim_Rewinder_Unit_Conversion[e?.split(" ")[1]];
  //   let minReelConversion = orderDim_Rewinder_Unit_Conversion[rangeUnit];

  //   let coreOD = e?.split(" ")[0] * coreodConversion;
  //   let reelOD = minReel * minReelConversion;

  //   if ((reelOD && parseFloat(reelOD)) < (coreOD && parseFloat(coreOD))) {
  //     setRangeValidationError(true);
  //   } else {
  //     setRangeValidationError(false);
  //   }

  //   if (selectedDataRows && selectedDataRows?.length) {
  //     for (let i = 0; i < selectedDataRows?.length; i++) {
  //       let tableRecordIndx = tableData.findIndex(
  //         (ele) => ele.orderno == selectedDataRows[i].orderno
  //       );
  //       let tableDataRecord = tableData[tableRecordIndx];
  //       let record = selectedDataRows[i];
  //       if (
  //         tableDataRecord &&
  //         selecteDia == "range" &&
  //         ((record.quantity_type != "reel_sheet" && record.type == "Reel") ||
  //           record.type == "Sheet")
  //       ) {
  //         record.inner_dia = e;
  //         record.coreid = e;
  //         tableDataRecord.inner_dia = e;
  //         tableDataRecord.coreid = e;

  //         record.minimum_reel_od = minReel ? minReel : "";
  //         tableDataRecord.minimum_reel_od = minReel ? minReel : "";
  //         record.units["minimum_reel_od"] = minReel ? rangeUnit : "";
  //         tableDataRecord.units["minimum_reel_od"] = minReel ? rangeUnit : "";

  //         record.maximum_reel_od = maxReel ? maxReel : "";
  //         tableDataRecord.maximum_reel_od = maxReel ? maxReel : "";
  //         record.units["maximum_reel_od"] = maxReel ? rangeUnit : "";
  //         tableDataRecord.units["maximum_reel_od"] = maxReel ? rangeUnit : "";

  //         record.id_od_type = selecteDia;
  //         tableDataRecord.id_od_type = selecteDia;
  //       }
  //       selectedDataRows[i] = { ...record };
  //       tableData[tableRecordIndx] = { ...tableDataRecord };
  //     }
  //     setSelectedDataRows([...selectedDataRows]);
  //     setTableData([...tableData]);
  //     setSelectedState(true);
  //   }
  //   setReelODValidationError(false);
  //   setTableRerender(true);
  // };

  // const onRangeUnitChange = (e) => {
  //   if (selectedDataRows && selectedDataRows?.length) {
  //     let minReel = form.getFieldValue("min_reel");
  //     let maxReel = form.getFieldValue("max_reel");
  //     let coreDia = form.getFieldValue("core_Dia");

  //     let coreodConversion =
  //       orderDim_Rewinder_Unit_Conversion[coreDia?.split(" ")[1]];
  //     let minReelConversion = orderDim_Rewinder_Unit_Conversion[e];

  //     let coreOD = coreDia?.split(" ")[0] * coreodConversion;
  //     let reelOD = minReel * minReelConversion;

  //     if ((reelOD && parseFloat(reelOD)) < (coreOD && parseFloat(coreOD))) {
  //       setRangeValidationError(true);
  //     } else {
  //       setRangeValidationError(false);
  //     }

  //     for (let i = 0; i < selectedDataRows?.length; i++) {
  //       let tableRecordIndx = tableData.findIndex(
  //         (ele) => ele.orderno == selectedDataRows[i].orderno
  //       );
  //       let tableDataRecord = tableData[tableRecordIndx];
  //       let record = selectedDataRows[i];
  //       if (
  //         tableDataRecord &&
  //         selecteDia == "range" &&
  //         ((record.type == "Reel" && record.quantity_type != "reel_sheet") ||
  //           record.type == "Sheet")
  //       ) {
  //         record.maximum_reel_od = maxReel ? maxReel : "";
  //         tableDataRecord.maximum_reel_od = maxReel ? maxReel : "";
  //         record.units["maximum_reel_od"] = maxReel ? e : "";
  //         tableDataRecord.units["maximum_reel_od"] = maxReel ? e : "";

  //         record.minimum_reel_od = minReel ? minReel : "";
  //         tableDataRecord.minimum_reel_od = minReel ? minReel : "";
  //         record.units["minimum_reel_od"] = minReel ? e : "";
  //         tableDataRecord.units["minimum_reel_od"] = minReel ? e : "";

  //         record.id_od_type = selecteDia;
  //         tableDataRecord.id_od_type = selecteDia;

  //         record.inner_dia = coreDia;
  //         record.coreid = coreDia;
  //         tableDataRecord.inner_dia = coreDia;
  //         tableDataRecord.coreid = coreDia;
  //       }
  //       selectedDataRows[i] = { ...record };
  //       tableData[tableRecordIndx] = { ...tableDataRecord };
  //     }
  //     setSelectedDataRows([...selectedDataRows]);
  //     setTableData([...tableData]);
  //     setSelectedState(true);
  //   }
  //   setTableRerender(true);
  // };

  // const removeReelOD = (data) => {
  //   let array = selectedReelOD;
  //   let coreid = form.getFieldValue("coreDia");
  //   let newArray = array.filter((item) => {
  //     return !(item.value === data.value);
  //   });
  //   setSelectedReelOD(newArray);
  //   if (newArray && newArray?.length == 0) {
  //     if (selectedDataRows && selectedDataRows?.length) {
  //       for (let i = 0; i < selectedDataRows?.length; i++) {
  //         let tableRecordIndx = tableData.findIndex(
  //           (ele) => ele.orderno == selectedDataRows[i].orderno
  //         );
  //         let tableDataRecord = tableData[tableRecordIndx];
  //         let record = selectedDataRows[i];
  //         if (tableDataRecord) {
  //           record.reelod = JSON.parse(
  //             JSON.stringify(tableDataCopyRef.current[tableRecordIndx].reelod)
  //           );
  //           record.outer_dia = JSON.parse(
  //             JSON.stringify(
  //               tableDataCopyRef.current[tableRecordIndx].outer_dia
  //             )
  //           );
  //           tableDataRecord.reelod = JSON.parse(
  //             JSON.stringify(tableDataCopyRef.current[tableRecordIndx].reelod)
  //           );
  //           tableDataRecord.outer_dia = JSON.parse(
  //             JSON.stringify(
  //               tableDataCopyRef.current[tableRecordIndx].outer_dia
  //             )
  //           );

  //           selectedDataRows[i] = { ...record };
  //           tableData[tableRecordIndx] = { ...tableDataRecord };
  //         }
  //       }
  //       setSelectedDataRows([...selectedDataRows]);
  //       setTableData([...tableData]);
  //       setSelectedState(true);
  //     }
  //     setCoreOdValidationError(false);
  //   }
  //   if (newArray && newArray?.length == 1) {
  //     let coreodConversion =
  //       orderDim_Rewinder_Unit_Conversion[coreid.split(" ")[1]];
  //     let reelodConversion =
  //       orderDim_Rewinder_Unit_Conversion[newArray[0]?.value?.split(" ")[1]];
  //     let coreOD = coreid?.split(" ")[0] * coreodConversion;
  //     let reelOD = newArray[0]?.value?.split(" ")[0] * reelodConversion;

  //     if ((coreOD && parseFloat(coreOD)) > (reelOD && parseFloat(reelOD))) {
  //       setCoreOdValidationError(true);
  //     } else {
  //       setCoreOdValidationError(false);
  //     }

  //     if (selectedDataRows && selectedDataRows?.length) {
  //       for (let i = 0; i < selectedDataRows?.length; i++) {
  //         let tableRecordIndx = tableData.findIndex(
  //           (ele) => ele.orderno == selectedDataRows[i].orderno
  //         );
  //         let tableDataRecord = tableData[tableRecordIndx];
  //         let record = selectedDataRows[i];
  //         if (tableDataRecord) {
  //           let reelDataArr = [];
  //           for (let k = 0; k < newArray.length; k++) {
  //             let reelData =
  //               newArray[k]?.value?.split(" ")[0] +
  //               " " +
  //               newArray[k]?.value?.split(" ")[1];
  //             reelDataArr.push(reelData);
  //           }
  //           record.reelod = reelDataArr;
  //           record.outer_dia = reelDataArr;
  //           tableDataRecord.reelod = reelDataArr;
  //           tableDataRecord.outer_dia = reelDataArr;

  //           record.coreid = coreid;
  //           record.inner_dia = coreid;
  //           tableDataRecord.coreid = coreid;
  //           tableDataRecord.inner_dia = coreid;

  //           record.id_od_type = selecteDia;
  //           tableDataRecord.id_od_type = selecteDia;

  //           selectedDataRows[i] = { ...record };
  //           tableData[tableRecordIndx] = { ...tableDataRecord };
  //         }
  //       }
  //       setSelectedDataRows([...selectedDataRows]);
  //       setTableData([...tableData]);
  //       setSelectedState(true);
  //     }
  //   }
  //   if (newArray.length > 1) {
  //     let coreodConversion =
  //       orderDim_Rewinder_Unit_Conversion[coreid.split(" ")[1]];
  //     let coreOD = coreid?.split(" ")[0] * coreodConversion;
  //     let dataArr = [];
  //     for (let ind = 0; ind < newArray.length; ind++) {
  //       let convertedValue =
  //         newArray[ind]?.value?.split(" ")[0] *
  //         orderDim_Rewinder_Unit_Conversion[
  //           newArray[ind]?.value?.split(" ")[1]
  //         ];
  //       dataArr.push(convertedValue);
  //     }
  //     let minValue = Math.min(...dataArr);

  //     if ((coreOD && parseFloat(coreOD)) > (minValue && parseFloat(minValue))) {
  //       setCoreOdValidationError(true);
  //     } else {
  //       setCoreOdValidationError(false);
  //     }

  //     if (selectedDataRows && selectedDataRows?.length) {
  //       for (let i = 0; i < selectedDataRows?.length; i++) {
  //         let tableRecordIndx = tableData.findIndex(
  //           (ele) => ele.orderno == selectedDataRows[i].orderno
  //         );
  //         let tableDataRecord = tableData[tableRecordIndx];
  //         let record = selectedDataRows[i];
  //         if (
  //           tableDataRecord &&
  //           ((selecteDia == "constant" &&
  //             record.type == "Reel" &&
  //             record.quantity_type == "reel_sheet" &&
  //             data.length == 1) ||
  //             (selecteDia == "constant" &&
  //               ((record.type == "Reel" &&
  //                 record.quantity_type != "reel_sheet") ||
  //                 record.type == "Sheet")))
  //         ) {
  //           let reelDataArr = [];
  //           for (let k = 0; k < newArray.length; k++) {
  //             let reelData =
  //               newArray[k]?.value?.split(" ")[0] +
  //               " " +
  //               newArray[k]?.value?.split(" ")[1];
  //             reelDataArr.push(reelData);
  //           }
  //           record.reelod = reelDataArr;
  //           record.outer_dia = reelDataArr;
  //           tableDataRecord.reelod = reelDataArr;
  //           tableDataRecord.outer_dia = reelDataArr;

  //           record.coreid = coreid;
  //           record.inner_dia = coreid;
  //           tableDataRecord.coreid = coreid;
  //           tableDataRecord.inner_dia = coreid;

  //           record.id_od_type = selecteDia;
  //           tableDataRecord.id_od_type = selecteDia;

  //           selectedDataRows[i] = { ...record };
  //           tableData[tableRecordIndx] = { ...tableDataRecord };
  //         }
  //       }
  //       setSelectedDataRows([...selectedDataRows]);
  //       setTableData([...tableData]);
  //       setSelectedState(true);
  //     }
  //   }
  //   setTableRerender(true);
  // };

  // const onMinReelODChange = (e) => {
  //   let rangeInnerDia = form.getFieldValue("core_Dia");
  //   let rangeUnit = form.getFieldValue("range_unit");

  //   let coreodConversion =
  //     orderDim_Rewinder_Unit_Conversion[rangeInnerDia.split(" ")[1]];
  //   let minReelConversion = orderDim_Rewinder_Unit_Conversion[rangeUnit];
  //   let coreOD = rangeInnerDia?.split(" ")[0] * coreodConversion;
  //   let reelOD = e.target.value * minReelConversion;

  //   if ((reelOD && parseFloat(reelOD)) < (coreOD && parseFloat(coreOD))) {
  //     setRangeValidationError(true);
  //   } else {
  //     setRangeValidationError(false);
  //   }

  //   if (
  //     (e.target.value && parseFloat(e.target.value)) >
  //     (form.getFieldValue("max_reel") &&
  //       parseFloat(form.getFieldValue("max_reel")))
  //   ) {
  //     setReelODValidationError(true);
  //   } else {
  //     if (selectedDataRows && selectedDataRows?.length) {
  //       let maxReel = form.getFieldValue("max_reel");
  //       for (let i = 0; i < selectedDataRows?.length; i++) {
  //         let tableRecordIndx = tableData.findIndex(
  //           (ele) => ele.orderno == selectedDataRows[i].orderno
  //         );
  //         let tableDataRecord = tableData[tableRecordIndx];
  //         let record = selectedDataRows[i];
  //         if (
  //           tableDataRecord &&
  //           selecteDia == "range" &&
  //           ((record.type == "Reel" && record.quantity_type != "reel_sheet") ||
  //             record.type == "Sheet")
  //         ) {
  //           record.minimum_reel_od = e.target.value ? e.target.value : "";
  //           tableDataRecord.minimum_reel_od = e.target.value
  //             ? e.target.value
  //             : "";
  //           record.units["minimum_reel_od"] = e.target.value ? rangeUnit : "";
  //           tableDataRecord.units["minimum_reel_od"] = e.target.value
  //             ? rangeUnit
  //             : "";

  //           record.maximum_reel_od = maxReel ? maxReel : "";
  //           tableDataRecord.maximum_reel_od = maxReel ? maxReel : "";
  //           record.units["maximum_reel_od"] = maxReel ? rangeUnit : "";
  //           tableDataRecord.units["maximum_reel_od"] = maxReel ? rangeUnit : "";

  //           record.id_od_type = selecteDia;
  //           tableDataRecord.id_od_type = selecteDia;

  //           record.inner_dia = rangeInnerDia;
  //           record.coreid = rangeInnerDia;
  //           tableDataRecord.inner_dia = rangeInnerDia;
  //           tableDataRecord.coreid = rangeInnerDia;

  //           selectedDataRows[i] = { ...record };
  //           tableData[tableRecordIndx] = { ...tableDataRecord };
  //         }
  //       }
  //       setSelectedDataRows([...selectedDataRows]);
  //       setTableData([...tableData]);
  //       setSelectedState(true);
  //     }
  //     setTableRerender(true);
  //     setReelODValidationError(false);
  //   }
  //   setTableRerender(true);
  // };

  // const onMaxReelODChange = (e) => {
  //   if (
  //     (e.target.value && parseFloat(e.target.value)) <
  //     (form.getFieldValue("min_reel") &&
  //       parseFloat(form.getFieldValue("min_reel")))
  //   ) {
  //     setReelODValidationError(true);
  //   } else {
  //     if (selectedDataRows && selectedDataRows?.length) {
  //       let rangeUnit = form.getFieldValue("range_unit");
  //       let minReel = form.getFieldValue("min_reel");
  //       let rangeInnerDia = form.getFieldValue("core_Dia");
  //       for (let i = 0; i < selectedDataRows?.length; i++) {
  //         let tableRecordIndx = tableData.findIndex(
  //           (ele) => ele.orderno == selectedDataRows[i].orderno
  //         );
  //         if (tableRecordIndx == 0 || tableRecordIndx != -1) {
  //           let tableDataRecord = tableData[tableRecordIndx];
  //           let record = selectedDataRows[i];
  //           if (
  //             tableDataRecord &&
  //             selecteDia == "range" &&
  //             ((record.type == "Reel" &&
  //               record.quantity_type != "reel_sheet") ||
  //               record.type == "Sheet")
  //           ) {
  //             record["maximum_reel_od"] = e.target.value ? e.target.value : "";
  //             tableDataRecord["maximum_reel_od"] = e.target.value
  //               ? e.target.value
  //               : "";
  //             record.units["maximum_reel_od"] = e.target.value ? rangeUnit : "";
  //             tableDataRecord.units["maximum_reel_od"] = e.target.value
  //               ? rangeUnit
  //               : "";

  //             record["minimum_reel_od"] = minReel ? minReel : "";
  //             tableDataRecord["minimum_reel_od"] = minReel ? minReel : "";
  //             record.units["minimum_reel_od"] = minReel ? rangeUnit : "";
  //             tableDataRecord.units["minimum_reel_od"] = minReel
  //               ? rangeUnit
  //               : "";

  //             record.id_od_type = selecteDia;
  //             tableDataRecord.id_od_type = selecteDia;

  //             record.inner_dia = rangeInnerDia;
  //             record.coreid = rangeInnerDia;
  //             tableDataRecord.inner_dia = rangeInnerDia;
  //             tableDataRecord.coreid = rangeInnerDia;
  //           }
  //           selectedDataRows[i] = { ...record };
  //           tableData[tableRecordIndx] = { ...tableDataRecord };
  //         }
  //       }
  //       setSelectedDataRows([...selectedDataRows]);
  //       setTableData([...tableData]);
  //       setSelectedState(true);
  //     }
  //     setTableRerender(true);
  //     setReelODValidationError(false);
  //   }
  //   setTableRerender(true);
  // };

  //M code
  const onChangeReelOdSelect = (data) => {
    setSelectedReelOD(data);

    let coreid = form.getFieldValue("coreDia");
    let coreodConversion =
      orderDim_Rewinder_Unit_Conversion[coreid?.split(" ")[1]];
    let reelodConversion =
      orderDim_Rewinder_Unit_Conversion[data[0]?.value?.split(" ")[1]];
    let coreOD = coreid?.split(" ")[0] * coreodConversion;
    let reelOD = data[0]?.value?.split(" ")[0] * reelodConversion;
    if (data.length == 1) {
      if ((coreOD && parseFloat(coreOD)) > (reelOD && parseFloat(reelOD))) {
        setCoreOdValidationError(true);
      } else {
        if (selectedDataRows && selectedDataRows?.length) {
          for (let i = 0; i < selectedDataRows?.length; i++) {
            let tableRecordIndx = tableData.findIndex(
              (ele) => ele.orderno == selectedDataRows[i].orderno
            );
            let tableDataRecord = tableData[tableRecordIndx];
            let record = selectedDataRows[i];
            if (tableRecordIndx != -1 && tableDataRecord) {
              let reelData =
                data[0]?.value?.split(" ")[0] +
                " " +
                data[0]?.value?.split(" ")[1];
              record.reelod = [reelData];
              record.outer_dia = [reelData];
              tableDataRecord.reelod = [reelData];
              tableDataRecord.outer_dia = [reelData];

              record.coreid = coreid;
              record.inner_dia = coreid;
              tableDataRecord.coreid = coreid;
              tableDataRecord.inner_dia = coreid;

              record.id_od_type = selecteDia;
              tableDataRecord.id_od_type = selecteDia;

              selectedDataRows[i] = { ...record };
              tableData[tableRecordIndx] = { ...tableDataRecord };
            } else {
              let reelData =
                data[0]?.value?.split(" ")[0] +
                " " +
                data[0]?.value?.split(" ")[1];
              record.reelod = [reelData];
              record.outer_dia = [reelData];
              //tableDataRecord.reelod = [reelData];
              //tableDataRecord.outer_dia = [reelData];

              record.coreid = coreid;
              record.inner_dia = coreid;
              //tableDataRecord.coreid = coreid;
              //tableDataRecord.inner_dia = coreid;

              record.id_od_type = selecteDia;
              //tableDataRecord.id_od_type = selecteDia;

              selectedDataRows[i] = { ...record };
              //tableData[tableRecordIndx] = { ...tableDataRecord };
            }
          }
          setSelectedDataRows([...selectedDataRows]);
          setTableData([...tableData]);
        }
        setCoreOdValidationError(false);
        setSelectedState(true);
      }
    }

    if (data.length > 1) {
      let dataArr = [];
      for (let ind = 0; ind < data.length; ind++) {
        let convertedValue =
          data[ind]?.value?.split(" ")[0] *
          orderDim_Rewinder_Unit_Conversion[data[ind]?.value?.split(" ")[1]];
        dataArr.push(convertedValue);
      }
      let minValue = Math.min(...dataArr);

      if ((coreOD && parseFloat(coreOD)) > (minValue && parseFloat(minValue))) {
        setCoreOdValidationError(true);
      } else {
        if (selectedDataRows && selectedDataRows?.length) {
          for (let i = 0; i < selectedDataRows?.length; i++) {
            let tableRecordIndx = tableData.findIndex(
              (ele) => ele.orderno == selectedDataRows[i].orderno
            );
            let tableDataRecord = tableData[tableRecordIndx];
            let record = selectedDataRows[i];
            if (
              tableRecordIndx != -1 &&
              tableDataRecord &&
              ((selecteDia == "constant" &&
                record.type == "Reel" &&
                record.quantity_type == "reel_sheet" &&
                data.length == 1) ||
                (selecteDia == "constant" &&
                  ((record.type == "Reel" &&
                    record.quantity_type == "weight") ||
                    record.type == "Sheet")))
            ) {
              let reelDataArr = [];
              for (let k = 0; k < data.length; k++) {
                let reelData =
                  data[k]?.value?.split(" ")[0] +
                  " " +
                  data[k]?.value?.split(" ")[1];
                reelDataArr.push(reelData);
              }
              record.reelod = reelDataArr;
              record.outer_dia = reelDataArr;
              tableDataRecord.reelod = reelDataArr;
              tableDataRecord.outer_dia = reelDataArr;

              record.coreid = coreid;
              record.inner_dia = coreid;
              tableDataRecord.coreid = coreid;
              tableDataRecord.inner_dia = coreid;

              record.id_od_type = selecteDia;
              tableDataRecord.id_od_type = selecteDia;

              selectedDataRows[i] = { ...record };
              tableData[tableRecordIndx] = { ...tableDataRecord };
            } else if (
              (selecteDia == "constant" &&
                record.type == "Reel" &&
                record.quantity_type == "reel_sheet" &&
                data.length == 1) ||
              (selecteDia == "constant" &&
                ((record.type == "Reel" && record.quantity_type == "weight") ||
                  record.type == "Sheet"))
            ) {
              let reelDataArr = [];
              for (let k = 0; k < data.length; k++) {
                let reelData =
                  data[k]?.value?.split(" ")[0] +
                  " " +
                  data[k]?.value?.split(" ")[1];
                reelDataArr.push(reelData);
              }
              record.reelod = reelDataArr;
              record.outer_dia = reelDataArr;
              //tableDataRecord.reelod = reelDataArr;
              //tableDataRecord.outer_dia = reelDataArr;

              record.coreid = coreid;
              record.inner_dia = coreid;
              //tableDataRecord.coreid = coreid;
              //tableDataRecord.inner_dia = coreid;

              record.id_od_type = selecteDia;
              //tableDataRecord.id_od_type = selecteDia;

              selectedDataRows[i] = { ...record };
              //tableData[tableRecordIndx] = { ...tableDataRecord };
            }
          }
          let finalData = [...tableData];
          setSelectedDataRows([...selectedDataRows]);
          setTableData([...finalData]);
          setSelectedState(true);
        }
        setCoreOdValidationError(false);
      }
    }

    if (data.length == 0) {
      if (selectedDataRows && selectedDataRows?.length) {
        for (let i = 0; i < selectedDataRows?.length; i++) {
          let tableRecordIndx = tableData.findIndex(
            (ele) => ele.orderno == selectedDataRows[i].orderno
          );
          let tableDataRecord = tableData[tableRecordIndx];
          let record = selectedDataRows[i];
          if (tableRecordIndx != -1 && tableDataRecord) {
            record.reelod = JSON.parse(
              JSON.stringify(tableDataCopyRef.current[tableRecordIndx].reelod)
            );
            record.outer_dia = JSON.parse(
              JSON.stringify(
                tableDataCopyRef.current[tableRecordIndx].outer_dia
              )
            );
            tableDataRecord.reelod = JSON.parse(
              JSON.stringify(tableDataCopyRef.current[tableRecordIndx].reelod)
            );
            tableDataRecord.outer_dia = JSON.parse(
              JSON.stringify(
                tableDataCopyRef.current[tableRecordIndx].outer_dia
              )
            );

            selectedDataRows[i] = { ...record };
            tableData[tableRecordIndx] = { ...tableDataRecord };
          }
        }
        setSelectedDataRows([...selectedDataRows]);
        setTableData([...tableData]);
        setSelectedState(true);
      }
    }
    setTableRerender(true);
    // setPageRerender(true);
  };

  const onCoreodChange = (e) => {
    let coreodConversion = orderDim_Rewinder_Unit_Conversion[e?.split(" ")[1]];
    let reelodConversion =
      orderDim_Rewinder_Unit_Conversion[
      selectedReelOD[0]?.value?.split(" ")[1]
      ];
    let coreOD = e?.split(" ")[0] * coreodConversion;
    let reelOD = selectedReelOD[0]?.value?.split(" ")[0] * reelodConversion;

    let dataArr = [];
    for (let ind = 0; ind < selectedReelOD.length; ind++) {
      let convertedValue =
        selectedReelOD[ind]?.value?.split(" ")[0] *
        orderDim_Rewinder_Unit_Conversion[
        selectedReelOD[ind]?.value?.split(" ")[1]
        ];
      dataArr.push(convertedValue);
    }
    let minValue = Math.min(...dataArr);

    if (
      ((coreOD && parseFloat(coreOD)) > (reelOD && parseFloat(reelOD)) &&
        selectedReelOD.length == 1) ||
      ((coreOD && parseFloat(coreOD)) > (minValue && parseFloat(minValue)) &&
        selectedReelOD.length > 1)
    ) {
      setCoreOdValidationError(true);
    } else {
      if (selectedDataRows && selectedDataRows?.length) {
        for (let i = 0; i < selectedDataRows?.length; i++) {
          let tableRecordIndx = tableData.findIndex(
            (ele) => ele.orderno == selectedDataRows[i].orderno
          );
          let tableDataRecord = tableData[tableRecordIndx];
          let record = selectedDataRows[i];
          if (tableRecordIndx != -1 && tableDataRecord) {
            record.coreid = e;
            record.inner_dia = e;
            tableDataRecord.coreid = e;
            tableDataRecord.inner_dia = e;

            let reelDataArr = [];
            if (
              record.type.toLowerCase() == "reel" &&
              record.quantity_type == "reel_sheet" &&
              selectedReelOD?.length
            ) {
              reelDataArr.push(selectedReelOD[0]?.value);
            } else {
              for (let k = 0; k < selectedReelOD.length; k++) {
                let reelData =
                  selectedReelOD[k]?.value?.split(" ")[0] +
                  " " +
                  selectedReelOD[k]?.value?.split(" ")[1];
                reelDataArr.push(reelData);
              }
            }

            record.reelod = reelDataArr;
            record.outer_dia = reelDataArr;
            tableDataRecord.reelod = reelDataArr;
            tableDataRecord.outer_dia = reelDataArr;

            record.id_od_type = selecteDia;
            tableDataRecord.id_od_type = selecteDia;

            selectedDataRows[i] = { ...record };
            tableData[tableRecordIndx] = { ...tableDataRecord };
          } else {
            record.coreid = e;
            record.inner_dia = e;

            let reelDataArr = [];
            if (
              record.type.toLowerCase() == "reel" &&
              record.quantity_type == "reel_sheet" &&
              selectedReelOD?.length
            ) {
              reelDataArr.push(selectedReelOD[0]?.value);
            } else {
              for (let k = 0; k < selectedReelOD.length; k++) {
                let reelData =
                  selectedReelOD[k]?.value?.split(" ")[0] +
                  " " +
                  selectedReelOD[k]?.value?.split(" ")[1];
                reelDataArr.push(reelData);
              }
            }

            record.reelod = reelDataArr;
            record.outer_dia = reelDataArr;

            record.id_od_type = selecteDia;
            // tableDataRecord.id_od_type = selecteDia;

            selectedDataRows[i] = { ...record };
            //tableData[tableRecordIndx] = { ...tableDataRecord };
          }
        }
        let finalselectedData = [...selectedDataRows];
        let finalData = [...tableData];
        setSelectedDataRows([...finalselectedData]);
        setTableData([...finalData]);
      }
      setCoreOdValidationError(false);
      setSelectedState(true);
    }
    setTableRerender(true);
    // setPageRerender(true);
  };

  const onCoreDiaChange = (e) => {
    let rangeUnit = form.getFieldValue("range_unit");
    let minReel = form.getFieldValue("min_reel");
    let maxReel = form.getFieldValue("max_reel");

    let coreodConversion = orderDim_Rewinder_Unit_Conversion[e?.split(" ")[1]];
    let minReelConversion = orderDim_Rewinder_Unit_Conversion[rangeUnit];

    let coreOD = e?.split(" ")[0] * coreodConversion;
    let reelOD = minReel * minReelConversion;

    if ((reelOD && parseFloat(reelOD)) < (coreOD && parseFloat(coreOD))) {
      setRangeValidationError(true);
    } else {
      setRangeValidationError(false);
    }

    if (selectedDataRows && selectedDataRows?.length) {
      for (let i = 0; i < selectedDataRows?.length; i++) {
        let tableRecordIndx = tableData.findIndex(
          (ele) => ele.orderno == selectedDataRows[i].orderno
        );
        let tableDataRecord = tableData[tableRecordIndx];
        let record = selectedDataRows[i];
        if (
          tableRecordIndx != -1 &&
          tableDataRecord &&
          selecteDia == "range" &&
          ((record.quantity_type != "reel_sheet" && record.type == "Reel") ||
            record.type == "Sheet")
        ) {
          record.inner_dia = e;
          record.coreid = e;
          tableDataRecord.inner_dia = e;
          tableDataRecord.coreid = e;

          record.minimum_reel_od = minReel ? minReel : "";
          tableDataRecord.minimum_reel_od = minReel ? minReel : "";
          record.units["minimum_reel_od"] = minReel ? rangeUnit : "";
          tableDataRecord.units["minimum_reel_od"] = minReel ? rangeUnit : "";

          record.maximum_reel_od = maxReel ? maxReel : "";
          tableDataRecord.maximum_reel_od = maxReel ? maxReel : "";
          record.units["maximum_reel_od"] = maxReel ? rangeUnit : "";
          tableDataRecord.units["maximum_reel_od"] = maxReel ? rangeUnit : "";

          record.id_od_type = selecteDia;
          tableDataRecord.id_od_type = selecteDia;
        } else if (
          selecteDia == "range" &&
          ((record.quantity_type != "reel_sheet" && record.type == "Reel") ||
            record.type == "Sheet")
        ) {
          record.inner_dia = e;
          record.coreid = e;
          //tableDataRecord.inner_dia = e;
          // tableDataRecord.coreid = e;

          record.minimum_reel_od = minReel ? minReel : "";
          //tableDataRecord.minimum_reel_od = minReel ? minReel : "";
          record.units["minimum_reel_od"] = minReel ? rangeUnit : "";
          //tableDataRecord.units["minimum_reel_od"] = minReel ? rangeUnit : "";

          record.maximum_reel_od = maxReel ? maxReel : "";
          //tableDataRecord.maximum_reel_od = maxReel ? maxReel : "";
          record.units["maximum_reel_od"] = maxReel ? rangeUnit : "";
          //tableDataRecord.units["maximum_reel_od"] = maxReel ? rangeUnit : "";

          record.id_od_type = selecteDia;
          //tableDataRecord.id_od_type = selecteDia;
        }
        selectedDataRows[i] = { ...record };
        //tableData[tableRecordIndx] = { ...tableDataRecord };
      }
      setSelectedDataRows([...selectedDataRows]);
      setTableData([...tableData]);
      setSelectedState(true);
    }
    setReelODValidationError(false);
    setTableRerender(true);
  };

  const onRangeUnitChange = (e) => {
    if (selectedDataRows && selectedDataRows?.length) {
      let minReel = form.getFieldValue("min_reel");
      let maxReel = form.getFieldValue("max_reel");
      let coreDia = form.getFieldValue("core_Dia");

      let coreodConversion =
        orderDim_Rewinder_Unit_Conversion[coreDia?.split(" ")[1]];
      let minReelConversion = orderDim_Rewinder_Unit_Conversion[e];

      let coreOD = coreDia?.split(" ")[0] * coreodConversion;
      let reelOD = minReel * minReelConversion;

      if ((reelOD && parseFloat(reelOD)) < (coreOD && parseFloat(coreOD))) {
        setRangeValidationError(true);
      } else {
        setRangeValidationError(false);
      }

      for (let i = 0; i < selectedDataRows?.length; i++) {
        let tableRecordIndx = tableData.findIndex(
          (ele) => ele.orderno == selectedDataRows[i].orderno
        );
        let tableDataRecord = tableData[tableRecordIndx];
        let record = selectedDataRows[i];
        if (
          tableRecordIndx != -1 &&
          tableDataRecord &&
          selecteDia == "range" &&
          ((record.type == "Reel" && record.quantity_type != "reel_sheet") ||
            record.type == "Sheet")
        ) {
          record.maximum_reel_od = maxReel ? maxReel : "";
          tableDataRecord.maximum_reel_od = maxReel ? maxReel : "";
          record.units["maximum_reel_od"] = maxReel ? e : "";
          tableDataRecord.units["maximum_reel_od"] = maxReel ? e : "";

          record.minimum_reel_od = minReel ? minReel : "";
          tableDataRecord.minimum_reel_od = minReel ? minReel : "";
          record.units["minimum_reel_od"] = minReel ? e : "";
          tableDataRecord.units["minimum_reel_od"] = minReel ? e : "";

          record.id_od_type = selecteDia;
          tableDataRecord.id_od_type = selecteDia;

          record.inner_dia = coreDia;
          record.coreid = coreDia;
          tableDataRecord.inner_dia = coreDia;
          tableDataRecord.coreid = coreDia;
        } else if (
          selecteDia == "range" &&
          ((record.type == "Reel" && record.quantity_type != "reel_sheet") ||
            record.type == "Sheet")
        ) {
          record.maximum_reel_od = maxReel ? maxReel : "";
          //tableDataRecord.maximum_reel_od = maxReel ? maxReel : "";
          record.units["maximum_reel_od"] = maxReel ? e : "";
          //tableDataRecord.units["maximum_reel_od"] = maxReel ? e : "";

          record.minimum_reel_od = minReel ? minReel : "";
          // tableDataRecord.minimum_reel_od = minReel ? minReel : "";
          record.units["minimum_reel_od"] = minReel ? e : "";
          // tableDataRecord.units["minimum_reel_od"] = minReel ? e : "";

          record.id_od_type = selecteDia;
          // tableDataRecord.id_od_type = selecteDia;

          record.inner_dia = coreDia;
          record.coreid = coreDia;
          //tableDataRecord.inner_dia = coreDia;
          //tableDataRecord.coreid = coreDia;
        }
        selectedDataRows[i] = { ...record };
        //tableData[tableRecordIndx] = { ...tableDataRecord };
      }
      setSelectedDataRows([...selectedDataRows]);
      setTableData([...tableData]);
      setSelectedState(true);
    }
    setTableRerender(true);
  };

  const removeReelOD = (data) => {
    let array = selectedReelOD;
    let coreid = form.getFieldValue("coreDia");
    let newArray = array.filter((item) => {
      return !(item.value === data.value);
    });
    setSelectedReelOD(newArray);
    if (newArray && newArray?.length == 0) {
      if (selectedDataRows && selectedDataRows?.length) {
        for (let i = 0; i < selectedDataRows?.length; i++) {
          let tableRecordIndx = tableData.findIndex(
            (ele) => ele.orderno == selectedDataRows[i].orderno
          );
          let tableDataRecord = tableData[tableRecordIndx];
          let record = selectedDataRows[i];
          if (tableRecordIndx != -1 && tableDataRecord) {
            record.reelod = JSON.parse(
              JSON.stringify(tableDataCopyRef.current[tableRecordIndx].reelod)
            );
            record.outer_dia = JSON.parse(
              JSON.stringify(
                tableDataCopyRef.current[tableRecordIndx].outer_dia
              )
            );
            tableDataRecord.reelod = JSON.parse(
              JSON.stringify(tableDataCopyRef.current[tableRecordIndx].reelod)
            );
            tableDataRecord.outer_dia = JSON.parse(
              JSON.stringify(
                tableDataCopyRef.current[tableRecordIndx].outer_dia
              )
            );

            selectedDataRows[i] = { ...record };
            tableData[tableRecordIndx] = { ...tableDataRecord };
          } else {
            record.reelod = JSON.parse(
              JSON.stringify(tableDataCopyRef.current[tableRecordIndx].reelod)
            );
            record.outer_dia = JSON.parse(
              JSON.stringify(
                tableDataCopyRef.current[tableRecordIndx].outer_dia
              )
            );
            //tableDataRecord.reelod = JSON.parse(JSON.stringify(tableDataCopyRef.current[tableRecordIndx].reelod));
            //tableDataRecord.outer_dia = JSON.parse(JSON.stringify(tableDataCopyRef.current[tableRecordIndx].outer_dia));

            selectedDataRows[i] = { ...record };
            //tableData[tableRecordIndx] = {...tableDataRecord};
          }
        }
        let finalselectedData = [...selectedDataRows];
        let finalData = [...tableData];
        setSelectedDataRows([...finalselectedData]);
        setTableData([...finalData]);
        setSelectedState(true);
      }
      setCoreOdValidationError(false);
    }
    if (newArray && newArray?.length == 1) {
      let coreodConversion =
        orderDim_Rewinder_Unit_Conversion[coreid.split(" ")[1]];
      let reelodConversion =
        orderDim_Rewinder_Unit_Conversion[newArray[0]?.value?.split(" ")[1]];
      let coreOD = coreid?.split(" ")[0] * coreodConversion;
      let reelOD = newArray[0]?.value?.split(" ")[0] * reelodConversion;

      if ((coreOD && parseFloat(coreOD)) > (reelOD && parseFloat(reelOD))) {
        setCoreOdValidationError(true);
      } else {
        setCoreOdValidationError(false);
      }

      if (selectedDataRows && selectedDataRows?.length) {
        for (let i = 0; i < selectedDataRows?.length; i++) {
          let tableRecordIndx = tableData.findIndex(
            (ele) => ele.orderno == selectedDataRows[i].orderno
          );
          let tableDataRecord = tableData[tableRecordIndx];
          let record = selectedDataRows[i];
          if (tableRecordIndx != -1 && tableDataRecord) {
            let reelDataArr = [];
            for (let k = 0; k < newArray.length; k++) {
              let reelData =
                newArray[k]?.value?.split(" ")[0] +
                " " +
                newArray[k]?.value?.split(" ")[1];
              reelDataArr.push(reelData);
            }
            record.reelod = reelDataArr;
            record.outer_dia = reelDataArr;
            tableDataRecord.reelod = reelDataArr;
            tableDataRecord.outer_dia = reelDataArr;

            record.coreid = coreid;
            record.inner_dia = coreid;
            tableDataRecord.coreid = coreid;
            tableDataRecord.inner_dia = coreid;

            record.id_od_type = selecteDia;
            tableDataRecord.id_od_type = selecteDia;

            selectedDataRows[i] = { ...record };
            tableData[tableRecordIndx] = { ...tableDataRecord };
          } else {
            {
              let reelDataArr = [];
              for (let k = 0; k < newArray.length; k++) {
                let reelData =
                  newArray[k]?.value?.split(" ")[0] +
                  " " +
                  newArray[k]?.value?.split(" ")[1];
                reelDataArr.push(reelData);
              }
              record.reelod = reelDataArr;
              record.outer_dia = reelDataArr;
              // tableDataRecord.reelod = reelDataArr;
              //tableDataRecord.outer_dia = reelDataArr;

              record.coreid = coreid;
              record.inner_dia = coreid;
              //tableDataRecord.coreid = coreid;
              //tableDataRecord.inner_dia = coreid;

              record.id_od_type = selecteDia;
              //tableDataRecord.id_od_type = selecteDia;

              selectedDataRows[i] = { ...record };
              //tableData[tableRecordIndx] = {...tableDataRecord};
            }
          }
        }
        let finalselectedData = [...selectedDataRows];
        let finalData = [...tableData];
        setSelectedDataRows([...finalselectedData]);
        setTableData([...finalData]);
        setSelectedState(true);
      }
    }
    if (newArray.length > 1) {
      let coreodConversion =
        orderDim_Rewinder_Unit_Conversion[coreid.split(" ")[1]];
      let coreOD = coreid?.split(" ")[0] * coreodConversion;
      let dataArr = [];
      for (let ind = 0; ind < newArray.length; ind++) {
        let convertedValue =
          newArray[ind]?.value?.split(" ")[0] *
          orderDim_Rewinder_Unit_Conversion[
          newArray[ind]?.value?.split(" ")[1]
          ];
        dataArr.push(convertedValue);
      }
      let minValue = Math.min(...dataArr);

      if ((coreOD && parseFloat(coreOD)) > (minValue && parseFloat(minValue))) {
        setCoreOdValidationError(true);
      } else {
        setCoreOdValidationError(false);
      }

      if (selectedDataRows && selectedDataRows?.length) {
        for (let i = 0; i < selectedDataRows?.length; i++) {
          let tableRecordIndx = tableData.findIndex(
            (ele) => ele.orderno == selectedDataRows[i].orderno
          );
          let tableDataRecord = tableData[tableRecordIndx];
          let record = selectedDataRows[i];
          if (
            tableRecordIndx != -1 &&
            tableDataRecord &&
            ((selecteDia == "constant" &&
              record.type == "Reel" &&
              record.quantity_type == "reel_sheet" &&
              data.length == 1) ||
              (selecteDia == "constant" &&
                ((record.type == "Reel" &&
                  record.quantity_type != "reel_sheet") ||
                  record.type == "Sheet")))
          ) {
            let reelDataArr = [];
            for (let k = 0; k < newArray.length; k++) {
              let reelData =
                newArray[k]?.value?.split(" ")[0] +
                " " +
                newArray[k]?.value?.split(" ")[1];
              reelDataArr.push(reelData);
            }
            record.reelod = reelDataArr;
            record.outer_dia = reelDataArr;
            tableDataRecord.reelod = reelDataArr;
            tableDataRecord.outer_dia = reelDataArr;

            record.coreid = coreid;
            record.inner_dia = coreid;
            tableDataRecord.coreid = coreid;
            tableDataRecord.inner_dia = coreid;

            record.id_od_type = selecteDia;
            tableDataRecord.id_od_type = selecteDia;

            selectedDataRows[i] = { ...record };
            tableData[tableRecordIndx] = { ...tableDataRecord };
          } else if (
            (selecteDia == "constant" &&
              record.type == "Reel" &&
              record.quantity_type == "reel_sheet" &&
              data.length == 1) ||
            (selecteDia == "constant" &&
              ((record.type == "Reel" &&
                record.quantity_type != "reel_sheet") ||
                record.type == "Sheet"))
          ) {
            let reelDataArr = [];
            for (let k = 0; k < newArray.length; k++) {
              let reelData =
                newArray[k]?.value?.split(" ")[0] +
                " " +
                newArray[k]?.value?.split(" ")[1];
              reelDataArr.push(reelData);
            }
            record.reelod = reelDataArr;
            record.outer_dia = reelDataArr;
            //tableDataRecord.reelod = reelDataArr;
            //tableDataRecord.outer_dia = reelDataArr;

            record.coreid = coreid;
            record.inner_dia = coreid;
            // tableDataRecord.coreid = coreid;
            //tableDataRecord.inner_dia = coreid;

            record.id_od_type = selecteDia;
            //tableDataRecord.id_od_type = selecteDia;

            selectedDataRows[i] = { ...record };
            // tableData[tableRecordIndx] = {...tableDataRecord};
          }
        }
        let finalselectedData = [...selectedDataRows];
        let finalData = [...tableData];
        setSelectedDataRows([...finalselectedData]);
        setTableData([...finalData]);
        setSelectedState(true);
      }
    }
    setTableRerender(true);
    // setPageRerender(true);
  };

  const onMinReelODChange = (e) => {
    let rangeInnerDia = form.getFieldValue("core_Dia");
    let rangeUnit = form.getFieldValue("range_unit");

    let coreodConversion =
      orderDim_Rewinder_Unit_Conversion[rangeInnerDia?.split(" ")[1]];
    let minReelConversion = orderDim_Rewinder_Unit_Conversion[rangeUnit];
    let coreOD = rangeInnerDia?.split(" ")[0] * coreodConversion;
    let reelOD = e.target.value * minReelConversion;

    if ((reelOD && parseFloat(reelOD)) < (coreOD && parseFloat(coreOD))) {
      setRangeValidationError(true);
    } else {
      setRangeValidationError(false);
    }

    if (
      (e.target.value && parseFloat(e.target.value)) >
      (form.getFieldValue("max_reel") &&
        parseFloat(form.getFieldValue("max_reel")))
    ) {
      setReelODValidationError(true);
    } else {
      if (selectedDataRows && selectedDataRows?.length) {
        let maxReel = form.getFieldValue("max_reel");
        for (let i = 0; i < selectedDataRows?.length; i++) {
          let tableRecordIndx = tableData.findIndex(
            (ele) => ele.orderno == selectedDataRows[i].orderno
          );
          let tableDataRecord = tableData[tableRecordIndx];
          let record = selectedDataRows[i];
          if (
            tableRecordIndx != -1 &&
            tableDataRecord &&
            selecteDia == "range" &&
            ((record.type == "Reel" && record.quantity_type != "reel_sheet") ||
              record.type == "Sheet")
          ) {
            record.minimum_reel_od = e.target.value ? e.target.value : "";
            tableDataRecord.minimum_reel_od = e.target.value
              ? e.target.value
              : "";
            record.units["minimum_reel_od"] = e.target.value ? rangeUnit : "";
            tableDataRecord.units["minimum_reel_od"] = e.target.value
              ? rangeUnit
              : "";

            record.maximum_reel_od = maxReel ? maxReel : "";
            tableDataRecord.maximum_reel_od = maxReel ? maxReel : "";
            record.units["maximum_reel_od"] = maxReel ? rangeUnit : "";
            tableDataRecord.units["maximum_reel_od"] = maxReel ? rangeUnit : "";

            record.id_od_type = selecteDia;
            tableDataRecord.id_od_type = selecteDia;

            record.inner_dia = rangeInnerDia;
            record.coreid = rangeInnerDia;
            tableDataRecord.inner_dia = rangeInnerDia;
            tableDataRecord.coreid = rangeInnerDia;

            selectedDataRows[i] = { ...record };
            tableData[tableRecordIndx] = { ...tableDataRecord };
          } else if (
            selecteDia == "range" &&
            ((record.type == "Reel" && record.quantity_type != "reel_sheet") ||
              record.type == "Sheet")
          ) {
            record.minimum_reel_od = e.target.value ? e.target.value : "";
            //tableDataRecord.minimum_reel_od = e.target.value ? e.target.value : "";
            record.units["minimum_reel_od"] = e.target.value ? rangeUnit : "";
            // tableDataRecord.units["minimum_reel_od"] = e.target.value ? rangeUnit : "";

            record.maximum_reel_od = maxReel ? maxReel : "";
            //tableDataRecord.maximum_reel_od = maxReel ? maxReel : "";
            record.units["maximum_reel_od"] = maxReel ? rangeUnit : "";
            //tableDataRecord.units["maximum_reel_od"] = maxReel ? rangeUnit : "";

            record.id_od_type = selecteDia;
            //tableDataRecord.id_od_type = selecteDia;

            record.inner_dia = rangeInnerDia;
            record.coreid = rangeInnerDia;
            //tableDataRecord.inner_dia = rangeInnerDia;
            //tableDataRecord.coreid = rangeInnerDia;

            selectedDataRows[i] = { ...record };
            //tableData[tableRecordIndx] = {...tableDataRecord};
          }
        }
        let finalselectedData = [...selectedDataRows];
        let finalData = [...tableData];
        setSelectedDataRows([...finalselectedData]);
        setTableData([...finalData]);
        setSelectedState(true);
      }
      setTableRerender(true);
      setReelODValidationError(false);
    }
    setTableRerender(true);
    // setPageRerender(true);
  };

  const onMaxReelODChange = (e) => {
    if (
      (e.target.value && parseFloat(e.target.value)) <
      (form.getFieldValue("min_reel") &&
        parseFloat(form.getFieldValue("min_reel")))
    ) {
      setReelODValidationError(true);
    } else {
      if (selectedDataRows && selectedDataRows?.length) {
        let rangeUnit = form.getFieldValue("range_unit");
        let minReel = form.getFieldValue("min_reel");
        let rangeInnerDia = form.getFieldValue("core_Dia");
        for (let i = 0; i < selectedDataRows?.length; i++) {
          let tableRecordIndx = tableData.findIndex(
            (ele) => ele.orderno == selectedDataRows[i].orderno
          );
          if (tableRecordIndx == 0 || tableRecordIndx != -1) {
            let tableDataRecord = tableData[tableRecordIndx];
            let record = selectedDataRows[i];
            if (
              tableDataRecord &&
              selecteDia == "range" &&
              ((record.type == "Reel" &&
                record.quantity_type != "reel_sheet") ||
                record.type == "Sheet")
            ) {
              record["maximum_reel_od"] = e.target.value ? e.target.value : "";
              tableDataRecord["maximum_reel_od"] = e.target.value
                ? e.target.value
                : "";
              record.units["maximum_reel_od"] = e.target.value ? rangeUnit : "";
              tableDataRecord.units["maximum_reel_od"] = e.target.value
                ? rangeUnit
                : "";

              record["minimum_reel_od"] = minReel ? minReel : "";
              tableDataRecord["minimum_reel_od"] = minReel ? minReel : "";
              record.units["minimum_reel_od"] = minReel ? rangeUnit : "";
              tableDataRecord.units["minimum_reel_od"] = minReel
                ? rangeUnit
                : "";

              record.id_od_type = selecteDia;
              tableDataRecord.id_od_type = selecteDia;

              record.inner_dia = rangeInnerDia;
              record.coreid = rangeInnerDia;
              tableDataRecord.inner_dia = rangeInnerDia;
              tableDataRecord.coreid = rangeInnerDia;
            }

            selectedDataRows[i] = { ...record };

            tableData[tableRecordIndx] = { ...tableDataRecord };
          } else {
            let tableDataRecord = tableData[tableRecordIndx];
            let record = selectedDataRows[i];
            if (
              selecteDia == "range" &&
              ((record.type == "Reel" &&
                record.quantity_type != "reel_sheet") ||
                record.type == "Sheet")
            ) {
              record["maximum_reel_od"] = e.target.value ? e.target.value : "";
              // tableDataRecord["maximum_reel_od"] = e.target.value ? e.target.value : "";
              record.units["maximum_reel_od"] = e.target.value ? rangeUnit : "";
              //tableDataRecord.units["maximum_reel_od"] = e.target.value ? rangeUnit : "";

              record["minimum_reel_od"] = minReel ? minReel : "";
              // tableDataRecord["minimum_reel_od"] = minReel ? minReel : "";
              record.units["minimum_reel_od"] = minReel ? rangeUnit : "";
              // tableDataRecord.units["minimum_reel_od"] = minReel ? rangeUnit : "";

              record.id_od_type = selecteDia;
              // tableDataRecord.id_od_type = selecteDia;

              record.inner_dia = rangeInnerDia;
              record.coreid = rangeInnerDia;
              // tableDataRecord.inner_dia = rangeInnerDia;
              // tableDataRecord.coreid = rangeInnerDia;

              selectedDataRows[i] = { ...record };

              // tableData[tableRecordIndx] = {...tableDataRecord};
            }
          }
        }
        let finalselectedData = [...selectedDataRows];
        let finalData = [...tableData];
        setSelectedDataRows([...finalselectedData]);
        setTableData([...finalData]);
        setSelectedState(true);
      }
      setTableRerender(true);
      setReelODValidationError(false);
    }
    setTableRerender(true);
    // setPageRerender(true);
  };

  return (
    <RightLayoutContainer id="right-layout-container">
      <PageTitleComp ref={titleRef} style={{ borderBottom: "0", position: "sticky", top: stickyOffsets.title, zIndex: 100, backgroundColor: "#fff" }}>
        <PageHeader ghost={false} title="Order Records"></PageHeader>
      </PageTitleComp>
      <TableLayoutData>
        <div className="tableDataFormat">
          <style dangerouslySetInnerHTML={{
            __html: `
            .ant-tabs, .ant-tabs-content-holder, .ant-tabs-content, .ant-tabs-tabpane {
              overflow: visible !important;
            }
            .ant-table-sticky-holder {
              z-index: 101 !important;
            }
          `}} />
          <StyledTab>
            <Tabs
              defaultActiveKey="0"
              onChange={handleTabChange}
              destroyInactiveTabPane={true}
              renderTabBar={(props, DefaultTabBar) => (
                <div ref={tabRef} style={{ position: "sticky", top: stickyOffsets.tabs, zIndex: 99, background: "#fff" }}>
                  <DefaultTabBar {...props} />
                </div>
              )}
            >
              {tabHeads.map((tab) => (
                <Panes tab={tab.title} key={tab.key}>
                  {tab.key === 0 && (
                    <AlertContainer
                      color="blue"
                      icon={alertBlue}
                      msg="The orders that have missing details ( i.e. missing diameter details if reels have to be manufactured) , cannot be considered for deckle matching. 
                      Please update the details by clicking on Update Rewinder Details button or edit icon in front of each order to consider these orders for deckle matching."
                      removeBottomMargin={true}
                    />
                  )}
                  <div ref={searchRef} style={{ backgroundColor: "#fff" }}>
                    {!loading ? (
                      <SearchContainer
                        placeholder={"Search PO/SO Number or Order No"}
                        fetchOrder={searchDeckle}
                        exportRole={
                          showBulkOrderUpdate && !tableData?.length ? false : true
                        }
                        // exportTrigger={() => exportHandler(tab.key,orderState)}
                        exportTrigger={exportHandler}
                        clearSearch={clearSearch}
                        setClearSearch={setClearSearch}
                        searchedValue={searchValue}
                        filterOptions={
                          !isAllOrders || isUpdateOrderDetailsButtonPressed
                            ? [
                              {
                                key: 0,
                                label: "Filter by Created Date",
                                value: "created_date",
                                type: "date",
                              },
                              {
                                key: 1,
                                label: "Filter by PO Date",
                                value: "po_date",
                                type: "date",
                              },
                              {
                                key: 2,
                                label: "Filter by GSM",
                                value: "gsm",
                                type: "inputSelect",
                              },
                              {
                                key: 3,
                                label: "Filter by Grade/Quality",
                                value: "grade_quality",
                                type: "grade",
                              },
                              {
                                key: 4,
                                label: "Filter by Burst Factor",
                                value: "burst_factor",
                                type: "inputSelect",
                              },
                              {
                                key: 5,
                                label: "Filter by Reel OD",
                                value: "reel_od",
                                type: "inputSelect",
                                unitType: "length",
                              },
                              {
                                key: 6,
                                label: "Filter by Core ID",
                                value: "core_id",
                                type: "inputSelect",
                                unitType: "length",
                              },
                              {
                                key: 7,
                                label: "Filter by Delivery Date",
                                value: "delivery_date",
                                type: "date",
                              },
                              {
                                key: 8,
                                label: "Filter by Customer",
                                value: "customer",
                                type: "multiSelect",
                              },
                              {
                                key: 9,
                                label: "Filter by Size",
                                value: "size",
                                type: "rangeTypeSelect",
                                unitType: "length",
                              },
                              {
                                key: 10,
                                label: "Filter by Consignee",
                                value: "consignee",
                                type: "multiSelect",
                              },
                              // {
                              //   key: 10,
                              //   label: "Filter by Status",
                              //   value: "orderStatus",
                              //   type: "multiSelect",
                              // },
                            ]
                            : [
                              {
                                key: 0,
                                label: "Filter by Created Date",
                                value: "created_date",
                                type: "date",
                              },
                              {
                                key: 1,
                                label: "Filter by PO Date",
                                value: "po_date",
                                type: "date",
                              },
                              {
                                key: 2,
                                label: "Filter by GSM",
                                value: "gsm",
                                type: "inputSelect",
                              },
                              {
                                key: 3,
                                label: "Filter by Grade/Quality",
                                value: "grade_quality",
                                type: "grade",
                              },
                              {
                                key: 4,
                                label: "Filter by Burst Factor",
                                value: "burst_factor",
                                type: "inputSelect",
                              },
                              {
                                key: 5,
                                label: "Filter by Reel OD",
                                value: "reel_od",
                                type: "inputSelect",
                                unitType: "length",
                              },
                              {
                                key: 6,
                                label: "Filter by Core ID",
                                value: "core_id",
                                type: "inputSelect",
                                unitType: "length",
                              },
                              {
                                key: 7,
                                label: "Filter by Delivery Date",
                                value: "delivery_date",
                                type: "date",
                              },
                              {
                                key: 8,
                                label: "Filter by Customer",
                                value: "customer",
                                type: "multiSelect",
                              },
                              {
                                key: 9,
                                label: "Filter by Order Type",
                                value: "order_type",
                                type: "multiSelect",
                              },
                              {
                                key: 10,
                                label: "Filter by Size",
                                value: "size",
                                type: "rangeTypeSelect",
                                unitType: "length",
                              },
                              {
                                key: 11,
                                label: "Filter by Consignee",
                                value: "consignee",
                                type: "multiSelect",
                              },
                              // {
                              //   key: 10,
                              //   label: "Filter by Status",
                              //   value: "orderStatus",
                              //   type: "multiSelect",
                              // },
                            ]
                        }
                        applyFilter={applyfilter}
                        isUpdateOrderDetailsInBulkVisible={
                          isUpdateOrderDetailsButtonVisible
                        }
                        isPendingTab={isPendingTab}
                        showBulkOrderUpdate={showBulkOrderUpdate}
                        // isUpdateOrderDetailsButtonEnable={isCheckboxClicked}
                        updateButtonClick={onUpdateButtonClick}
                        isShowCancelButton={isUpdateOrderDetailsButtonPressed}
                        cancelButtonClick={onCancelButtonPress}
                        isShowReviewAndUpdateButton={
                          isUpdateOrderDetailsButtonPressed
                        }
                        reviewAndUpdateClick={onReviewAndUpdateClick}
                        onShowOrders={onShowOrders}
                        isAllOrder={isAllOrders}
                        selectedOrderType={
                          selectedOrderType === "reel"
                            ? "Reel Orders"
                            : selectedOrderType === "sheet"
                              ? "Sheet Orders"
                              : "All Orders"
                        }
                        deckleOrderType={
                          deckleOrderType === "incomplete_orders"
                            ? "Unplanned Orders"
                            : deckleOrderType === "planned_orders"
                              ? "Planned Orders"
                              : "Planned & Unplanned"
                        }
                        isDisableSave={
                          !selectedDataRows.length
                          // || !form.getFieldValue("reel_od") || !form.getFieldValue("core_od")
                        }
                        setOrderType={handleOrderType}
                        setDeckleOrderType={handleDeckleOrderType}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                  {orderState &&
                    orderState === "pending_for_deckle_match" &&
                    showBulkOrderUpdate &&
                    reelCoreData && (
                      <DetailFields>
                        <HaberForm>
                          <div className="groupDetailWrap">
                            <Form
                              name="basic"
                              autoComplete="off"
                              form={form}
                              className="haberLogin"
                              onFinish={onFinish}
                            >
                              <Row gutter={[16, 16]} className="groupForm">
                                <Col span={8}>
                                  <GroupTitle>
                                    <h2>Rewinder Dimensions</h2>
                                    <p>
                                      The diameter which will be used for
                                      rewinding the selected orders
                                    </p>
                                  </GroupTitle>
                                </Col>
                                <Col span={8} style={{ marginTop: "16px" }}>
                                  <div className="boxFieldTitle">
                                    <label>Reel And Core Diameter</label>
                                    <p>
                                      The reel and core diameter for the reels
                                      that will be used for rewinding
                                    </p>
                                  </div>
                                </Col>
                                <Col span={8} className="blockBreak">
                                  <Row className="centerAlign">
                                    <Col
                                      span={24}
                                      className="d-flex threeFields"
                                    >
                                      <div
                                        className="boxFormType unitSelect"
                                        style={{
                                          marginBottom: "0",
                                          maxWidth: "28%",
                                        }}
                                      >
                                        <span
                                          style={{
                                            fontSize: "12px",
                                            fontWeight: "normal",
                                          }}
                                        >
                                          Dia Type
                                        </span>
                                        <Form.Item
                                          name="diameter_type"
                                          rules={[
                                            {
                                              required: true,
                                              message:
                                                "This is a required field",
                                            },
                                          ]}
                                          className="dBlock"
                                          initialValue={selecteDia}
                                        >
                                          <Select
                                            placeholder="Dia type"
                                            showSearch
                                            suffixIcon={<DownArrowDraw />}
                                            onChange={(e) => {
                                              onDiameterChange(e);
                                            }}
                                          >
                                            {diameterType.map((item) => (
                                              <Option key={item.value}>
                                                {item.label}
                                              </Option>
                                            ))}
                                          </Select>
                                        </Form.Item>
                                      </div>
                                      {selecteDia == "constant" ? (
                                        <>
                                          <div>
                                            <span
                                              style={{
                                                fontSize: "12px",
                                                fontWeight: "normal",
                                              }}
                                            >
                                              Reel OD
                                            </span>
                                            <PaperMachineQualitySelect
                                              style={{
                                                marginBottom: "0",
                                                marginTop: "-7px",
                                              }}
                                            >
                                              <MultiSelectCard>
                                                <Multiselect
                                                  className="multiQuality"
                                                  options={reelValues}
                                                  style={multiselectStyle}
                                                  showArrow={true}
                                                  selectedValues={
                                                    selectedReelOD
                                                  }
                                                  displayValue={"value"}
                                                  showCheckbox={true}
                                                  onSelect={
                                                    onChangeReelOdSelect
                                                  }
                                                  onRemove={
                                                    onChangeReelOdSelect
                                                  }
                                                  hideSelectedList
                                                  keepSearchTerm
                                                />
                                              </MultiSelectCard>
                                            </PaperMachineQualitySelect>
                                            <PaperMachineGradeSelect>
                                              <div className="mainMachineGrade">
                                                {selectedReelOD &&
                                                  selectedReelOD?.map(
                                                    (item, index) => {
                                                      return (
                                                        index <= 1 && (
                                                          <span
                                                            className={
                                                              "MachineGradeSelect-active"
                                                            }
                                                          >
                                                            {item.value}
                                                            <Button
                                                              className="textTypeBtn textBtnIcon paperButtonBg"
                                                              onClick={() => {
                                                                removeReelOD(
                                                                  item
                                                                );
                                                              }}
                                                            >
                                                              <Iconmoon
                                                                icon="wrong"
                                                                size={14}
                                                                color="#EA655B"
                                                              />
                                                            </Button>
                                                          </span>
                                                        )
                                                      );
                                                    }
                                                  )}
                                              </div>
                                              {selectedReelOD &&
                                                selectedReelOD?.length > 1 &&
                                                selectedReelOD?.map(
                                                  (item, index) => {
                                                    let tooltipData = "";
                                                    for (
                                                      let index = 2;
                                                      index <
                                                      selectedReelOD?.length;
                                                      index++
                                                    ) {
                                                      const data =
                                                        selectedReelOD[index];
                                                      tooltipData =
                                                        tooltipData +
                                                        data.value +
                                                        ", ";
                                                    }
                                                    tooltipData =
                                                      tooltipData.substring(
                                                        0,
                                                        tooltipData.length - 3
                                                      );
                                                    return (
                                                      index == 2 && (
                                                        <Tooltip
                                                          title={tooltipData}
                                                        >
                                                          {" "}
                                                          <span
                                                            style={{
                                                              display: "flex",
                                                              width:
                                                                "maxContent",
                                                              justifyContent:
                                                                "flex-end",
                                                            }}
                                                          >
                                                            &{" "}
                                                            {selectedReelOD.length -
                                                              2}{" "}
                                                            More
                                                          </span>
                                                        </Tooltip>
                                                      )
                                                    );
                                                  }
                                                )}
                                            </PaperMachineGradeSelect>
                                          </div>
                                          <div
                                            className="boxFormType unitSelect"
                                            style={{ marginBottom: "0" }}
                                          >
                                            <span
                                              style={{
                                                fontSize: "12px",
                                                fontWeight: "normal",
                                              }}
                                            >
                                              Core OD
                                            </span>
                                            <Form.Item
                                              name="coreDia"
                                              rules={[
                                                {
                                                  required: true,
                                                  message:
                                                    "This is a required field",
                                                },
                                              ]}
                                              className="dBlock"
                                            >
                                              <Select
                                                placeholder="Core OD"
                                                showSearch
                                                suffixIcon={<DownArrowDraw />}
                                                onChange={(e) => {
                                                  onCoreodChange(e);
                                                }}
                                              >
                                                {coreValues.map((item) => (
                                                  <Option key={item.value}>
                                                    {item.label}
                                                  </Option>
                                                ))}
                                              </Select>
                                            </Form.Item>
                                          </div>
                                        </>
                                      ) : (
                                        <>
                                          <div
                                            className="boxFormType unitSelect"
                                            style={{ marginBottom: "0" }}
                                          >
                                            <span
                                              style={{
                                                fontSize: "12px",
                                                fontWeight: "normal",
                                              }}
                                            >
                                              Min OD
                                            </span>
                                            <Form.Item
                                              name="min_reel"
                                              rules={[
                                                {
                                                  pattern: new RegExp(
                                                    /^\d+(\.\d{0,3})?$/
                                                  ),
                                                  message:
                                                    "Only Numeric value is possible upto 3 decimal point",
                                                },
                                                {
                                                  required: true,
                                                  message:
                                                    "This is a required field",
                                                },
                                                {
                                                  validator(_, value) {
                                                    if (
                                                      parseFloat(value) == 0
                                                    ) {
                                                      return Promise.reject(
                                                        "Min Reel can't be 0"
                                                      );
                                                    } else {
                                                      return Promise.resolve();
                                                    }
                                                  },
                                                },
                                              ]}
                                              className="dBlock"
                                            >
                                              <Input
                                                placeholder="Min OD"
                                                className={
                                                  reelODValidationError
                                                    ? "showErrorBorder"
                                                    : ""
                                                }
                                                onChange={(e) => {
                                                  onMinReelODChange(e);
                                                }}
                                              />
                                            </Form.Item>
                                          </div>
                                          <div
                                            className="boxFormType unitSelect"
                                            style={{ marginBottom: "0" }}
                                          >
                                            <span
                                              style={{
                                                fontSize: "12px",
                                                fontWeight: "normal",
                                              }}
                                            >
                                              Max OD
                                            </span>
                                            <Form.Item
                                              name="max_reel"
                                              rules={[
                                                {
                                                  pattern: new RegExp(
                                                    /^\d+(\.\d{0,3})?$/
                                                  ),
                                                  message:
                                                    "Only Numeric value is possible upto 3 decimal point",
                                                },
                                                {
                                                  required: true,
                                                  message:
                                                    "This is a required field",
                                                },
                                                {
                                                  validator(_, value) {
                                                    if (
                                                      parseFloat(value) == 0
                                                    ) {
                                                      return Promise.reject(
                                                        "Max Reel can't be 0"
                                                      );
                                                    } else {
                                                      return Promise.resolve();
                                                    }
                                                  },
                                                },
                                              ]}
                                              className="dBlock"
                                            >
                                              <Input
                                                placeholder="Max OD"
                                                className={
                                                  reelODValidationError
                                                    ? "showErrorBorder"
                                                    : ""
                                                }
                                                onChange={(e) => {
                                                  onMaxReelODChange(e);
                                                }}
                                              />
                                            </Form.Item>
                                          </div>
                                          <div
                                            className="boxFormType unitSelect"
                                            style={{ marginBottom: "0" }}
                                          >
                                            <span
                                              style={{
                                                fontSize: "12px",
                                                fontWeight: "normal",
                                              }}
                                            >
                                              Unit
                                            </span>
                                            <Form.Item
                                              name="range_unit"
                                              rules={[
                                                {
                                                  required: true,
                                                  message:
                                                    "This is a required field",
                                                },
                                              ]}
                                              className="dBlock"
                                            >
                                              <Select
                                                placeholder="Unit"
                                                showSearch
                                                suffixIcon={<DownArrowDraw />}
                                                onChange={(e) => {
                                                  onRangeUnitChange(e);
                                                }}
                                              >
                                                {measurementData?.data.units_management.length.data?.map(
                                                  (reelUnit) => (
                                                    <Option
                                                      key={reelUnit}
                                                      value={reelUnit}
                                                    >
                                                      {
                                                        lengthUnit[reelUnit]
                                                          ?.displayName
                                                      }
                                                    </Option>
                                                  )
                                                )}
                                              </Select>
                                            </Form.Item>
                                          </div>
                                        </>
                                      )}
                                    </Col>
                                    {selecteDia == "range" && (
                                      <Col
                                        span={24}
                                        className="d-flex threeFields"
                                      >
                                        <div
                                          className="boxFormType unitSelect"
                                          style={{
                                            marginBottom: "0",
                                            maxWidth: "13%",
                                          }}
                                        ></div>
                                        <div
                                          className="boxFormType"
                                          style={{ marginBottom: "0" }}
                                        >
                                          <span
                                            style={{
                                              fontSize: "12px",
                                              fontWeight: "normal",
                                            }}
                                          >
                                            Core OD
                                          </span>
                                          <Form.Item
                                            name="core_Dia"
                                            rules={[
                                              {
                                                required: true,
                                                message:
                                                  "This is a required field",
                                              },
                                            ]}
                                            className="dBlock"
                                          >
                                            <Select
                                              style={{ width: "207%" }}
                                              placeholder="Core OD"
                                              showSearch
                                              suffixIcon={<DownArrowDraw />}
                                              onChange={(e) => {
                                                onCoreDiaChange(e);
                                              }}
                                            >
                                              {coreValues.map((item) => (
                                                <Option key={item?.value}>
                                                  {item?.label}
                                                </Option>
                                              ))}
                                            </Select>
                                          </Form.Item>
                                        </div>
                                        <div
                                          className="boxFormType unitSelect"
                                          style={{ marginBottom: "0" }}
                                        ></div>
                                      </Col>
                                    )}
                                    {coreOdValidationError &&
                                      selecteDia == "constant" ? (
                                      <span
                                        className="errorText"
                                        style={{ color: "#ea4e2c" }}
                                      >
                                        Reel OD cannot be less than Core OD
                                      </span>
                                    ) : null}
                                    {selecteDia == "range" &&
                                      reelODValidationError ? (
                                      <span
                                        className="errorText"
                                        style={{
                                          color: "#ea4e2c",
                                          marginTop: "-2px",
                                        }}
                                      >
                                        Max dia cannot be less than Min dia
                                      </span>
                                    ) : null}
                                    {selecteDia == "range" &&
                                      rangeValidationError ? (
                                      <span
                                        className="errorText"
                                        style={{
                                          color: "#ea4e2c",
                                          marginTop: "-2px",
                                        }}
                                      >
                                        Min Reel dia cannot be less than Core OD
                                      </span>
                                    ) : null}
                                  </Row>
                                </Col>
                              </Row>
                            </Form>
                          </div>
                        </HaberForm>
                      </DetailFields>
                    )}
                  {filterTags.map((filter) => (
                    // <Tooltip
                    //   placement="bottomRight"
                    //   title={filter.tooltip || ""}
                    //   className="edit-tooltip"
                    //   getPopupContainer={(triggerNode) => triggerNode}
                    // >
                    <span className="filter-tags">
                      <Iconmoon icon="filter" size={13} color="#a8a8a8" />
                      &nbsp;
                      <span>{filter.formattedType}</span>
                      &nbsp;
                      <span>{filter.operand}</span>
                      &nbsp;
                      <span>{filter.value}</span>
                      <span>
                        {" "}
                        <button
                          onClick={() => {
                            removeFilter(filter);
                          }}
                        >
                          {" "}
                          <Iconmoon
                            icon="wrong"
                            size={15}
                            color="#a8a8a8"
                          />{" "}
                        </button>
                      </span>
                      <Styled></Styled>
                    </span>
                    // </Tooltip>
                  ))}
                  {orderState &&
                    orderState === "pending_for_deckle_match" &&
                    !showBulkOrderUpdate &&
                    isAllOrders && (
                      <PendingDetails>
                        <div className="pendingDetailsStyle">
                          <span className="pendingOrderStyle">
                            {" "}
                            Pending PO: {pendingPOSO ? pendingPOSO : ""}
                          </span>{" "}
                          Pending Planned Qty:{" "}
                          {pendingQuantity ? pendingQuantity.toFixed(3) : " "}{" "}
                          {measurementData?.data
                            ? capitalize(
                              weightUnit[
                                measurementData?.data?.units_management
                                  ?.weight?.default
                              ]?.displayName
                            )
                            : "T"}
                          {/* <span className="pendingOrderStyle">
                          {" "}
                          Pending Orders: {pendingOrders ? pendingOrders : ""}
                        </span>{" "}
                        <span className="pendingOrderStyle">
                          {" "}
                          Planned Orders:{plannedQuantity ? plannedQuantity : ""}
                        </span>{" "}
                        Pending Planned Qty:{" "}
                        {pendingQuantity ? pendingQuantity.toFixed(3) : " "}{" "}
                        {measurementData?.data ? capitalize(weightUnit[measurementData?.data?.units_management?.weight?.default]?.displayName) : "T"} */}
                        </div>
                      </PendingDetails>
                    )}
                  {orderState &&
                    orderState === "pending_for_deckle_match" &&
                    !showBulkOrderUpdate &&
                    !isAllOrders && (
                      <PendingDetails>
                        <div className="pendingDetailsStyle">
                          <span className="pendingOrderStyle">
                            {" "}
                            Unplanned Orders:{totalRecords}
                          </span>{" "}
                        </div>
                      </PendingDetails>
                    )}
                  {orderState &&
                    orderState === "pending_for_deckle_match" &&
                    showBulkOrderUpdate && (
                      <PendingDetails>
                        <div className="pendingDetailsStyle">
                          <span className="pendingOrderStyle">
                            {" "}
                            Total Orders: {totalRecords}
                          </span>{" "}
                          Selected Orders:{selectedDataRows.length}
                        </div>
                      </PendingDetails>
                    )}
                  {loading ? (
                    <TableShimmer
                      // header={
                      //   orderState === "incomplete_orders"
                      //     ? !isUpdateOrderDetailsButtonPressed
                      //       ? incompleteOrdersColumnsHead.current.filter(
                      //           (item) =>
                      //             item.dataIndex !== "calculatedreels" &&
                      //             item.dataIndex !== "rewinderreels" &&
                      //             item.dataIndex !== "plannedweight"
                      //         )
                      //       : incompleteOrdersColumnsHead.current.filter(
                      //           (item) => item.dataIndex !== "select"
                      //         )
                      //     : orderState == "pending_for_deckle_match"
                      //     ? columnsHead.current
                      //     : columnsHeader.current
                      // }
                      header={
                        orderState === "incomplete_orders"
                          ? (
                            (
                              !isUpdateOrderDetailsButtonPressed
                                ? incompleteOrdersColumnsHead.current.filter(
                                  (item) =>
                                    item.dataIndex !== "calculatedreels" &&
                                    item.dataIndex !== "rewinderreels" &&
                                    item.dataIndex !== "plannedweight"
                                )
                                : incompleteOrdersColumnsHead.current.filter(
                                  (item) => item.dataIndex !== "select"
                                )
                            )
                              .filter(
                                (item) =>
                                  orderManagementSettings?.fetch_balance_quantity?.value ||
                                  item.dataIndex !== "balance_qty"
                              )
                          )
                          : orderState === "pending_for_deckle_match"
                            ? (
                              orderManagementSettings?.fetch_balance_quantity?.value
                                ? columnsHead.current
                                : columnsHead.current?.filter(
                                  (item) => item.dataIndex !== "balance_qty"
                                )
                            )
                            : (
                              orderManagementSettings?.fetch_balance_quantity?.value
                                ? columnsHeader.current
                                : columnsHeader.current?.filter(
                                  (item) => item.dataIndex !== "balance_qty"
                                )
                            )
                        // ? columnsHead.current
                        // : columnsHeader.current
                      }
                      scroll={
                        //  isUpdateOrderDetailsButtonPressed?
                        //        1900:
                        //        2500
                        // x: orderState == "completely_matched" ? 1900 : 2800
                        2900
                      }
                    />
                  ) : tableData?.length ? (
                    <Form
                      id="plannedQntyForm"
                      form={plannedQntyForm}
                      name="basic"
                      autoComplete="off"
                      className="qtyToBePlannedInput"
                      onFinish={onFinishPlannedQtyForm}
                    >
                      <Table
                        sticky={{
                          offsetHeader: stickyOffsets.table,
                          getContainer: () => {
                            let node = document.getElementById('right-layout-container');
                            while (node && node !== document.body) {
                              const style = window.getComputedStyle(node);
                              if (style.overflowY === 'auto' || style.overflowY === 'scroll') return node;
                              node = node.parentNode;
                            }
                            return window;
                          }
                        }}
                        rowSelection={
                          showBulkOrderUpdate &&
                            userDetails.roles.job_cards.edit
                            ? {
                              columnWidth: "2.5%",
                              selectedRowKeys,
                              columnTitle: headerCheckbox,
                              onSelect: handleSelect,
                            }
                            : null
                        }
                        // columns={
                        //   orderState === "pending_for_deckle_match" &&
                        //   isUpdateOrderDetailsButtonPressed
                        //     ? // ? !isUpdateOrderDetailsButtonPressed
                        //       //   ? incompleteOrdersColumnsHead.filter(
                        //       //       (item) =>
                        //       //         item.dataIndex !== "calculatedreels" &&
                        //       //         item.dataIndex !== "rewinderreels" &&
                        //       //         item.dataIndex !== "plannedweight"
                        //       //     )
                        //       //   : incompleteOrdersColumnsHead.filter(
                        //       //       (item) => item.dataIndex !== "select"
                        //       //     )
                        //       incompleteOrdersColumnsHead.current
                        //     : orderState == "pending_for_deckle_match"
                        //     ? columnsHead.current
                        //     : columnsHeader.current
                        // }
                        columns={
                          orderState === "pending_for_deckle_match" && isUpdateOrderDetailsButtonPressed
                            ? (
                              orderManagementSettings?.fetch_balance_quantity?.value
                                ? incompleteOrdersColumnsHead.current
                                : incompleteOrdersColumnsHead.current?.filter(
                                  (item) => item.dataIndex !== "balance_qty"
                                )
                            )
                            : orderState === "pending_for_deckle_match"
                              ? (
                                orderManagementSettings?.fetch_balance_quantity?.value
                                  ? columnsHead.current
                                  : columnsHead.current?.filter(
                                    (item) => item.dataIndex !== "balance_qty"
                                  )
                              )
                              : (
                                orderManagementSettings?.fetch_balance_quantity?.value
                                  ? columnsHeader.current
                                  : columnsHeader.current?.filter(
                                    (item) => item.dataIndex !== "balance_qty"
                                  )
                              )
                        }
                        dataSource={tableData}
                        onChange={onChange}
                        expandable={
                          orderState !== "incomplete_orders" &&
                            !showBulkOrderUpdate &&
                            orderState !== "pending_for_deckle_match" &&
                            orderState !== "planned_orders"
                            ? {
                              expandedRowRender,
                              defaultExpandedRowKeys: ["0"],
                              rowExpandable,
                              onExpand,
                            }
                            : {}
                        }
                        pagination={{
                          current: currentPage,
                          total: totalRecords,
                          showTitle: false,
                          defaultPageSize: settingsData?.settings?.default_page_size || 10,
                          pageSize: paginationRef.current.size,
                          showTotal: (total, range) =>
                            `Showing ${range[0]}-${range[1]} of ${total} results`,
                          pageSizeOptions: [10, 20, 60, 100],
                          showSizeChanger: true,
                        }}
                        scroll={{
                          // x:
                          //   isUpdateOrderDetailsButtonPressed
                          //       ?
                          //       1900
                          //     : 2500,
                          x: 3000,
                          // x: orderState == "completely_matched" ? 1900 : 2800
                        }}
                        rowClassName={(record) => `small-row ${record.priority} && "true"`}
                        size="small"
                      />
                    </Form>
                  ) : (
                    <EmptyState
                      img={
                        emptyStateLabel === "noData" ||
                          emptyStateLabel === "filter"
                          ? emptyState_NoData
                          : emptyStateLabel === "search"
                            ? emptyState_Search
                            : emptyState_ConnectionAPIError
                      }
                      heading={emptyStatePropsData.heading}
                      subHeading={emptyStatePropsData.subHeading}
                      label={emptyStatePropsData.label}
                      refresh={refresh}
                    />
                  )}
                </Panes>
              ))}
            </Tabs>
          </StyledTab>
        </div>
      </TableLayoutData>

      {/* {viewDeckleOrders && (
        <ViewDeckleOrder
          selectedOrderNo={selectedOrder?.orderno}
          showButton={true}
          visible={viewDeckleOrders}
          onClose={onCloseViewDrawer}
          onCloseGrade={onCloseFullViewDrawer}
        />
      )} */}

      {viewDeckleOrders && (
        <MultiDiaEditOrderDrawer
          visible={viewDeckleOrders}
          onClose={onCloseViewDrawer}
          onCloseGrade={onCloseFullViewDrawer}
          selectedOrderNo={selectedOrder?.orderno}
          selectedState={selectedOrder?.status}
          selectedOrder={selectedOrder}
          actionType="view"
          type="deckleRecord"
          category={selectedOrder?.category}

        ></MultiDiaEditOrderDrawer>
      )}

      {/* Toasters */}

      {visibleToaster && !actionToaster.error && (
        <AlertContainer
          color="green toaster"
          icon={alertGreen}
          msg={actionToaster.msg}
        />
      )}
      {visibleToaster && actionToaster.error && (
        <AlertContainer
          color="red toaster"
          icon={alertRed}
          msg={actionToaster.msg}
        />
      )}

      {/* {resendApprovalData && (
        <ResendApprovalData
          visible={resendApprovalData}
          onClose={onCloseNewGrade}
          onCloseGrade={onCloseFullViewDrawer}
          selectedOrderNo={selectedOrder?.orderno}
          selectedState={"approved"}
          rendering={setRendering}
          toasterAction={setActionToaster}
          showToaster={showToaster}
          isEditFromIncompleteOrder={true}
          type="deckleRecord"
        ></ResendApprovalData>
      )} */}

      {resendApprovalData && (
        <MultiDiaEditOrderDrawer
          visible={resendApprovalData}
          onClose={onCloseNewGrade}
          onCloseGrade={onCloseFullViewDrawer}
          selectedOrderNo={selectedOrder?.orderno}
          selectedState={"approved"}
          rendering={setRendering}
          toasterAction={setActionToaster}
          showToaster={() => showToaster(setVisibleToaster)}
          isEditFromIncompleteOrder={true}
          type="deckleRecord"
          actionType="edit"
          category={selectedOrder?.category}
        ></MultiDiaEditOrderDrawer>
      )}

      {productionDetailsSideDrawer && (
        <ProductionDetailsDrawer
          visible={productionDetailsSideDrawer}
          onCloseGrade={onCloseFullViewDrawer}
          selectedOrderNo={selectedOrder?.orderno}
          handleCancel={onCloseFullViewDrawer}
        ></ProductionDetailsDrawer>
      )}

      {processedQtyDetailsSideDrawer && (
        <ViewProcessedQuantityDrawer
          visible={processedQtyDetailsSideDrawer}
          onCloseGrade={onCloseFullViewDrawer}
          selectedOrderNo={selectedOrder?.orderno}
          handleCancel={onCloseFullViewDrawer}
        ></ViewProcessedQuantityDrawer>
      )}

      {pendingQtyDetailsSideDrawer && (
        <ViewPendingQuantityDrawer
          visible={pendingQtyDetailsSideDrawer}
          onCloseGrade={onCloseFullViewDrawer}
          selectedOrderNo={selectedOrder?.orderno}
          handleCancel={onCloseFullViewDrawer}
        ></ViewPendingQuantityDrawer>
      )}

      <ConfirmationModal
        visible={isVisiblePriorityModal}
        icon={warning}
        param={selectedOrder}
        confirmAction={priorityModalConfirm}
        cancelAction={priorityModalClose}
      >
        <span>
          {selectedOrder?.priority ? "Remove priority?" : "Prioritize Order?"}
        </span>
        <p>
          {selectedOrder?.priority
            ? "The order will be treated as a regular order. Are you sure you want to continue?"
            : "The order will be upgraded to a prioritized order and will be completely matched in deckle. Are you sure you want to proceed?"}
        </p>
      </ConfirmationModal>

      {editReelCoreModal && selectedRecord && (
        <ReelCoreEditModal
          visible={editReelCoreModal}
          icon={warning}
          confirmAction={confirmEditReelCoreModal}
          cancelAction={closeEditReelCoreModal}
          orderData={selectedRecord}
          type={selectedType}
        >
          <span></span>
          <p></p>
        </ReelCoreEditModal>
      )}
    </RightLayoutContainer>
  );
};

export default OrderRecordsData;
